"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[970],{

/***/ 682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Icon; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/index.js + 230 modules
var esm = __webpack_require__(7804);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/index.js + 230 modules
var solid_esm = __webpack_require__(4653);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/icons/ArrowRightDownIcon.tsx



/* eslint-disable max-len */
var ArrowRightDownIcon = function ArrowRightDownIcon(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M32 3.04451L29.1583 3.04451L29.1583 27.1085L1.98683 -1.32968e-06L1.81801e-06 2.07152L27.0957 29.1028L3.02879 29.1028L3.02879 32L32 32L32 3.04451Z",
      fill: "currentColor"
    })
  });
};

/* harmony default export */ var icons_ArrowRightDownIcon = (ArrowRightDownIcon);
;// CONCATENATED MODULE: ./components/icons/ArrowRightDownSolidIcon.tsx




/* eslint-disable max-len */
var ArrowRightDownSolidIcon = function ArrowRightDownSolidIcon(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
      cx: "15.7869",
      cy: "16",
      rx: "16",
      ry: "15.7862",
      transform: "rotate(90 15.7869 16)",
      fill: "currentColor"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M22.6934 10.3064L21.4668 10.3064L21.4668 20.6326L9.73808 9L8.88045 9.88892L20.5764 21.4884L10.1878 21.4884L10.1878 22.7317L22.6934 22.7317L22.6934 10.3064Z",
      fill: "#F7F7FA"
    })]
  });
};

/* harmony default export */ var icons_ArrowRightDownSolidIcon = (ArrowRightDownSolidIcon);
;// CONCATENATED MODULE: ./components/icons/ArrowRightUpCircle.tsx




/* eslint-disable max-len */
var ArrowRightUpCircle = function ArrowRightUpCircle(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    className: className,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      clipPath: "url(#clip0_566_7271)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.5308 8.0015L15.5308 8.00124C15.5308 3.8409 12.1591 0.469151 7.99876 0.469151C3.83841 0.469151 0.466666 3.8409 0.466666 8.00124C0.466666 12.1616 3.83841 15.5333 7.99876 15.5333C12.1593 15.5333 15.5332 12.1614 15.5308 8.0015ZM-3.49637e-07 8.00124C-1.56516e-07 12.4193 3.58068 16 7.99876 16C12.4168 16 16 12.4193 15.9975 8.00124C15.9975 3.58316 12.4168 0.00248362 7.99876 0.00248381C3.58068 0.00248401 -5.42757e-07 3.58316 -3.49637e-07 8.00124Z",
        fill: "currentColor"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.51392 4.97068L11.6481 4.97068L11.6481 11.1048L11.1481 11.1048L11.1481 5.47068L5.51392 5.47068L5.51392 4.97068Z",
        fill: "currentColor"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.48462 13.7807L11.2214 5.0439L11.5749 5.39746L2.83817 14.1342L2.48462 13.7807Z",
        fill: "currentColor"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_566_7271",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "16",
          height: "16",
          fill: "currentColor"
        })
      })
    })]
  });
};

/* harmony default export */ var icons_ArrowRightUpCircle = (ArrowRightUpCircle);
;// CONCATENATED MODULE: ./components/icons/DiscordIcon.tsx



/* eslint-disable max-len */
var DiscordIcon = function DiscordIcon(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: "currentColor",
      d: "M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418Z"
    })
  });
};

/* harmony default export */ var icons_DiscordIcon = (DiscordIcon);
;// CONCATENATED MODULE: ./components/Icon.tsx









var Icon = function Icon(_ref) {
  var icon = _ref.icon,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;

  switch (icon) {
    case 'academic-cap':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* AcademicCapIcon */.fh6, {
        className: className
      });

    case 'arrow-right-down':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(icons_ArrowRightDownIcon, {
        className: className
      });

    case 'arrow-right-down-solid':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(icons_ArrowRightDownSolidIcon, {
        className: className
      });

    case 'arrow-right-up-circle':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(icons_ArrowRightUpCircle, {
        className: className
      });

    case 'at-symbol':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* AtSymbolIcon */.QjI, {
        className: className
      });

    case 'book-open':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* BookOpenIcon */.KNL, {
        className: className
      });

    case 'briefcase':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* BriefcaseIcon */.VpB, {
        className: className
      });

    case 'calendar':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* CalendarIcon */.Que, {
        className: className
      });

    case 'chat-alt-2':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* ChatAlt2Icon */.ItX, {
        className: className
      });

    case 'check-circle-solid':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* CheckCircleIcon */.rE2, {
        className: className
      });

    case 'chevron-double-down':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* ChevronDoubleDownIcon */.PYG, {
        className: className
      });

    case 'chevron-left':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* ChevronLeftIcon */.wyc, {
        className: className
      });

    case 'chevron-right':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* ChevronRightIcon */.XCv, {
        className: className
      });

    case 'clock':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* ClockIcon */.T39, {
        className: className
      });

    case 'cloud':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* CloudIcon */.v3n, {
        className: className
      });

    case 'cursor-click':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* CursorClickIcon */.UNN, {
        className: className
      });

    case 'desktop-computer':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* DesktopComputerIcon */.DAM, {
        className: className
      });

    case 'discord':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(icons_DiscordIcon, {
        className: className
      });

    case 'exclamation-circle':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* ExclamationCircleIcon */.$Ow, {
        className: className
      });

    case 'fire':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* FireIcon */.YqE, {
        className: className
      });

    case 'heart':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* HeartIcon */.h_8, {
        className: className
      });

    case 'light-bulb':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* LightBulbIcon */.tWY, {
        className: className
      });

    case 'location-marker':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* LocationMarkerIcon */.IS8, {
        className: className
      });

    case 'mail':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* MailIcon */.bV6, {
        className: className
      });

    case 'pencil':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* PencilIcon */.vdY, {
        className: className
      });

    case 'puzzle':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* PuzzleIcon */.Mfs, {
        className: className
      });

    case 'receipt-tax':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* ReceiptTaxIcon */.ErD, {
        className: className
      });

    case 'sparkles':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* SparklesIcon */.T$Z, {
        className: className
      });

    case 'star':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* StarIcon */.r7p, {
        className: className
      });

    case 'ticket':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* TicketIcon */.Prq, {
        className: className
      });

    case 'trending-up':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* TrendingUpIcon */.Zab, {
        className: className
      });

    case 'user-circle':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* UserCircleIcon */.lMe, {
        className: className
      });

    case 'user-group':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* UserGroupIcon */.vxs, {
        className: className
      });

    case 'video-camera':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* VideoCameraIcon */.y3v, {
        className: className
      });

    case 'cross':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* XIcon */.b0D, {
        className: className
      });

    case 'plus':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* PlusIcon */.pOD, {
        className: className
      });

    default:
      return null;
  }
};

/* harmony default export */ var components_Icon = (Icon);

/***/ }),

/***/ 1590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _hooks_useLinkResolver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3949);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);


var _excluded = ["href", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var LinkWithQuery = function LinkWithQuery(_ref) {
  var href = _ref.href,
      children = _ref.children,
      props = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  var url = (0,_hooks_useLinkResolver__WEBPACK_IMPORTED_MODULE_2__/* .useLinkResolver */ .u)(href);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", _objectSpread(_objectSpread({
      href: url
    }, props), {}, {
      children: children
    }))
  );
};

/* harmony default export */ __webpack_exports__["default"] = (LinkWithQuery);

/***/ }),

/***/ 7310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ModalSize": function() { return /* binding */ ModalSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9196);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8346);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4653);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);







var ModalSize;

(function (ModalSize) {
  ModalSize["sm"] = "small";
  ModalSize["md"] = "medium";
  ModalSize["lg"] = "large";
})(ModalSize || (ModalSize = {}));

var Modal = function Modal(_ref) {
  var state = _ref.state,
      setOpen = _ref.setOpen,
      size = _ref.size,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Transition.Root */ .u.Root, {
    show: state,
    as: react__WEBPACK_IMPORTED_MODULE_0__.Fragment,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Dialog */ .V, {
      as: "div",
      className: "fixed z-30 inset-0 overflow-y-auto",
      onClose: function onClose() {
        return setOpen(false);
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Transition.Child */ .u.Child, {
          as: react__WEBPACK_IMPORTED_MODULE_0__.Fragment,
          enter: "ease-out duration-300",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "ease-in duration-200",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Dialog.Overlay */ .V.Overlay, {
            className: "fixed inset-0 bg-black-2/75 transition-opacity"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
          className: "hidden sm:inline-block sm:align-middle sm:h-screen",
          "aria-hidden": "true",
          children: "\u200B"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_4__/* .Transition.Child */ .u.Child, {
          as: react__WEBPACK_IMPORTED_MODULE_0__.Fragment,
          enter: "ease-out duration-300",
          enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
          enterTo: "opacity-100 translate-y-0 sm:scale-100",
          leave: "ease-in duration-200",
          leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
          leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl', 'transform transition-all sm:my-8 sm:align-middle sm:w-full sm:p-6', {
              'sm:max-w-sm': size === ModalSize.sm,
              'sm:max-w-sm md:max-w-3xl': size === ModalSize.md,
              'sm:max-w-sm md:max-w-3xl lg:max-w-6xl': !size || size === ModalSize.lg
            }),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
              className: "flex justify-end -mt-5 -mr-3",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("button", {
                type: "button",
                onClick: function onClick() {
                  return setOpen(false);
                },
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()('px-3 py-3 text-black place-self-end'),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_2__/* .XIcon */ .b0D, {
                  className: "h-5 w-5 text-black",
                  "aria-hidden": "true"
                })
              })
            }), children]
          })
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Modal);

/***/ }),

/***/ 689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useAnalytics; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7794);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var process__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4155);
/* harmony import */ var process__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(process__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _contexts_AnalyticsContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9166);
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4539);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8058);







var useAnalytics = function useAnalytics() {
  var result = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_contexts_AnalyticsContext__WEBPACK_IMPORTED_MODULE_3__/* .AnalyticsContext */ .f);
  var promise = result !== null && result !== void 0 ? result : [];

  if (!result && true && process__WEBPACK_IMPORTED_MODULE_2__.env.NODE_ENV !== 'test') {
    throw new Error('Context used outside of its Provider!');
  }

  return {
    page: function () {
      var _page2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(category, name, properties) {
        var analytics;
        return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return promise;

              case 2:
                analytics = _context.sent[0];

                (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_4__/* .page */ .Md)(analytics, category, name, properties);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function page(_x, _x2, _x3) {
        return _page2.apply(this, arguments);
      }

      return page;
    }(),
    track: function () {
      var _track2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(eventName, payload, locale) {
        var hasDelay,
            analytics,
            _args2 = arguments;
        return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                hasDelay = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : false;
                _context2.next = 3;
                return promise;

              case 3:
                analytics = _context2.sent[0];

                if (!hasDelay) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 7;
                return (0,_utils_common__WEBPACK_IMPORTED_MODULE_5__/* .delay */ .gw)(1000);

              case 7:
                (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_4__/* .track */ .j)(analytics, eventName, payload, locale);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function track(_x4, _x5, _x6) {
        return _track2.apply(this, arguments);
      }

      return track;
    }(),
    identify: function () {
      var _identify2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(payload) {
        var analytics;
        return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return promise;

              case 2:
                analytics = _context3.sent[0];

                (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_4__/* .identify */ .yV)(analytics, payload);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function identify(_x7) {
        return _identify2.apply(this, arguments);
      }

      return identify;
    }(),
    addSourceMiddleware: function () {
      var _addSourceMiddleware = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(callback) {
        var analytics;
        return _vercel_path0_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return promise;

              case 2:
                analytics = _context4.sent[0];
                analytics.addSourceMiddleware(callback);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function addSourceMiddleware(_x8) {
        return _addSourceMiddleware.apply(this, arguments);
      }

      return addSourceMiddleware;
    }()
  };
};

/***/ }),

/***/ 6958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _contexts_AppContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8960);



var useGeoCountry = function useGeoCountry() {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_contexts_AppContext__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .I),
      state = _useContext.state;

  return state.geoCountry.loc;
};

/* harmony default export */ __webpack_exports__["Z"] = (useGeoCountry);

/***/ }),

/***/ 3949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ useLinkResolver; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4539);



var useLinkResolver = function useLinkResolver() {
  var _global, _global$location, _global2, _global2$location;

  var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(link),
      url = _useState[0],
      setUrl = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}),
      pathParams = _useState2[0],
      setPathParams = _useState2[1];

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var href = (_global = __webpack_require__.g) === null || _global === void 0 ? void 0 : (_global$location = _global.location) === null || _global$location === void 0 ? void 0 : _global$location.href;
  var host = (_global2 = __webpack_require__.g) === null || _global2 === void 0 ? void 0 : (_global2$location = _global2.location) === null || _global2$location === void 0 ? void 0 : _global2$location.host;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    setPathParams(router === null || router === void 0 ? void 0 : router.query);
  }, [router]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var allowedQueryString = (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_2__/* .getAllowedQueryString */ .cM)(pathParams);
    var linkWithQuery = new URLSearchParams(allowedQueryString).toString(); // relative path

    if (link && link[0] === '/') {
      setUrl("".concat(link).concat(linkWithQuery ? "?".concat(linkWithQuery) : ''));
    } else if (href && link) {
      var siteUrl = new URL(href);
      var linkUrl = new URL(link);

      if (siteUrl.hostname === linkUrl.hostname || linkUrl.hostname.indexOf(host) >= 0) {
        linkUrl.search = linkWithQuery;
        setUrl(linkUrl.toString());
      }
    }
  }, [pathParams]); // eslint-disable-line react-hooks/exhaustive-deps

  return url;
};

/***/ }),

/***/ 4044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8058);




var useLocale = function useLocale() {
  var shortLocale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'es';

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(shortLocale),
      locale = _useState[0],
      setLocale = _useState[1];

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (router !== null && router !== void 0 && router.locale) setLocale((0,_utils_common__WEBPACK_IMPORTED_MODULE_2__/* .getRealLocale */ .L6)(router.locale));
  }, [router]);
  return locale;
};

/* harmony default export */ __webpack_exports__["Z"] = (useLocale);

/***/ }),

/***/ 7445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useTrackingPayload; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_optimize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5220);
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4539);
/* harmony import */ var _useGeoCountry__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6958);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var useTrackingPayload = function useTrackingPayload(_ref) {
  var _cluster$name, _cluster$businessUnit;

  var slice = _ref.slice,
      cluster = _ref.cluster,
      vertical = _ref.vertical,
      product = _ref.product;
  var gclidKey = 'gclid';
  var utm = (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_4__/* .getUtm */ .PB)();
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  var experiments = (0,_utils_optimize__WEBPACK_IMPORTED_MODULE_3__/* .getExperiments */ .g)();
  var geoCountry = (0,_useGeoCountry__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
    context: {
      platform: 'Web',
      slice: slice === null || slice === void 0 ? void 0 : slice.slice_type,
      slice_variant: slice === null || slice === void 0 ? void 0 : slice.variation
    },
    product: {
      name: (_cluster$name = cluster === null || cluster === void 0 ? void 0 : cluster.name) !== null && _cluster$name !== void 0 ? _cluster$name : vertical === null || vertical === void 0 ? void 0 : vertical.name,
      business_unit: (_cluster$businessUnit = cluster === null || cluster === void 0 ? void 0 : cluster.businessUnit) !== null && _cluster$businessUnit !== void 0 ? _cluster$businessUnit : vertical === null || vertical === void 0 ? void 0 : vertical.name,
      vertical: vertical === null || vertical === void 0 ? void 0 : vertical.name,
      start_date: product === null || product === void 0 ? void 0 : product.startDate,
      end_date: product === null || product === void 0 ? void 0 : product.endDate
    },
    geo_country: '',
    experiments: experiments
  }),
      params = _useState[0],
      setParams = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var gclid = (router === null || router === void 0 ? void 0 : router.query[gclidKey]) || undefined;
    setParams(function (prevParams) {
      return _objectSpread(_objectSpread({}, prevParams), {}, {
        geo_country: geoCountry,
        tracking: {
          gclid: gclid,
          utm: Object.keys(utm).length ? utm : undefined
        }
      });
    });
  }, [router, geoCountry]); // eslint-disable-line react-hooks/exhaustive-deps

  return params;
};

/***/ }),

/***/ 3053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1955);



var PRISMIC_REPO = "dh-frontend" || 0;

var useUpdatePreviewRef = function useUpdatePreviewRef(preview, documentId) {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (router.isPreview) {
      var rawPreviewCookie = js_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get('io.prismic.preview');

      if (rawPreviewCookie) {
        var previewCookie = JSON.parse(rawPreviewCookie);
        var previewCookieObject = previewCookie["".concat(PRISMIC_REPO, ".prismic.io")];
        var previewCookieRef = previewCookieObject && previewCookieObject.preview ? previewCookieObject.preview : null;

        if (previewCookieRef && preview.activeRef !== previewCookieRef) {
          window.location.href = "/api/preview?token=".concat(previewCookieRef, "&documentId=").concat(documentId);
        }
      } else {
        window.location.href = '/api/exit-preview';
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

/* harmony default export */ __webpack_exports__["Z"] = (useUpdatePreviewRef);

/***/ }),

/***/ 894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SliceResolver; }
});

// NAMESPACE OBJECT: ./slices/index.js
var slices_namespaceObject = {};
__webpack_require__.r(slices_namespaceObject);
__webpack_require__.d(slices_namespaceObject, {
  "Accordion": function() { return slices_Accordion; },
  "Banners": function() { return slices_Banners; },
  "Boxes": function() { return slices_Boxes; },
  "Button": function() { return slices_Button; },
  "CallToAction": function() { return slices_CallToAction; },
  "Cards": function() { return Cards; },
  "Carousel": function() { return slices_Carousel; },
  "Content": function() { return slices_Content; },
  "Divider": function() { return slices_Divider; },
  "Embed": function() { return slices_Embed; },
  "Faq": function() { return slices_Faq; },
  "Feature": function() { return slices_Feature; },
  "Form": function() { return slices_Form; },
  "GridLists": function() { return slices_GridLists; },
  "Header": function() { return slices_Header; },
  "Hero": function() { return slices_Hero; },
  "Incentives": function() { return slices_Incentives; },
  "LogoCloud": function() { return slices_LogoCloud; },
  "Marquee": function() { return slices_Marquee; },
  "Pricing": function() { return Pricing; },
  "ProductOverviews": function() { return slices_ProductOverviews; },
  "Stats": function() { return slices_Stats; },
  "Steps": function() { return slices_Steps; },
  "Tabs": function() { return slices_Tabs; },
  "Team": function() { return slices_Team; },
  "Video": function() { return slices_Video; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./slices/Accordion/Accordion.types.ts
var AccordionVariations;

(function (AccordionVariations) {
  AccordionVariations["withTabs"] = "accordionWithTabs";
  AccordionVariations["withWhatsApp"] = "accordionWithWhatsApp";
})(AccordionVariations || (AccordionVariations = {}));
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/nanoid/index.browser.js
var index_browser = __webpack_require__(3416);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(5833);
// EXTERNAL MODULE: ./node_modules/lodash.clonedeep/index.js
var lodash_clonedeep = __webpack_require__(3465);
var lodash_clonedeep_default = /*#__PURE__*/__webpack_require__.n(lodash_clonedeep);
// EXTERNAL MODULE: ./node_modules/lodash.set/index.js
var lodash_set = __webpack_require__(1468);
var lodash_set_default = /*#__PURE__*/__webpack_require__.n(lodash_set);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/lodash.groupby/index.js
var lodash_groupby = __webpack_require__(276);
var lodash_groupby_default = /*#__PURE__*/__webpack_require__.n(lodash_groupby);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/LinkWithQuery.tsx
var LinkWithQuery = __webpack_require__(1590);
// EXTERNAL MODULE: ./hooks/useTrackPayload.ts
var useTrackPayload = __webpack_require__(7445);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(352);
// EXTERNAL MODULE: ./hooks/useLocale.ts
var useLocale = __webpack_require__(4044);
// EXTERNAL MODULE: ./utils/colors.ts
var colors = __webpack_require__(5963);
// EXTERNAL MODULE: ./hooks/useAnalytics.ts
var useAnalytics = __webpack_require__(689);
// EXTERNAL MODULE: ./utils/common.ts
var common = __webpack_require__(8058);
// EXTERNAL MODULE: ./utils/prismic.ts
var prismic = __webpack_require__(1369);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./slices/Accordion/variations/AccordionWithTabs.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






















var AccordionFull = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 688).then(__webpack_require__.bind(__webpack_require__, 688));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(688)];
    }
  }
});
var Tooltip = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 795).then(__webpack_require__.bind(__webpack_require__, 8795));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8795)];
    }
  }
});
var DialogDownload = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 70).then(__webpack_require__.bind(__webpack_require__, 4070));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4070)];
    }
  }
});
var Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});

var AccordionWithTabs = function AccordionWithTabs(_ref) {
  var _slice$_vertical, _slice$_cluster, _slice$_checkout$allP, _slice$_checkout, _slice$_checkout$allP2, _slice$_checkout$allP3, _slice$primary, _slice$primary2, _slice$primary3;

  var slice = _ref.slice;

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track;

  var _useState = (0,react.useState)(1),
      tab = _useState[0],
      setTab = _useState[1];

  var _useState2 = (0,react.useState)(false),
      openDialog = _useState2[0],
      setOpenDialog = _useState2[1];

  var accordionRef = (0,react.useRef)(null);
  var tabsRef = (0,react.useRef)(null);
  var locale = (0,useLocale/* default */.Z)();
  var maxTabs = 2;
  var maxTabsItems = 4;
  var tabsColor = (0,colors/* getColor */.Lq)(slice.primary.tabsColor, 600);
  var iconsColor = (0,colors/* getColor */.Lq)(slice.primary.iconsColor, 800);
  var isSingleTab = !(slice.primary.tab1Label && slice.primary.tab2Label);
  var hasDescription = (0,prismic/* hasRichText */.M)(slice.primary.description);
  var tab2ButtonVertical = slice.primary.tab2ButtonUrl ? (0,common/* getVerticalByLink */.SP)(slice.primary.tab2ButtonUrl, slice._verticals, slice._clusters, slice._products) : null;
  var accordionData = {
    bgColor: 'bg-gray-2',
    textColor: 'text-white-1',
    bgDescColor: 'bg-gray-4',
    chevronColor: 'text-white-2'
  };
  var vertical = slice === null || slice === void 0 ? void 0 : (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var cluster = slice === null || slice === void 0 ? void 0 : (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : _slice$_cluster.data;

  var clusterCheckout = _objectSpread(_objectSpread({}, cluster), {}, {
    businessUnit: (_slice$_checkout$allP = (_slice$_checkout = slice._checkout) === null || _slice$_checkout === void 0 ? void 0 : (_slice$_checkout$allP2 = _slice$_checkout.allProducts[0]) === null || _slice$_checkout$allP2 === void 0 ? void 0 : (_slice$_checkout$allP3 = _slice$_checkout$allP2.defaultOffer) === null || _slice$_checkout$allP3 === void 0 ? void 0 : _slice$_checkout$allP3.businessUnit) !== null && _slice$_checkout$allP !== void 0 ? _slice$_checkout$allP : cluster.businessUnit
  });

  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({
    slice: slice,
    cluster: clusterCheckout,
    vertical: vertical
  });
  var groupItems = lodash_groupby_default()(slice.items, 'group');
  var handleClickBtnDownload = (0,react.useCallback)(function (label) {
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'context.label', label);
    setOpenDialog(true);
    track(constants/* TrackEvents.brochureDownloadedClicked */.Um.brochureDownloadedClicked, payload, locale);
  }, [trackPayload, locale, track]);

  var setTabsMargin = function setTabsMargin() {
    var _accordionRef$current, _tabsRef$current;

    if (!((_accordionRef$current = accordionRef.current) !== null && _accordionRef$current !== void 0 && _accordionRef$current.offsetTop) || !((_tabsRef$current = tabsRef.current) !== null && _tabsRef$current !== void 0 && _tabsRef$current.offsetTop)) return;
    var offsetDiff = accordionRef.current.offsetTop - tabsRef.current.offsetTop;
    if (offsetDiff <= 0) return;
    tabsRef.current.style.marginTop = "".concat(offsetDiff, "px");
  };

  (0,react.useEffect)(function () {
    var handleWindowSizeChange = function handleWindowSizeChange() {
      setTabsMargin();
    };

    setTabsMargin();
    window.addEventListener('resize', handleWindowSizeChange);
    return function () {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "bg-black-2 text-white-2",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "dh-content-full py-20 lg:py-[8.75rem] 3xl:py-[12.5rem]",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "lg:max-w-7xl mx-auto 2xl:max-w-8xl 3xl:max-w-8x5l",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
          className: "text-center mb-20",
          children: [slice.primary.title && /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            className: "font-bold text-h4 lg:text-h2 3xl:text-h1",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
              render: slice.primary.title
            })
          }), hasDescription && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "font-semibold text-p3 3xl:text-p2 mt-4",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
              render: slice.primary.description
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-col lg:flex-row lg:gap-28 2xl:gap-36 3xl:gap-40 justify-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mb-14 lg:mb-0 lg:w-7/12 2xl:w-6/12 flex flex-col gap-20",
            children: Object.keys(groupItems).map(function (key, index) {
              var groupTitle = slice.primary["accordionGroupName".concat(key)];
              var tootlip = slice.primary["accordionGroupNameTooltip".concat(key)];
              var hasGroupTitle = (0,prismic/* hasRichText */.M)(groupTitle);
              var accordionItems = groupItems[key];
              var hasAccordion = !!(accordionItems !== null && accordionItems !== void 0 && accordionItems.length);
              var isFirstGroup = index === 0;
              if (!hasAccordion) return null;

              var getTitle = function getTitle(item) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "font-medium text-p2 lg:text-h6 3xl:text-h5",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                    render: item.title
                  })
                });
              };

              var getDescription = function getDescription(item) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                  render: item.description
                });
              };

              var getFooter = function getFooter(item) {
                var _item$footerLogo, _item$footerLogo2;

                if (!item.footerText && !item.footerLogo1.url && !item.footerLogo2.url) return null;
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex flex-col items-start gap-2 lg:flex-row lg:gap-5 lg:items-center",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "",
                    children: item.footerText
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "flex gap-4 lg:gap-5",
                    children: [!!((_item$footerLogo = item.footerLogo1) !== null && _item$footerLogo !== void 0 && _item$footerLogo.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: item.footerLogo1.url,
                      alt: item.footerLogo1.alt,
                      width: item.footerLogo1.dimensions.width,
                      height: item.footerLogo1.dimensions.height
                    }), !!((_item$footerLogo2 = item.footerLogo2) !== null && _item$footerLogo2 !== void 0 && _item$footerLogo2.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: item.footerLogo2.url,
                      alt: item.footerLogo2.alt,
                      width: item.footerLogo2.dimensions.width,
                      height: item.footerLogo2.dimensions.height
                    })]
                  })]
                });
              };

              var items = accordionItems.map(function (item) {
                return {
                  title: getTitle(item),
                  description: getDescription(item),
                  footer: getFooter(item)
                };
              });
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                children: [hasGroupTitle && /*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
                  className: "text-h3 font-medium mb-8 flex flex-row items-center",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                    render: groupTitle
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip, {
                    tip: tootlip,
                    className: "align-middle ml-2 hidden lg:inline-block",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
                      icon: "exclamation-circle",
                      className: "text-gray-8 w-6 h-6 inline-block"
                    })
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  ref: isFirstGroup ? accordionRef : undefined,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionFull, {
                    items: items,
                    bgColor: accordionData.bgColor,
                    textColor: accordionData.textColor,
                    bgDescColor: accordionData.bgDescColor,
                    chevronColor: accordionData.chevronColor
                  })
                })]
              }, (0,index_browser/* nanoid */.x0)());
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "py-8 px-6 lg:w-4/12 2xl:w-3/12 lg:px-8 text-gray-1 bg-white-1 rounded h-fit",
            ref: tabsRef,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: classnames_default()('border rounded-[1.875rem] p-1', tabsColor.border),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row relative",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: classnames_default()('absolute top-0 h-full rounded-[1.875rem] transition-all', tabsColor.bg, tabsColor.textContrast, {
                    'left-0': tab === 1 || isSingleTab,
                    'left-1/2': tab !== 1 && !isSingleTab,
                    'w-1/2': !isSingleTab,
                    'w-full': isSingleTab
                  })
                }), slice.primary.tab1Label && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  type: "button",
                  className: classnames_default()('p-2 text-center text-h6 font-bold cursor-pointer 3xl:text-h5', (0,defineProperty/* default */.Z)({
                    'text-white-1 z-0': tab === 1,
                    'w-1/2': !isSingleTab,
                    'w-full': isSingleTab
                  }, tabsColor.text, tab !== 1)),
                  onClick: function onClick() {
                    return setTab(1);
                  },
                  children: slice.primary.tab1Label
                }), slice.primary.tab2Label && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  type: "button",
                  className: classnames_default()('p-2 text-center text-h6 font-bold cursor-pointer 3xl:text-h5', (0,defineProperty/* default */.Z)({
                    'text-white-1 z-0': tab === 2,
                    'w-1/2': !isSingleTab,
                    'w-full': isSingleTab
                  }, tabsColor.text, tab !== 2)),
                  onClick: function onClick() {
                    return setTab(2);
                  },
                  children: slice.primary.tab2Label
                })]
              })
            }), Array.from({
              length: maxTabs
            }).map(function (_, iTab) {
              var isActiveTab = tab === iTab + 1;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                className: classnames_default()('mt-8 flex flex-col gap-6', isActiveTab ? 'block' : 'hidden'),
                children: Array.from({
                  length: maxTabsItems
                }).map(function (__, iTabItem) {
                  var prefix = "tab".concat(iTab + 1, "Item").concat(iTabItem + 1);
                  var icon = slice.primary["".concat(prefix, "Icon")];
                  var title = slice.primary["".concat(prefix, "Title")];
                  var description = slice.primary["".concat(prefix, "Description")];
                  var hasItemDescription = (0,prismic/* hasRichText */.M)(description);
                  var tooltip = slice.primary["".concat(prefix, "Tooltip")];
                  if (!title || !hasItemDescription) return null;
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                    className: "flex flex-row gap-4",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "row-span-2 flex-none",
                      children: icon && /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
                        icon: icon,
                        className: classnames_default()('h-6 w-6', iconsColor.text)
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      children: [title && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "font-bold text-p2 3xl:text-h6",
                        children: [title, /*#__PURE__*/(0,jsx_runtime.jsx)(Tooltip, {
                          tip: tooltip,
                          className: "text-p3 align-middle ml-1 hidden lg:inline-block",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {
                            icon: "exclamation-circle",
                            className: "text-gray-700 w-4 h-4 inline-block"
                          })
                        })]
                      }), hasItemDescription && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "font-medium text-p3 3xl:text-p2",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                          render: description
                        })
                      })]
                    })]
                  }, (0,index_browser/* nanoid */.x0)());
                })
              }, (0,index_browser/* nanoid */.x0)());
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-col mt-10",
              children: [tab === 1 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [slice.primary.buttonDownloadLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  type: "button",
                  onClick: function onClick() {
                    return handleClickBtnDownload(slice.primary.buttonDownloadLabel);
                  },
                  className: "dh-btn bg-black-1 text-white-1 text-p2 md:text-p2 md:p-3 3xl:text-h6 font-bold",
                  children: slice.primary.buttonDownloadLabel
                }), slice.primary.buttonFaqLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  type: "button",
                  className: "dh-btn bg-transparent underline font-medium text-p3 text-gray-700 mt-2 3xl:text-p2",
                  onClick: function onClick() {
                    return (0,common/* scrollTo */.X5)({
                      id: slice.primary.buttonFaqScrollTo
                    });
                  },
                  children: slice.primary.buttonFaqLabel
                })]
              }), tab === 2 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [(0,prismic/* hasLink */.A)(slice.primary.tab2ButtonUrl) && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery["default"], {
                  href: prismic_reactjs.Link.url(slice.primary.tab2ButtonUrl, function (doc) {
                    return (0,common/* prismicLinkResolver */.LT)(doc, {
                      verticalId: tab2ButtonVertical === null || tab2ButtonVertical === void 0 ? void 0 : tab2ButtonVertical.uid,
                      clusterId: tab2ButtonVertical === null || tab2ButtonVertical === void 0 ? void 0 : tab2ButtonVertical.clusterId
                    });
                  }),
                  className: "dh-btn bg-black-1 text-white-1 text-p2 md:text-p2 md:p-3 3xl:text-h6 font-bold",
                  children: slice.primary.tab2ButtonLabel
                }), (0,prismic/* hasLink */.A)(slice.primary.tab2LinkUrl) && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery["default"], {
                  href: prismic_reactjs.Link.url(slice.primary.tab2LinkUrl, function (doc) {
                    return (0,common/* prismicLinkResolver */.LT)(doc, {
                      verticalId: tab2ButtonVertical === null || tab2ButtonVertical === void 0 ? void 0 : tab2ButtonVertical.uid,
                      clusterId: tab2ButtonVertical === null || tab2ButtonVertical === void 0 ? void 0 : tab2ButtonVertical.clusterId
                    });
                  }),
                  className: "dh-btn bg-transparent underline font-medium text-p3 text-gray-700 mt-2 3xl:text-p2",
                  children: slice.primary.tab2LinkLabel
                })]
              })]
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DialogDownload, {
      color: tabsColor,
      close: function close() {
        return setOpenDialog(false);
      },
      open: openDialog,
      termsAndConditionsLink: (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.termsAndConditionsLink,
      buttonLabel: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.buttonDownloadLabel,
      downloadFile: (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.buttonDownloadFile,
      cluster: slice === null || slice === void 0 ? void 0 : slice._cluster,
      trackPayload: trackPayload
    })]
  });
};

/* harmony default export */ var variations_AccordionWithTabs = (AccordionWithTabs);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
;// CONCATENATED MODULE: ./slices/Accordion/variations/AccordionWithWhatsApp.tsx


function AccordionWithWhatsApp_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function AccordionWithWhatsApp_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { AccordionWithWhatsApp_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { AccordionWithWhatsApp_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

















var AccordionWithWhatsApp_AccordionFull = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 688).then(__webpack_require__.bind(__webpack_require__, 688));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(688)];
    }
  }
}); // TODO: replace svg with Icon component

var WhatsappIcon = function WhatsappIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
    })
  });
};

var AccordionWithWhatsApp = function AccordionWithWhatsApp(_ref2) {
  var _slice$_vertical, _slice$_cluster, _slice$primary, _slice$primary2, _slice$primary3;

  var slice = _ref2.slice;
  var vertical = slice === null || slice === void 0 ? void 0 : (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var cluster = slice === null || slice === void 0 ? void 0 : (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : _slice$_cluster.data;

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track;

  var locale = (0,useLocale/* default */.Z)();
  var intl = (0,useIntl/* default */.Z)();
  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({
    slice: slice,
    cluster: cluster,
    vertical: vertical
  });

  var _useState = (0,react.useState)(false),
      isDropdownOpen = _useState[0],
      setDropdownOpen = _useState[1];

  var _useState2 = (0,react.useState)([]),
      items = _useState2[0],
      setItems = _useState2[1];

  (0,react.useEffect)(function () {
    var limitedItems = isDropdownOpen ? slice.items : slice.items.slice(0, 3);
    var formattedItems = limitedItems.map(function (item) {
      return AccordionWithWhatsApp_objectSpread(AccordionWithWhatsApp_objectSpread({}, item), {}, {
        description: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-p3 lg:text-p2 3xl:text-p1",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: item.description
          })
        }),
        title: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "font-medium text-p3 lg:text-p2 3xl:text-p1",
          children: item.title
        })
      });
    });
    setItems(formattedItems);
  }, [isDropdownOpen, slice.items]);
  var handleClick = (0,react.useCallback)(function (url, label) {
    var fixed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'context.label', label);
    lodash_set_default()(payload, 'context.destination_url', url);
    lodash_set_default()(payload, 'context.fixed', fixed);
    track(constants/* TrackEvents.whatsappClicked */.Um.whatsappClicked, payload, locale);
  }, [trackPayload, locale, track]);
  if (!items.length) return null;
  var accordionData = {
    bgColor: slice.primary.darkMode ? 'bg-gray-2' : 'bg-white-1',
    textColor: slice.primary.darkMode ? 'text-white-1' : 'text-gray-3',
    bgDescColor: slice.primary.darkMode ? 'bg-gray-4' : 'bg-white-3',
    chevronColor: slice.primary.darkMode ? 'text-white-2' : 'text-gray-6'
  };
  var hasWhatsApp = !!slice.primary.whatsAppNumber;
  var link = (0,common/* buildWhatsappLink */.t7)((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.whatsAppNumber, (_slice$primary2 = slice.primary) !== null && _slice$primary2 !== void 0 && _slice$primary2.whatsAppMessage ? prismic_reactjs.RichText.asText((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.whatsAppMessage) : '');
  var primaryMessages = slice.primary;
  var defaultMessages = {
    textSeeMore: intl.formatMessage({
      id: "C2oD0J",
      defaultMessage: [{
        "type": 0,
        "value": "Ver más"
      }]
    }),
    textSeeLess: intl.formatMessage({
      id: "oqJulP",
      defaultMessage: [{
        "type": 0,
        "value": "Ver menos"
      }]
    })
  };

  var onClick = function onClick() {
    setDropdownOpen(!isDropdownOpen);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    "data-testid": slice.primary.darkMode ? 'black' : 'white',
    className: classnames_default()(' px-4 py-10 lg:py-[6.25rem] lg:px-15', {
      'bg-black-1': slice.primary.darkMode
    }, {
      'bg-white-2': !slice.primary.darkMode
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()('flex flex-col gap-8 lg:flex-row lg:justify-between lg:m-auto lg:max-w-7xl', '2xl:max-w-8xl 3xl:m-auto', {
        'justify-center': !hasWhatsApp
      }),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()('flex flex-col shadow-lg lg:w-7/12 3xl:w-6/10', {
          'lg:w-10/12 3xl:w-11/12': !hasWhatsApp
        }),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()('flex pb-6  items-end justify-between p-4 lg:p-6 rounded-t-[4px] ', 'lg:items-baseline lg:gap-28', {
            'justify-between': !hasWhatsApp
          }, {
            'bg-gray-2 border-b-2 border-gray-4': slice.primary.darkMode
          }, {
            'bg-white-1 border-b': !slice.primary.darkMode
          }),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: classnames_default()('font-bold text-h4 lg:text-h3 3xl:text-h2', {
              'text-white-2': slice.primary.darkMode
            }, {
              'text-black-1 ': !slice.primary.darkMode
            }),
            children: slice.primary.title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: classnames_default()('text-white-1 w-full text-right lg:w-fit font-medium underline', ' lg:mr-2.5 lg:text-p2 3xl:text-p1', {
              'text-white-1': slice.primary.darkMode
            }, {
              'text-gray-6': !slice.primary.darkMode
            }),
            onClick: onClick,
            type: "button",
            children: isDropdownOpen ? (0,common/* getDefaultText */.T9)('textSeeLess', primaryMessages, defaultMessages) : (0,common/* getDefaultText */.T9)('textSeeMore', primaryMessages, defaultMessages)
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionWithWhatsApp_AccordionFull, {
            items: items,
            bgColor: accordionData.bgColor,
            textColor: accordionData.textColor,
            bgDescColor: accordionData.bgDescColor,
            chevronColor: accordionData.chevronColor
          })
        })]
      }), hasWhatsApp && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "bg-white-1 border-1 px-4 py-8 border-white-3 rounded shadow-sl flex flex-col h-fit lg:w-4/12 lg:p-8 3xl:w-3/10",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-gray-4 font-bold text-p1 pb-4 lg:text-xl 3xl:text-h6",
          children: slice.primary.cardTitle
        }), (0,prismic/* hasRichText */.M)(slice.primary.cardDescription) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-gray-4 font-medium text-p3 pb-4 lg:pb-6 3xl:text-p2",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: slice.primary.cardDescription
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-full",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            onClick: function onClick() {
              var _slice$primary4;

              return handleClick(link, (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.label);
            },
            href: link,
            target: "_blank",
            className: classnames_default()('dh-button-full rounded-x p-2.5 3xl:p-3 3xl:text-p1', 'text-white-1 font-bold text-p2 bg-whatsapp-900 hover:bg-whatsapp-800'),
            rel: "noreferrer",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(WhatsappIcon, {
              className: "mr-1.5 lg:mr-[0.313rem] w-6 h-6 text-white-1 fill-current",
              "aria-hidden": "true"
            }), slice.primary.whatsAppText]
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var variations_AccordionWithWhatsApp = (AccordionWithWhatsApp);
;// CONCATENATED MODULE: ./slices/Accordion/index.tsx






var Accordion = function Accordion(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case AccordionVariations.withTabs:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_AccordionWithTabs, {
        slice: slice
      });

    case AccordionVariations.withWhatsApp:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_AccordionWithWhatsApp, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var slices_Accordion = (Accordion);
;// CONCATENATED MODULE: ./slices/Banners/Banners.types.ts
var BannersVariations;

(function (BannersVariations) {
  BannersVariations["countdown"] = "bannersCountdown";
  BannersVariations["heading"] = "bannersHeading";
})(BannersVariations || (BannersVariations = {}));
;// CONCATENATED MODULE: ./slices/Banners/variations/BannersCountdown.tsx











var BannersCountdown_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var Countdown = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 776).then(__webpack_require__.bind(__webpack_require__, 9776));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9776)];
    }
  }
});

var BannersCountdown = function BannersCountdown(_ref) {
  var _slice$primary$countd, _slice$primary, _slice$primary$countd2, _slice$primary$button, _slice$primary$button2;

  var slice = _ref.slice;
  var hasTitle = (0,prismic/* hasRichText */.M)(slice.primary.title);
  var hasRightContent = !!(slice.primary.countdown || slice.primary.buttonText);
  var countDownDate = new Date(slice.primary.countdown || '').getTime();
  var isFutureDate = countDownDate - new Date().getTime() > 0;

  var _useState = (0,react.useState)(hasTitle),
      showBanner = _useState[0],
      setShowBanner = _useState[1];

  var hasImage = !!((_slice$primary$countd = slice.primary.countdownBackgroundImage) !== null && _slice$primary$countd !== void 0 && _slice$primary$countd.url);
  var countdownClasses = {
    numbers: 'text-h3',
    titles: 'text-p3'
  };
  var color = (0,colors/* getColor */.Lq)(slice.primary.countdownBackgroundColor);
  var backgroundColor = slice.primary.backgroundColor === 'black' ? 'bg-black-2' : 'bg-white-2';
  var textColor = slice.primary.colorText === 'black' ? 'text-gray-1' : 'text-white-1';
  var buttonColor = slice.primary.colorText === 'black' ? 'bg-gray-1 text-white-1' : 'bg-white-1 text-gray-1';
  var backgroundCountdown = hasImage ? 'bg-black' : color.bg;

  if (!isFutureDate) {
    return null;
  }

  return showBanner ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: classnames_default()('px-4 py-16 lg:px-15 3xl:py-20 3xl:px-20', backgroundColor),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()('py-8 px-4 m-auto flex flex-col rounded items-center justify-evenly w-full', 'lg:justify-between lg:py-[42px] lg:px-10 relative overflow-hidden', {
        'border border-gray-3': hasImage
      }, backgroundCountdown, textColor, {
        'lg:flex-row': hasRightContent
      }),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()('lg:pt-2.5 lg:pr-8', {
          'lg:text-center': !hasRightContent
        }),
        children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : (_slice$primary$countd2 = _slice$primary.countdownBackgroundImage) === null || _slice$primary$countd2 === void 0 ? void 0 : _slice$primary$countd2.url) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "w-full top-0 left-0 border",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-full",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              className: "object-cover w-full",
              src: slice.primary.countdownBackgroundImage.url,
              alt: slice.primary.countdownBackgroundImage.alt,
              layout: "fill",
              objectFit: "cover",
              objectPosition: "center center",
              priority: true
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-full h-screen absolute top-0 left-0 z-0 bg-black-1/80"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "relative font-normal leading-[3rem] text-4xl lg:text-h2",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: slice.primary.title
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "relative text-h7 pt-3 leading-6 pr-1 ",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: slice.primary.description
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative flex flex-col w-full pt-6 items-center justify-evenly gap-2.5 lg:pt-0  lg:w-4/12 ",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hidden lg:flex text-h8",
          children: slice.primary.countdownText
        }), slice.primary.countdown &&
        /*#__PURE__*/
        // REVISAR
        (0,jsx_runtime.jsx)("div", {
          className: "pb-8 px-5 lg:pb-4 lg:pt-0",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Countdown, {
            finalDate: slice.primary.countdown,
            onFinish: function onFinish() {
              return setShowBanner(false);
            },
            classes: countdownClasses
          })
        }), slice.primary.buttonText && slice.primary.buttonLink && /*#__PURE__*/(0,jsx_runtime.jsx)(BannersCountdown_LinkWithQuery, {
          href: prismic_reactjs.Link.url(slice.primary.buttonLink, common/* prismicLinkResolver */.LT),
          target: (_slice$primary$button = (_slice$primary$button2 = slice.primary.buttonLink) === null || _slice$primary$button2 === void 0 ? void 0 : _slice$primary$button2.target) !== null && _slice$primary$button !== void 0 ? _slice$primary$button : '_blank',
          className: classnames_default()(buttonColor, 'dh-btn text-sm font-bold w-full rounded-lg py-3 px-6 lg:w-80'),
          children: slice.primary.buttonText
        })]
      })]
    })
  }) : null;
};

/* harmony default export */ var variations_BannersCountdown = (BannersCountdown);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/index.js + 230 modules
var esm = __webpack_require__(7804);
;// CONCATENATED MODULE: ./slices/Banners/variations/BannersHeading.tsx











var BannersHeading_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var BannersHeading_Countdown = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 776).then(__webpack_require__.bind(__webpack_require__, 9776));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9776)];
    }
  }
});

var BannersHeading_BannersCountdown = function BannersCountdown(_ref) {
  var _global$sessionStorag, _slice$primary$button, _slice$primary$button2;

  var slice = _ref.slice;
  var hasDescription = (0,prismic/* hasRichText */.M)(slice.primary.description);
  var hasRightContent = !!(slice.primary.countdown && slice.primary.buttonText);
  var hasSession = !!((_global$sessionStorag = __webpack_require__.g.sessionStorage) !== null && _global$sessionStorag !== void 0 && _global$sessionStorag.getItem('banner'));
  var countDownDate = new Date(slice.primary.countdown || '').getTime();
  var isFutureDate = countDownDate - new Date().getTime() > 0;

  var _useState = (0,react.useState)(hasDescription && !hasSession),
      showBanner = _useState[0],
      setShowBanner = _useState[1];

  var onClickX = function onClickX() {
    setShowBanner(false);
    __webpack_require__.g.sessionStorage.setItem('banner', 'show');
  };

  var countdownClasses = {
    numbers: 'text-[26px] lg:text-[32px]',
    titles: 'text-xs'
  };
  var color = (0,colors/* getColor */.Lq)(slice.primary.colorBackground);
  var textColor = slice.primary.colorText === 'black' ? 'text-gray-1' : 'text-white-1';
  var buttonColor = slice.primary.colorText === 'black' ? 'bg-gray-1 text-white-1' : 'bg-white-1 text-gray-1';
  var XColor = slice.primary.colorText === 'black' ? 'gray-1' : 'white-1';

  if (!isFutureDate) {
    return null;
  }

  return showBanner ? /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()('flex flex-col items-center pt-10 pb-8 px-[54px] w-full relative', 'lg:flex-row lg:justify-evenly lg:py-3 lg:px-[100px]', color.bg, textColor),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()('text-sm text-center w-[212px] leading-[18px] font-medium lg:w-full lg:text-base', {
        'lg:w-[60%]': hasRightContent
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
        render: slice.primary.description
      })
    }), slice.primary.countdown && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "pt-3 lg:ml-3",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(BannersHeading_Countdown, {
        finalDate: slice.primary.countdown,
        onFinish: function onFinish() {
          return setShowBanner(false);
        },
        classes: countdownClasses
      })
    }), slice.primary.buttonText && /*#__PURE__*/(0,jsx_runtime.jsx)(BannersHeading_LinkWithQuery, {
      href: prismic_reactjs.Link.url(slice.primary.buttonLink, common/* prismicLinkResolver */.LT),
      target: (_slice$primary$button = (_slice$primary$button2 = slice.primary.buttonLink) === null || _slice$primary$button2 === void 0 ? void 0 : _slice$primary$button2.target) !== null && _slice$primary$button !== void 0 ? _slice$primary$button : '_blank',
      className: classnames_default()(buttonColor, 'dh-btn px-6 py-2 rounded-lg mt-3 lg:ml-8 lg:mt-0'),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "font-bold text-sm leading-5",
        children: slice.primary.buttonText
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute right-[22px] top-[30px] lg:h-full lg:flex lg:top-0 lg:right-[34px] lg:align-middle ",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* XIcon */.b0D, {
        className: classnames_default()('w-6 flex-none lg:inline', XColor),
        onClick: onClickX
      })
    })]
  }) : null;
};

/* harmony default export */ var BannersHeading = (BannersHeading_BannersCountdown);
;// CONCATENATED MODULE: ./slices/Banners/index.tsx






var Banners = function Banners(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case BannersVariations.countdown:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_BannersCountdown, {
        slice: slice
      });

    case BannersVariations.heading:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(BannersHeading, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var slices_Banners = (Banners);
;// CONCATENATED MODULE: ./slices/Boxes/variants/boxesSquare.tsx


function boxesSquare_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function boxesSquare_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { boxesSquare_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { boxesSquare_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var boxesSquare_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var boxesGridTemplateModel = {
  1: {
    colClass: 'lg:grid-cols-1',
    rowSpan: [0]
  },
  2: {
    colClass: 'lg:grid-cols-2',
    rowSpan: [0, 1]
  },
  3: {
    colClass: 'lg:grid-cols-3',
    rowSpan: [0, 1, 2]
  },
  4: {
    colClass: 'lg:grid-cols-3',
    rowSpan: [0, 2]
  },
  5: {
    colClass: 'lg:grid-cols-3',
    rowSpan: [0]
  }
};

var Item = function Item(_ref) {
  var item = _ref.item,
      color = _ref.color;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(boxesSquare_LinkWithQuery, {
    href: prismic_reactjs.Link.url(item.link, function (doc) {
      return (0,common/* prismicLinkResolver */.LT)(doc, item);
    }),
    className: classnames_default()('block h-full w-full rounded-lg overflow-hidden text-center break-all cursor-pointer', // mobile
    'bg-gray-200 text-white hover:brightness-75', // mobile
    'lg:relative ', // desktop
    color.bg),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hidden w-full h-full relative lg:block",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: item.image.url,
        alt: item.image.alt,
        layout: "fill",
        objectFit: "cover"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()('text-base flex items-center justify-center h-32 p-2', // mobile,
      'lg:block lg:h-auto lg:absolute lg:bottom-0 lg:w-full lg:p-5 lg:text-left', // desktop
      color.bg),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "font-medium lg:font-medium lg:text-lg dark:text-athensGray break-normal ",
        children: item.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: classnames_default()('hidden', 'lg:block mt-1 text-sm font-normal dark:text-white-2'),
        children: item.linkLabel
      })]
    })]
  });
};

var getBoxesModel = function getBoxesModel(size) {
  var model = {};

  for (var index = 1, i = 1; index <= size; index += 1, i += 1) {
    if (!boxesGridTemplateModel[i]) i = 3;
    model[index] = boxesGridTemplateModel[i];
  }

  return model[size] || {};
};

var mustBeRowSpan = function mustBeRowSpan(i, boxesModel) {
  var _boxesModel$rowSpan;

  return (_boxesModel$rowSpan = boxesModel.rowSpan) === null || _boxesModel$rowSpan === void 0 ? void 0 : _boxesModel$rowSpan.includes(i);
};

var Boxes = function Boxes(_ref2) {
  var _slice$items$length, _slice$items, _slice$primary, _slice$primary2, _slice$items2, _slice$primary3, _slice$primary4, _slice$primary5;

  var slice = _ref2.slice;
  var boxesSize = (_slice$items$length = (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.length) !== null && _slice$items$length !== void 0 ? _slice$items$length : 0;
  var boxesModel = getBoxesModel(boxesSize);
  return boxesSize ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-gray-100 dark:bg-gray-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content space-y-10 text-center",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "max-w-3xl mx-auto text-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "dh-title",
          children: slice.primary.title
        }), ((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "dh-description",
          children: slice.primary.description
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()('mt-6 max-w-2xl mx-auto lg:max-w-7xl grid grid-cols-2 gap-5', boxesModel.colClass),
        children: slice === null || slice === void 0 ? void 0 : (_slice$items2 = slice.items) === null || _slice$items2 === void 0 ? void 0 : _slice$items2.map(function (item, i) {
          var _getVerticalByLink = (0,common/* getVerticalByLink */.SP)(item === null || item === void 0 ? void 0 : item.link, slice._verticals, slice._clusters),
              verticalColor = _getVerticalByLink.color,
              uid = _getVerticalByLink.uid;

          var color = (0,colors/* getColor */.Lq)(verticalColor);

          var itemWithVerticalId = boxesSquare_objectSpread(boxesSquare_objectSpread({}, item), {}, {
            verticalId: uid
          });

          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classnames_default()('w-full rounded-lg', // mobile
            'lg:w-auto lg:h-auto lg:m-0 lg:aspect-w-3 lg:aspect-h-4 lg:rounded-lg', // desktop
            'lg:overflow-hidden lg:block', // desktop
            {
              'lg:h-56': !mustBeRowSpan(i, boxesModel),
              'lg:row-span-2 lg:h-117': mustBeRowSpan(i, boxesModel)
            }),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Item, {
              item: itemWithVerticalId,
              color: color
            })
          }, (0,index_browser/* nanoid */.x0)());
        })
      }), ((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.buttonLink) && ((_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.buttonLabel) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mt-8 flex justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "inline-flex rounded-md shadow",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(boxesSquare_LinkWithQuery, {
            href: prismic_reactjs.Link.url(slice.primary.buttonLink, common/* prismicLinkResolver */.LT),
            className: classnames_default()('dh-button-sm bg-black hover:bg-black border border-white'),
            children: (_slice$primary5 = slice.primary) === null || _slice$primary5 === void 0 ? void 0 : _slice$primary5.buttonLabel
          })
        })
      })]
    })
  }) : null;
};

/* harmony default export */ var boxesSquare = (Boxes);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(7812);
;// CONCATENATED MODULE: ./slices/Boxes/Boxes.types.ts
var BoxesVariations;

(function (BoxesVariations) {
  BoxesVariations["square"] = "boxesSquare";
  BoxesVariations["rectangle"] = "boxesRectangle";
  BoxesVariations["rectangleClusters"] = "boxesRectangleClusters";
  BoxesVariations["colorCards"] = "boxesColorCards";
  BoxesVariations["kpi"] = "boxesKpi";
})(BoxesVariations || (BoxesVariations = {}));
;// CONCATENATED MODULE: ./slices/Boxes/variants/boxesRectangle.tsx













var boxesRectangle_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var BusinessUnits;

(function (BusinessUnits) {
  BusinessUnits["course"] = "course";
  BusinessUnits["career"] = "career";
  BusinessUnits["other"] = "other";
})(BusinessUnits || (BusinessUnits = {}));

var getBusinessUnitLabel = function getBusinessUnitLabel(businessUnit, data) {
  switch (businessUnit) {
    case BusinessUnits.course:
      return data.businessUnitCoursesLabel;

    case BusinessUnits.career:
      return data.businessUnitCareerLabel;

    case BusinessUnits.other:
    default:
      return data.businessUnitOtherLabel;
  }
};

var groupBy = function groupBy(data, key) {
  return data.reduce(function (value, x) {
    var rv = value;
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

var sort = function sort(data) {
  var dataByBU = groupBy(data, 'businessUnit');
  return [].concat((0,toConsumableArray/* default */.Z)(dataByBU[BusinessUnits.course] || []), (0,toConsumableArray/* default */.Z)(dataByBU[BusinessUnits.career] || []), (0,toConsumableArray/* default */.Z)(dataByBU[BusinessUnits.other] || []));
};

var getColorByVertical = function getColorByVertical(verticalColor, color) {
  return (0,colors/* getColor */.Lq)(verticalColor || color);
};

var BoxesRectangle = function BoxesRectangle(_ref) {
  var _slice$_verticals, _slice$_clusters, _slice$items;

  var slice = _ref.slice;

  var _useState = (0,react.useState)(),
      otherExpanded = _useState[0],
      setOtherExpanded = _useState[1];

  var hasOthers = slice.items.some(function (item) {
    return item.businessUnit === BusinessUnits.other;
  });
  var verticals = (_slice$_verticals = slice === null || slice === void 0 ? void 0 : slice._verticals) !== null && _slice$_verticals !== void 0 ? _slice$_verticals : [slice === null || slice === void 0 ? void 0 : slice._vertical];
  var clusters = (_slice$_clusters = slice === null || slice === void 0 ? void 0 : slice._clusters) !== null && _slice$_clusters !== void 0 ? _slice$_clusters : [slice === null || slice === void 0 ? void 0 : slice._cluster];

  var showOthers = function showOthers() {
    setOtherExpanded(true);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-white dark:bg-gray-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "dh-content relative space-y-10",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-center grid grid-cols-2 gap-5 lg:gap-y-4 lg:gap-x-4 lg:grid-cols-2",
        children: !!(slice !== null && slice !== void 0 && (_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [sort(slice.items).map(function (item, i) {
            var key = "".concat(BoxesVariations.rectangle, "-item-").concat(i);

            var _getVerticalByLink = (0,common/* getVerticalByLink */.SP)(item.link, verticals, clusters),
                verticalColor = _getVerticalByLink.color;

            var itemColor = getColorByVertical(verticalColor, item.color);
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: classnames_default()('w-full rounded-lg', // mobile
              'lg:w-auto lg:h-auto lg:m-0 lg:overflow-hidden lg:block', // desktop
              {
                'hidden lg:hidden': item.businessUnit === BusinessUnits.other && !otherExpanded
              }),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(boxesRectangle_LinkWithQuery, {
                href: prismic_reactjs.Link.url(item.link, function (doc) {
                  return (0,common/* prismicLinkResolver */.LT)(doc, item);
                }),
                className: classnames_default()('block h-full w-full rounded-lg overflow-hidden text-center break-all cursor-pointer', 'lg:flex lg:w-full lg:justify-center lg:items-center lg:font-light lg:p-7 lg:text-xl', 'lg:py-4', itemColor.bg, itemColor.bgHover, itemColor.textContrast),
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: classnames_default()('text-base flex items-center justify-center h-32 p-2', 'lg:grow lg:block lg:w-auto lg:h-auto lg:text-left'),
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "text-center break-normal lg:text-left font-medium",
                    children: item.title
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "hidden text-sm font-normal text-left lg:inline",
                    children: item.description
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* ArrowNarrowRightIcon */.BZ6, {
                  className: "hidden w-6 flex-none lg:inline"
                })]
              })
            }, key);
          }), hasOthers && !otherExpanded && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: classnames_default()(!otherExpanded ? 'block mt-9 col-span-2 lg:text-white' : 'hidden'),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              type: "button",
              className: classnames_default()('dh-button-sm inline-flex bg-black border border-white mt-0' // mobile
              ),
              onClick: !otherExpanded ? showOthers : undefined,
              children: getBusinessUnitLabel(BusinessUnits.other, slice.primary)
            })
          })]
        })
      })
    })
  });
};

/* harmony default export */ var boxesRectangle = (BoxesRectangle);
// EXTERNAL MODULE: ./node_modules/lodash.sortby/index.js
var lodash_sortby = __webpack_require__(8254);
var lodash_sortby_default = /*#__PURE__*/__webpack_require__.n(lodash_sortby);
;// CONCATENATED MODULE: ./slices/Boxes/variants/boxesRectangleClusters.tsx












var boxesRectangleClusters_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});

var boxesRectangleClusters_sort = function sort(data) {
  return lodash_sortby_default()(data, function (item) {
    var _item$data;

    return (_item$data = item.data) === null || _item$data === void 0 ? void 0 : _item$data.priority;
  });
};

var getClusterLink = function getClusterLink(cluster) {
  var _cluster$data, _cluster$data$vertica;

  return {
    uid: cluster.uid,
    link_type: 'Document',
    type: cluster.type,
    lang: cluster.lang,
    verticalId: cluster === null || cluster === void 0 ? void 0 : (_cluster$data = cluster.data) === null || _cluster$data === void 0 ? void 0 : (_cluster$data$vertica = _cluster$data.verticalPage) === null || _cluster$data$vertica === void 0 ? void 0 : _cluster$data$vertica.uid,
    data: {
      verticalId: cluster.data.verticalPage.uid
    }
  };
};

var findVertical = function findVertical(verticalId, verticals) {
  return verticals === null || verticals === void 0 ? void 0 : verticals.find(function (vertical) {
    return vertical.uid === verticalId;
  });
};

var BoxesRectangleClusters = function BoxesRectangleClusters(_ref) {
  var slice = _ref.slice;
  var clusters = slice._clusters,
      verticals = slice._verticals,
      vertical = slice._vertical;
  var filteredClusters = vertical ? clusters.filter(function (item) {
    var _item$data2, _item$data2$verticalP;

    return ((_item$data2 = item.data) === null || _item$data2 === void 0 ? void 0 : (_item$data2$verticalP = _item$data2.verticalPage) === null || _item$data2$verticalP === void 0 ? void 0 : _item$data2$verticalP.uid) === vertical.uid;
  }) : clusters;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-white dark:bg-gray-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "dh-content relative space-y-10",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-center grid grid-cols-2 gap-5 lg:gap-y-4 lg:gap-x-4 lg:grid-cols-2",
        "data-testid": "cluster-box",
        children: !!(filteredClusters !== null && filteredClusters !== void 0 && filteredClusters.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: boxesRectangleClusters_sort(filteredClusters).map(function (cluster, i) {
            var _cluster$data2, _cluster$data2$vertic, _itemVerical$data, _cluster$data3, _cluster$data4;

            var key = "".concat(BoxesVariations.rectangleClusters, "-item-").concat(i);
            var itemVerical = vertical || findVertical(cluster === null || cluster === void 0 ? void 0 : (_cluster$data2 = cluster.data) === null || _cluster$data2 === void 0 ? void 0 : (_cluster$data2$vertic = _cluster$data2.verticalPage) === null || _cluster$data2$vertic === void 0 ? void 0 : _cluster$data2$vertic.uid, verticals);
            var itemColor = (0,colors/* getColor */.Lq)(itemVerical === null || itemVerical === void 0 ? void 0 : (_itemVerical$data = itemVerical.data) === null || _itemVerical$data === void 0 ? void 0 : _itemVerical$data.color);
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: classnames_default()('w-full rounded-lg', // mobile
              'lg:w-auto lg:h-auto lg:m-0 lg:overflow-hidden lg:block' // desktop
              ),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(boxesRectangleClusters_LinkWithQuery, {
                href: prismic_reactjs.Link.url(getClusterLink(cluster), common/* prismicLinkResolver */.LT),
                className: classnames_default()('block h-full w-full rounded-lg overflow-hidden text-center break-all cursor-pointer', 'lg:flex lg:w-full lg:justify-center lg:items-center lg:font-light lg:p-7 lg:text-xl', 'lg:py-4', itemColor.bg, itemColor.bgHover, itemColor.textContrast),
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: classnames_default()('text-base flex items-center justify-center h-32 p-2', 'lg:grow lg:block lg:w-auto lg:h-auto lg:text-left'),
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "text-center break-normal lg:text-left font-medium",
                    children: cluster === null || cluster === void 0 ? void 0 : (_cluster$data3 = cluster.data) === null || _cluster$data3 === void 0 ? void 0 : _cluster$data3.name
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "hidden text-sm font-normal text-left lg:inline",
                    children: cluster === null || cluster === void 0 ? void 0 : (_cluster$data4 = cluster.data) === null || _cluster$data4 === void 0 ? void 0 : _cluster$data4.description
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* ArrowNarrowRightIcon */.BZ6, {
                  className: "hidden w-6 flex-none lg:inline"
                })]
              })
            }, key);
          })
        })
      })
    })
  });
};

/* harmony default export */ var boxesRectangleClusters = (BoxesRectangleClusters);
;// CONCATENATED MODULE: ./slices/Boxes/components/BoxesCardsPics.tsx




var PicDiamonds = function PicDiamonds(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "58",
    height: "162",
    viewBox: "0 0 58 162",
    className: classnames_default()('right-11 bottom-6 lg:right-16 w-11 h-32 2xl:w-14 2xl:h-40', className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      opacity: "0.2",
      clipPath: "url(#clip0_39_3784)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M46.112 0C46.112 0 45.8078 19.04 34.3214 19.04C45.8078 19.04 46.112 38.08 46.112 38.08C46.112 38.08 46.4162 19.04 57.9027 19.04C46.4162 19.04 46.112 0 46.112 0Z",
        fill: "currentColor"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M28.3685 72.99C28.3685 72.99 27.6613 117.25 0.955566 117.25C27.6613 117.25 28.3685 161.51 28.3685 161.51C28.3685 161.51 29.0756 117.25 55.7813 117.25C29.0756 117.25 28.3685 72.99 28.3685 72.99Z",
        fill: "currentColor"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_39_3784",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "56.9553",
          height: "161.51",
          fill: "white",
          transform: "translate(0.955566)"
        })
      })
    })]
  });
};
var PicCircleRectangleOutline = function PicCircleRectangleOutline(_ref2) {
  var className = _ref2.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "274",
    height: "182",
    viewBox: "0 0 274 182",
    xmlns: "http://www.w3.org/2000/svg",
    className: classnames_default()('right-0 bottom-0 h-36 w-52 2xl:w-64 2xl:h-44', className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      opacity: "0.2",
      d: "M229 66C247.225 66 262 51.2254 262 33C262 14.7746 247.225 0 229 0C210.775 0 196 14.7746 196 33C196 51.2254 210.775 66 229 66Z",
      fill: "currentColor"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      opacity: "0.2",
      clipPath: "url(#clip0_1_2)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M332.79 119.162V207.838H21.7464C11.8033 207.838 3.7214 199.212 3.7214 188.618V138.382C3.7214 127.78 11.8108 119.162 21.7464 119.162H332.79ZM335.756 116H21.7464C10.1499 116 0.755554 126.025 0.755554 138.382V188.618C0.755554 200.983 10.1573 211 21.7464 211H335.756V116Z",
        fill: "currentColor"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_1_2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "272.978",
          height: "66",
          fill: "white",
          transform: "translate(0.755554 116)"
        })
      })
    })]
  });
};
var PicDiamondRectangle = function PicDiamondRectangle(_ref3) {
  var className = _ref3.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "259",
    height: "180",
    viewBox: "0 0 259 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: classnames_default()('right-8 bottom-0 lg:right-12 w-52 h-36 2xl:w-64 2xl:h-44', className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      opacity: "0.2",
      d: "M206.4 147H0.844482V180H206.4V147Z",
      fill: "currentColor"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      opacity: "0.2",
      d: "M239.462 0C239.462 0 238.968 30.82 220.378 30.82C238.968 30.82 239.462 61.64 239.462 61.64C239.462 61.64 239.955 30.82 258.545 30.82C239.955 30.82 239.462 0 239.462 0Z",
      fill: "currentColor"
    })]
  });
};
var PicDiamondCircle = function PicDiamondCircle(_ref4) {
  var className = _ref4.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "120",
    height: "137",
    viewBox: "0 0 120 137",
    className: classnames_default()('right-8 bottom-8 w-24 h-24 2xl:w-28 2xl:h-32', className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      opacity: "0.2",
      d: "M33 137C51.2254 137 66 122.225 66 104C66 85.7746 51.2254 71 33 71C14.7746 71 0 85.7746 0 104C0 122.225 14.7746 137 33 137Z",
      fill: "currentColor"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      opacity: "0.2",
      d: "M107.302 0C107.302 0 106.998 19.04 95.5111 19.04C106.998 19.04 107.302 38.08 107.302 38.08C107.302 38.08 107.606 19.04 119.092 19.04C107.606 19.04 107.302 0 107.302 0Z",
      fill: "currentColor"
    })]
  });
};
var PicDiamondRectangleOutline = function PicDiamondRectangleOutline(_ref5) {
  var className = _ref5.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "274",
    height: "182",
    viewBox: "0 0 274 182",
    className: classnames_default()('right-0 bottom-0 w-52 h-36 2xl:w-72 2xl:h-44', className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      opacity: "0.2",
      clipPath: "url(#clip0_1_2)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M332.745 119.162V207.838H21.7019C11.7589 207.838 3.67697 199.212 3.67697 188.618V138.382C3.67697 127.78 11.7663 119.162 21.7019 119.162H332.745ZM335.711 116H21.7019C10.1054 116 0.711121 126.025 0.711121 138.382V188.618C0.711121 200.983 10.1129 211 21.7019 211H335.711V116Z",
        fill: "currentColor"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      opacity: "0.2",
      d: "M209.728 0C209.728 0 209.235 30.82 190.644 30.82C209.235 30.82 209.728 61.64 209.728 61.64C209.728 61.64 210.222 30.82 228.812 30.82C210.222 30.82 209.728 0 209.728 0Z",
      fill: "currentColor"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_1_2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "272.978",
          height: "66",
          fill: "white",
          transform: "translate(0.711121 116)"
        })
      })
    })]
  });
};
;// CONCATENATED MODULE: ./slices/Boxes/variants/BoxesColorCards.tsx









var ReactCarousel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(957), __webpack_require__.e(892)]).then(__webpack_require__.bind(__webpack_require__, 1892));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1892)];
    }
  }
});
var colorPic = {
  violet: PicDiamonds,
  orange: PicCircleRectangleOutline,
  green: PicDiamondRectangle,
  yellow: PicDiamondCircle,
  blue: PicDiamondRectangleOutline,
  coral: PicCircleRectangleOutline,
  lime: PicDiamondRectangle,
  emerald: PicDiamondRectangle,
  purple: PicDiamonds,
  pink: PicDiamondCircle
};
var carouselOptions = {
  isRTL: false,
  pagination: true,
  itemPadding: [0, 0, 0, 0],
  itemsToShow: 1,
  showArrows: false,
  breakPoints: []
};
var boxesWidthCards = {
  2: 'w-6/12',
  4: 'w-6/12'
};

var BoxesColorCards = function BoxesColorCards(_ref) {
  var _slice$items;

  var slice = _ref.slice;
  var size = (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.length;
  if (!size) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "dh-content-full",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "lg:hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ReactCarousel, {
        options: carouselOptions,
        children: slice.items.map(function (item) {
          var itemColor200 = (0,colors/* getColor */.Lq)(item.color, 200);
          var itemColor400 = (0,colors/* getColor */.Lq)(item.color, 400);
          var Pic = colorPic[item.color] || colorPic[0];
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()('flex w-full h-full relative text-2xl leading-10 pt-9 pl-6 pr-11 pb-28', 'bg-opacity-40 overflow-hidden rounded', itemColor200.bg),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
              render: item.text
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Pic, {
              className: classnames_default()('absolute', itemColor400.text)
            })]
          }, (0,index_browser/* nanoid */.x0)());
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hidden lg:flex flex-wrap justify-center",
      children: slice.items.map(function (item) {
        var _boxesWidthCards$size;

        var itemColor200 = (0,colors/* getColor */.Lq)(item.color, 200);
        var itemColor400 = (0,colors/* getColor */.Lq)(item.color, 400);
        var Pic = colorPic[item.color] || colorPic[0];
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()('p-1', (_boxesWidthCards$size = boxesWidthCards[size]) !== null && _boxesWidthCards$size !== void 0 ? _boxesWidthCards$size : 'w-4/12'),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()('flex h-full relative text-3.5xl leading-10 pt-9 pl-7 pr-15 pb-24 ', '2xl:text-4.5xl 2xl:leading-15 2xl:pt-12 2xl:pl-10 2xl:pr-20 2xl:pb-32', 'bg-opacity-40 overflow-hidden rounded', itemColor200.bg),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
              render: item.text
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Pic, {
              className: classnames_default()('absolute', itemColor400.text)
            })]
          })
        }, (0,index_browser/* nanoid */.x0)());
      })
    })]
  });
};

/* harmony default export */ var variants_BoxesColorCards = (BoxesColorCards);
;// CONCATENATED MODULE: ./slices/Boxes/variants/BoxesKPI.tsx









var BoxesKPI = function BoxesKPI(_ref) {
  var _slice$items;

  var slice = _ref.slice;
  if (!((_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length)) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "dh-content-full bg-gray-2 py-20 lg:py-24 2xl:py-40 3xl:py-52",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "lg:w-10/12 flex flex-col mx-auto 2xl:w-full 2xl:flex-row 2xl:gap-[8.33%]",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
        className: "2xl:w-3/12 text-white-1 flex flex-col justify-center mb-6 lg:mb-14",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "text-2xl leading-7 lg:text-4.5xl lg:leading-10 lg:mb-2 2xl:mb-4",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: slice.primary.title
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-sm lg:text-xl lg:leading-8",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: slice.primary.description
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "grid gap-3 lg:grid-cols-2 lg:gap-4 2xl:w-8/12 3xl:grid-cols-4",
        children: slice.items.map(function (item) {
          var color = (0,colors/* getColor */.Lq)(item.color, 400);
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()('border flex flex-row overflow-hidden p-8 3xl:flex-col gap-4 rounded', color.border),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "w-6/12 lg:w-4/12 flex items-center justify-center 3xl:w-full",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "w-32 lg:w-36 opacity-80",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: item.image.url,
                  alt: item.image.alt,
                  width: item.image.dimensions.width,
                  height: item.image.dimensions.height,
                  layout: "responsive",
                  objectFit: "cover"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "grow items-center justify-center flex flex-col",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "font-bold text-3.5xl text-center text-white-1 lg:mb-2 lg:text-7xl",
                children: item.value
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "text-sm lg:text-lg text-center text-white-4",
                children: item.label
              })]
            })]
          }, (0,index_browser/* nanoid */.x0)());
        })
      })]
    })
  });
};

/* harmony default export */ var variants_BoxesKPI = (BoxesKPI);
;// CONCATENATED MODULE: ./slices/Boxes/index.tsx









var Boxes_Boxes = function Boxes(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case BoxesVariations.rectangle:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(boxesRectangle, {
        slice: slice
      });

    case BoxesVariations.rectangleClusters:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(boxesRectangleClusters, {
        slice: slice
      });

    case BoxesVariations.square:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(boxesSquare, {
        slice: slice
      });

    case BoxesVariations.colorCards:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variants_BoxesColorCards, {
        slice: slice
      });

    case BoxesVariations.kpi:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variants_BoxesKPI, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var slices_Boxes = (Boxes_Boxes);
;// CONCATENATED MODULE: ./slices/Button/Button.types.ts
var ButtonVariations;

(function (ButtonVariations) {
  ButtonVariations["whatsapp"] = "buttonWhatsapp";
  ButtonVariations["whatsappProduct"] = "buttonWhatsappProduct";
  ButtonVariations["download"] = "buttonDownload";
  ButtonVariations["generic"] = "buttonGeneric";
})(ButtonVariations || (ButtonVariations = {}));
// EXTERNAL MODULE: ./node_modules/file-saver/dist/FileSaver.min.js
var FileSaver_min = __webpack_require__(3162);
// EXTERNAL MODULE: ./components/Modal.tsx
var Modal = __webpack_require__(7310);
;// CONCATENATED MODULE: ./slices/Button/variants/ButtonDownload.tsx


function ButtonDownload_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ButtonDownload_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ButtonDownload_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ButtonDownload_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




















var ButtonDownload_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var FormInput = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 547).then(__webpack_require__.bind(__webpack_require__, 547));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(547)];
    }
  }
});
var ButtonDownload_Modal = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7310));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(7310)];
    }
  }
});

var ButtonDownload = function ButtonDownload(_ref) {
  var _slice$_vertical, _slice$_cluster, _slice$primary, _slice$primary3, _slice$primary3$terms, _slice$primary$termsA, _slice$primary$termsA2;

  var slice = _ref.slice;

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track,
      identify = _useAnalytics.identify;

  var intl = (0,useIntl/* default */.Z)();
  var locale = (0,useLocale/* default */.Z)();

  var _useState = (0,react.useState)({}),
      formData = _useState[0],
      setFormData = _useState[1];

  var _useState2 = (0,react.useState)(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0,react.useState)(),
      isSending = _useState3[0],
      setIsSending = _useState3[1];

  var vertical = slice === null || slice === void 0 ? void 0 : (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var cluster = slice === null || slice === void 0 ? void 0 : (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : _slice$_cluster.data;
  var color = (0,colors/* getColor */.Lq)(vertical === null || vertical === void 0 ? void 0 : vertical.color);
  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({
    slice: slice,
    cluster: cluster,
    vertical: vertical
  });
  var handleDownload = (0,react.useCallback)(function (event, file) {
    event.preventDefault();
    setIsSending(true);
    var filename = (cluster === null || cluster === void 0 ? void 0 : cluster.name) || file.split('/').slice(-1).pop();
    setOpen(false);
    (0,FileSaver_min.saveAs)(file, filename);
    var fields = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.email,
      phone: "".concat(formData.ex).concat(formData.phone)
    };
    identify(fields);
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'product_name', cluster === null || cluster === void 0 ? void 0 : cluster.name);
    lodash_set_default()(payload, 'fields', fields);
    track(constants/* TrackEvents.brochureDownloaded */.Um.brochureDownloaded, payload, locale, true);
    setFormData({}); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackPayload]);
  var handleClick = (0,react.useCallback)(function (label) {
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'context.label', label);
    setOpen(true);
    track(constants/* TrackEvents.brochureDownloadedClicked */.Um.brochureDownloadedClicked, payload, locale);
  }, [trackPayload, locale, track]);

  var handleChange = function handleChange(e, key) {
    setFormData(function (prev) {
      return ButtonDownload_objectSpread(ButtonDownload_objectSpread({}, prev), {}, (0,defineProperty/* default */.Z)({}, key, e.target.value));
    });
  };

  (0,react.useEffect)(function () {
    if (open) setIsSending(false);
  }, [open]);
  return (_slice$primary = slice.primary) !== null && _slice$primary !== void 0 && _slice$primary.file ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "dark:bg-gray-1",
      id: slice.variation,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "dh-content flex justify-center pt-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "button",
          onClick: function onClick() {
            return handleClick(slice.primary.label);
          },
          className: classnames_default()('dh-button-lg m-0', color.textContrast, color.bg, color.bgHover),
          children: slice.primary.label
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonDownload_Modal, {
      state: open,
      setOpen: setOpen,
      size: Modal.ModalSize.sm,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
        onSubmit: function onSubmit(e) {
          var _slice$primary2;

          return handleDownload(e, prismic_reactjs.Link.url((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.file));
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "overflow-hidden sm:rounded-md text-gray-800 dark:text-gray-300",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-6 gap-4",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "col-span-6 sm:col-span-3",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput, {
                    label: intl.formatMessage({
                      id: "hCOqfl",
                      defaultMessage: [{
                        "type": 0,
                        "value": "Nombre"
                      }]
                    }),
                    name: "name",
                    id: "name",
                    required: true,
                    onChange: function onChange(e) {
                      return handleChange(e, 'firstName');
                    },
                    darkSupport: false
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "col-span-6 sm:col-span-3",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput, {
                    label: intl.formatMessage({
                      id: "cEArc/",
                      defaultMessage: [{
                        "type": 0,
                        "value": "Apellido"
                      }]
                    }),
                    name: "lastname",
                    id: "lastname",
                    required: true,
                    onChange: function onChange(e) {
                      return handleChange(e, 'lastName');
                    },
                    darkSupport: false
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "col-span-6",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput, {
                    label: intl.formatMessage({
                      id: "tkwCac",
                      defaultMessage: [{
                        "type": 0,
                        "value": "E-mail"
                      }]
                    }),
                    name: "email",
                    id: "email",
                    type: "email",
                    onChange: function onChange(e) {
                      return handleChange(e, 'email');
                    },
                    required: true,
                    darkSupport: false
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "col-span-2 self-end",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput, {
                    label: intl.formatMessage({
                      id: "/0jxhp",
                      defaultMessage: [{
                        "type": 0,
                        "value": "Código de Área"
                      }]
                    }),
                    name: "ex",
                    id: "ex",
                    className: "w-24",
                    onChange: function onChange(e) {
                      return handleChange(e, 'ex');
                    },
                    required: true,
                    darkSupport: false
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "col-span-4 self-end",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormInput, {
                    label: intl.formatMessage({
                      id: "S6W4PT",
                      defaultMessage: [{
                        "type": 0,
                        "value": "Teléfono"
                      }]
                    }),
                    name: "phone",
                    id: "phone",
                    placeholder: intl.formatMessage({
                      id: "YTgK22",
                      defaultMessage: [{
                        "type": 0,
                        "value": "11 0000 0000"
                      }]
                    }),
                    onChange: function onChange(e) {
                      return handleChange(e, 'phone');
                    },
                    required: true,
                    darkSupport: false
                  })
                })]
              })
            })
          })
        }), ((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : (_slice$primary3$terms = _slice$primary3.termsAndConditionsLink) === null || _slice$primary3$terms === void 0 ? void 0 : _slice$primary3$terms.type) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative flex items-center pt-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex items-center h-5",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              id: "tyc",
              "aria-describedby": "agree-terms-and-conditions",
              name: "tyc",
              type: "checkbox",
              className: "focus:ring-grey-500 h-4 w-4 text-gey-600 border-gray-300 rounded",
              required: true
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "ml-3 text-sm font-normal font-archivo text-left",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
              htmlFor: "tyc",
              className: "mr-2 text-black",
              children: intl.formatMessage({
                id: "1I7zTd",
                defaultMessage: [{
                  "type": 0,
                  "value": "Aceptar"
                }]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ButtonDownload_LinkWithQuery, {
              href: prismic_reactjs.Link.url(slice.primary.termsAndConditionsLink, common/* prismicLinkResolver */.LT),
              target: (_slice$primary$termsA = (_slice$primary$termsA2 = slice.primary.termsAndConditionsLink) === null || _slice$primary$termsA2 === void 0 ? void 0 : _slice$primary$termsA2.target) !== null && _slice$primary$termsA !== void 0 ? _slice$primary$termsA : '_blank',
              className: classnames_default()('underline', color.text),
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: "sr-only",
                children: [intl.formatMessage({
                  id: "1I7zTd",
                  defaultMessage: [{
                    "type": 0,
                    "value": "Aceptar"
                  }]
                }), ' ']
              }), intl.formatMessage({
                id: "o24Y39",
                defaultMessage: [{
                  "type": 0,
                  "value": "Términos y condiciones"
                }]
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-5 sm:mt-6",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            disabled: isSending,
            type: "submit",
            className: classnames_default()('dh-button-sm w-full', // mobile
            color.textContrast, color.bg, color.bgHover),
            children: slice.primary.label
          })
        })]
      })
    })]
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "hidden"
  });
};

/* harmony default export */ var variants_ButtonDownload = (ButtonDownload);
;// CONCATENATED MODULE: ./slices/Button/variants/ButtonGeneric.tsx















var ButtonGeneric = function ButtonGeneric(_ref) {
  var _slice$_vertical, _slice$_cluster, _slice$_product, _slice$primary2;

  var slice = _ref.slice;
  var color = (0,colors/* getColor */.Lq)(slice.primary.color);

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track;

  var locale = (0,useLocale/* default */.Z)();
  var vertical = slice === null || slice === void 0 ? void 0 : (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var cluster = slice === null || slice === void 0 ? void 0 : (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : _slice$_cluster.data;
  var product = slice === null || slice === void 0 ? void 0 : (_slice$_product = slice._product) === null || _slice$_product === void 0 ? void 0 : _slice$_product.data;
  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({
    slice: slice,
    cluster: cluster,
    vertical: vertical,
    product: product
  });
  var handleClick = (0,react.useCallback)(function (url, label) {
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'context.label', label);
    lodash_set_default()(payload, 'context.destination_url', url);
    track(constants/* TrackEvents.buttonClicked */.Um.buttonClicked, payload, locale);
  }, [trackPayload, locale, track]);
  if (!slice.primary.label) return null;

  if ((0,prismic/* hasLink */.A)(slice.primary.link)) {
    var _slice$primary$link$t, _slice$primary;

    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex justify-center w-full lg:py-16",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        onClick: function onClick() {
          return handleClick(slice.primary.link, slice.primary.label);
        },
        href: prismic_reactjs.Link.url(slice.primary.link, common/* prismicLinkResolver */.LT),
        target: (_slice$primary$link$t = slice.primary.link.target) !== null && _slice$primary$link$t !== void 0 ? _slice$primary$link$t : '_blank',
        className: classnames_default()('dh-button-full', color.bg, color.bgHover, color.textContrast),
        rel: "noreferrer",
        children: (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.label
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "flex justify-center w-full lg:py-16",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      type: "button",
      className: classnames_default()('dh-button-full', color.bg, color.bgHover, color.textContrast),
      children: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.label
    })
  });
};

/* harmony default export */ var variants_ButtonGeneric = (ButtonGeneric);
;// CONCATENATED MODULE: ./slices/Button/variants/ButtonWhatsapp.tsx










 // TODO: replace svg with Icon component





var ButtonWhatsapp_WhatsappIcon = function WhatsappIcon(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
    })
  });
};

var ButtonWhatsapp = function ButtonWhatsapp(_ref2) {
  var _slice$_vertical, _slice$_cluster, _slice$_product, _slice$primary, _slice$primary2, _slice$primary3, _slice$primary4, _slice$primary6, _slice$primary7;

  var slice = _ref2.slice;

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track;

  var locale = (0,useLocale/* default */.Z)();
  var vertical = slice === null || slice === void 0 ? void 0 : (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var cluster = slice === null || slice === void 0 ? void 0 : (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : _slice$_cluster.data;
  var product = slice === null || slice === void 0 ? void 0 : (_slice$_product = slice._product) === null || _slice$_product === void 0 ? void 0 : _slice$_product.data;
  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({
    slice: slice,
    cluster: cluster,
    vertical: vertical,
    product: product
  });
  var link = (0,common/* buildWhatsappLink */.t7)((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.phoneNumber, (_slice$primary2 = slice.primary) !== null && _slice$primary2 !== void 0 && _slice$primary2.message ? prismic_reactjs.RichText.asText((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.message) : '');
  var handleClick = (0,react.useCallback)(function (url, label) {
    var fixed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'context.label', label);
    lodash_set_default()(payload, 'context.destination_url', url);
    lodash_set_default()(payload, 'context.fixed', fixed);
    track(constants/* TrackEvents.whatsappClicked */.Um.whatsappClicked, payload, locale);
  }, [trackPayload, locale, track]);
  if (!((_slice$primary4 = slice.primary) !== null && _slice$primary4 !== void 0 && _slice$primary4.phoneNumber)) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex justify-center w-full lg:py-16",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
        onClick: function onClick() {
          var _slice$primary5;

          return handleClick(link, (_slice$primary5 = slice.primary) === null || _slice$primary5 === void 0 ? void 0 : _slice$primary5.label);
        },
        href: link,
        target: "_blank",
        className: classnames_default()('dh-button-full text-white bg-whatsapp hover:bg-whatsapp-800'),
        rel: "noreferrer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWhatsapp_WhatsappIcon, {
          className: "-ml-1 mr-3 w-7 h-7 text-white fill-current",
          "aria-hidden": "true"
        }), (_slice$primary6 = slice.primary) === null || _slice$primary6 === void 0 ? void 0 : _slice$primary6.label]
      })
    }), ((_slice$primary7 = slice.primary) === null || _slice$primary7 === void 0 ? void 0 : _slice$primary7.showFloatingButton) && /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      onClick: function onClick() {
        var _slice$primary8;

        return handleClick(link, (_slice$primary8 = slice.primary) === null || _slice$primary8 === void 0 ? void 0 : _slice$primary8.label, true);
      },
      href: link,
      target: "_blank",
      className: classnames_default()('hidden dh-button fixed z-50 right-12 bottom-12 items-center p-3 border border-transparent rounded-full', 'filter drop-shadow-md text-white bg-whatsapp hover:bg-whatsapp-800 lg:inline-flex'),
      rel: "noreferrer",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonWhatsapp_WhatsappIcon, {
        className: "w-9 h-9 text-white fill-current",
        "aria-hidden": "true"
      })
    })]
  });
};

/* harmony default export */ var variants_ButtonWhatsapp = (ButtonWhatsapp);
;// CONCATENATED MODULE: ./slices/Button/index.tsx


function Button_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Button_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Button_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Button_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var Button = function Button(_ref) {
  var _slice$_cluster, _slice$_cluster$data, _slice$_cluster$data$;

  var slice = _ref.slice;
  var clusterSlice = (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : (_slice$_cluster$data = _slice$_cluster.data) === null || _slice$_cluster$data === void 0 ? void 0 : (_slice$_cluster$data$ = _slice$_cluster$data.slices) === null || _slice$_cluster$data$ === void 0 ? void 0 : _slice$_cluster$data$.find(function (_ref2) {
    var variation = _ref2.variation;
    return variation === ButtonVariations.whatsapp;
  });

  var productSlice = Button_objectSpread(Button_objectSpread({}, slice), clusterSlice || {});

  switch (slice.variation) {
    case ButtonVariations.whatsappProduct:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variants_ButtonWhatsapp, {
        slice: productSlice || {}
      });

    case ButtonVariations.whatsapp:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variants_ButtonWhatsapp, {
        slice: slice
      });

    case ButtonVariations.download:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variants_ButtonDownload, {
        slice: slice
      });

    case ButtonVariations.generic:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variants_ButtonGeneric, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var slices_Button = (Button);
;// CONCATENATED MODULE: ./slices/CallToAction/index.tsx







var CallToAction_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});

var CallToAction = function CallToAction(_ref) {
  var slice = _ref.slice;
  var colored = slice.variation.endsWith('Color');

  switch (slice.variation) {
    case 'ctaJustified':
    case 'ctaJustifiedColor':
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(colored ? 'bg-primary-700' : 'bg-gray-50'),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "dh-content lg:flex lg:items-center lg:justify-between",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
            className: classnames_default()(colored ? 'text-white' : 'text-gray-900', 'text-3xl font-extrabold tracking-tight  sm:text-4xl'),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "block",
              children: prismic_reactjs.RichText.asText(slice.primary.titleLine1)
            }), slice.primary.titleLine2 && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: classnames_default()(colored ? '' : 'text-primary-600', 'block'),
              children: prismic_reactjs.RichText.asText(slice.primary.titleLine2)
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mt-8 flex lg:mt-0 lg:shrink-0",
            children: [slice.primary.primaryButtonLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "inline-flex rounded-md shadow",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CallToAction_LinkWithQuery, {
                href: prismic_reactjs.Link.url(slice.primary.primaryButtonLink, common/* prismicLinkResolver */.LT),
                className: classnames_default()(colored ? 'bg-white text-primary-600 hover:bg-primary-50' : 'text-white bg-primary-600 hover:bg-primary-700', 'inline-flex items-center justify-center px-5 py-3 border border-transparent', 'text-base font-medium rounded-md'),
                children: slice.primary.primaryButtonLabel
              })
            }), slice.primary.secondaryButtonLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "ml-3 inline-flex rounded-md shadow",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CallToAction_LinkWithQuery, {
                href: prismic_reactjs.Link.url(slice.primary.secondaryButtonLink, common/* prismicLinkResolver */.LT),
                className: classnames_default()(colored ? 'text-white bg-primary-800 hover:bg-primary-900' : 'text-primary-600 bg-white hover:bg-primary-50', 'inline-flex items-center justify-center px-5 py-3 border border-transparent', 'text-base font-medium rounded-md'),
                children: slice.primary.secondaryButtonLabel
              })
            })]
          })]
        })
      });

    case 'ctaCentered':
    case 'ctaCenteredColor':
    default:
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()(colored ? 'bg-primary-700' : 'bg-white'),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "dh-content text-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
            className: classnames_default()(colored ? 'text-white' : 'text-gray-900', 'text-3xl font-extrabold tracking-tight  sm:text-4xl'),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "block",
              children: prismic_reactjs.RichText.asText(slice.primary.titleLine1)
            }), slice.primary.titleLine2 && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "block",
              children: prismic_reactjs.RichText.asText(slice.primary.titleLine2)
            })]
          }), slice.primary.description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: classnames_default()(colored ? 'text-primary-200' : '', 'mt-4 text-lg leading-6'),
            children: prismic_reactjs.RichText.asText(slice.primary.description)
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mt-8 flex justify-center",
            children: [slice.primary.primaryButtonLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "inline-flex rounded-md shadow",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CallToAction_LinkWithQuery, {
                href: prismic_reactjs.Link.url(slice.primary.primaryButtonLink, common/* prismicLinkResolver */.LT),
                className: classnames_default()(colored ? 'bg-white text-primary-600 hover:bg-primary-50' : 'text-white bg-primary-600 hover:bg-primary-700', 'inline-flex items-center justify-center px-5 py-3 border', 'border-transparent text-base font-medium rounded-md'),
                children: slice.primary.primaryButtonLabel
              })
            }), slice.primary.secondaryButtonLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "ml-3 inline-flex",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CallToAction_LinkWithQuery, {
                href: prismic_reactjs.Link.url(slice.primary.secondaryButtonLink, common/* prismicLinkResolver */.LT),
                className: classnames_default()(colored ? 'text-white bg-primary-800 hover:bg-primary-900' : 'text-primary-600 bg-white hover:bg-primary-50', 'inline-flex items-center justify-center px-5 py-3 border', 'border-transparent text-base font-medium rounded-md'),
                children: slice.primary.secondaryButtonLabel
              })
            })]
          })]
        })
      });
  }
};

/* harmony default export */ var slices_CallToAction = (CallToAction);
;// CONCATENATED MODULE: ./slices/Cards/Cards.types.ts
var CardsVariations;

(function (CardsVariations) {
  CardsVariations["products"] = "cardsProducts";
})(CardsVariations || (CardsVariations = {}));
;// CONCATENATED MODULE: ./slices/Cards/variations/CardsProducts.tsx













var CardsProducts_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var CardsProducts_Tooltip = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 795).then(__webpack_require__.bind(__webpack_require__, 8795));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8795)];
    }
  }
});
var CardsProducts_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});
var InstallmentKeyText;

(function (InstallmentKeyText) {
  InstallmentKeyText["count"] = "[installment_count]";
})(InstallmentKeyText || (InstallmentKeyText = {}));

var installmentFormat = function installmentFormat(_ref) {
  var installmentCount = _ref.installmentCount,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text;
  return text.replace(InstallmentKeyText.count, installmentCount);
};

var formatCurrency = function formatCurrency(symbol, number, locale) {
  var numberFormatted = symbol && locale ? new Intl.NumberFormat(locale).format(number) : '';
  return " ".concat(symbol).concat(numberFormatted);
};

var getAvailableItems = function getAvailableItems(items, clusterUID) {
  var _items$filter;

  var itemsPage = items === null || items === void 0 ? void 0 : (_items$filter = items.filter(function (product) {
    var _product$data, _product$data$cluster;

    return (product === null || product === void 0 ? void 0 : (_product$data = product.data) === null || _product$data === void 0 ? void 0 : (_product$data$cluster = _product$data.clusterPage) === null || _product$data$cluster === void 0 ? void 0 : _product$data$cluster.uid) === clusterUID;
  })) === null || _items$filter === void 0 ? void 0 : _items$filter.filter(function (product) {
    var _product$data2, _product$data3;

    return !(product !== null && product !== void 0 && (_product$data2 = product.data) !== null && _product$data2 !== void 0 && _product$data2.startDate) || new Date(product === null || product === void 0 ? void 0 : (_product$data3 = product.data) === null || _product$data3 === void 0 ? void 0 : _product$data3.startDate).getTime() >= new Date().getTime();
  });
  return itemsPage;
};

var CardsProducts = function CardsProducts(_ref2) {
  var _slice$_cluster, _slice$_vertical, _slice$_cluster2, _slice$primary;

  var slice = _ref2.slice;
  var locale = (0,useLocale/* default */.Z)();
  var products = lodash_sortby_default()(getAvailableItems(slice._products, (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : _slice$_cluster.uid), function (item) {
    return item.data.startDate;
  });
  if (!(products !== null && products !== void 0 && products.length)) return null;
  var vertical = (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var cluster = (_slice$_cluster2 = slice._cluster) === null || _slice$_cluster2 === void 0 ? void 0 : _slice$_cluster2.data;
  var primaryColor = (0,colors/* getColor */.Lq)(slice.primary.primaryColor || (vertical === null || vertical === void 0 ? void 0 : vertical.color), 600);
  var secondaryColor = (0,colors/* getColor */.Lq)(slice.primary.secondaryColor || (vertical === null || vertical === void 0 ? void 0 : vertical.color), 500);
  var uniqueProductPlan = [];
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "dh-content-full px-4 py-15 lg:px-15 lg:pb-13 lg:pt-[8.75rem] 3xl:pt-40 bg-white-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "2xl:w-10/12 lg:m-auto lg:max-w-7xl 2xl:max-w-8xl 3xl:w-full",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        className: "lg:mb-6 lg:flex lg:flex-row",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "grow",
          children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "text-black-1 text-h4 font-bold lg:text-h2 3xl:text-h1",
            children: slice.primary.title
          }), (0,prismic/* hasRichText */.M)(slice.primary.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-gray-1 text-p2 mt-1.5 font-medium lg:w-9/12 lg:mt-4 2xl:w-7/10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
              render: slice.primary.description
            })
          })]
        })
      }), products === null || products === void 0 ? void 0 : products.map(function (_ref3) {
        var _item$installmentAmou, _slice$items, _slice$items2, _slice$primary2, _slice$primary2$benef, _slice$primary3;

        var item = _ref3.data;
        if (!item) return null;
        var productKey = "".concat(item.installmentAmount, "_").concat(item === null || item === void 0 ? void 0 : item.remarkedInstallmentAmount, "_").concat(item === null || item === void 0 ? void 0 : item.bookingPrice);
        if (uniqueProductPlan.includes(productKey)) return null;
        uniqueProductPlan.push(productKey);
        var installmentAmount = (_item$installmentAmou = item === null || item === void 0 ? void 0 : item.installmentAmount) !== null && _item$installmentAmou !== void 0 ? _item$installmentAmou : item === null || item === void 0 ? void 0 : item.remarkedInstallmentAmount;
        var hasPaymentTooltip = (0,prismic/* hasRichText */.M)(slice.primary.paymentMethodsTooltip) || !!((_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length);
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
          className: classnames_default()('bg-white-1 border-[0.031rem] border-white-3 shadow-md rounded flex flex-col my-4', 'lg:gap-8 lg:flex-row'),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classnames_default()('text-white-1 lg:w-9 lg:min-h-[11.25rem] text-center font-bold text-h8 overflow-hidden', 'flex-none flex justify-center items-center rounded-t lg:rounded-l lg:rounded-t-0 lg:rounded-tr-none', secondaryColor.bg, secondaryColor.textContrast),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "lg:-rotate-90 h-9 flex justify-center items-center flex-none",
              children: slice.primary.installmentTag
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: " flex flex-col items-center justify-center w-full gap-8 py-10 px-6 lg:py-15 lg:flex-row lg:px-0",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: classnames_default()('text-h4 lg:text-h3 font-bold', primaryColor.text),
                children: item.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-p2 text-gray-5 font-bold mt-0.5",
                children: item.description
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-col grow gap-8 lg:grid lg:grid-cols-3 lg:mr-14",
              children: [item.bookingPrice && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row gap-1.5",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CardsProducts_Icon, {
                  icon: "check-circle-solid",
                  className: classnames_default()('w-6 h-6 flex-none', secondaryColor.text)
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "text-gray-1",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "text-h8 font-bold block mr-1.5 pt-0.5 3xl:text-h7 3xl:inline-block",
                    children: slice.primary.bookingLabel
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "text-h8 font-bold block pt-0.5 3xl:text-h7 3xl:inline-block",
                    children: item.bookingPrice
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "text-p3 font-medium block mt-0.5 text-gray-4",
                    children: slice.primary.bookingDescription
                  }), hasPaymentTooltip && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    className: "text-gray-6 text-p4 font-medium mt-1.5 flex items-center gap-0.5",
                    children: [slice.primary.paymentMethodsLabel, /*#__PURE__*/(0,jsx_runtime.jsx)(CardsProducts_Tooltip, {
                      tip: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "text-left",
                        children: [(0,prismic/* hasRichText */.M)(slice.primary.paymentMethodsTooltip) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "text-p4 text-black",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                            render: slice.primary.paymentMethodsTooltip
                          })
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "mt-2.5",
                          children: (_slice$items2 = slice.items) === null || _slice$items2 === void 0 ? void 0 : _slice$items2.map(function (_ref4) {
                            var paymentMethodImage = _ref4.paymentMethodImage;
                            return (paymentMethodImage === null || paymentMethodImage === void 0 ? void 0 : paymentMethodImage.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                              className: "inline-block mr-2.5 my-1",
                              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                                src: paymentMethodImage.url,
                                alt: paymentMethodImage.alt,
                                width: paymentMethodImage.dimensions.width,
                                height: paymentMethodImage.dimensions.height
                              })
                            }, (0,index_browser/* nanoid */.x0)());
                          })
                        })]
                      }),
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardsProducts_Icon, {
                        icon: "exclamation-circle",
                        className: "text-gray-6 w-3 h-3 inline-block"
                      })
                    })]
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row gap-1.5",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CardsProducts_Icon, {
                  icon: "check-circle-solid",
                  className: classnames_default()('w-6 h-6 flex-none', secondaryColor.text)
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "text-gray-1",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "text-h8 font-bold block mr-1.5 pt-0.5 3xl:text-h7 3xl:inline-block",
                    children: slice.primary.installmentLabel
                  }), !!slice.primary.installmentCount && !!item.installmentCount && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "text-p3 text-gray-5 block pt-0.5",
                    children: installmentFormat({
                      installmentCount: item.installmentCount,
                      text: slice.primary.installmentCount
                    })
                  }), cluster.showBenefitsButton && ((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : (_slice$primary2$benef = _slice$primary2.benefitsLink) === null || _slice$primary2$benef === void 0 ? void 0 : _slice$primary2$benef.uid) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "text-p4 font-medium block mt-1.5 text-gray-5",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardsProducts_LinkWithQuery, {
                      href: prismic_reactjs.Link.url((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.benefitsLink, common/* prismicLinkResolver */.LT),
                      target: "_blank",
                      className: "underline",
                      children: slice.primary.benefitsLabel
                    })
                  }), !!slice.primary.totalPriceLabel && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    className: "text-gray-6 text-p4 font-medium mt-1.5 flex items-center gap-0.5",
                    children: [slice.primary.totalPriceLabel, /*#__PURE__*/(0,jsx_runtime.jsx)(CardsProducts_Tooltip, {
                      tip: item.totalPrice,
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardsProducts_Icon, {
                        icon: "exclamation-circle",
                        className: "text-gray-6 w-3 h-3 inline-block"
                      })
                    })]
                  })]
                })]
              }), installmentAmount && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "text-center lg:text-right relative",
                children: [!!(item !== null && item !== void 0 && item.discount) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: " inline-block bg-green-550 text-p3 font-bold text-white-1 rounded-full py-1.5 px-3.5 mb-1.5 lg:absolute lg:-top-9 lg:right-0 lg:mb-0 ",
                  children: [item.discount, "% Off"]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: classnames_default()('text-h4 font-bold block 3xl:text-h3', secondaryColor.text),
                  children: [formatCurrency(item.currency, installmentAmount, locale), slice.primary.installmentPriceSuffix]
                }), !!(item !== null && item !== void 0 && item.discount) && (item === null || item === void 0 ? void 0 : item.remarkedInstallmentAmount) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: "line-through text-p2 font-medium text-gray-8",
                  children: [formatCurrency(item.currency, item.remarkedInstallmentAmount, locale), slice.primary.installmentPriceSuffix]
                })]
              })]
            })]
          })]
        }, (0,index_browser/* nanoid */.x0)());
      })]
    })
  });
};

/* harmony default export */ var variations_CardsProducts = (CardsProducts);
;// CONCATENATED MODULE: ./slices/Cards/index.tsx





var GridLists = function GridLists(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case CardsVariations.products:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_CardsProducts, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var Cards = (GridLists);
;// CONCATENATED MODULE: ./slices/Carousel/variations/CarouselWithoutControls.tsx








var HighlightText = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(774), __webpack_require__.e(935), __webpack_require__.e(166)]).then(__webpack_require__.bind(__webpack_require__, 8166));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8166)];
    }
  }
});
var CarouselWithoutControls_ReactCarousel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(957), __webpack_require__.e(892)]).then(__webpack_require__.bind(__webpack_require__, 1892));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1892)];
    }
  }
});
var CarouselWithoutControls_carouselOptions = {
  isRTL: false,
  breakPoints: [{
    width: 1,
    itemsToShow: 1,
    itemPadding: [0, 19, 0, 0],
    outerSpacing: 19
  }, {
    width: 880,
    itemsToShow: 3,
    itemPadding: [0, 16, 0, 16],
    pagination: true
  }]
};

var CarouselWithoutControls = function CarouselWithoutControls(_ref) {
  var _slice$_vertical, _slice$_vertical$data, _slice$primary, _slice$primary2, _slice$primary3, _slice$_vertical2, _slice$_vertical2$dat, _slice$items;

  var slice = _ref.slice;
  var color = (0,colors/* getColor */.Lq)(slice === null || slice === void 0 ? void 0 : (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : (_slice$_vertical$data = _slice$_vertical.data) === null || _slice$_vertical$data === void 0 ? void 0 : _slice$_vertical$data.color);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "text-center dark:bg-gray-2",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "max-w-3xl mx-auto text-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "dh-title",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(HighlightText, {
            text: slice.primary.title,
            highlight: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.highlightedText,
            className: classnames_default()(color.textContrast, color.bg)
          })
        })
      }), ((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "dh-description",
        children: slice.primary.description
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "my-8",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithoutControls_ReactCarousel, {
          options: CarouselWithoutControls_carouselOptions,
          color: slice === null || slice === void 0 ? void 0 : (_slice$_vertical2 = slice._vertical) === null || _slice$_vertical2 === void 0 ? void 0 : (_slice$_vertical2$dat = _slice$_vertical2.data) === null || _slice$_vertical2$dat === void 0 ? void 0 : _slice$_vertical2$dat.color,
          children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (item, i) {
            var _slice$primary4;

            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: classnames_default()('h-full w-full py-6 px-4 text-center rounded-2xl bg-gray-100 dark:bg-gray-4 xl:py-10 xl:px-6'),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "space-y-4",
                children: [((_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.showNumbers) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: classnames_default()('text-3.5xl font-bold', color.text),
                  children: i + 1
                }), item.title && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                  className: "text-xl font-bold uppercase dark:text-athensGray",
                  children: item.title
                }), item.description && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "text-sm font-normal dark:text-white-2 font-archivo",
                  children: prismic_reactjs.RichText.render(item.description)
                })]
              })
            }, (0,index_browser/* nanoid */.x0)());
          })
        })
      })]
    })
  });
};

/* harmony default export */ var variations_CarouselWithoutControls = (CarouselWithoutControls);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./utils/dates.ts
var dates = __webpack_require__(7744);
;// CONCATENATED MODULE: ./slices/Carousel/variations/CarouselWithDate.tsx













var CarouselWithDate_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var CarouselWithDate_ReactCarousel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(957), __webpack_require__.e(892)]).then(__webpack_require__.bind(__webpack_require__, 1892));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1892)];
    }
  }
});

var dateFromat = function dateFromat(date, language) {
  var locale = (0,dates/* getCurrentDateLocale */.Et)(dates/* DATE_LOCALES */.DJ, language);
  return (0,dates/* parseDate */.sG)(date, locale, 'd MMM');
};

var CarouselWithDate_getAvailableItems = function getAvailableItems(items) {
  return items === null || items === void 0 ? void 0 : items.filter(function (_ref) {
    var dateStart = _ref.dateStart;
    var date = new Date(dateStart).getTime();
    var now = new Date().getTime();
    return now <= date;
  });
};

var CarouselWithDate_carouselOptions = {
  isRTL: false,
  pagination: true
};

var CarouselWithDate = function CarouselWithDate(_ref2) {
  var _slice$primary;

  var slice = _ref2.slice;
  var items = CarouselWithDate_getAvailableItems(slice === null || slice === void 0 ? void 0 : slice.items);

  var _useState = (0,react.useState)('es'),
      lang = _useState[0],
      setLang = _useState[1];

  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    if (router !== null && router !== void 0 && router.locale) setLang((0,common/* getRealLocale */.L6)(router.locale));
  }, [router]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "text-center bg-white dark:bg-gray-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: "dh-title",
        children: slice.primary.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "my-8",
        children: (items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithDate_ReactCarousel, {
          options: CarouselWithDate_carouselOptions,
          children: items.map(function (item) {
            var _slice$_verticals, _slice$_clusters;

            var _getVerticalByLink = (0,common/* getVerticalByLink */.SP)(item.link, (_slice$_verticals = slice._verticals) !== null && _slice$_verticals !== void 0 ? _slice$_verticals : [slice._vertical], (_slice$_clusters = slice._clusters) !== null && _slice$_clusters !== void 0 ? _slice$_clusters : [slice._cluster]),
                verticalColor = _getVerticalByLink.color;

            var color = (0,colors/* getColor */.Lq)(verticalColor);
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()('grid w-full h-full py-5 px-8 rounded-2xl border bg-gray-4 dark:bg-white', 'lg:px-6 xl:px-8 dark:border-none', color.border),
              children: [item.title && /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "uppercase tracking-widest-xl text-white text-base dark:text-black",
                children: item.title
              }), item.dateStart && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: classnames_default()('uppercase text-2xl my-4 font-bold', "".concat(color.text)),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: dateFromat(item.dateStart, lang)
                }), item.dateEnd && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: " - "
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: dateFromat(item.dateEnd, lang)
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "text-left text-base text-white dark:text-black",
                children: [item.days && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "font-semibold font-archivo",
                  children: item.days
                }), item.hours && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "mt-3",
                  children: item.hours
                })]
              }), item.link && item.linkLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithDate_LinkWithQuery, {
                href: prismic_reactjs.Link.url(item.link, common/* prismicLinkResolver */.LT),
                className: classnames_default()('dh-button', color.bg, color.bgHover),
                children: item.linkLabel
              })]
            }, (0,index_browser/* nanoid */.x0)());
          })
        })
      })]
    })
  });
};

/* harmony default export */ var variations_CarouselWithDate = (CarouselWithDate);
;// CONCATENATED MODULE: ./slices/Carousel/variations/CarouselWithImage.tsx












var CarouselWithImage_ReactCarousel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(957), __webpack_require__.e(892)]).then(__webpack_require__.bind(__webpack_require__, 1892));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1892)];
    }
  }
});
var itemsToShowSm = 1;
var itemsToShowLg = 3;
var breakPoints = [{
  width: 1,
  itemsToShow: itemsToShowSm,
  itemPadding: [0, 5, 0, 5],
  pagination: true
}, {
  width: 955,
  itemsToShow: itemsToShowLg,
  itemPadding: [0, 16, 0, 16],
  pagination: false
}];
var CarouselWithImage_carouselOptions = {
  isRTL: false,
  pagination: true,
  breakPoints: breakPoints
};

var CarouselWithImage = function CarouselWithImage(_ref) {
  var _slice$items, _slice$primary, _slice$primary2, _slice$_vertical, _slice$_vertical$data, _slice$items2;

  var slice = _ref.slice;

  var _useState = (0,react.useState)('es'),
      lang = _useState[0],
      setLang = _useState[1];

  var router = (0,next_router.useRouter)();
  var itemsLength = (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.length;
  CarouselWithImage_carouselOptions.breakPoints[0].pagination = itemsLength > itemsToShowSm;
  CarouselWithImage_carouselOptions.breakPoints[1].pagination = itemsLength > itemsToShowLg;
  (0,react.useEffect)(function () {
    if (router !== null && router !== void 0 && router.locale) setLang((0,common/* getRealLocale */.L6)(router.locale));
  }, [router]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "bg-gray-100 dark:bg-gray-2",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "max-w-3xl mx-auto text-center mb-16",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "dh-title",
          children: slice.primary.title
        }), ((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "dh-description font-archivo",
          children: slice.primary.description
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithImage_ReactCarousel, {
        options: CarouselWithImage_carouselOptions,
        color: (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : (_slice$_vertical$data = _slice$_vertical.data) === null || _slice$_vertical$data === void 0 ? void 0 : _slice$_vertical$data.color,
        children: (_slice$items2 = slice.items) === null || _slice$items2 === void 0 ? void 0 : _slice$items2.map(function (item) {
          var _item$cluster, _slice$_verticals, _slice$_clusters, _slice$_verticals2, _cluster$data2, _cluster$data3, _vertical$data, _slice$_vertical2, _slice$_vertical2$dat, _cluster$data4, _item$image;

          var isVerticalPage = ((_item$cluster = item.cluster) === null || _item$cluster === void 0 ? void 0 : _item$cluster.type) === 'verticalpage';
          var cluster = isVerticalPage ? (_slice$_verticals = slice._verticals) === null || _slice$_verticals === void 0 ? void 0 : _slice$_verticals.find(function (_ref2) {
            var _item$cluster2;

            var uid = _ref2.uid;
            return uid === ((_item$cluster2 = item.cluster) === null || _item$cluster2 === void 0 ? void 0 : _item$cluster2.uid);
          }) : (_slice$_clusters = slice._clusters) === null || _slice$_clusters === void 0 ? void 0 : _slice$_clusters.find(function (_ref3) {
            var _item$cluster3;

            var uid = _ref3.uid;
            return uid === ((_item$cluster3 = item.cluster) === null || _item$cluster3 === void 0 ? void 0 : _item$cluster3.uid);
          });
          var vertical = isVerticalPage ? cluster : (_slice$_verticals2 = slice._verticals) === null || _slice$_verticals2 === void 0 ? void 0 : _slice$_verticals2.find(function (_ref4) {
            var _cluster$data, _cluster$data$vertica;

            var uid = _ref4.uid;
            return uid === (cluster === null || cluster === void 0 ? void 0 : (_cluster$data = cluster.data) === null || _cluster$data === void 0 ? void 0 : (_cluster$data$vertica = _cluster$data.verticalPage) === null || _cluster$data$vertica === void 0 ? void 0 : _cluster$data$vertica.uid);
          });
          var itemBadgeLabel = item.badgeLabel || (isVerticalPage ? cluster === null || cluster === void 0 ? void 0 : (_cluster$data2 = cluster.data) === null || _cluster$data2 === void 0 ? void 0 : _cluster$data2.name : (0,common/* getBusinessUnitName */.gB)(cluster === null || cluster === void 0 ? void 0 : (_cluster$data3 = cluster.data) === null || _cluster$data3 === void 0 ? void 0 : _cluster$data3.businessUnit, lang));
          var itemColor = item.color || (vertical === null || vertical === void 0 ? void 0 : (_vertical$data = vertical.data) === null || _vertical$data === void 0 ? void 0 : _vertical$data.color) || ((_slice$_vertical2 = slice._vertical) === null || _slice$_vertical2 === void 0 ? void 0 : (_slice$_vertical2$dat = _slice$_vertical2.data) === null || _slice$_vertical2$dat === void 0 ? void 0 : _slice$_vertical2$dat.color);
          var itemSubtitle = item.subtitle || (cluster === null || cluster === void 0 ? void 0 : (_cluster$data4 = cluster.data) === null || _cluster$data4 === void 0 ? void 0 : _cluster$data4.name);
          var color = (0,colors/* getColor */.Lq)(itemColor);
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()('w-full py-10 px-6 relative border bg-gray-4 text-center rounded-lg', color.border),
            children: [itemBadgeLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: classnames_default()('absolute left-0 top-5 inline-flex items-center px-4 py-3 rounded-r-xl', 'text-sm font-medium text-black capitalize', color.bg),
              children: itemBadgeLabel
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "space-y-6 xl:space-y-10",
              children: [((_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mx-auto relative h-28 w-28",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  className: "rounded-full",
                  src: item.image.url,
                  alt: item.image.alt,
                  layout: "fill",
                  objectFit: "contain"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "xl:flex xl:items-center xl:justify-between",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "font-medium text-lg leading-6 space-y-1",
                  children: [item.title && /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                    className: "text-white text-xl pb-2",
                    children: item.title
                  }), itemSubtitle && /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
                    className: "text-secondary-400 pb-3",
                    children: itemSubtitle
                  }), item.description && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "text-sm pt-5 text-white font-archivo",
                    children: prismic_reactjs.RichText.render(item.description)
                  })]
                })
              })]
            })]
          }, (0,index_browser/* nanoid */.x0)());
        })
      })]
    })
  });
};

/* harmony default export */ var variations_CarouselWithImage = (CarouselWithImage);
;// CONCATENATED MODULE: ./slices/Carousel/variations/CarouselWithPrice.tsx













var CarouselWithPrice_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var CarouselWithPrice_ReactCarousel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(957), __webpack_require__.e(892)]).then(__webpack_require__.bind(__webpack_require__, 1892));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1892)];
    }
  }
});

var CarouselWithPrice_dateFromat = function dateFromat(date, language) {
  var locale = (0,dates/* getCurrentDateLocale */.Et)(dates/* DATE_LOCALES */.DJ, language);
  return (0,dates/* parseDate */.sG)(date, locale, 'd MMM');
};

var CarouselWithPrice_Item = function Item(_ref) {
  var item = _ref.item,
      lang = _ref.lang,
      className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()('grid w-full h-full py-5 px-8 rounded-2xl border bg-gray-4', 'lg:px-6 xl:px-8', color.border, className),
    children: [item.title && /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      className: "uppercase tracking-widest-xl text-white text-base",
      children: item.title
    }), item.dateStart && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()('uppercase text-2xl my-4', "".concat(color.text)),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: CarouselWithPrice_dateFromat(item.dateStart, lang)
      }), item.dateEnd && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: " - "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: CarouselWithPrice_dateFromat(item.dateEnd, lang)
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "text-left text-base text-white",
      children: [item.days && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "font-semibold",
        children: item.days
      }), item.hours && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "my-3",
        children: item.hours
      }), item.quota && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mt-3 text-xs",
        children: item.quota
      }), item.price && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-3xl",
        children: item.price
      })]
    }), item.link && item.linkLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithPrice_LinkWithQuery, {
      href: prismic_reactjs.Link.url(item.link, common/* prismicLinkResolver */.LT),
      className: classnames_default()('dh-button', color.bg, color.bgHover),
      children: item.linkLabel
    })]
  });
};

var CarouselWithPrice_getAvailableItems = function getAvailableItems(items) {
  return items === null || items === void 0 ? void 0 : items.filter(function (_ref2) {
    var dateStart = _ref2.dateStart;
    var date = new Date(dateStart).getTime();
    var now = new Date().getTime();
    return now <= date;
  });
};

var CarouselWithPrice_getColorByVertical = function getColorByVertical(link, verticals, clusters) {
  var _getVerticalByLink = (0,common/* getVerticalByLink */.SP)(link, verticals, clusters),
      verticalColor = _getVerticalByLink.color;

  return (0,colors/* getColor */.Lq)(verticalColor);
};

var CarouselWithPrice_carouselOptions = {
  isRTL: false,
  pagination: true
};

var CarouselWithPrice = function CarouselWithPrice(_ref3) {
  var _slice$_verticals, _slice$_clusters, _slice$primary, _slice$primary2;

  var slice = _ref3.slice;
  var items = CarouselWithPrice_getAvailableItems(slice === null || slice === void 0 ? void 0 : slice.items);

  var _useState = (0,react.useState)('es'),
      lang = _useState[0],
      setLang = _useState[1];

  var router = (0,next_router.useRouter)();
  var verticals = (_slice$_verticals = slice._verticals) !== null && _slice$_verticals !== void 0 ? _slice$_verticals : [slice._vertical];
  var clusters = (_slice$_clusters = slice._clusters) !== null && _slice$_clusters !== void 0 ? _slice$_clusters : [slice._cluster];
  (0,react.useEffect)(function () {
    if (router !== null && router !== void 0 && router.locale) setLang((0,common/* getRealLocale */.L6)(router.locale));
  }, [router]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title,
    className: "text-center bg-white dark:bg-blueGray-900",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: "dh-title",
        children: slice.primary.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "my-8",
        children: !!(items !== null && items !== void 0 && items.length) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "hidden lg:block",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithPrice_ReactCarousel, {
              options: CarouselWithPrice_carouselOptions,
              children: items.map(function (item) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithPrice_Item, {
                  item: item,
                  lang: lang,
                  color: CarouselWithPrice_getColorByVertical(item.link, verticals, clusters)
                }, (0,index_browser/* nanoid */.x0)());
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "lg:hidden",
            children: items.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithPrice_Item, {
                item: item,
                lang: lang,
                className: "my-4",
                color: CarouselWithPrice_getColorByVertical(item.link, verticals, clusters)
              }, (0,index_browser/* nanoid */.x0)());
            })
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var variations_CarouselWithPrice = (CarouselWithPrice);
;// CONCATENATED MODULE: ./slices/Carousel/variations/CarouselWithDateLight.tsx













var CarouselWithDateLight_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var CarouselWithDateLight_ReactCarousel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(957), __webpack_require__.e(892)]).then(__webpack_require__.bind(__webpack_require__, 1892));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1892)];
    }
  }
});

var CarouselWithDateLight_dateFromat = function dateFromat(date, language) {
  var locale = (0,dates/* getCurrentDateLocale */.Et)(dates/* DATE_LOCALES */.DJ, language);
  return (0,dates/* parseDate */.sG)(date, locale, 'd MMM');
};

var CarouselWithDateLight_getAvailableItems = function getAvailableItems(items) {
  return items === null || items === void 0 ? void 0 : items.filter(function (_ref) {
    var dateStart = _ref.dateStart;
    var date = new Date(dateStart).getTime();
    var now = new Date().getTime();
    return now <= date;
  });
};

var CarouselWithDateLight_breakPoints = [{
  width: 1,
  itemsToShow: 1,
  itemPadding: [0, 5, 0, 5]
}, {
  width: 955,
  itemsToShow: 4,
  itemPadding: [0, 16, 0, 16]
}];

var CarouselWithDateLight = function CarouselWithDateLight(_ref2) {
  var _slice$primary, _slice$primary2;

  var slice = _ref2.slice;
  var carouselOptions = {
    isRTL: false,
    pagination: true,
    breakPoints: CarouselWithDateLight_breakPoints
  };
  var items = CarouselWithDateLight_getAvailableItems(slice === null || slice === void 0 ? void 0 : slice.items);

  var _useState = (0,react.useState)('es'),
      lang = _useState[0],
      setLang = _useState[1];

  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    if (router !== null && router !== void 0 && router.locale) setLang((0,common/* getRealLocale */.L6)(router.locale));
  }, [router]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "bg-white",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content pt-5",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: "dh-title",
        children: slice.primary.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()({
          'my-8': (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title
        }),
        children: !!(items !== null && items !== void 0 && items.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithDateLight_ReactCarousel, {
          options: carouselOptions,
          children: items.map(function (item) {
            var _slice$_verticals, _slice$_clusters, _slice$_products;

            var _getVerticalByLink = (0,common/* getVerticalByLink */.SP)(item.link, (_slice$_verticals = slice._verticals) !== null && _slice$_verticals !== void 0 ? _slice$_verticals : [slice._vertical], (_slice$_clusters = slice._clusters) !== null && _slice$_clusters !== void 0 ? _slice$_clusters : [slice._cluster], (_slice$_products = slice._products) !== null && _slice$_products !== void 0 ? _slice$_products : [slice._product]),
                verticalColor = _getVerticalByLink.color,
                verticalId = _getVerticalByLink.uid,
                clusterId = _getVerticalByLink.clusterId;

            var color = (0,colors/* getColor */.Lq)(verticalColor);
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()('grid w-full h-full py-5 px-8 rounded-2xl border bg-gray-4 dark:bg-white-2', 'lg:px-6 xl:px-8 dark:border-none', color.border),
              children: [item.title && /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: classnames_default()('font-bold text-white text-lg dark:text-black-2', 'lg:min-h-[3.563rem] flex lg:items-center'),
                children: item.title
              }), item.dateStart && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "text-gray-3 text-lg my-2 font-semibold",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: CarouselWithDateLight_dateFromat(item.dateStart, lang)
                }), item.dateEnd && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: " - "
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: CarouselWithDateLight_dateFromat(item.dateEnd, lang)
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "text-gray-3 text-sm font-normal",
                children: [item.days && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  children: item.days
                }), item.hours && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "mt-1",
                  children: item.hours
                })]
              }), item.link && item.linkLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithDateLight_LinkWithQuery, {
                href: prismic_reactjs.Link.url(item.link, function (doc) {
                  return (0,common/* prismicLinkResolver */.LT)(doc, {
                    verticalId: verticalId,
                    clusterId: clusterId
                  });
                }),
                className: classnames_default()('dh-button-sm mt-4 h-9 self-end text-xs text-athensGray', color.bg, color.bgHover),
                children: item.linkLabel
              })]
            }, (0,index_browser/* nanoid */.x0)());
          })
        })
      })]
    })
  });
};

/* harmony default export */ var variations_CarouselWithDateLight = (CarouselWithDateLight);
;// CONCATENATED MODULE: ./slices/Carousel/variations/CarouselWithHeaderImage.tsx








var CarouselWithHeaderImage_ReactCarousel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(957), __webpack_require__.e(892)]).then(__webpack_require__.bind(__webpack_require__, 1892));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1892)];
    }
  }
});
var CarouselWithHeaderImage_breakPoints = [{
  width: 1,
  itemsToShow: 1,
  itemPadding: [0, 5, 0, 5],
  showArrows: false
}, {
  width: 955,
  itemsToShow: 3,
  itemPadding: [0, 32, 0, 32],
  showArrows: true
}];
var CarouselWithHeaderImage_carouselOptions = {
  isRTL: false,
  pagination: true,
  breakPoints: CarouselWithHeaderImage_breakPoints
};

var CarouselWithHeaderImage = function CarouselWithHeaderImage(_ref) {
  var _slice$items, _slice$primary;

  var slice = _ref.slice;
  var itemsLength = (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.length;
  return itemsLength ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-gray-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        className: "max-w-3xl mx-auto text-center mb-16",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "dh-title text-3.5xl text-athensGray",
          children: slice.primary.title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithHeaderImage_ReactCarousel, {
        options: CarouselWithHeaderImage_carouselOptions,
        children: slice.items.map(function (item) {
          var _item$link, _item$link2, _item$link3, _item$headerImage, _item$titleImage;

          return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: prismic_reactjs.Link.url(item.link),
            target: (_item$link = item.link) === null || _item$link === void 0 ? void 0 : _item$link.target,
            className: classnames_default()('w-full h-full relative bg-athensGray rounded-lg overflow-hidden', {
              'cursor-pointer': (_item$link2 = item.link) === null || _item$link2 === void 0 ? void 0 : _item$link2.url,
              'pointer-events-none': !((_item$link3 = item.link) !== null && _item$link3 !== void 0 && _item$link3.url)
            }),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [((_item$headerImage = item.headerImage) === null || _item$headerImage === void 0 ? void 0 : _item$headerImage.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "relative w-full h-32",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: item.headerImage.url,
                  alt: item.headerImage.alt,
                  layout: "fill",
                  objectFit: "cover"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "font-medium text-lg leading-6 space-y-5 pt-5 pb-7 px-7",
                  children: [((_item$titleImage = item.titleImage) === null || _item$titleImage === void 0 ? void 0 : _item$titleImage.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "relative w-full h-10",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: item.titleImage.url,
                      alt: item.titleImage.alt,
                      layout: "fill",
                      objectFit: "contain",
                      objectPosition: "left"
                    })
                  }), item.description && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "text-sm leading-6 text-black-2 font-archivo",
                    children: prismic_reactjs.RichText.render(item.description)
                  })]
                })
              })]
            })
          }, (0,index_browser/* nanoid */.x0)());
        })
      })]
    })
  }) : null;
};

/* harmony default export */ var variations_CarouselWithHeaderImage = (CarouselWithHeaderImage);
;// CONCATENATED MODULE: ./slices/Carousel/variations/CarouselWithFlags.tsx










var CarouselWithFlags_ReactCarousel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(957), __webpack_require__.e(892)]).then(__webpack_require__.bind(__webpack_require__, 1892));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1892)];
    }
  }
});
var CarouselWithFlags_itemsToShowSm = 1;
var CarouselWithFlags_itemsToShowLg = 4;
var CarouselWithFlags_breakPoints = [{
  width: 1,
  itemsToShow: CarouselWithFlags_itemsToShowSm,
  itemPadding: [0, 7, 0, 7]
}, {
  width: 955,
  itemsToShow: CarouselWithFlags_itemsToShowLg,
  itemPadding: [0, 7.5, 0, 7.5]
}];
var CarouselWithFlags_carouselOptions = {
  isRTL: false,
  pagination: false,
  breakPoints: CarouselWithFlags_breakPoints
};
var flagsBasePath = 'assets/flags';
var flags = {
  argentina: "".concat(flagsBasePath, "/ar.svg"),
  brasil: "".concat(flagsBasePath, "/br.svg"),
  chile: "".concat(flagsBasePath, "/cl.svg"),
  colombia: "".concat(flagsBasePath, "/co.svg"),
  mexico: "".concat(flagsBasePath, "/mx.svg"),
  peru: "".concat(flagsBasePath, "/pe.svg"),
  uruguay: "".concat(flagsBasePath, "/uy.svg")
};

var CarouselWithFlags = function CarouselWithFlags(_ref) {
  var _slice$primary, _slice$items;

  var slice = _ref.slice;
  var locale = (0,useLocale/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "dh-content-full pb-20 bg-white-1 pt-[3.75rem] lg:pb-[8.75rem]",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "lg:m-auto lg:max-w-7xl 2xl:max-w-8xl",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-3 text-left lg:mb-12 lg:text-center 3xl:mb-14",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "text-black-1 font-bold text-h4 lg:text-h2 3xl:text-h1",
          children: slice.primary.title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithFlags_ReactCarousel, {
          options: CarouselWithFlags_carouselOptions,
          children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (item) {
            var _item$image;

            var countryFlag = flags[item.flag];
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "py-3",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "filter block h-full shadow-md bg-white-1 rounded-[0.25rem] border-white-3 border-[0.031rem] w-full p-6 2xl:px-8 3xl:px-6",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex pb-4 items-center",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: " relative",
                    children: [((_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "mx-auto relative h-[4.5rem] w-[4.5rem] 3xl:w-[7.313rem] 3xl:h-[7.375rem]",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                        className: "rounded-full",
                        src: item.image.url,
                        alt: item.image.alt,
                        layout: "fill",
                        objectFit: "contain"
                      })
                    }), !!countryFlag && !!locale && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "flex-none flex items-center absolute right-0 bottom-0 w-6 h-6 3xl:w-[2.188rem] 3xl:h-[2.188rem]",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                        width: "100%",
                        height: "100%",
                        src: "".concat((0,common/* getLocale */.Kd)(locale).path).concat(countryFlag),
                        alt: item.flag,
                        layout: "intrinsic"
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "pl-4",
                    children: [item.name && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "text-p2 font-bold text-gray-1 pb-0.5 3xl:text-p1 3xl:pb-1.5",
                      children: item.name
                    }), item.position && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "text-p3 font-medium text-violet-800 3xl:text-p2",
                      children: item.position
                    })]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "text-p3 font-medium text-gray-4 3xl:text-base 3xl:font-normal",
                  children: (0,prismic/* hasRichText */.M)(item.testimony) && /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                    render: item.testimony
                  })
                })]
              })
            }, (0,index_browser/* nanoid */.x0)());
          })
        })
      })]
    })
  });
};

/* harmony default export */ var variations_CarouselWithFlags = (CarouselWithFlags);
;// CONCATENATED MODULE: ./slices/Carousel/variations/CarouselWithPills.tsx









var CarouselWithPills_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var CarouselWithPills_ReactCarousel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(957), __webpack_require__.e(892)]).then(__webpack_require__.bind(__webpack_require__, 1892));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1892)];
    }
  }
});
var CarouselWithPills_itemsToShowSm = 1;
var CarouselWithPills_itemsToShowLg = 3;
var CarouselWithPills_breakPoints = [{
  width: 1,
  itemsToShow: CarouselWithPills_itemsToShowSm,
  itemPadding: [0, 5, 0, 5],
  showArrows: false
}, {
  width: 800,
  itemsToShow: CarouselWithPills_itemsToShowLg,
  itemPadding: [0, 7.5, 0, 7.5],
  showArrows: false
}];
var CarouselWithPills_carouselOptions = {
  isRTL: false,
  pagination: false,
  showArrows: false,
  breakPoints: CarouselWithPills_breakPoints
};

var CarouselWithPills = function CarouselWithPills(_ref) {
  var _slice$primary, _slice$items;

  var slice = _ref.slice;
  var quantity = !!slice.items.length;
  CarouselWithPills_carouselOptions.breakPoints[1].showArrows = slice.items.length > CarouselWithPills_itemsToShowLg;
  return quantity ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "-mb-1 bg-black-2 py-20 px-4 lg:px-0 lg:py-8.5 2xl:py-45 3xl:py-50",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "lg:w-10/12 xl:w-9/12 lg:max-w-7xl lg:m-auto 2xl:max-w-8xl 3xl:max-w-8x5l 3xl:w-full 3xl:px-45",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: ((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "text-white-1 font-bold text-center text-h4 pb-8 lg:text-h2 lg:pb-15 3xl:text-h1",
          children: slice.primary.title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithPills_ReactCarousel, {
          options: CarouselWithPills_carouselOptions,
          children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (item) {
            var _item$backgroundImage, _item$buttonLink$targ, _item$buttonLink;

            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "rounded relative overflow-hidden py-8 px-6 h-full min-h-fit",
              children: [((_item$backgroundImage = item.backgroundImage) === null || _item$backgroundImage === void 0 ? void 0 : _item$backgroundImage.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "w-full h-full absolute left-0 top-0",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  className: "object-cover w-full h-full absolute",
                  src: item.backgroundImage.url,
                  alt: item.backgroundImage.alt,
                  layout: "fill",
                  objectFit: "cover",
                  objectPosition: "center center"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "w-full h-full absolute top-0 left-0 z-0 bg-black-1/80"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "relative flex flex-col items-start justify-between h-full gap-15",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex flex-col items-start gap-4.5 lg:gap-4",
                  children: [item.pillText && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "bg-transparent dh-pill py-1.25 px-3.5 text-p4 lg:py-[0.375rem] lg:px-4 lg:text-sm",
                    children: item.pillText
                  }), item.cardTitle && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "font-bold text-white-2 text-h7 lg:text-h4 3xl:text-h3",
                    children: item.cardTitle
                  })]
                }), (0,prismic/* hasLink */.A)(item.buttonLink) && item.buttonLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithPills_LinkWithQuery, {
                  href: prismic_reactjs.Link.url(item.buttonLink, common/* prismicLinkResolver */.LT),
                  target: (_item$buttonLink$targ = (_item$buttonLink = item.buttonLink) === null || _item$buttonLink === void 0 ? void 0 : _item$buttonLink.target) !== null && _item$buttonLink$targ !== void 0 ? _item$buttonLink$targ : '_blank',
                  className: "bg-white-1 rounded-x text-sm text-center w-full py-3 px-2 lg:text-h8 xl:text-h7",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "text-black-1 font-bold text-p3 lg:text-p2 3xl:text-h7",
                    children: item.buttonLabel
                  })
                })]
              })]
            }, (0,index_browser/* nanoid */.x0)());
          })
        })
      })]
    })
  }) : null;
};

/* harmony default export */ var variations_CarouselWithPills = (CarouselWithPills);
;// CONCATENATED MODULE: ./slices/Carousel/variations/CarouselWithClusters.tsx











var CarouselWithClusters_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var CarouselWithClusters_Tooltip = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 795).then(__webpack_require__.bind(__webpack_require__, 8795));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8795)];
    }
  }
});
var CarouselWithClusters_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});
var CarouselWithClusters_ReactCarousel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(957), __webpack_require__.e(892)]).then(__webpack_require__.bind(__webpack_require__, 1892));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1892)];
    }
  }
});
var CarouselWithClusters_itemsToShowSm = 1.1;
var itemsToShowMd = 2.5;
var CarouselWithClusters_itemsToShowLg = 3;
var CarouselWithClusters_breakPoints = [{
  width: 1,
  itemsToShow: CarouselWithClusters_itemsToShowSm,
  itemPadding: [0, 0, 0, 16],
  showArrows: false
}, {
  width: 955,
  itemsToShow: itemsToShowMd,
  itemPadding: [0, 16, 0, 16],
  showArrows: true
}, {
  width: 1149,
  itemsToShow: CarouselWithClusters_itemsToShowLg,
  itemPadding: [0, 39, 0, 39],
  showArrows: true
}, {
  width: 1484,
  itemsToShow: CarouselWithClusters_itemsToShowLg,
  itemPadding: [0, 45, 0, 45],
  showArrows: true
}];
var CarouselWithClusters_carouselOptions = {
  isRTL: false,
  pagination: false,
  breakPoints: [{
    width: 0,
    itemsToShow: 0,
    itemPadding: [0, 0, 0, 0],
    showArrows: false
  }],
  classNames: {
    arrowRight: 'lg:ml-4 2xl:ml-0'
  }
};

var CarouselWithClusters = function CarouselWithClusters(_ref) {
  var _slice$items, _slice$_vertical, _slice$_vertical$data, _slice$items2;

  var slice = _ref.slice;
  var items = (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.filter(function (item) {
    var _item$link;

    return (item === null || item === void 0 ? void 0 : (_item$link = item.link) === null || _item$link === void 0 ? void 0 : _item$link.link_type) !== 'Any';
  });
  var itemsLength = items === null || items === void 0 ? void 0 : items.length;
  var intl = (0,useIntl/* default */.Z)();
  var defaultMessages = {
    buttonLabel: intl.formatMessage({
      id: "2EXAfq",
      defaultMessage: [{
        "type": 0,
        "value": "Ver Carrera"
      }]
    })
  };

  var _useState = (0,react.useState)(false),
      hasArrows = _useState[0],
      setHasArrows = _useState[1];

  var showSlice = Boolean(slice._clusters && slice._verticals && slice.primary.title && itemsLength);

  var _useState2 = (0,react.useState)('max-w-none'),
      classNames4Container = _useState2[0],
      setClassNames4Container = _useState2[1];

  (0,react.useEffect)(function () {
    switch (itemsLength) {
      case 1:
        CarouselWithClusters_carouselOptions.breakPoints = [CarouselWithClusters_breakPoints[0], {
          width: 400,
          itemsToShow: 1,
          itemPadding: [0, 0, 0, 0],
          showArrows: false
        }];
        setClassNames4Container('justify-center max-w-[439px] m-auto');
        break;

      case 2:
        CarouselWithClusters_carouselOptions.breakPoints = [CarouselWithClusters_breakPoints[0], {
          width: 750,
          itemsToShow: 2,
          itemPadding: [0, 45, 0, 45],
          showArrows: false
        }];
        setClassNames4Container('justify-center max-w-[968px] m-auto');
        break;

      default:
        CarouselWithClusters_breakPoints[1].showArrows = Boolean(itemsLength > itemsToShowMd);
        CarouselWithClusters_breakPoints[2].showArrows = Boolean(itemsLength > CarouselWithClusters_itemsToShowLg);
        CarouselWithClusters_breakPoints[3].showArrows = Boolean(itemsLength > CarouselWithClusters_itemsToShowLg);
        setHasArrows(CarouselWithClusters_breakPoints[1].showArrows);
        CarouselWithClusters_carouselOptions.breakPoints = CarouselWithClusters_breakPoints;
    }
  }, [itemsLength]);

  if (!Object.keys(CarouselWithClusters_carouselOptions.breakPoints[0]).length) {
    return null;
  }

  return showSlice ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-black-1 py-20 px-4 lg:py-50 lg:px-15",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()('m-auto 3xl:max-w-[100rem] justify-center', {
        'lg:w-11/12': hasArrows
      }, {
        'lg:w-10/12': !hasArrows
      }),
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mx-auto text-center mb-[3.813rem] lg:mb-[7.5rem] 2xl:mb-20",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "text-h5 text-left text-white-1 font-bold mb-4 lg:text-center lg:text-h3 2xl:text-h1",
          children: slice.primary.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-left lg:text-p1 lg:text-center font-medium text-white-2 2xl:text-h5",
          children: slice.primary.description
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classNames4Container,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithClusters_ReactCarousel, {
          options: CarouselWithClusters_carouselOptions,
          color: (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : (_slice$_vertical$data = _slice$_vertical.data) === null || _slice$_vertical$data === void 0 ? void 0 : _slice$_vertical$data.color,
          children: (_slice$items2 = slice.items) === null || _slice$items2 === void 0 ? void 0 : _slice$items2.map(function (item) {
            var _item$link2, _slice$_clusters, _slice$_verticals, _item$link5, _item$link6, _item$link7, _item$link8;

            var discountColor = (0,colors/* getColor */.Lq)(item.discountColor, 600);
            var showPartners = Boolean(item.partnersText && item.partnersImage.url);
            var url;
            var cluster;
            var vertical;

            switch (item === null || item === void 0 ? void 0 : (_item$link2 = item.link) === null || _item$link2 === void 0 ? void 0 : _item$link2.type) {
              case 'page':
                url = (0,common/* prismicLinkResolver */.LT)(item === null || item === void 0 ? void 0 : item.link);
                break;

              case 'clusterpage':
                cluster = slice === null || slice === void 0 ? void 0 : (_slice$_clusters = slice._clusters) === null || _slice$_clusters === void 0 ? void 0 : _slice$_clusters.find(function (element) {
                  var _item$link3;

                  return element.id === (item === null || item === void 0 ? void 0 : (_item$link3 = item.link) === null || _item$link3 === void 0 ? void 0 : _item$link3.id);
                });
                url = (0,common/* prismicLinkResolver */.LT)(cluster);
                break;

              case 'verticalpage':
                vertical = slice === null || slice === void 0 ? void 0 : (_slice$_verticals = slice._verticals) === null || _slice$_verticals === void 0 ? void 0 : _slice$_verticals.find(function (element) {
                  var _item$link4;

                  return element.id === (item === null || item === void 0 ? void 0 : (_item$link4 = item.link) === null || _item$link4 === void 0 ? void 0 : _item$link4.id);
                });
                url = (0,common/* prismicLinkResolver */.LT)(vertical);
                break;

              default:
                url = item === null || item === void 0 ? void 0 : (_item$link5 = item.link) === null || _item$link5 === void 0 ? void 0 : _item$link5.url;
            }

            return item !== null && item !== void 0 && (_item$link6 = item.link) !== null && _item$link6 !== void 0 && _item$link6.id || item !== null && item !== void 0 && (_item$link7 = item.link) !== null && _item$link7 !== void 0 && _item$link7.url ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()('flex flex-col rounded border border-gray-5 bg-gray-3 shadow-sm h-auto px-[1.625rem]', 'pt-20 pb-15.5 relative min-w-[16.25rem] min-h-[38.188rem]', 'lg:px-7 lg:min-w-[23.5rem] lg:min-h-[40.563rem] 2xl:min-w-[22.375rem]', '3xl:min-h-[38.938rem] 3xl:min-w-[27.438rem]'),
              children: [item.discountHeader && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: classnames_default()('text-white-2 rounded-t font-bold absolute left-0 top-0 px-1.5 py-3.5 text-p2', 'lg:py-3 lg:text-p1 w-full text-center', discountColor.bg),
                children: item.discountHeader
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: classnames_default()({
                  invisible: !item.pillText
                }, 'text-white-1 border-white-2 capitalize font-medium border rounded-4xl visible', 'w-fit text-p3 py-1.5 px-4 mb-6'),
                children: item.pillText
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: "text-white-1 font-bold text-p1 lg:text-h5 3xl:text-h4",
                children: item.cardTitle
              }), showPartners && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "lg:flex items-center pt-4",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "font-medium text-p4 text-left pb-1.5 text-gray-8 lg:text-p4 lg:mr-3 lg:pb-0",
                  children: item.partnersText
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex lg:contents",
                  children: [item.partnersImage.url && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "max-w-lg mr-5",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: item.partnersImage.url,
                      alt: item.partnersImage.alt,
                      width: item.partnersImage.dimensions.width,
                      height: item.partnersImage.dimensions.height
                    })
                  }), item.partnersImage2.url && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "max-w-lg",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: item.partnersImage2.url,
                      alt: item.partnersImage2.alt,
                      width: item.partnersImage2.dimensions.width,
                      height: item.partnersImage2.dimensions.height
                    })
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "font-medium text-white-4 text-p4 pt-6 pb-8 lg:text-p2",
                children: item.cardDescription
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "pb-4 grid grid-flow-col justify-start",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithClusters_Icon, {
                  icon: item.iconDuration,
                  className: classnames_default()('text-white-4 w-4 h-4 lg:w-5 lg:h-5')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "pl-2 text-p4 text-white-4 font-medium lg:pl-3 lg:text-p2",
                  children: item.durationText
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "lg:mb-12 grid grid-flow-col justify-start",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithClusters_Icon, {
                  icon: item.iconHours,
                  className: classnames_default()('text-white-4 w-4 h-4 lg:w-5 lg:h-5')
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "pl-2 text-p4 text-white-4 font-medium lg:pl-3 lg:text-p2",
                  children: item.hoursText
                }), !!item.tooltipText && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "flex items-center ml-2",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithClusters_Tooltip, {
                    tip: item.tooltipText,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithClusters_Icon, {
                      icon: "exclamation-circle",
                      className: "text-white-4 w-3 h-3 inline-block"
                    })
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "lg:mt-16",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithClusters_LinkWithQuery, {
                  href: url,
                  target: item === null || item === void 0 ? void 0 : (_item$link8 = item.link) === null || _item$link8 === void 0 ? void 0 : _item$link8.target,
                  className: "text-black-1 font-bold lg:text-p1 absolute min-w-[13rem] lg:mt-12 bg-white-1 px-4 py-2 lg:py-4 text-center rounded-x bottom-[3.875rem] lg:min-w-[20.313rem] left-[1.625rem] right-[1.625rem]",
                  children: (0,common/* getDefaultText */.T9)('buttonLabel', item, defaultMessages)
                })
              })]
            }, (0,index_browser/* nanoid */.x0)()) : null;
          })
        })
      })]
    })
  }) : null;
};

/* harmony default export */ var variations_CarouselWithClusters = (CarouselWithClusters);
;// CONCATENATED MODULE: ./slices/Carousel/variations/CarouselWithTabs.tsx














var CarouselWithTabs_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var CarouselWithTabs_ReactCarousel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(957), __webpack_require__.e(892)]).then(__webpack_require__.bind(__webpack_require__, 1892));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1892)];
    }
  }
});
var TABS_BG = {
  cursos: (0,colors/* getColor */.Lq)('coral'),
  cursosLive: (0,colors/* getColor */.Lq)('green'),
  cursosOnDemand: (0,colors/* getColor */.Lq)('orange'),
  carreras: (0,colors/* getColor */.Lq)('violet'),
  certificaciones: (0,colors/* getColor */.Lq)('pink'),
  especializaciones: (0,colors/* getColor */.Lq)('pink'),
  escuelas: (0,colors/* getColor */.Lq)('yellow'),
  empresas: (0,colors/* getColor */.Lq)('blue'),
  membresia: (0,colors/* getColor */.Lq)('violet'),
  "default": (0,colors/* getColor */.Lq)('blue')
};
var CarouselWithTabs_itemsToShowSm = 1;
var CarouselWithTabs_itemsToShowLg = 4;
var CarouselWithTabs_breakPoints = [{
  width: 1,
  itemsToShow: CarouselWithTabs_itemsToShowSm,
  itemPadding: [0, 5, 0, 5],
  showArrows: false,
  pagination: true
}, {
  width: 600,
  itemsToShow: CarouselWithTabs_itemsToShowLg,
  itemPadding: [0, 7.5, 0, 7.5],
  showArrows: true,
  pagination: true
}];
var CarouselWithTabs_carouselOptions = {
  isRTL: false,
  pagination: false,
  showArrows: true,
  breakPoints: CarouselWithTabs_breakPoints
};
var wrapperSize = {
  2: 'lg:w-[610px]',
  3: 'lg:w-[900px]',
  "default": '2xl:w-9/12'
};

var CarouselWithTabs = function CarouselWithTabs(_ref) {
  var _slice$primary, _slice$primary2, _slice$primary3;

  var slice = _ref.slice;
  var group = lodash_groupby_default()(slice.items, 'tab');

  var _useState = (0,react.useState)(group),
      tabItems = _useState[0];

  var _useState2 = (0,react.useState)(Object.keys(group)[0]),
      tab = _useState2[0],
      setTab = _useState2[1];

  var renderTabs = (0,react.useCallback)(function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex justify-center mt-8 flex-grow",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: "grid grid-cols-2 lg:inline-flex flex-row bg-[#41414A] p-0.5 rounded m-auto",
        children: Object.keys(tabItems).map(function (key) {
          var _getColor, _tabItems$key, _tabItems$key$;

          var color = (_getColor = (0,colors/* getColor */.Lq)((_tabItems$key = tabItems[key]) === null || _tabItems$key === void 0 ? void 0 : (_tabItems$key$ = _tabItems$key[0]) === null || _tabItems$key$ === void 0 ? void 0 : _tabItems$key$.color)) !== null && _getColor !== void 0 ? _getColor : TABS_BG["default"];
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              type: "button",
              onClick: function onClick() {
                return setTab(key);
              },
              className: classnames_default()('rounded border border-[#4B5563] min-w-[144px] px-3 min-h-[40px]', 'h-full capitalize w-full text-xs sm:text-base', (0,defineProperty/* default */.Z)({}, "".concat(color.bg, " ").concat(color.textContrast), key === tab), {
                'bg-[#2C2C31]': key !== tab
              }),
              children: key
            })
          }, "tab_".concat(key));
        })
      })
    });
  }, [tabItems, tab, setTab]);
  if (!slice.items.length) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "-mb-1 bg-black-2 py-20 px-4 lg:px-0 text-white-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "lg:w-10/12 lg:m-auto",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
        children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "text-white-1 text-3xl font-extrabold text-center lg:text-[48px]",
          children: slice.primary.title
        }), (0,prismic/* hasRichText */.M)((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-base lg:text-xl font-normal text-center w-full mt-5",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.description
          })
        })]
      }), renderTabs(), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "min-h-[400px] transition-all",
        children: Object.keys(tabItems).map(function (key) {
          var _classNames2;

          var items = tabItems[key];
          var tabOptions = lodash_clonedeep_default()(CarouselWithTabs_carouselOptions);
          tabOptions.breakPoints[1].showArrows = items.length > CarouselWithTabs_itemsToShowLg;
          tabOptions.breakPoints[1].pagination = items.length > CarouselWithTabs_itemsToShowLg;
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classnames_default()('mt-16 m-auto', (_classNames2 = {
              hidden: tab !== key
            }, (0,defineProperty/* default */.Z)(_classNames2, wrapperSize[2], items.length === 2), (0,defineProperty/* default */.Z)(_classNames2, wrapperSize[3], items.length === 3), (0,defineProperty/* default */.Z)(_classNames2, wrapperSize["default"], items.length >= 4), _classNames2)),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithTabs_ReactCarousel, {
              options: tabOptions,
              children: items === null || items === void 0 ? void 0 : items.map(function (item) {
                var _slice$_verticals, _slice$_clusters, _slice$_products, _item$link$target, _item$link;

                var _getVerticalByLink = (0,common/* getVerticalByLink */.SP)(item.link, (_slice$_verticals = slice._verticals) !== null && _slice$_verticals !== void 0 ? _slice$_verticals : [slice._vertical], (_slice$_clusters = slice._clusters) !== null && _slice$_clusters !== void 0 ? _slice$_clusters : [slice._cluster], (_slice$_products = slice._products) !== null && _slice$_products !== void 0 ? _slice$_products : [slice._product]),
                    verticalId = _getVerticalByLink.uid,
                    clusterId = _getVerticalByLink.clusterId;

                return /*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
                  className: "rounded-lg relative overflow-hidden h-full min-h-fit bg-[#202024] lg:max-w-[288px]",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
                    className: "flex flex-col items-start border-b border-white-1 p-6",
                    children: [item.title && /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                      className: "font-medium text-lg mb-4",
                      children: item.title
                    }), (0,prismic/* hasRichText */.M)(item.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "text-sm font-normal",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                        render: item.description
                      })
                    }), (0,prismic/* hasLink */.A)(item.link) && item.linkLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselWithTabs_LinkWithQuery, {
                      href: prismic_reactjs.Link.url(item.link, function (doc) {
                        return (0,common/* prismicLinkResolver */.LT)(doc, {
                          verticalId: verticalId,
                          clusterId: clusterId
                        });
                      }),
                      target: (_item$link$target = (_item$link = item.link) === null || _item$link === void 0 ? void 0 : _item$link.target) !== null && _item$link$target !== void 0 ? _item$link$target : '_self',
                      className: " bg-[#4B5563] rounded-md text-sm text-center font-medium w-full py-3 px-2 text mt-12 ",
                      children: item.linkLabel
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "p-6",
                    children: (0,prismic/* hasRichText */.M)(item.content) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "text-gray-200 font-normal text-xs my-richtext-list-checklist",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                        render: item.content
                      })
                    })
                  })]
                }, (0,index_browser/* nanoid */.x0)());
              })
            })
          }, "items_".concat(key));
        })
      })]
    })
  });
};

/* harmony default export */ var variations_CarouselWithTabs = (CarouselWithTabs);
;// CONCATENATED MODULE: ./slices/Carousel/Carousel.types.ts
var CarouselVariations;

(function (CarouselVariations) {
  CarouselVariations["withoutControls"] = "carouselWithoutControls";
  CarouselVariations["withDate"] = "carouselWithDate";
  CarouselVariations["withDateLight"] = "carouselWithDateLight";
  CarouselVariations["withImage"] = "carouselWithImage";
  CarouselVariations["withHeaderImage"] = "carouselWithHeaderImage";
  CarouselVariations["withPrice"] = "carouselWithPrice";
  CarouselVariations["withFlags"] = "carouselWithFlags";
  CarouselVariations["withPills"] = "carouselWithPills";
  CarouselVariations["withClusters"] = "carouselWithClusters";
  CarouselVariations["withTabs"] = "carouselWithTabs";
})(CarouselVariations || (CarouselVariations = {}));
;// CONCATENATED MODULE: ./slices/Carousel/index.tsx














var Carousel = function Carousel(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case CarouselVariations.withPrice:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_CarouselWithPrice, {
        slice: slice
      });

    case CarouselVariations.withDate:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_CarouselWithDate, {
        slice: slice
      });

    case CarouselVariations.withDateLight:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_CarouselWithDateLight, {
        slice: slice
      });

    case CarouselVariations.withImage:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_CarouselWithImage, {
        slice: slice
      });

    case CarouselVariations.withHeaderImage:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_CarouselWithHeaderImage, {
        slice: slice
      });

    case CarouselVariations.withoutControls:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_CarouselWithoutControls, {
        slice: slice
      });

    case CarouselVariations.withFlags:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_CarouselWithFlags, {
        slice: slice
      });

    case CarouselVariations.withPills:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_CarouselWithPills, {
        slice: slice
      });

    case CarouselVariations.withClusters:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_CarouselWithClusters, {
        slice: slice
      });

    case CarouselVariations.withTabs:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_CarouselWithTabs, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var slices_Carousel = (Carousel);
;// CONCATENATED MODULE: ./slices/Content/Content.types.ts
var ContentVariations;

(function (ContentVariations) {
  ContentVariations["withOneColumn"] = "contentWithOneColumn";
  ContentVariations["withTwoColumns"] = "contentWithTwoColumns";
  ContentVariations["withTwoColumnsLight"] = "contentWithTwoColumnsLight";
  ContentVariations["withTwoAlternative"] = "contentWithTwoAlternative";
  ContentVariations["withLogoCloud"] = "contentWithLogoCloud";
  ContentVariations["withTwoSections"] = "contentWithTwoSections";
  ContentVariations["withList"] = "contentWithList";
  ContentVariations["withLogo"] = "contentWithLogo";
  ContentVariations["withButton"] = "contentWithButton";
  ContentVariations["withButtonCentered"] = "contentWithButtonCentered";
  ContentVariations["withImage"] = "contentWithImage";
  ContentVariations["withSteps"] = "contentWithSteps";
  ContentVariations["withOnlyTextDark"] = "contentWithOnlyTextDark";
  ContentVariations["withOnlyTextFull"] = "contentWithOnlyTextFull";
  ContentVariations["descriptiveBox"] = "contentDescriptiveBox";
  ContentVariations["checkList"] = "contentCheckList";
  ContentVariations["checkListImage"] = "contentCheckListImage";
})(ContentVariations || (ContentVariations = {}));
;// CONCATENATED MODULE: ./slices/Content/variations/ContentWithList.tsx








var ContentWithList_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});

var ContentWithList = function ContentWithList(_ref) {
  var _slice$_vertical, _slice$_vertical$data, _slice$primary, _slice$primary2, _slice$items;

  var slice = _ref.slice;
  var color = (0,colors/* getColor */.Lq)((_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : (_slice$_vertical$data = _slice$_vertical.data) === null || _slice$_vertical$data === void 0 ? void 0 : _slice$_vertical$data.color);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-gray-100",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content grid grid-cols-1 lg:gap-x-48 lg:grid-cols-2 lg:text-left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-7 lg:mb-0",
        children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
          className: "lg:max-w-sm",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "text-2xl font-bold mb-7 text-gray-800",
            children: slice.primary.title
          })
        }), ((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-xs font-semibold text-black",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: slice.primary.description
          })
        })]
      }), ((_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-lg font-normal lg:m-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: "text-gray-800 text-xs font-normal lg:max-w-md space-y-5",
          children: slice.items.map(function (_ref2) {
            var icon = _ref2.icon,
                title = _ref2.title;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              className: "flex items-start",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ContentWithList_Icon, {
                icon: icon,
                className: classnames_default()('w-4 mr-4 inline-block flex-none', color.text)
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: title
              })]
            }, (0,index_browser/* nanoid */.x0)());
          })
        })
      })]
    })
  });
};

/* harmony default export */ var variations_ContentWithList = (ContentWithList);
;// CONCATENATED MODULE: ./slices/Content/variations/ContentWithLogoCloud.tsx








var ContentWithLogoCloud_HighlightText = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(774), __webpack_require__.e(935), __webpack_require__.e(166)]).then(__webpack_require__.bind(__webpack_require__, 8166));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8166)];
    }
  }
});

var ContentWithLogoCloud = function ContentWithLogoCloud(_ref) {
  var _slice$_verticals, _verticals$, _slice$primary, _slice$primary2, _slice$primary3, _slice$primary4;

  var slice = _ref.slice;
  var verticals = (_slice$_verticals = slice._verticals) !== null && _slice$_verticals !== void 0 ? _slice$_verticals : [slice._vertical];
  var color = (0,colors/* getColor */.Lq)((_verticals$ = verticals[0]) === null || _verticals$ === void 0 ? void 0 : _verticals$.data.color);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: classnames_default()('bg-white text-black dark:bg-gray-1 dark:text-white' // mobile
    ),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()('dh-content grid grid-cols-1', 'lg:gap-x-10 lg:grid-cols-2 text-left'),
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        className: classnames_default()('text-center lg:text-left lg:flex lg:items-center'),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:pl-10 lg:max-w-sm",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "text-2xl lg:text-3.5xl font-semibold not-italic text-white-2",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentWithLogoCloud_HighlightText, {
              text: slice.primary.title,
              highlight: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.highlightedText,
              className: classnames_default()(color.textContrast, color.bg)
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()('text-lg font-normal', // mobile
        'lg:m-0 lg:p-0 lg:px-8' // desktop
        ),
        children: [((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "dh-description my-richtext-6 lg:max-w-md dark:text-white-2 text-sm leading-6",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: slice.primary.description
          })
        }), ((_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.logoCloudText) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "lg:max-w-md dark:bg-gray-4 rounded-xl p-4 text-sm",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "dh-description my-richtext-6 dark:text-white-2 -mt-6 -mb-4 leading-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
              render: slice.primary.logoCloudText
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "grid lg:grid-cols-3 gap-4 px-4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "grid gap-3 lg:col-span-2",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "text-xxs",
                children: slice.primary.logoCloudTitle1
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-2 gap-4 items-center lg:justify-items-center",
                children: [slice.primary.logo1.url && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "w-36 max-w-full",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    src: slice.primary.logo1.url,
                    alt: slice.primary.logo1.alt,
                    width: slice.primary.logo1.dimensions.width,
                    height: slice.primary.logo1.dimensions.height,
                    layout: "responsive",
                    objectFit: "cover"
                  })
                }), slice.primary.logo2.url && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "w-36 max-w-full",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    src: slice.primary.logo2.url,
                    alt: slice.primary.logo2.alt,
                    width: slice.primary.logo2.dimensions.width,
                    height: slice.primary.logo2.dimensions.height,
                    layout: "responsive",
                    objectFit: "cover"
                  })
                })]
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "grid gap-3",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "text-xxs",
                children: slice.primary.logoCloudTitle2
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "grid items-center lg:justify-items-center",
                children: slice.primary.logo3.url && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "w-36 lg:w-full max-w-full",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    src: slice.primary.logo3.url,
                    alt: slice.primary.logo3.alt,
                    width: slice.primary.logo3.dimensions.width,
                    height: slice.primary.logo3.dimensions.height,
                    layout: "responsive",
                    objectFit: "cover"
                  })
                })
              })]
            })]
          })]
        }), slice.primary.bottomText && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "dh-description my-richtext-6 dark:text-white-4 text-xs leading-6",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: slice.primary.bottomText
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var variations_ContentWithLogoCloud = (ContentWithLogoCloud);
;// CONCATENATED MODULE: ./slices/Content/variations/ContentWithOneColumn.tsx






var Header = function Header(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()('lg:dark:bg-gray-2 text-lg mx-auto lg:pb-64 lg:pt-24 dark:bg-transparent lg:rounded-t-xl', 'dark:bg-gradient-to-t from-black to-transparent', {
      'pt-20': !title,
      'lg:hidden': !title
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      children: title && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "dh-title pt-24 pb-6 block text-center leading-8",
        children: title
      })
    })
  });
};

var ContentWithOneColumn = function ContentWithOneColumn(_ref2) {
  var _slice$primary, _slice$primary2, _slice$primary3, _slice$primary4;

  var slice = _ref2.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()('relative lg:pb-16 lg:dark:bg-white dark:bg-transparent overflow-hidden lg:mt-0', {
      '-mt-12': !!(slice !== null && slice !== void 0 && (_slice$primary = slice.primary) !== null && _slice$primary !== void 0 && _slice$primary.title)
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "lg:dh-content relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header, {
        title: slice === null || slice === void 0 ? void 0 : (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()('lg:dh-description px-6 pb-10 prose-sm dark:text-primary-50 dark:bg-black lg:rounded-xl lg:p-14', {
          'lg:-mt-56': !!(slice !== null && slice !== void 0 && (_slice$primary3 = slice.primary) !== null && _slice$primary3 !== void 0 && _slice$primary3.title)
        }),
        children: prismic_reactjs.RichText.render(slice === null || slice === void 0 ? void 0 : (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.description)
      })]
    })
  });
};

/* harmony default export */ var variations_ContentWithOneColumn = (ContentWithOneColumn);
;// CONCATENATED MODULE: ./slices/Content/variations/ContentWithTwoColumns.tsx








var ContentWithTwoColumns_HighlightText = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(774), __webpack_require__.e(935), __webpack_require__.e(166)]).then(__webpack_require__.bind(__webpack_require__, 8166));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8166)];
    }
  }
});

var ContentWithTwoColumns = function ContentWithTwoColumns(_ref) {
  var _slice$_vertical, _slice$_vertical$data, _slice$primary, _slice$primary2, _slice$primary3;

  var slice = _ref.slice;
  var color = (0,colors/* getColor */.Lq)((_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : (_slice$_vertical$data = _slice$_vertical.data) === null || _slice$_vertical$data === void 0 ? void 0 : _slice$_vertical$data.color);
  var isDark = slice.variation !== ContentVariations.withTwoColumnsLight;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()({
      'bg-gray-2 text-white': isDark,
      'bg-athensGray-400 text-gray-800': !isDark
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()('dh-content grid grid-cols-1 text-center', 'lg:gap-x-10 lg:grid-cols-2 lg:text-left'),
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()('lg:pr-28 lg:items-center lg:flex', {
          'lg:pl-24 lg:justify-end': isDark,
          'lg:pr-28': !isDark
        }),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:max-w-sm",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: classnames_default()({
              'dh-title text-3.5xl text-white': isDark,
              'text-2xl font-bold leading-8 text-black': !isDark
            }),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentWithTwoColumns_HighlightText, {
              text: slice.primary.title,
              highlight: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.highlightedText,
              className: classnames_default()(color.textContrast, color.bg)
            })
          })
        })
      }), ((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()('text-lg font-normal lg:m-0 lg:p-0', {
          'lg:px-8': isDark
        }),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()('my-richtext-6 font-archivo text-base leading-7', {
            'dh-description': isDark,
            'font-medium leading-7': !isDark
          }),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: slice.primary.description
          })
        })
      })]
    })
  });
};

/* harmony default export */ var variations_ContentWithTwoColumns = (ContentWithTwoColumns);
;// CONCATENATED MODULE: ./slices/Content/variations/ContentWithTwoSections.tsx








var ContentWithTwoSections_HighlightText = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(774), __webpack_require__.e(935), __webpack_require__.e(166)]).then(__webpack_require__.bind(__webpack_require__, 8166));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8166)];
    }
  }
});

var Card = function Card(_ref) {
  var tag = _ref.tag,
      title = _ref.title,
      highlight = _ref.highlight,
      description = _ref.description,
      images = _ref.images,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()('py-12 lg:py-20 w-full', className),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
      children: [tag && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: classnames_default()('inline-block font-medium text-xs text-gray-600 bg-gray-400 rounded-sm py-1 px-2 mb-4'),
        children: tag
      }), title && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: "text-2xl font-medium leading-9 text-gray-800",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentWithTwoSections_HighlightText, {
          highlight: highlight,
          text: title,
          className: "bg-transparent font-bold m-0 px-0"
        })
      })]
    }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()('text-gray-800 text-xs font-normal leading-5 mt-7 my-richtext-6 my-richtext-list-disc'),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
        render: description
      })
    }), !!(images !== null && images !== void 0 && images.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "grid gap-4 grid-cols-4 mt-7",
      children: images === null || images === void 0 ? void 0 : images.map(function (_ref2) {
        var _image$dimensions, _image$dimensions2;

        var image = _ref2.image;
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: image.url,
            alt: image.alt,
            width: (_image$dimensions = image.dimensions) === null || _image$dimensions === void 0 ? void 0 : _image$dimensions.width,
            height: (_image$dimensions2 = image.dimensions) === null || _image$dimensions2 === void 0 ? void 0 : _image$dimensions2.height,
            layout: "intrinsic"
          })
        }, (0,index_browser/* nanoid */.x0)());
      })
    })]
  });
};

var ContentWithTwoSections = function ContentWithTwoSections(_ref3) {
  var _slice$primary, _slice$primary2, _slice$primary3, _slice$primary4, _slice$primary5, _slice$primary6, _slice$primary7, _slice$primary8;

  var slice = _ref3.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "bg-gray-200 text-black relative overflow-hidden",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hidden lg:block absolute top-0 left-1/2 w-full h-full bg-gray-300 z-0"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content grid grid-cols-1 p-0 lg:grid-cols-2 relative z-10 lg:gap-48",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Card, {
        tag: (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.leftSectionTag,
        title: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.leftSectionTitle,
        highlight: (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.leftSectionHighlightedText,
        description: (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.leftSectionDescription,
        images: slice.items,
        className: "px-4 lg:px-0 lg:pl-8"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "bg-gray-300",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, {
          tag: (_slice$primary5 = slice.primary) === null || _slice$primary5 === void 0 ? void 0 : _slice$primary5.rightSectionTag,
          title: (_slice$primary6 = slice.primary) === null || _slice$primary6 === void 0 ? void 0 : _slice$primary6.rightSectionTitle,
          highlight: (_slice$primary7 = slice.primary) === null || _slice$primary7 === void 0 ? void 0 : _slice$primary7.rightSectionHighlightedText,
          description: (_slice$primary8 = slice.primary) === null || _slice$primary8 === void 0 ? void 0 : _slice$primary8.rightSectionDescription,
          className: "px-4 lg:px-0 lg:pr-8"
        })
      })]
    })]
  });
};

/* harmony default export */ var variations_ContentWithTwoSections = (ContentWithTwoSections);
;// CONCATENATED MODULE: ./slices/Content/variations/ContentWithTwoAlternative.tsx







var ContentWithTwoAlternative_HighlightText = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(774), __webpack_require__.e(935), __webpack_require__.e(166)]).then(__webpack_require__.bind(__webpack_require__, 8166));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8166)];
    }
  }
});

var ContentWithTwoAlternative = function ContentWithTwoAlternative(_ref) {
  var _slice$_verticals, _verticals$, _slice$primary, _slice$primary2, _slice$primary3;

  var slice = _ref.slice;
  var verticals = (_slice$_verticals = slice._verticals) !== null && _slice$_verticals !== void 0 ? _slice$_verticals : [slice._vertical];
  var color = (0,colors/* getColor */.Lq)((_verticals$ = verticals[0]) === null || _verticals$ === void 0 ? void 0 : _verticals$.data.color);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()('bg-athensGray-400' // mobile
    ),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()('dh-content grid grid-cols-1 text-center', 'lg:gap-x-10 lg:grid-cols-2 lg:text-left'),
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()('lg:pr-28 lg:pl-24 lg:flex lg:justify-end lg:items-center'),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:max-w-sm",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "dh-title dark:text-gray-800",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentWithTwoAlternative_HighlightText, {
              text: slice.primary.title,
              highlight: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.highlightedText,
              className: classnames_default()(color.textContrast, color.bg)
            })
          })
        })
      }), ((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()('text-lg font-normal', // mobile
        'lg:m-0 lg:p-0 lg:px-8' // desktop
        ),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "dh-description my-richtext-6 lg:max-w-md dark:text-gray-800",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: slice.primary.description
          })
        })
      })]
    })
  });
};

/* harmony default export */ var variations_ContentWithTwoAlternative = (ContentWithTwoAlternative);
;// CONCATENATED MODULE: ./slices/Content/variations/ContentWithLogo.tsx







var ContentWithLogo = function ContentWithLogo(_ref) {
  var _slice$primary, _slice$primary2, _slice$primary3, _slice$primary3$logo, _slice$primary$logo, _slice$primary$logo2, _slice$primary$logo3, _slice$primary$logo3$, _slice$primary$logo4, _slice$primary$logo4$;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-athensGray",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()('dh-content py-24 grid grid-cols-1 text-center', 'lg:gap-x-10 lg:grid-cols-2 lg:text-left'),
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()('lg:pr-28 lg:flex lg:items-center'),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:max-w-sm",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "dh-title font-semibold dark:text-gray-800 text-3.5xl",
            children: slice.primary.title
          })
        })
      }), ((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()('text-lg font-medium', // mobile
        'lg:m-0 lg:p-0' // desktop
        ),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "dh-description text-gray-800 dark:text-gray-800 my-richtext-6 font-medium text-sm leading-6",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: slice.primary.description
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-2 mt-6 items-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "content-center font-normal",
              children: slice.primary.logoTitle
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: ((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : (_slice$primary3$logo = _slice$primary3.logo) === null || _slice$primary3$logo === void 0 ? void 0 : _slice$primary3$logo.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: (_slice$primary$logo = slice.primary.logo) === null || _slice$primary$logo === void 0 ? void 0 : _slice$primary$logo.url,
                alt: (_slice$primary$logo2 = slice.primary.logo) === null || _slice$primary$logo2 === void 0 ? void 0 : _slice$primary$logo2.alt,
                width: (_slice$primary$logo3 = slice.primary.logo) === null || _slice$primary$logo3 === void 0 ? void 0 : (_slice$primary$logo3$ = _slice$primary$logo3.dimensions) === null || _slice$primary$logo3$ === void 0 ? void 0 : _slice$primary$logo3$.width,
                height: (_slice$primary$logo4 = slice.primary.logo) === null || _slice$primary$logo4 === void 0 ? void 0 : (_slice$primary$logo4$ = _slice$primary$logo4.dimensions) === null || _slice$primary$logo4$ === void 0 ? void 0 : _slice$primary$logo4$.height,
                layout: "intrinsic"
              })
            })]
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var variations_ContentWithLogo = (ContentWithLogo);
;// CONCATENATED MODULE: ./slices/Content/variations/ContentWithButton.tsx







var ContentWithButton_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});

var ContentWithButton = function ContentWithButton(_ref) {
  var _slice$primary, _slice$primary2, _slice$primary3, _slice$primary3$butto, _slice$primary$button;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()('bg-gray-1'),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()('dh-content py-20 grid grid-cols-1 text-center', 'sm:gap-x-10 sm:grid-cols-2 sm:text-left'),
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()('sm:pr-28 sm:flex sm:items-center'),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "sm:max-w-sm",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: classnames_default()('dh-title font-semibold text-athensGray dark:text-athensGray text-3.5xl'),
            children: slice.primary.title
          })
        })
      }), ((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()('text-lg', // mobile
        'sm:flex sm:items-center sm:m-0 sm:p-0' // desktop
        ),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()('text-white-2 dark:text-white-2 font-normal font-archivo my-richtext-6 text-base leading-6'),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "sm:-mt-6 leading-7",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
              render: slice.primary.description
            })
          }), (slice === null || slice === void 0 ? void 0 : (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : (_slice$primary3$butto = _slice$primary3.buttonLink) === null || _slice$primary3$butto === void 0 ? void 0 : _slice$primary3$butto.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentWithButton_LinkWithQuery, {
              href: prismic_reactjs.Link.url(slice.primary.buttonLink, common/* prismicLinkResolver */.LT),
              target: (_slice$primary$button = slice.primary.buttonLink.target) !== null && _slice$primary$button !== void 0 ? _slice$primary$button : '_self',
              className: classnames_default()('dh-button-sm text-sm font-semibold text-athensGray bg-blue leading-6'),
              children: slice.primary.buttonLabel
            })
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var variations_ContentWithButton = (ContentWithButton);
;// CONCATENATED MODULE: ./slices/Content/variations/ContentWithImage.tsx








var ContentWithImage_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});

var ContentWithImage = function ContentWithImage(_ref) {
  var _slice$primary, _slice$primary$image, _slice$primary2, _slice$primary2$image, _slice$primary3, _slice$primary3$image, _slice$primary4, _slice$primary4$image, _slice$primary4$image2, _slice$primary5, _slice$primary5$image, _slice$primary5$image2, _slice$primary6, _slice$primary7, _slice$primary7$butto, _slice$primary$button;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "bg-gray-2",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()('dh-content py-20 grid grid-cols-1 text-center', 'sm:gap-x-10 sm:grid-cols-2 sm:text-left'),
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : (_slice$primary$image = _slice$primary.image) === null || _slice$primary$image === void 0 ? void 0 : _slice$primary$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()('text-center'),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : (_slice$primary2$image = _slice$primary2.image) === null || _slice$primary2$image === void 0 ? void 0 : _slice$primary2$image.url,
          alt: (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : (_slice$primary3$image = _slice$primary3.image) === null || _slice$primary3$image === void 0 ? void 0 : _slice$primary3$image.alt,
          width: (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : (_slice$primary4$image = _slice$primary4.image) === null || _slice$primary4$image === void 0 ? void 0 : (_slice$primary4$image2 = _slice$primary4$image.dimensions) === null || _slice$primary4$image2 === void 0 ? void 0 : _slice$primary4$image2.width,
          height: (_slice$primary5 = slice.primary) === null || _slice$primary5 === void 0 ? void 0 : (_slice$primary5$image = _slice$primary5.image) === null || _slice$primary5$image === void 0 ? void 0 : (_slice$primary5$image2 = _slice$primary5$image.dimensions) === null || _slice$primary5$image2 === void 0 ? void 0 : _slice$primary5$image2.height,
          layout: "responsive",
          objectFit: "contain",
          className: "rounded-2xl"
        })
      }), ((_slice$primary6 = slice.primary) === null || _slice$primary6 === void 0 ? void 0 : _slice$primary6.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()('flex items-center', 'text-lg', // mobile
        'sm:m-0 sm:p-0' // desktop
        ),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()('text-white-2 dark:text-white-2', 'font-normal font-archivo my-richtext-6 text-base leading-6'),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: classnames_default()('dh-title font-semibold text-athensGray dark:text-athensGray text-xl', 'leading-8 pt-6 sm:pt-0'),
            children: slice.primary.title
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-base leading-7",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
              render: slice.primary.description
            })
          }), (slice === null || slice === void 0 ? void 0 : (_slice$primary7 = slice.primary) === null || _slice$primary7 === void 0 ? void 0 : (_slice$primary7$butto = _slice$primary7.buttonLink) === null || _slice$primary7$butto === void 0 ? void 0 : _slice$primary7$butto.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentWithImage_LinkWithQuery, {
              href: prismic_reactjs.Link.url(slice.primary.buttonLink, common/* prismicLinkResolver */.LT),
              target: (_slice$primary$button = slice.primary.buttonLink.target) !== null && _slice$primary$button !== void 0 ? _slice$primary$button : '_self',
              className: classnames_default()('dh-button-sm text-sm font-semibold text-athensGray', 'bg-transparent hover:bg-transparent border-blue border-2'),
              children: slice.primary.buttonLabel
            })
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var variations_ContentWithImage = (ContentWithImage);
;// CONCATENATED MODULE: ./slices/Content/variations/ContentWithSteps.tsx






var MAX_ITEMS = 3;

var ContentWithSteps = function ContentWithSteps(_ref) {
  var _slice$items, _slice$primary, _slice$primary2, _slice$primary3;

  var slice = _ref.slice;
  var items = ((_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.slice(0, MAX_ITEMS)) || [];
  var itemsLength = items.length;
  return itemsLength ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "bg-white text-gray-800",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content grid lg:flex text-center my-7 lg:gap-x-10 lg:text-left",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        className: "lg:pr-28 lg:flex lg:items-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "lg:max-w-sm",
          children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "text-black text-lg font-semibold leading-6",
            children: slice.primary.title
          }), ((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "font-normal text-xs leading-5 mt-2",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
              render: (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.description
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-lg font-normal mt-6 lg:mt-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
          "aria-label": "Progress",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("ol", {
            className: classnames_default()('grid items-start gap-2 sm:gap-3', {
              'grid-cols-2': itemsLength === 2,
              'grid-cols-3': itemsLength === 3
            }),
            children: items.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: classnames_default()('relative'),
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "grid items-start",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "relative px-0 sm:px-10 flex items-center justify-center",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "absolute inset-0 flex items-center",
                      "aria-hidden": "true",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: classnames_default()('h-0.5 w-full border-t border-dashed border-gray-700', {
                          'ml-[50%] -mr-2 sm:-mr-3': !index,
                          '-ml-2 sm:-ml-3 w-1/2 ': index === itemsLength - 1,
                          hidden: itemsLength === 1
                        })
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: classnames_default()('group relative w-16 h-16 flex items-center justify-center', 'bg-white border-14 border-primary/20 rounded-full'),
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        "aria-hidden": "true",
                        className: classnames_default()('h-9 w-9 rounded-full bg-primary flex items-center justify-center', 'text-white font-semibold text-base leading-6'),
                        children: index + 1
                      })
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "text-center mt-7 font-bold text-black text-xs sm:text-sm leading-5",
                    children: item.stepLabel
                  })]
                })
              }, (0,index_browser/* nanoid */.x0)());
            })
          })
        })
      })]
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "hidden"
  });
};

/* harmony default export */ var variations_ContentWithSteps = (ContentWithSteps);
;// CONCATENATED MODULE: ./slices/Content/variations/ContentWithOnlyText.tsx






var ContentWithOnlyText = function ContentWithOnlyText(_ref) {
  var _slice$primary, _slice$primary$descri, _slice$primary2;

  var slice = _ref.slice,
      fullWidth = _ref.fullWidth,
      centered = _ref.centered,
      opacity = _ref.opacity;
  return slice !== null && slice !== void 0 && (_slice$primary = slice.primary) !== null && _slice$primary !== void 0 && (_slice$primary$descri = _slice$primary.description) !== null && _slice$primary$descri !== void 0 && _slice$primary$descri.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()('relative text-white font-medium', {
      'bg-gray-800': fullWidth
    }, {
      'bg-gray-900': !fullWidth
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()('dh-content', {
        'pt-2': !fullWidth,
        'p-0': fullWidth
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()('p-9', {
          'text-center': centered,
          rounded: !centered,
          'bg-gray-800': !opacity,
          'bg-gray-800/50': opacity,
          'text-lg leading-[2.875rem]': slice.variation === ContentVariations.withOnlyTextFull,
          'text-sm leading-7': slice.variation === ContentVariations.withOnlyTextDark
        }),
        children: prismic_reactjs.RichText.render(slice === null || slice === void 0 ? void 0 : (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.description)
      })
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "hidden"
  });
};

/* harmony default export */ var variations_ContentWithOnlyText = (ContentWithOnlyText);
;// CONCATENATED MODULE: ./slices/Content/variations/ContentDescriptiveBox.tsx






var ContentDescriptiveBox = function ContentDescriptiveBox(_ref) {
  var _slice$primary, _slice$primary$descri, _slice$primary2, _slice$primary3;

  var slice = _ref.slice;
  return slice !== null && slice !== void 0 && (_slice$primary = slice.primary) !== null && _slice$primary !== void 0 && (_slice$primary$descri = _slice$primary.description) !== null && _slice$primary$descri !== void 0 && _slice$primary$descri.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "dh-content-full",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classnames_default()('w-full px-6 py-12 mx-auto bg-gray-2 text-white-1 rounded', 'lg:px-30 lg:py-27 3xl:w-10/12'),
      children: [(slice === null || slice === void 0 ? void 0 : (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-xs mb-2 lg:mb-6 lg:text-2xl",
        children: slice === null || slice === void 0 ? void 0 : (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-base lg:text-3.5xl",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
          render: slice.primary.description
        })
      })]
    })
  }) : null;
};

/* harmony default export */ var variations_ContentDescriptiveBox = (ContentDescriptiveBox);
;// CONCATENATED MODULE: ./slices/Content/variations/ContentCheckList.tsx









var CheckList = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 172).then(__webpack_require__.bind(__webpack_require__, 172));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(172)];
    }
  }
});

var ContentCheckList = function ContentCheckList(_ref) {
  var _slice$_vertical, _slice$primary, _slice$primary2, _slice$primary3, _slice$primary4, _slice$primary5, _slice$primary6;

  var slice = _ref.slice;
  var vertical = slice === null || slice === void 0 ? void 0 : (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var checklistColor = (0,colors/* getColor */.Lq)((slice === null || slice === void 0 ? void 0 : (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.checklistColor) || (vertical === null || vertical === void 0 ? void 0 : vertical.color), 600);
  var items = slice.items;

  var htmlSerializer = function htmlSerializer(type, element) {
    if (type === 'paragraph') {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-6",
        children: element.text
      }, (0,index_browser/* nanoid */.x0)());
    }

    return null;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "bg-black-2",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "dh-content-full",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col px-4 py-3 items-start lg:items-center lg:flex-row lg:py-16 lg:justify-evenly lg:max-w-7xl lg:m-auto xl:px-27 2xl:max-w-8xl 3xl:max-w-8x5l 2xl:px-36 2xl:items-end",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()('text-white-1 rounded lg:w-[43%] 2xl:w-[51%]'),
          children: [(slice === null || slice === void 0 ? void 0 : (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.pill) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "dh-pill",
            children: slice.primary.pill
          }), (slice === null || slice === void 0 ? void 0 : (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-3xl leading-9 font-bold pt-5 pb-2 lg:py-4 lg:text-4.5xl lg:leading-15 3xl:text-[3rem]",
            children: slice === null || slice === void 0 ? void 0 : (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.title
          }), (0,prismic/* hasRichText */.M)(slice === null || slice === void 0 ? void 0 : (_slice$primary5 = slice.primary) === null || _slice$primary5 === void 0 ? void 0 : _slice$primary5.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-sm w-72 leading-5 font-medium pb-6 lg:w-full lg:pb-0 lg:text-sm 2xl:text-base",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
              render: (_slice$primary6 = slice.primary) === null || _slice$primary6 === void 0 ? void 0 : _slice$primary6.description,
              htmlSerializer: htmlSerializer
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CheckList, {
          items: items,
          color: checklistColor
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {})]
      })
    })
  });
};

/* harmony default export */ var variations_ContentCheckList = (ContentCheckList);
;// CONCATENATED MODULE: ./slices/Content/variations/ContentWithButtonCentered.tsx







var ContentWithButtonCentered_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});

var ContentWithButtonCentered_Button = function Button(_ref) {
  var _link$target;

  var link = _ref.link,
      scrollToId = _ref.scrollToId,
      className = _ref.className,
      children = _ref.children;
  return scrollToId ? /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
    type: "button",
    className: className,
    onClick: function onClick() {
      return (0,common/* scrollTo */.X5)({
        id: scrollToId
      });
    },
    children: children
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ContentWithButtonCentered_LinkWithQuery, {
    href: prismic_reactjs.Link.url(link, common/* prismicLinkResolver */.LT),
    target: (_link$target = link === null || link === void 0 ? void 0 : link.target) !== null && _link$target !== void 0 ? _link$target : '_self',
    className: className,
    children: children
  });
};

var ContentWithButtonCentered = function ContentWithButtonCentered(_ref2) {
  var slice = _ref2.slice;
  var _slice$primary = slice.primary,
      description = _slice$primary.description,
      buttonLink = _slice$primary.buttonLink,
      buttonScrollTo = _slice$primary.buttonScrollTo,
      buttonLabel = _slice$primary.buttonLabel;
  if (!(0,prismic/* hasRichText */.M)(description)) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "dh-content-full bg-white-2 text-black text-h6 font-medium text-center py-10",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
      render: description
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContentWithButtonCentered_Button, {
      className: " dh-btn bg-black-1 font-bold text-white-1 mt-6 lg:text-base 2xl:px-15 3xl:py-4 3xl:px-[3.125rem] 3xl:text-lg",
      link: buttonLink,
      scrollToId: buttonScrollTo,
      children: buttonLabel
    })]
  });
};

/* harmony default export */ var variations_ContentWithButtonCentered = (ContentWithButtonCentered);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/index.js + 230 modules
var solid_esm = __webpack_require__(4653);
;// CONCATENATED MODULE: ./slices/Content/variations/ContentCheckListImage.tsx











var ContentCheckListImage = function ContentCheckListImage(_ref) {
  var _slice$_vertical, _slice$primary, _slice$primary2, _slice$primary3, _slice$primary4, _slice$primary5, _slice$primary6, _slice$primary7, _slice$primary7$image, _slice$primary8, _slice$primary8$image, _slice$primary9, _slice$primary9$image, _slice$primary10, _slice$primary10$imag, _slice$primary11, _slice$primary11$imag;

  var slice = _ref.slice;
  var items = slice.items;
  var vertical = slice === null || slice === void 0 ? void 0 : (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var bulletsColor = (0,colors/* getColor */.Lq)(((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.checkListColor) || (vertical === null || vertical === void 0 ? void 0 : vertical.color), 600);
  var backgroundColor = ((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.backgroundColor) === 'black' ? 'bg-black-1' : 'bg-white-1';
  var textColor = backgroundColor === 'bg-black-1' ? 'text-white-1' : 'text-gray-1';

  var htmlSerializer = function htmlSerializer(type, element) {
    if (type === 'paragraph') {
      return /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-3",
        children: element.text
      }, (0,index_browser/* nanoid */.x0)());
    }

    return null;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: classnames_default()('pb-10 pt-15 px-4 lg:dh-content-full lg:py-20', backgroundColor),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col lg:flex-row lg:items-center w-full lg:max-w-7xl lg:m-auto 2xl:max-w-8xl 3xl:max-w-8x5l",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col lg:w-6/12 lg:items-start 2xl:items-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "lg:w-5/6 2xl:w-4/6",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [(slice === null || slice === void 0 ? void 0 : (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: classnames_default()('text-h4 leading-9 font-bold lg:text-h2 3xl:text-5xl', textColor),
              children: slice === null || slice === void 0 ? void 0 : (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.title
            }), (0,prismic/* hasRichText */.M)(slice === null || slice === void 0 ? void 0 : (_slice$primary5 = slice.primary) === null || _slice$primary5 === void 0 ? void 0 : _slice$primary5.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: classnames_default()('text-sm font-medium pt-1.5 pb-4 lg:pt-4 3xl:text-base', textColor),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                render: (_slice$primary6 = slice.primary) === null || _slice$primary6 === void 0 ? void 0 : _slice$primary6.description,
                htmlSerializer: htmlSerializer
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex flex-col w-full",
            children: items === null || items === void 0 ? void 0 : items.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex items-center pb-4 lg:pb-1.5",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* CheckCircleIcon */.rE2, {
                  className: classnames_default()('flex-none w-6 lg:w-6 lg:h-6 3xl:w-8 3xl:h-8', bulletsColor.text)
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: classnames_default()('font-medium leading-5 text-sm', 'ml-[0.375rem] lg:ml-3 3xl:text-base 3xl:ml-2', textColor),
                  children: item.checkListText
                })]
              }, (0,index_browser/* nanoid */.x0)());
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {})]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full lg:w-6/12",
        children: ((_slice$primary7 = slice.primary) === null || _slice$primary7 === void 0 ? void 0 : (_slice$primary7$image = _slice$primary7.image) === null || _slice$primary7$image === void 0 ? void 0 : _slice$primary7$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-4 filter drop-shadow-md w-full h-auto self-center 2xl:w-5/6",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            width: (_slice$primary8 = slice.primary) === null || _slice$primary8 === void 0 ? void 0 : (_slice$primary8$image = _slice$primary8.image) === null || _slice$primary8$image === void 0 ? void 0 : _slice$primary8$image.dimensions.width,
            height: (_slice$primary9 = slice.primary) === null || _slice$primary9 === void 0 ? void 0 : (_slice$primary9$image = _slice$primary9.image) === null || _slice$primary9$image === void 0 ? void 0 : _slice$primary9$image.dimensions.height,
            src: (_slice$primary10 = slice.primary) === null || _slice$primary10 === void 0 ? void 0 : (_slice$primary10$imag = _slice$primary10.image) === null || _slice$primary10$imag === void 0 ? void 0 : _slice$primary10$imag.url,
            alt: (_slice$primary11 = slice.primary) === null || _slice$primary11 === void 0 ? void 0 : (_slice$primary11$imag = _slice$primary11.image) === null || _slice$primary11$imag === void 0 ? void 0 : _slice$primary11$imag.alt
          })
        })
      })]
    })
  });
};

/* harmony default export */ var variations_ContentCheckListImage = (ContentCheckListImage);
;// CONCATENATED MODULE: ./slices/Content/index.tsx



















var Content = function Content(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case ContentVariations.withTwoColumns:
    case ContentVariations.withTwoColumnsLight:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_ContentWithTwoColumns, {
        slice: slice
      });

    case ContentVariations.withList:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_ContentWithList, {
        slice: slice
      });

    case ContentVariations.withOneColumn:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_ContentWithOneColumn, {
        slice: slice
      });

    case ContentVariations.withTwoAlternative:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_ContentWithTwoAlternative, {
        slice: slice
      });

    case ContentVariations.withLogoCloud:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_ContentWithLogoCloud, {
        slice: slice
      });

    case ContentVariations.withTwoSections:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_ContentWithTwoSections, {
        slice: slice
      });

    case ContentVariations.withLogo:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_ContentWithLogo, {
        slice: slice
      });

    case ContentVariations.withButton:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_ContentWithButton, {
        slice: slice
      });

    case ContentVariations.withButtonCentered:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_ContentWithButtonCentered, {
        slice: slice
      });

    case ContentVariations.withImage:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_ContentWithImage, {
        slice: slice
      });

    case ContentVariations.withSteps:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_ContentWithSteps, {
        slice: slice
      });

    case ContentVariations.withOnlyTextDark:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_ContentWithOnlyText, {
        slice: slice,
        opacity: true
      });

    case ContentVariations.withOnlyTextFull:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_ContentWithOnlyText, {
        slice: slice,
        fullWidth: true,
        centered: true
      });

    case ContentVariations.descriptiveBox:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_ContentDescriptiveBox, {
        slice: slice
      });

    case ContentVariations.checkList:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_ContentCheckList, {
        slice: slice
      });

    case ContentVariations.checkListImage:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_ContentCheckListImage, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var slices_Content = (Content);
;// CONCATENATED MODULE: ./slices/Divider/Divider.types.ts
var DividerVariations;

(function (DividerVariations) {
  DividerVariations["d360"] = "divider360";
  DividerVariations["d360TripleBackflip"] = "divider360TripleBackflip";
  DividerVariations["d360DownArrow"] = "divider360DownArrow";
  DividerVariations["tripleArrowDown"] = "dividerTripleArrowDown";
})(DividerVariations || (DividerVariations = {}));
;// CONCATENATED MODULE: ./slices/Divider/variations/Divider.tsx





var contentClassName = 'flex justify-center w-full p-4 lg:p-6';

var Divider = function Divider(_ref) {
  var slice = _ref.slice,
      DividerMobile = _ref.mobile,
      DividerDesktop = _ref.desktop;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(contentClassName, 'lg:hidden', {
        hidden: slice.primary.hideOnMobile
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DividerMobile, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()(contentClassName, 'hidden', {
        'lg:hidden': slice.primary.hideOnDesktop,
        'lg:flex': !slice.primary.hideOnDesktop
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DividerDesktop, {})
    })]
  });
};

/* harmony default export */ var variations_Divider = (Divider);
;// CONCATENATED MODULE: ./slices/Divider/variations/Divider360.tsx





var DividerMobile = function DividerMobile() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "284",
    height: "37",
    viewBox: "0 0 284 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      clipPath: "url(#clip0_39_6075)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M-0.136334 1.48821C-0.125099 0.659854 0.55552 -0.00254913 1.38387 0.00868575C43.7188 0.582876 85.813 7.13437 126.645 19.5032L126.649 19.5045C126.956 19.5985 127.268 19.7036 127.582 19.8192C127.891 19.4924 128.213 19.1859 128.545 18.9025C132.004 15.9525 136.37 14.9018 140.23 14.0717C187.085 3.9671 235.267 6.08605 282.705 8.25692C283.533 8.29479 284.173 8.99636 284.135 9.82393C284.097 10.6515 283.395 11.2917 282.568 11.2538C235.067 9.08002 187.274 6.99511 140.862 17.0045L140.861 17.0046C136.965 17.8424 133.321 18.781 130.509 21.171C132.24 22.1374 133.892 23.3742 135.177 24.7931C137.417 27.2659 138.822 30.6791 136.783 34.1321L136.782 34.1334C135.291 36.6535 132.558 37.3326 130.171 36.8369C127.808 36.3462 125.508 34.6756 124.536 32.1232C123.286 28.8417 124.002 25.2421 125.691 22.3489C85.1522 10.0774 43.3658 3.57836 1.34319 3.00841C0.514835 2.99717 -0.147569 2.31656 -0.136334 1.48821ZM128.498 23.4958C127.028 25.8053 126.433 28.6761 127.339 31.0553C127.903 32.5359 129.293 33.5907 130.781 33.8996C132.243 34.2032 133.518 33.7564 134.2 32.6066C135.279 30.7796 134.77 28.8124 132.954 26.8072C131.777 25.508 130.167 24.3556 128.498 23.4958Z",
        fill: "black"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_39_6075",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "284",
          height: "37",
          fill: "white"
        })
      })
    })]
  });
};

var DividerDesktop = function DividerDesktop() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "567",
    height: "64",
    viewBox: "0 0 567 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.22251 2.59201C1.23211 1.76364 1.91141 1.09988 2.73978 1.10948C86.9812 2.08507 171.095 13.4263 252.357 34.7677L252.357 34.7678C253.281 35.0106 254.224 35.2984 255.175 35.6278C255.967 34.8398 256.811 34.1142 257.691 33.4639C264.267 28.604 272.604 26.8401 280.34 25.4021C373.618 7.91797 469.612 11.6189 564.355 15.3753C565.183 15.4081 565.828 16.1058 565.795 16.9335C565.762 17.7613 565.064 18.4058 564.237 18.3729C469.436 14.6143 373.781 10.9393 280.891 28.3512L280.889 28.3516C273.09 29.8013 265.42 31.4819 259.474 35.8766C259.06 36.182 258.659 36.5032 258.272 36.8386C262.146 38.5276 265.917 40.8414 268.737 43.5444C270.871 45.5899 272.556 47.9503 273.238 50.53C273.938 53.1746 273.548 55.9278 271.744 58.5665C269.137 62.3865 264.437 63.4 260.241 62.6474C256.043 61.8945 251.854 59.3047 250.06 55.2476C247.497 49.453 249.283 43.0124 253.028 38.0802C252.547 37.931 252.068 37.7938 251.595 37.6693C170.571 16.3904 86.7016 5.08204 2.70504 4.10928C1.87667 4.09968 1.21292 3.42038 1.22251 2.59201ZM256.005 39.1408C252.333 43.5202 250.695 49.2663 252.803 54.0342C254.094 56.9529 257.282 59.0688 260.771 59.6945C264.26 60.3204 267.554 59.3859 269.267 56.8747L269.267 56.8735C270.585 54.9458 270.812 53.089 270.338 51.2971C269.847 49.4402 268.568 47.5375 266.661 45.7102C263.882 43.0456 259.972 40.7372 256.005 39.1408Z",
      fill: "black"
    })
  });
};

var Divider360 = function Divider360(_ref) {
  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_Divider, {
    slice: slice,
    mobile: DividerMobile,
    desktop: DividerDesktop
  });
};

/* harmony default export */ var variations_Divider360 = (Divider360);
;// CONCATENATED MODULE: ./slices/Divider/variations/Divider360DownArrow.tsx





var DividerSVG = function DividerSVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "44",
    height: "150",
    viewBox: "0 0 44 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      clipPath: "url(#clip0_48_3792)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.296136 140.827C0.104185 141.1 0.000901713 141.425 0.000409603 141.759C0.00263356 141.993 0.0568671 142.224 0.15917 142.435C0.261476 142.646 0.409288 142.831 0.591867 142.977L6.92888 148.358L6.92888 148.443C7.07536 148.941 7.39401 149.37 7.82761 149.653C8.26123 149.937 8.78139 150.056 9.29469 149.989C9.77565 149.952 10.2247 149.734 10.5518 149.378C10.6845 149.234 10.7932 149.071 10.8754 148.897L17.3318 146.038C17.6173 145.917 17.8655 145.721 18.051 145.472C18.2366 145.223 18.3528 144.928 18.3879 144.619C18.4095 144.333 18.3555 144.046 18.2313 143.788C18.107 143.529 17.917 143.308 17.6803 143.147L17.6802 143.147C16.9649 142.653 16.6415 142.43 11.1538 145.152C11.6885 134.035 14.178 123.092 18.5151 112.831L18.6524 112.524C21.8191 115.533 25.1363 118.379 28.5909 121.051C31.5482 123.434 36.3537 125.574 39.913 124.663C40.7324 124.465 41.4927 124.073 42.1303 123.52C42.7679 122.968 43.2642 122.27 43.5779 121.485C44.1618 119.621 44.106 117.615 43.4195 115.786C41.1382 107.641 35.4243 98.669 26.8271 100.173C23.3417 100.745 20.4056 103.054 17.913 107.101C16.6176 105.604 15.4383 104.011 14.3854 102.334C11.0057 96.9106 8.65044 88.6379 12.1675 81.7104C13.6786 78.7319 16.0761 76.3076 18.6139 73.7415L18.6629 73.6919C19.6452 72.7174 20.6696 71.6581 21.6308 70.5989C26.1625 65.5766 29.5425 59.6198 31.5332 53.1472C33.5239 46.6746 34.077 39.8432 33.1536 33.1333C32.1077 26.4054 29.625 19.9835 25.8753 14.3069C22.1257 8.63041 17.1976 3.83325 11.4282 0.243696C11.2522 0.114322 11.0515 0.0227989 10.8386 -0.0251352C10.6257 -0.0730694 10.4052 -0.0763815 10.191 -0.0348638C9.97673 0.00665381 9.77336 0.092106 9.5936 0.216137C9.41384 0.340167 9.26156 0.500102 9.14631 0.685915C9.03106 0.871729 8.95533 1.07942 8.92385 1.29596C8.89238 1.5125 8.90584 1.73323 8.96341 1.9443C9.02097 2.15538 9.12138 2.35226 9.25836 2.5226C9.39534 2.69293 9.56592 2.83306 9.75942 2.93418C15.1373 6.28118 19.732 10.7524 23.2297 16.0427C26.7275 21.333 29.0461 27.3178 30.0273 33.5888C30.8836 39.8343 30.3688 46.192 28.5189 52.2171C26.669 58.2423 23.5287 63.7892 19.3177 68.4698C18.3989 69.4761 17.4061 70.4824 16.445 71.4463L16.4418 71.4495C13.8235 74.0966 11.1212 76.8287 9.37919 80.2698C5.92552 87.0702 6.83382 96.1585 11.7345 104.018C13.0904 106.168 14.635 108.192 16.3499 110.066C16.1175 110.522 15.8852 111.062 15.6634 111.581C11.1692 122.217 8.58752 133.568 8.03785 145.106L3.81318 141.579C3.68455 141.307 3.47885 141.078 3.22172 140.922L2.40847 140.414C2.06853 140.206 1.66326 140.133 1.27235 140.209C0.881452 140.286 0.533216 140.506 0.296136 140.827ZM40.3672 116.644C40.6326 117.471 40.7888 118.33 40.8319 119.197C40.8455 119.577 40.7807 119.956 40.6418 120.309C40.5197 120.642 40.3165 120.938 40.0508 121.171C39.7851 121.404 39.4654 121.567 39.1209 121.644C36.8396 122.237 32.9846 120.585 30.5765 118.636C26.9307 115.806 23.4535 112.764 20.1627 109.526C22.2539 105.829 24.6303 103.775 27.3763 103.298C34.3365 102.08 38.8146 111.115 40.3672 116.644Z",
        fill: "black"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_48_3792",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "150",
          height: "44",
          fill: "white",
          transform: "translate(44) rotate(90)"
        })
      })
    })]
  });
};

var Divider360DownArrow = function Divider360DownArrow(_ref) {
  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_Divider, {
    slice: slice,
    mobile: DividerSVG,
    desktop: DividerSVG
  });
};

/* harmony default export */ var variations_Divider360DownArrow = (Divider360DownArrow);
;// CONCATENATED MODULE: ./slices/Divider/variations/Divider360TripleBackflip.tsx





var Divider360TripleBackflip_DividerMobile = function DividerMobile() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "209",
    height: "28",
    viewBox: "0 0 209 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      clipPath: "url(#clip0_39_6072)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M130.949 27.9903C127.184 28.0781 123.436 27.4785 119.91 26.224C116.886 25.0638 114.242 23.1618 112.248 20.7128C109.262 21.7992 106.166 22.5916 103.009 23.0775C95.7188 24.0982 88.3467 24.4988 80.981 24.2744C75.2322 24.2068 69.6768 23.9559 64.7013 21.6201C62.8931 20.7689 61.257 19.6221 59.8683 18.2323C58.8508 18.8597 57.8333 19.4485 56.7243 20.0083C48.0324 24.3117 38.3201 26.4228 28.5202 26.1388C18.7202 25.8549 9.16182 23.1854 0.763047 18.3868C0.468394 18.169 0.268153 17.8563 0.200244 17.5079C0.132336 17.1595 0.201476 16.7995 0.394571 16.4962C0.587666 16.1929 0.891307 15.9673 1.24799 15.8621C1.60467 15.757 1.98963 15.7795 2.32996 15.9255C10.2689 20.4666 19.3064 22.9931 28.5726 23.2619C37.8389 23.5307 47.0221 21.5327 55.2388 17.4602C55.9714 17.0934 56.9074 16.5915 57.9249 15.9545C56.2775 13.6348 55.5892 10.8205 55.9917 8.04963C56.309 6.42354 57.0614 4.90205 58.1767 3.63108C59.292 2.36012 60.7329 1.38231 62.3611 0.79144C63.6437 0.233524 65.0599 0.0100678 66.4638 0.144093C67.8678 0.278118 69.2086 0.764777 70.3483 1.55394C70.548 1.69477 70.7074 1.88062 70.8122 2.09466C70.9171 2.3087 70.9639 2.54416 70.9486 2.77972C70.6637 7.72146 67.6011 12.5474 62.3611 16.5239C63.4358 17.5461 64.6801 18.3939 66.0444 19.0334C70.4501 21.0989 75.6392 21.3209 81.0115 21.3885C88.1954 21.622 95.3869 21.2473 102.501 20.2689C105.274 19.8348 107.999 19.1562 110.64 18.242C109.899 16.755 109.494 15.1376 109.45 13.4933C109.451 11.8475 109.851 10.2239 110.618 8.74793C111.385 7.27191 112.5 5.98289 113.876 4.98034C114.971 4.11371 116.265 3.50393 117.655 3.20041C119.044 2.89689 120.489 2.90818 121.873 3.23336C122.964 3.48119 123.95 4.03638 124.702 4.82591C126.594 6.92036 125.719 9.93174 124.275 12.0455C121.979 15.2756 118.819 17.8675 115.117 19.5546C116.74 21.3186 118.785 22.6886 121.08 23.5505C125.862 25.3747 131.255 25.2589 136.454 24.8631C147.738 23.9848 157.516 21.7842 165.706 18.2806C164.76 16.7411 164.304 14.9743 164.394 13.1941C164.495 8.80247 167.243 4.67148 171.74 2.1427C176.237 -0.386085 181.375 -0.694944 185.496 1.32229C185.729 1.43928 185.927 1.61047 186.071 1.8198C186.215 2.02913 186.301 2.26976 186.32 2.51912C186.565 6.27369 184.285 10.009 179.585 13.6284C177.136 15.5021 174.522 17.1716 171.77 18.6184C172.076 18.686 172.381 18.7342 172.696 18.7921C184.13 20.6653 195.828 20.5279 207.209 18.3868C207.406 18.3519 207.609 18.3542 207.805 18.3935C208.001 18.4329 208.187 18.5085 208.352 18.616C208.518 18.7236 208.659 18.861 208.768 19.0204C208.878 19.1798 208.953 19.358 208.99 19.545C209.027 19.7319 209.024 19.9239 208.983 20.11C208.941 20.296 208.861 20.4725 208.748 20.6294C208.635 20.7862 208.49 20.9204 208.322 21.0241C208.154 21.1279 207.966 21.1992 207.769 21.234C196.026 23.45 183.953 23.5907 172.157 21.6491C170.719 21.4796 169.325 21.0712 168.036 20.4426C159.306 24.3709 148.816 26.8225 136.678 27.7587C134.795 27.8938 132.872 27.9903 130.949 27.9903ZM119.696 5.7911C118.259 5.83655 116.878 6.33205 115.769 7.20026C114.771 7.92904 113.96 8.86233 113.396 9.93034C112.832 10.9984 112.53 12.1735 112.513 13.3678C112.545 14.6428 112.864 15.8965 113.449 17.0451C116.789 15.5832 119.646 13.2839 121.711 10.395C122.586 9.12098 123.125 7.49947 122.382 6.64046C122.022 6.31076 121.57 6.08626 121.08 5.99378C120.631 5.86604 120.165 5.79784 119.696 5.7911V5.7911ZM179.605 2.89554C177.366 2.92255 175.176 3.5228 173.266 4.63287C171.6 5.48387 170.188 6.72173 169.163 8.23074C168.139 9.73975 167.534 11.4706 167.405 13.2616C167.327 14.5798 167.683 15.8884 168.423 17.0065C171.671 15.4337 174.739 13.5481 177.58 11.3795C181.091 8.68665 182.963 6.0517 183.176 3.53256C182.037 3.11344 180.827 2.89748 179.605 2.89554V2.89554ZM65.8002 3.02102C65.013 3.02738 64.2349 3.18156 63.5109 3.47465C62.3784 3.88467 61.3729 4.55841 60.587 5.43381C59.8011 6.30921 59.26 7.35813 59.0136 8.48396C58.7462 10.5123 59.2475 12.5649 60.4279 14.2751C63.7551 11.7656 67.184 8.11719 67.8046 3.47465C67.1822 3.17898 66.4963 3.02373 65.8002 3.02102V3.02102Z",
        fill: "black"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_39_6072",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "209",
          height: "28",
          fill: "white"
        })
      })
    })]
  });
};

var Divider360TripleBackflip_DividerDesktop = function DividerDesktop() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "298",
    height: "40",
    viewBox: "0 0 298 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      clipPath: "url(#clip0_39_6358)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M186.896 40.0391C181.589 40.1735 176.306 39.3047 171.336 37.4805C166.957 35.7497 163.155 32.8663 160.35 29.1504C155.967 30.8382 151.41 32.0562 146.758 32.7832C136.262 34.5312 125.446 34.6582 115.319 34.541C107.18 34.4434 99.3402 34.082 92.2895 30.7031C89.5968 29.3791 87.1789 27.5777 85.1588 25.3906C83.5668 26.4494 81.9201 27.4272 80.2252 28.3203C67.8738 34.6238 54.0716 37.7137 40.1458 37.293C26.22 36.8723 12.6392 32.955 0.709312 25.918C0.404776 25.6997 0.195776 25.377 0.124137 25.0145C0.0524978 24.6519 0.123505 24.2763 0.322948 23.9628C0.52239 23.6493 0.835556 23.421 1.19977 23.3236C1.56399 23.2262 1.95239 23.2669 2.28725 23.4375C13.7694 30.2067 26.84 33.9726 40.2413 34.3728C53.6427 34.773 66.9239 31.7941 78.8071 25.7227C80.3429 24.9214 81.8362 24.0447 83.2812 23.0957C80.7882 19.7072 79.7162 15.514 80.2852 11.3769C80.7095 9.09306 81.7216 6.95243 83.2259 5.15678C84.7303 3.36112 86.6775 1.96958 88.8839 1.11328C90.6143 0.335832 92.5249 0.0219895 94.4201 0.203878C96.3153 0.385766 98.127 1.05685 99.6698 2.14843C99.8634 2.2947 100.017 2.4851 100.118 2.703C100.219 2.9209 100.264 3.15967 100.249 3.39843C99.8695 10.7422 95.3355 17.8516 87.6256 23.6621C89.3388 25.4597 91.3684 26.9416 93.6177 28.0371C100.059 31.1426 107.599 31.4844 115.359 31.5723C125.346 31.6895 136.002 31.5723 146.259 29.8633C150.541 29.188 154.741 28.0852 158.792 26.5723C157.561 24.2886 156.877 21.7603 156.795 19.1797C156.8 16.8529 157.351 14.5582 158.405 12.4724C159.46 10.3865 160.989 8.56512 162.877 7.14843C164.361 5.93574 166.116 5.08189 168.001 4.65604C169.885 4.23018 171.845 4.24431 173.723 4.69726C175.146 5.03238 176.433 5.77742 177.418 6.83593C179.875 9.64843 178.686 13.7695 176.739 16.6894C173.349 21.5901 168.637 25.4771 163.127 27.9199C165.575 30.9533 168.79 33.3096 172.455 34.7559C179.445 37.5 187.305 37.3242 194.785 36.709C211.364 35.4004 225.745 32.0117 237.659 26.6016C236.043 24.3147 235.259 21.5636 235.432 18.7891C235.582 12.5391 239.427 6.65039 245.629 3.0371C251.831 -0.576177 258.981 -0.976567 264.654 1.875C264.885 1.99035 265.081 2.1628 265.223 2.37522C265.365 2.58764 265.448 2.83264 265.463 3.08593C265.812 8.39843 262.656 13.7305 256.075 18.9258C252.141 22.0199 247.914 24.7405 243.452 27.0508C244.46 27.3457 245.488 27.5741 246.528 27.7344C262.986 30.525 279.829 30.323 296.213 27.1387C296.593 27.0833 296.982 27.1735 297.296 27.3905C297.611 27.6075 297.828 27.9346 297.903 28.3041C297.977 28.6735 297.903 29.0568 297.697 29.3744C297.49 29.692 297.166 29.9195 296.792 30.0098C280.049 33.26 262.838 33.4686 246.018 30.625C243.916 30.3757 241.882 29.736 240.026 28.7402C227.522 34.5996 212.462 38.2324 195.015 39.6191C192.358 39.834 189.632 40.0391 186.896 40.0391ZM170.777 7.23632C168.562 7.29072 166.431 8.07146 164.725 9.45312C163.211 10.5948 161.98 12.0567 161.126 13.7293C160.271 15.4019 159.815 17.2418 159.791 19.1113C159.858 21.3052 160.442 23.4542 161.499 25.3906C166.648 23.1787 171.059 19.5992 174.232 15.0586C175.521 13.1055 176.529 10.293 175.141 8.71093C174.54 8.10272 173.769 7.68148 172.924 7.5C172.223 7.32106 171.501 7.23242 170.777 7.23632ZM256.584 2.92968C253.255 2.97052 249.998 3.88811 247.157 5.58593C241.814 8.68164 238.548 13.6523 238.428 18.8867C238.428 20.2051 238.548 23.2812 240.426 25.2832C245.318 22.8936 249.935 19.9996 254.198 16.6504C259.6 12.3828 262.387 8.16406 262.487 4.11132C260.625 3.32105 258.614 2.91863 256.584 2.92968ZM93.5778 3.11523C92.3568 3.12669 91.1495 3.36875 90.0224 3.82812C88.3018 4.48133 86.776 5.54577 85.5844 6.92416C84.3929 8.30255 83.5735 9.95095 83.2013 11.7187C82.7788 15.1169 83.6849 18.5457 85.738 21.3184C90.8913 17.4121 96.4141 11.6113 97.193 4.02343C96.0944 3.40589 94.8448 3.09196 93.5778 3.11523Z",
        fill: "black"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_39_6358",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "298",
          height: "40",
          fill: "white"
        })
      })
    })]
  });
};

var Divider360TripleBackflip = function Divider360TripleBackflip(_ref) {
  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_Divider, {
    slice: slice,
    mobile: Divider360TripleBackflip_DividerMobile,
    desktop: Divider360TripleBackflip_DividerDesktop
  });
};

/* harmony default export */ var variations_Divider360TripleBackflip = (Divider360TripleBackflip);
;// CONCATENATED MODULE: ./slices/Divider/variations/DividerTripleArrowDown.tsx





var DividerTripleArrowDown_DividerSVG = function DividerSVG() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    width: "82",
    height: "60",
    viewBox: "0 0 82 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      clipPath: "url(#clip0_50_3819)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M81.2275 30.2166C81.9527 29.816 82.2157 28.9034 81.8151 28.1783C81.4145 27.4531 80.5019 27.1901 79.7768 27.5907L72.4079 31.6618C74.4085 27.2949 75.9786 22.748 77.0792 18.0857C77.2695 17.2794 76.7702 16.4715 75.9639 16.2812C75.1576 16.0909 74.3497 16.5902 74.1594 17.3964C73.0817 21.9619 71.533 26.416 69.5517 30.6918C67.8746 28.2386 65.8438 26.0111 63.5358 24.0975C62.8981 23.5688 61.9524 23.6571 61.4237 24.2948C60.8949 24.9326 60.9833 25.8782 61.621 26.407C64.2179 28.5601 66.4238 31.148 68.1079 34.0113C68.1141 34.5037 68.3632 34.9781 68.7981 35.2564C68.8074 35.2741 68.8165 35.2917 68.8257 35.3094C69.012 35.6687 69.3356 35.9374 69.7229 36.0546C70.1102 36.1718 70.5285 36.1275 70.8827 35.9318L81.2275 30.2166ZM49.5121 20.7307C49.87 19.9836 49.5545 19.0878 48.8074 18.7299C48.0603 18.3719 47.1645 18.6874 46.8066 19.4345C43.8896 25.5231 40.7001 31.4923 37.2534 37.317C36.2577 25.3083 35.1054 13.309 33.804 1.32633C33.7188 0.541645 33.04 -0.04275 32.2514 -0.0104441C31.4627 0.0218618 30.834 0.659815 30.8133 1.44885L30.7334 4.48506C30.7211 4.95214 30.9237 5.37496 31.2512 5.65877C32.3221 15.7817 33.2858 25.9156 34.1377 36.0559C33.7876 35.7763 33.442 35.5192 33.1191 35.2867L33.1184 35.2862C28.124 31.6944 23.784 27.2745 20.3596 22.2716C19.8917 21.588 18.9582 21.4131 18.2746 21.881C17.5909 22.349 17.4161 23.2825 17.884 23.9661C21.5091 29.2622 26.0958 33.9309 31.3661 37.7213C32.3798 38.4512 33.3575 39.2521 33.977 40.0759C34.5876 40.8879 34.666 41.4543 34.4797 41.9325C34.1983 42.6545 34.5132 43.4719 35.2061 43.8187C35.8991 44.1654 36.742 43.9272 37.1512 43.2692C41.6833 35.9797 45.8137 28.4503 49.5121 20.7307ZM23.6019 46.1796C24.3574 46.5195 24.6943 47.4075 24.3544 48.163L19.4216 59.1271C19.0905 59.8629 18.2367 60.205 17.4891 59.9014C16.7416 59.5977 16.3682 58.7571 16.6441 57.9988L16.6448 57.9969C16.6551 57.9691 16.7028 57.8416 16.462 57.4752C16.2075 57.0881 15.7768 56.6722 15.2624 56.2461C9.76168 51.7361 4.74635 46.6719 0.32781 41.1635C-0.190554 40.5173 -0.0869005 39.5732 0.559317 39.0548C1.20553 38.5365 2.1496 38.6401 2.66797 39.2863C6.64364 44.2426 11.119 48.8304 16.0078 52.9631L13.9982 36.2666C13.8992 35.4441 14.4857 34.6971 15.3082 34.5981C16.1307 34.4991 16.8777 35.0856 16.9767 35.9081L19.0032 52.7451L21.6185 46.9321C21.9584 46.1766 22.8464 45.8397 23.6019 46.1796Z",
        fill: "#0F0F11"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "clip0_50_3819",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: "60",
          height: "82",
          fill: "white",
          transform: "translate(82) rotate(90)"
        })
      })
    })]
  });
};

var DividerTripleArrowDown = function DividerTripleArrowDown(_ref) {
  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_Divider, {
    slice: slice,
    mobile: DividerTripleArrowDown_DividerSVG,
    desktop: DividerTripleArrowDown_DividerSVG
  });
};

/* harmony default export */ var variations_DividerTripleArrowDown = (DividerTripleArrowDown);
;// CONCATENATED MODULE: ./slices/Divider/index.tsx








var Divider_Divider = function Divider(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case DividerVariations.d360:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_Divider360, {
        slice: slice
      });

    case DividerVariations.d360TripleBackflip:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_Divider360TripleBackflip, {
        slice: slice
      });

    case DividerVariations.d360DownArrow:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_Divider360DownArrow, {
        slice: slice
      });

    case DividerVariations.tripleArrowDown:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_DividerTripleArrowDown, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var slices_Divider = (Divider_Divider);
;// CONCATENATED MODULE: ./slices/Embed/index.tsx




var Embed = function Embed(_ref) {
  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    children: slice.primary.url.url && /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
      frameBorder: "0",
      src: prismic_reactjs.Link.url(slice.primary.url),
      title: slice.primary.a11yTitle,
      height: slice.primary.height,
      className: "w-full"
    })
  });
};

/* harmony default export */ var slices_Embed = (Embed);
;// CONCATENATED MODULE: ./slices/Faq/variations/FaqOffsetLeft.tsx






var FaqOffsetLeft = function FaqOffsetLeft(_ref) {
  var _slice$items;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-white",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-20 lg:px-8",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "lg:grid lg:grid-cols-3 lg:gap-8",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "dh-title dark:text-gray-900",
            children: prismic_reactjs.RichText.asText(slice.primary.title)
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "dh-description dark:text-gray-500",
            children: prismic_reactjs.RichText.asText(slice.primary.description)
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-12 lg:mt-0 lg:col-span-2",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("dl", {
            className: "space-y-12",
            children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (faq) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
                  className: "text-lg leading-6 font-medium text-gray-900",
                  children: faq.question
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
                  className: "mt-2 text-base text-gray-500",
                  children: prismic_reactjs.RichText.asText(faq.answer)
                })]
              }, (0,index_browser/* nanoid */.x0)());
            })
          })
        })]
      })
    })
  });
};

/* harmony default export */ var variations_FaqOffsetLeft = (FaqOffsetLeft);
;// CONCATENATED MODULE: ./slices/Faq/variations/FaqColumns.tsx






var FaqColumns = function FaqColumns(_ref) {
  var _slice$items;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-white",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: "text-3xl font-extrabold text-gray-900 text-center",
        children: prismic_reactjs.RichText.asText(slice.primary.title)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mt-12",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("dl", {
          className: "space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-12 lg:grid-cols-3",
          children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (faq) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
                className: "text-lg leading-6 font-medium text-gray-900",
                children: faq.question
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
                className: "mt-2 text-base text-gray-500",
                children: prismic_reactjs.RichText.asText(faq.answer)
              })]
            }, (0,index_browser/* nanoid */.x0)());
          })
        })
      })]
    })
  });
};

/* harmony default export */ var variations_FaqColumns = (FaqColumns);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.esm.js
var disclosure_esm = __webpack_require__(1228);
;// CONCATENATED MODULE: ./slices/Faq/variations/FaqAccordion.tsx











var MAX_SIZE = 3;

var FaqAccordion = function FaqAccordion(_ref) {
  var _slice$items, _slice$primary;

  var slice = _ref.slice;
  var intl = (0,useIntl/* default */.Z)();

  var _useState = (0,react.useState)(),
      expanded = _useState[0],
      setExpanded = _useState[1];

  var _useState2 = (0,react.useState)([]),
      items = _useState2[0],
      setItems = _useState2[1];

  var size = slice === null || slice === void 0 ? void 0 : (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.length;
  var isExpandable = size > MAX_SIZE;
  var seeMoreLabel = intl.formatMessage({
    id: "C2oD0J",
    defaultMessage: [{
      "type": 0,
      "value": "Ver más"
    }]
  });
  var seeLessLabel = intl.formatMessage({
    id: "oqJulP",
    defaultMessage: [{
      "type": 0,
      "value": "Ver menos"
    }]
  });
  (0,react.useEffect)(function () {
    var _slice$items2;

    setItems(expanded ? slice.items : slice === null || slice === void 0 ? void 0 : (_slice$items2 = slice.items) === null || _slice$items2 === void 0 ? void 0 : _slice$items2.slice(0, MAX_SIZE));
  }, [expanded, slice.items, setItems]);
  return size ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-athensGray",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "dh-content",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "max-w-3xl mx-auto",
        children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-col sm:flex-row",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "dh-title text-left flex-none dark:text-gray-900",
            children: prismic_reactjs.RichText.asText(slice.primary.title)
          }), isExpandable && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-full flex sm:justify-end",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              type: "button",
              className: "text-primary underline cursor-pointer",
              onClick: function onClick() {
                return setExpanded(function (prev) {
                  return !prev;
                });
              },
              children: expanded ? seeLessLabel : seeMoreLabel
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("dl", {
          className: "mt-6 pb-5 space-y-6 divide-y divide-gray-200",
          children: items === null || items === void 0 ? void 0 : items.map(function (faq) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(disclosure_esm/* Disclosure */.p, {
              as: "div",
              className: "pt-6",
              children: function children(_ref2) {
                var open = _ref2.open;
                return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
                    className: "text-lg",
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(disclosure_esm/* Disclosure.Button */.p.Button, {
                      className: "text-left w-full flex justify-between items-start text-gray-400",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "font-medium text-gray-900",
                        children: faq.question
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "ml-3 lg:ml-6 h-7 flex items-center",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* ChevronDownIcon */.v4q, {
                          className: classnames_default()(open ? '-rotate-180' : 'rotate-0', 'h-6 w-6 transform'),
                          "aria-hidden": "true"
                        })
                      })]
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(disclosure_esm/* Disclosure.Panel */.p.Panel, {
                    as: "dd",
                    className: "mt-2 pr-12",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "text-base text-gray-5",
                      children: prismic_reactjs.RichText.asText(faq.answer)
                    })
                  })]
                });
              }
            }, (0,index_browser/* nanoid */.x0)());
          })
        })]
      })
    })
  }) : null;
};

/* harmony default export */ var variations_FaqAccordion = (FaqAccordion);
;// CONCATENATED MODULE: ./slices/Faq/variations/FaqAccordionCentered.tsx












var FaqAccordionCentered = function FaqAccordionCentered(_ref) {
  var _slice$_vertical, _slice$_vertical$data, _slice$primary, _slice$items;

  var slice = _ref.slice;
  var color = (0,colors/* getColor */.Lq)(slice === null || slice === void 0 ? void 0 : (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : (_slice$_vertical$data = _slice$_vertical.data) === null || _slice$_vertical$data === void 0 ? void 0 : _slice$_vertical$data.color);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "dark:bg-gray-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content lg:pb-10",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "max-w-3xl mx-auto text-center py-8",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "dh-title",
          children: slice.primary.title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "max-w-3xl mx-auto divide-y-2 divide-gray-200",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("dl", {
          className: "divide-y divide-gray-200",
          children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (item, i) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(disclosure_esm/* Disclosure */.p, {
              as: "div",
              children: function children() {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
                    className: "text-lg",
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(disclosure_esm/* Disclosure.Button */.p.Button, {
                      className: classnames_default()('text-left w-full flex items-start space-x-4 space-y-0 text-white bg-gray-900', 'py-4 px-4 sm:px-6 lg:rounded-lg lg:px-16'),
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: classnames_default()('text-2xl font-bold lg:text-4xl lg:font-semibold lg:text-center lg:w-24 lg:mr-8', color.text),
                        children: (0,common/* addExtraZeros */.rf)(i + 1)
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "grow self-center text-xs lg:text-lg font-semibold text-white lg:max-w-md",
                        children: item.title
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "h-7 flex items-center self-center",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* SelectorIcon */.Ta4, {
                          className: "h-6 w-6",
                          "aria-hidden": "true"
                        })
                      })]
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(disclosure_esm/* Disclosure.Panel */.p.Panel, {
                    as: "dd",
                    className: "p-7 bg-gray-700 lg:rounded-b-lg lg:px-16 lg:py-6",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "text-sm lg:text-lg font-normal text-white",
                      children: prismic_reactjs.RichText.asText(item.description)
                    })
                  })]
                });
              }
            }, (0,index_browser/* nanoid */.x0)());
          })
        })
      })]
    })
  });
};

/* harmony default export */ var variations_FaqAccordionCentered = (FaqAccordionCentered);
;// CONCATENATED MODULE: ./slices/Faq/index.tsx






var FaqVariations;

(function (FaqVariations) {
  FaqVariations["offsetLeft"] = "faqOffsetLeft";
  FaqVariations["columns"] = "faqColumns";
  FaqVariations["accordionCentered"] = "faqAccordionCentered";
  FaqVariations["accordion"] = "faqAccordion";
  FaqVariations["accordionProduct"] = "faqAccordionProduct";
})(FaqVariations || (FaqVariations = {}));

var Faq = function Faq(_ref) {
  var _slice$_cluster, _slice$_cluster$data, _slice$_cluster$data$;

  var slice = _ref.slice;
  var clusterSlice = (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : (_slice$_cluster$data = _slice$_cluster.data) === null || _slice$_cluster$data === void 0 ? void 0 : (_slice$_cluster$data$ = _slice$_cluster$data.slices) === null || _slice$_cluster$data$ === void 0 ? void 0 : _slice$_cluster$data$.find(function (_ref2) {
    var variation = _ref2.variation;
    return variation === FaqVariations.accordion;
  });

  switch (slice.variation) {
    case FaqVariations.offsetLeft:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FaqOffsetLeft, {
        slice: slice
      });

    case FaqVariations.columns:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FaqColumns, {
        slice: slice
      });

    case FaqVariations.accordionCentered:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FaqAccordionCentered, {
        slice: slice
      });

    case FaqVariations.accordionProduct:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FaqAccordion, {
        slice: clusterSlice || {}
      });

    case FaqVariations.accordion:
    default:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FaqAccordion, {
        slice: slice
      });
  }
};

/* harmony default export */ var slices_Faq = (Faq);
;// CONCATENATED MODULE: ./slices/Feature/Feature.types.ts
var FeatureVariations;

(function (FeatureVariations) {
  FeatureVariations["leftIcons"] = "featureLeftIcons";
  FeatureVariations["rightIcons"] = "featureRightIcons";
  FeatureVariations["withList"] = "featureWithList";
  FeatureVariations["withListLight"] = "featureWithListLight";
  FeatureVariations["withGridList"] = "featureWithGridList";
  FeatureVariations["simpleList"] = "featureSimpleList";
})(FeatureVariations || (FeatureVariations = {}));
;// CONCATENATED MODULE: ./slices/Feature/variations/FeatureLeftIcons.tsx








var FeatureLeftIcons = function FeatureLeftIcons(_ref) {
  var _slice$items;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "overflow-hidden",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
        className: "hidden lg:block absolute left-full transform -translate-x-1/2 -translate-y-1/4",
        width: 404,
        height: 784,
        fill: "none",
        viewBox: "0 0 404 784",
        "aria-hidden": "true",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("pattern", {
            id: "b1e6e422-73f8-40a6-b5d9-c8586e37e0e7",
            x: 0,
            y: 0,
            width: 20,
            height: 20,
            patternUnits: "userSpaceOnUse",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
              x: 0,
              y: 0,
              width: 4,
              height: 4,
              className: "text-gray-200",
              fill: "currentColor"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: 404,
          height: 784,
          fill: "url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            className: "dh-title dark:text-gray-900",
            children: prismic_reactjs.RichText.asText(slice.primary.title)
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "dh-description dark:text-gray-500",
            children: prismic_reactjs.RichText.asText(slice.primary.description)
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("dl", {
            className: "mt-10 space-y-10",
            children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("dt", {
                  children: [item.icon.url && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: classnames_default()('absolute flex items-center justify-center h-12 w-12 rounded-md bg-primary-600 text-white'),
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "w-6 h-6",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                        src: item.icon.url,
                        alt: item.icon.alt,
                        width: item.icon.dimensions.width,
                        height: item.icon.dimensions.height,
                        layout: "intrinsic",
                        "aria-hidden": "true"
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: classnames_default()(item.icon.url ? 'ml-16' : '', 'text-lg leading-6 font-medium text-gray-900'),
                    children: item.name
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
                  className: classnames_default()(item.icon.url ? 'ml-16' : '', 'mt-2 text-base text-gray-500'),
                  children: prismic_reactjs.RichText.asText(item.description)
                })]
              }, (0,index_browser/* nanoid */.x0)());
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mt-10 -mx-4 relative lg:mt-0",
          "aria-hidden": "true",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
            className: "absolute left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden",
            width: 784,
            height: 404,
            fill: "none",
            viewBox: "0 0 784 404",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("pattern", {
                id: "ca9667ae-9f92-4be7-abcb-9e3d727f2941",
                x: 0,
                y: 0,
                width: 20,
                height: 20,
                patternUnits: "userSpaceOnUse",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
                  x: 0,
                  y: 0,
                  width: 4,
                  height: 4,
                  className: "text-gray-200",
                  fill: "currentColor"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
              width: 784,
              height: 404,
              fill: "url(#ca9667ae-9f92-4be7-abcb-9e3d727f2941)"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              className: "rounded-lg md:rounded-2xl",
              src: slice.primary.image.url,
              alt: slice.primary.image.alt,
              width: slice.primary.image.dimensions.width,
              height: slice.primary.image.dimensions.height,
              layout: "intrinsic"
            })
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var variations_FeatureLeftIcons = (FeatureLeftIcons);
;// CONCATENATED MODULE: ./slices/Feature/variations/FeatureRightIcons.tsx








var FeatureRightIcons = function FeatureRightIcons(_ref) {
  var _slice$items;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "overflow-hidden",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
        className: "hidden lg:block absolute right-full transform translate-x-1/2 translate-y-12",
        width: 404,
        height: 784,
        fill: "none",
        viewBox: "0 0 404 784",
        "aria-hidden": "true",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("pattern", {
            id: "64e643ad-2176-4f86-b3d7-f2c5da3b6a6d",
            x: 0,
            y: 0,
            width: 20,
            height: 20,
            patternUnits: "userSpaceOnUse",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
              x: 0,
              y: 0,
              width: 4,
              height: 4,
              className: "text-gray-200",
              fill: "currentColor"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
          width: 404,
          height: 784,
          fill: "url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "lg:col-start-2",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "dh-title dark:text-gray-900",
              children: prismic_reactjs.RichText.asText(slice.primary.title)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "dh-description dark:text-gray-500",
              children: prismic_reactjs.RichText.asText(slice.primary.description)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("dl", {
              className: "mt-10 space-y-10",
              children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (item) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "relative",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("dt", {
                    children: [item.icon.url && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: classnames_default()('absolute flex items-center justify-center h-12 w-12 rounded-md', 'bg-primary-600 text-white'),
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "w-6 h-6",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                          src: item.icon.url,
                          alt: item.icon.alt,
                          width: item.icon.dimensions.width,
                          height: item.icon.dimensions.height,
                          layout: "intrinsic",
                          "aria-hidden": "true"
                        })
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: classnames_default()(item.icon.url ? 'ml-16' : '', 'text-lg leading-6 font-medium text-gray-900'),
                      children: item.name
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
                    className: classnames_default()(item.icon.url ? 'ml-16' : '', 'mt-2 text-base text-gray-500'),
                    children: prismic_reactjs.RichText.asText(item.description)
                  })]
                }, (0,index_browser/* nanoid */.x0)());
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mt-10 -mx-4 relative lg:mt-0 lg:col-start-1",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
              className: "absolute left-1/2 transform -translate-x-1/2 translate-y-16 lg:hidden",
              width: 784,
              height: 404,
              fill: "none",
              viewBox: "0 0 784 404",
              "aria-hidden": "true",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("pattern", {
                  id: "e80155a9-dfde-425a-b5ea-1f6fadd20131",
                  x: 0,
                  y: 0,
                  width: 20,
                  height: 20,
                  patternUnits: "userSpaceOnUse",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
                    x: 0,
                    y: 0,
                    width: 4,
                    height: 4,
                    className: "text-gray-200",
                    fill: "currentColor"
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
                width: 784,
                height: 404,
                fill: "url(#e80155a9-dfde-425a-b5ea-1f6fadd20131)"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-center",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                className: "rounded-lg md:rounded-2xl",
                src: slice.primary.image.url,
                alt: slice.primary.image.alt,
                width: slice.primary.image.dimensions.width,
                height: slice.primary.image.dimensions.height,
                layout: "intrinsic"
              })
            })]
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var variations_FeatureRightIcons = (FeatureRightIcons);
;// CONCATENATED MODULE: ./slices/Feature/variations/FeatureSimpleList.tsx







var FeatureSimpleList_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});

var FeatureSimpleList = function FeatureSimpleList(_ref) {
  var _slice$items, _slice$primary, _slice$items2;

  var slice = _ref.slice;
  return (_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-gray-2",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        className: "text-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "font-semibold text-3.5xl text-white mb-8",
          children: slice.primary.title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: "bg-gray-3 rounded-2xl p-8 max-w-[48rem] m-auto space-y-6",
        children: (_slice$items2 = slice.items) === null || _slice$items2 === void 0 ? void 0 : _slice$items2.map(function (_ref2) {
          var title = _ref2.title,
              description = _ref2.description;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "flex gap-6 items-start",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: classnames_default()('relative before:w-6 before:h-6 before:top-1 before:left-1', 'before:rounded-full before:bg-white before:block before:absolute'),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(FeatureSimpleList_Icon, {
                icon: "check-circle-solid",
                className: "w-8 flex-none text-primary row-span-2 relative z-10"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "font-semibold text-xl leading-8 text-athensGray mb-1",
                children: title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "font-archivo text-sm leading-6 text-white-2",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                  render: description
                })
              })]
            })]
          }, (0,index_browser/* nanoid */.x0)());
        })
      })]
    })
  }) : null;
};

/* harmony default export */ var variations_FeatureSimpleList = (FeatureSimpleList);
;// CONCATENATED MODULE: ./slices/Feature/variations/FeatureWithGridList.tsx







var FeatureWithGridList = function FeatureWithGridList(_ref) {
  var _slice$primary, _slice$items;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-white",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "font-bold text-2xl text-gray-800 mb-8",
          children: slice.primary.title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: "grid lg:gap-x-48 gap-y-5 lg:grid-cols-2",
        children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (_ref2) {
          var description = _ref2.description;
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: classnames_default()('list-none flex text-gray-800 text-sm font-normal items-start', 'before:flex-none before:inline-block before:-mt-3 before:mr-4', "before:content-['•'] before:text-3xl before:text-primary"),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
              render: description
            })
          }, (0,index_browser/* nanoid */.x0)());
        })
      })]
    })
  });
};

/* harmony default export */ var variations_FeatureWithGridList = (FeatureWithGridList);
;// CONCATENATED MODULE: ./slices/Feature/variations/FeatureWithList.tsx









var FeatureWithList = function FeatureWithList(_ref) {
  var _slice$primary, _slice$primary2, _slice$primary3, _slice$items, _slice$items2, _slice$primary4;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-white text-athensGray-100",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()('bg-black rounded-2xl mt-14 mb-7 py-11 mx-4 sm:mx-6 lg:mx-8', {
        'lg:pt-40': (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.bottomText
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "dh-content grid lg:grid-cols-3 lg:gap-x-12 py-0",
        children: [((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title) && /*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
          className: "pr-16",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "font-bold text-2xl mb-8",
            children: slice.primary.title
          }), (0,prismic/* hasRichText */.M)((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-xs my-richtext-2 text-white",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
              render: slice.primary.description
            })
          })]
        }), !!((_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: "lg:col-span-2 grid gap-8 my-6 sm:my-0 sm:gap-12 sm:grid-cols-3 sm:mt-16 lg:mt-0",
          children: (_slice$items2 = slice.items) === null || _slice$items2 === void 0 ? void 0 : _slice$items2.map(function (_ref2) {
            var label = _ref2.label,
                text = _ref2.text,
                logo = _ref2.logo;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              className: "list-none sm:text-center text-sm font-normal dark:text-athensGray-100",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "rounded-md bg-primary font-bold text-2xl inline-block px-2 py-1 mb-3 sm:mb-6",
                children: label
              }), (0,prismic/* hasRichText */.M)(text) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "dark:text-white text-xs font-normal leading-5",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                  render: text
                })
              }), !!(logo !== null && logo !== void 0 && logo.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "text-center mt-3 sm:mt-6",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: logo === null || logo === void 0 ? void 0 : logo.url,
                  alt: logo === null || logo === void 0 ? void 0 : logo.alt,
                  height: logo === null || logo === void 0 ? void 0 : logo.dimensions.height,
                  width: logo === null || logo === void 0 ? void 0 : logo.dimensions.width
                })
              })]
            }, (0,index_browser/* nanoid */.x0)());
          })
        }), ((_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.bottomText) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()('text-dustyGray font-medium italic text-xs leading-5', 'text-center lg:col-span-2 lg:col-start-2 sm:pt-16'),
          children: slice.primary.bottomText
        })]
      })
    })
  });
};

/* harmony default export */ var variations_FeatureWithList = (FeatureWithList);
;// CONCATENATED MODULE: ./slices/Feature/variations/FeatureWithListLight.tsx






var FeatureWithListLight = function FeatureWithListLight(_ref) {
  var _slice$primary, _slice$items, _slice$items2;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-athensGray-400 text-mineSharft",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content grid lg:grid-cols-3 lg:gap-x-12",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "font-bold text-4xl leading-15 mb-8 lg:mb-0",
          children: slice.primary.title
        })
      }), !!((_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: "lg:col-span-2 grid gap-8 my-6 sm:my-0 sm:gap-12 sm:grid-cols-3 lg:mt-0",
        children: (_slice$items2 = slice.items) === null || _slice$items2 === void 0 ? void 0 : _slice$items2.map(function (_ref2) {
          var label = _ref2.label,
              text = _ref2.text;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "list-none sm:text-center text-sm font-normal",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "font-semibold text-2xl inline-block px-2 py-1 mb-3",
              children: label
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-sm font-medium leading-6",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                render: text
              })
            })]
          }, (0,index_browser/* nanoid */.x0)());
        })
      })]
    })
  });
};

/* harmony default export */ var variations_FeatureWithListLight = (FeatureWithListLight);
;// CONCATENATED MODULE: ./slices/Feature/index.tsx










var Feature = function Feature(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case FeatureVariations.leftIcons:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FeatureLeftIcons, {
        slice: slice
      });

    case FeatureVariations.rightIcons:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FeatureRightIcons, {
        slice: slice
      });

    case FeatureVariations.withList:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FeatureWithList, {
        slice: slice
      });

    case FeatureVariations.withListLight:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FeatureWithListLight, {
        slice: slice
      });

    case FeatureVariations.withGridList:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FeatureWithGridList, {
        slice: slice
      });

    case FeatureVariations.simpleList:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FeatureSimpleList, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var slices_Feature = (Feature);
;// CONCATENATED MODULE: ./slices/Form/Form.types.ts
var FormVariations;

(function (FormVariations) {
  FormVariations["contact"] = "formContact";
  FormVariations["contactBenefitSelect"] = "formContactBenefitSelect";
  FormVariations["contactClusterSelect"] = "formContactClusterSelect";
  FormVariations["contactWithLocation"] = "formContactWithLocation";
  FormVariations["contactCompany"] = "formContactCompany";
  FormVariations["contactSchedule"] = "formContactSchedule";
  FormVariations["contactProducts"] = "formContactProducts";
})(FormVariations || (FormVariations = {}));
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
;// CONCATENATED MODULE: ./slices/Form/variations/FormContact.tsx


function FormContact_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function FormContact_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FormContact_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FormContact_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




















var FormContact_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var FormContact_FormInput = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 547).then(__webpack_require__.bind(__webpack_require__, 547));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(547)];
    }
  }
});

var FormContact = function FormContact(_ref) {
  var _slice$_vertical, _slice$_cluster, _slice$_product, _slice$primary, _slice$primary2, _slice$primary3, _slice$primary4, _slice$primary5, _slice$primary6, _slice$primary7, _slice$primary8, _slice$primary8$benef, _slice$primary9, _slice$primary9$benef, _slice$primary10;

  var slice = _ref.slice;

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track,
      identify = _useAnalytics.identify;

  var intl = (0,useIntl/* default */.Z)();
  var locale = (0,useLocale/* default */.Z)();
  var router = (0,next_router.useRouter)();
  var vertical = slice === null || slice === void 0 ? void 0 : (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var cluster = slice === null || slice === void 0 ? void 0 : (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : _slice$_cluster.data;
  var product = slice === null || slice === void 0 ? void 0 : (_slice$_product = slice._product) === null || _slice$_product === void 0 ? void 0 : _slice$_product.data;
  var color = (0,colors/* getColor */.Lq)(vertical === null || vertical === void 0 ? void 0 : vertical.color);
  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({
    slice: slice,
    cluster: cluster,
    vertical: vertical,
    product: product
  });
  var showBenefitsButton = cluster === null || cluster === void 0 ? void 0 : cluster.showBenefitsButton;

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset;

  var defaultMessages = {
    nameLabel: intl.formatMessage({
      id: "hCOqfl",
      defaultMessage: [{
        "type": 0,
        "value": "Nombre"
      }]
    }),
    lastnameLabel: intl.formatMessage({
      id: "cEArc/",
      defaultMessage: [{
        "type": 0,
        "value": "Apellido"
      }]
    }),
    emailLabel: intl.formatMessage({
      id: "tkwCac",
      defaultMessage: [{
        "type": 0,
        "value": "E-mail"
      }]
    }),
    phoneCodeLabel: intl.formatMessage({
      id: "/0jxhp",
      defaultMessage: [{
        "type": 0,
        "value": "Código de Área"
      }]
    }),
    phoneLabel: intl.formatMessage({
      id: "S6W4PT",
      defaultMessage: [{
        "type": 0,
        "value": "Teléfono"
      }]
    }),
    phonePlaceholder: intl.formatMessage({
      id: "YTgK22",
      defaultMessage: [{
        "type": 0,
        "value": "11 0000 0000"
      }]
    }),
    termsAndConditionsAgree: intl.formatMessage({
      id: "1I7zTd",
      defaultMessage: [{
        "type": 0,
        "value": "Aceptar"
      }]
    }),
    termsAndConditionsLabel: intl.formatMessage({
      id: "o24Y39",
      defaultMessage: [{
        "type": 0,
        "value": "Términos y condiciones"
      }]
    }),
    sendButtonLabel: intl.formatMessage({
      id: "hKJZJR",
      defaultMessage: [{
        "type": 0,
        "value": "Enviar"
      }]
    })
  };

  var dateFormat = function dateFormat(date, language) {
    return (0,dates/* parseDate */.sG)(date, (0,dates/* getCurrentDateLocale */.Et)(dates/* DATE_LOCALES */.DJ, language), 'd MMM');
  };

  var handleClick = (0,react.useCallback)(function (event) {
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'product_name', cluster === null || cluster === void 0 ? void 0 : cluster.name);
    lodash_set_default()(payload, 'label', 'Benefits');
    lodash_set_default()(payload, 'url', event.target.href);
    lodash_set_default()(payload, 'context.label', 'Benefits');
    lodash_set_default()(payload, 'context.destination_url', event.target.href);
    track(constants/* TrackEvents.buttonClicked */.Um.buttonClicked, payload, locale);
  }, [trackPayload, locale, cluster, track]);
  var formTrack = (0,react.useCallback)(function (localeCountry, firstName, lastName, email, phoneCode, phone) {
    var _slice$_product2, _slice$_product2$data, _slice$_product3, _slice$_product3$data, _slice$_product4, _slice$_product4$data, _slice$_product5, _slice$_product5$data, _slice$_product6, _slice$_product6$data, _slice$_product7, _slice$_product7$data;

    var fields = {
      locale_country: localeCountry,
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone: "".concat(phoneCode).concat(phone)
    };
    identify(fields);
    var startDate = (_slice$_product2 = slice._product) !== null && _slice$_product2 !== void 0 && (_slice$_product2$data = _slice$_product2.data) !== null && _slice$_product2$data !== void 0 && _slice$_product2$data.startDate ? dateFormat((_slice$_product3 = slice._product) === null || _slice$_product3 === void 0 ? void 0 : (_slice$_product3$data = _slice$_product3.data) === null || _slice$_product3$data === void 0 ? void 0 : _slice$_product3$data.startDate, locale) : '';
    var startEnd = (_slice$_product4 = slice._product) !== null && _slice$_product4 !== void 0 && (_slice$_product4$data = _slice$_product4.data) !== null && _slice$_product4$data !== void 0 && _slice$_product4$data.endDate ? dateFormat((_slice$_product5 = slice._product) === null || _slice$_product5 === void 0 ? void 0 : (_slice$_product5$data = _slice$_product5.data) === null || _slice$_product5$data === void 0 ? void 0 : _slice$_product5$data.endDate, locale) : '';
    var schedule = ["".concat(startDate, " - ").concat(startEnd), (_slice$_product6 = slice._product) === null || _slice$_product6 === void 0 ? void 0 : (_slice$_product6$data = _slice$_product6.data) === null || _slice$_product6$data === void 0 ? void 0 : _slice$_product6$data.scheduleDays, (_slice$_product7 = slice._product) === null || _slice$_product7 === void 0 ? void 0 : (_slice$_product7$data = _slice$_product7.data) === null || _slice$_product7$data === void 0 ? void 0 : _slice$_product7$data.scheduleHours].join(' | ');
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'product_name', (cluster === null || cluster === void 0 ? void 0 : cluster.name) || 'Unknown');
    lodash_set_default()(payload, 'fields', fields);
    lodash_set_default()(payload, 'fields.schedule', schedule);
    track(constants/* TrackEvents.productApplicationSubmitted */.Um.productApplicationSubmitted, payload, locale, true); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackPayload]);

  var onSubmit = function onSubmit(_ref2) {
    var _localStorage, _localStorage2, _slice$_thankyou;

    var name = _ref2.name,
        lastname = _ref2.lastname,
        email = _ref2.email,
        phonecode = _ref2.phonecode,
        phone = _ref2.phone;
    (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.setItem('formFirstName', name);
    (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.setItem('formVertical', vertical === null || vertical === void 0 ? void 0 : vertical.color);
    formTrack(locale, name, lastname, email, phonecode, phone);
    reset();
    var redirectLink = "".concat(__webpack_require__.g.location.pathname, "/").concat(slice === null || slice === void 0 ? void 0 : (_slice$_thankyou = slice._thankyou) === null || _slice$_thankyou === void 0 ? void 0 : _slice$_thankyou.uid);
    router === null || router === void 0 ? void 0 : router.push({
      pathname: redirectLink
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "dark:bg-gray-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "max-w-3xl mx-auto py-24 lg:py-20 lg:px-4",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: "dh-title mb-11 text-3xl text-center",
        children: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title
      }), ((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "dh-description mb-14 text-center",
        children: slice.primary.description
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("form", {
          onSubmit: handleSubmit(onSubmit),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "overflow-hidden sm:rounded-md text-gray-800 dark:text-gray-300",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "px-4 py-5 sm:p-6",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 gap-6",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContact_FormInput, {
                    label: (0,common/* getDefaultText */.T9)('nameLabel', slice.primary, defaultMessages),
                    placeholder: (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.namePlaceholder,
                    id: "name",
                    required: true,
                    register: register('name', {
                      required: true
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContact_FormInput, {
                    label: (0,common/* getDefaultText */.T9)('lastnameLabel', slice.primary, defaultMessages),
                    placeholder: (_slice$primary5 = slice.primary) === null || _slice$primary5 === void 0 ? void 0 : _slice$primary5.lastnamePlaceholder,
                    id: "lastname",
                    required: true,
                    register: register('lastname', {
                      required: true
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContact_FormInput, {
                    label: (0,common/* getDefaultText */.T9)('emailLabel', slice.primary, defaultMessages),
                    placeholder: (_slice$primary6 = slice.primary) === null || _slice$primary6 === void 0 ? void 0 : _slice$primary6.emailPlaceholder,
                    id: "email",
                    type: "email",
                    required: true,
                    register: register('email', {
                      required: true,
                      pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex gap-6",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "flex-none",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContact_FormInput, {
                      label: (0,common/* getDefaultText */.T9)('phoneCodeLabel', slice.primary, defaultMessages),
                      placeholder: (_slice$primary7 = slice.primary) === null || _slice$primary7 === void 0 ? void 0 : _slice$primary7.phoneCodePlaceholder,
                      id: "phonecode",
                      className: "w-20 lg:w-24",
                      register: register('phonecode', {
                        required: false
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "grow",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContact_FormInput, {
                      label: (0,common/* getDefaultText */.T9)('phoneLabel', slice.primary, defaultMessages),
                      placeholder: (0,common/* getDefaultText */.T9)('phonePlaceholder', slice.primary, defaultMessages),
                      id: "phone",
                      register: register('phone', {
                        required: false
                      })
                    })
                  })]
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "px-4 py-3 text-right sm:px-6",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "relative flex items-start",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "flex items-center h-5",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", FormContact_objectSpread({
                    id: "tyc",
                    "aria-describedby": "agree-terms-and-conditions",
                    type: "checkbox",
                    className: "focus:ring-grey-500 h-4 w-4 text-gey-600 border-gray-300 rounded",
                    required: true
                  }, register('tyc', {
                    required: true
                  })))
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "ml-3 text-sm font-normal",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                    htmlFor: "tyc",
                    className: "mr-2 text-black dark:text-white",
                    children: (0,common/* getDefaultText */.T9)('termsAndConditionsAgree', slice.primary, defaultMessages)
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormContact_LinkWithQuery, {
                    href: prismic_reactjs.Link.url(slice.primary.termsAndConditionsLink, common/* prismicLinkResolver */.LT),
                    target: "_blank",
                    className: classnames_default()('underline', color.text),
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: "sr-only",
                      children: [(0,common/* getDefaultText */.T9)('termsAndConditionsAgree', slice.primary, defaultMessages), ' ']
                    }), (0,common/* getDefaultText */.T9)('termsAndConditionsLabel', slice.primary, defaultMessages)]
                  })]
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "grid lg:grid-cols-2 gap-6 px-4 py-3 text-right sm:px-6",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                type: "submit",
                className: classnames_default()('dh-button', color.bg, color.bgHover, color.textContrast),
                children: (0,common/* getDefaultText */.T9)('sendButtonLabel', slice.primary, defaultMessages)
              }), showBenefitsButton && (((_slice$primary8 = slice.primary) === null || _slice$primary8 === void 0 ? void 0 : (_slice$primary8$benef = _slice$primary8.benefitsButtonLink) === null || _slice$primary8$benef === void 0 ? void 0 : _slice$primary8$benef.uid) || ((_slice$primary9 = slice.primary) === null || _slice$primary9 === void 0 ? void 0 : (_slice$primary9$benef = _slice$primary9.benefitsButtonLink) === null || _slice$primary9$benef === void 0 ? void 0 : _slice$primary9$benef.url)) && /*#__PURE__*/(0,jsx_runtime.jsx)(FormContact_LinkWithQuery, {
                onClick: handleClick,
                href: prismic_reactjs.Link.url((_slice$primary10 = slice.primary) === null || _slice$primary10 === void 0 ? void 0 : _slice$primary10.benefitsButtonLink, common/* prismicLinkResolver */.LT),
                target: "_blank",
                className: classnames_default()('dh-button border border-black dark:border-white text-black dark:text-white', 'bg-transparent hover:bg-transparent'),
                children: (0,common/* getDefaultText */.T9)('benefitsButtonLabel', slice.primary, defaultMessages)
              })]
            })]
          })
        })
      })]
    })
  });
};

/* harmony default export */ var variations_FormContact = (FormContact);
// EXTERNAL MODULE: ./contexts/AppContext.tsx + 1 modules
var AppContext = __webpack_require__(8960);
;// CONCATENATED MODULE: ./slices/Form/variations/FormContactBenefitSelect.tsx


function FormContactBenefitSelect_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function FormContactBenefitSelect_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FormContactBenefitSelect_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FormContactBenefitSelect_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }























var FormContactBenefitSelect_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var FormContactBenefitSelect_FormInput = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 547).then(__webpack_require__.bind(__webpack_require__, 547));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(547)];
    }
  }
});
var FormContactBenefitSelect_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});
var Toast = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 123).then(__webpack_require__.bind(__webpack_require__, 4123));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4123)];
    }
  }
});

var FormContactBenefitSelect = function FormContactBenefitSelect(_ref) {
  var _slice$_clusters, _slice$_verticals, _slice$_vertical, _slice$_vertical$data, _slice$primary, _slice$primary$image, _slice$primary$image2, _slice$primary$image3, _slice$primary2, _slice$primary3, _slice$primary4, _slice$primary5, _slice$primary6, _state$benefits3, _state$benefits3$item, _slice$primary7, _slice$primary7$terms;

  var slice = _ref.slice;

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track,
      identify = _useAnalytics.identify;

  var intl = (0,useIntl/* default */.Z)();
  var locale = (0,useLocale/* default */.Z)();

  var _useState = (0,react.useState)(false),
      showToast = _useState[0],
      setShowToast = _useState[1];

  var clusters = (_slice$_clusters = slice._clusters) !== null && _slice$_clusters !== void 0 ? _slice$_clusters : [];
  var verticals = (_slice$_verticals = slice._verticals) !== null && _slice$_verticals !== void 0 ? _slice$_verticals : [];
  var clustersWithBenefits = clusters.filter(function (_ref2) {
    var data = _ref2.data;
    return data.showBenefitsButton;
  });
  var color = (0,colors/* getColor */.Lq)((_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : (_slice$_vertical$data = _slice$_vertical.data) === null || _slice$_vertical$data === void 0 ? void 0 : _slice$_vertical$data.color);

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      setValue = _useForm.setValue;

  var _useContext = (0,react.useContext)(AppContext/* AppContext */.I),
      state = _useContext.state;

  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({
    slice: slice
  });
  var defaultMessages = {
    nameLabel: intl.formatMessage({
      id: "hCOqfl",
      defaultMessage: [{
        "type": 0,
        "value": "Nombre"
      }]
    }),
    lastnameLabel: intl.formatMessage({
      id: "cEArc/",
      defaultMessage: [{
        "type": 0,
        "value": "Apellido"
      }]
    }),
    emailLabel: intl.formatMessage({
      id: "tkwCac",
      defaultMessage: [{
        "type": 0,
        "value": "E-mail"
      }]
    }),
    phoneCodeLabel: intl.formatMessage({
      id: "/0jxhp",
      defaultMessage: [{
        "type": 0,
        "value": "Código de Área"
      }]
    }),
    phoneLabel: intl.formatMessage({
      id: "S6W4PT",
      defaultMessage: [{
        "type": 0,
        "value": "Teléfono"
      }]
    }),
    phonePlaceholder: intl.formatMessage({
      id: "YTgK22",
      defaultMessage: [{
        "type": 0,
        "value": "11 0000 0000"
      }]
    }),
    benefitLabel: intl.formatMessage({
      id: "+9Crf2",
      defaultMessage: [{
        "type": 0,
        "value": "Beneficio"
      }]
    }),
    benefitPlaceholder: intl.formatMessage({
      id: "eCtI1b",
      defaultMessage: [{
        "type": 0,
        "value": "Elegir beneficio"
      }]
    }),
    clusterLabel: intl.formatMessage({
      id: "u2d89y",
      defaultMessage: [{
        "type": 0,
        "value": "Curso de interés"
      }]
    }),
    clusterPlaceholder: intl.formatMessage({
      id: "52QCr9",
      defaultMessage: [{
        "type": 0,
        "value": "Elegir curso"
      }]
    }),
    sendButtonLabel: intl.formatMessage({
      id: "hKJZJR",
      defaultMessage: [{
        "type": 0,
        "value": "Enviar"
      }]
    })
  };
  var onSubmit = (0,react.useCallback)(function (_ref3) {
    var _clustersWithBenefits, _verticals$find, _state$benefits, _state$benefits$items;

    var name = _ref3.name,
        lastname = _ref3.lastname,
        email = _ref3.email,
        phonecode = _ref3.phonecode,
        phone = _ref3.phone,
        cluster = _ref3.cluster,
        benefit = _ref3.benefit;
    var fields = {
      locale_country: locale,
      first_name: name,
      last_name: lastname,
      email: email,
      phone: "".concat(phonecode).concat(phone)
    };
    var clusterData = clustersWithBenefits === null || clustersWithBenefits === void 0 ? void 0 : (_clustersWithBenefits = clustersWithBenefits.find(function (_ref4) {
      var data = _ref4.data;
      return data.name === cluster;
    })) === null || _clustersWithBenefits === void 0 ? void 0 : _clustersWithBenefits.data;
    var vertical = (_verticals$find = verticals.find(function (_ref5) {
      var _clusterData$vertical;

      var uid = _ref5.uid;
      return uid === (clusterData === null || clusterData === void 0 ? void 0 : (_clusterData$vertical = clusterData.verticalPage) === null || _clusterData$vertical === void 0 ? void 0 : _clusterData$vertical.uid);
    })) === null || _verticals$find === void 0 ? void 0 : _verticals$find.data;
    var benefitData = (_state$benefits = state.benefits) === null || _state$benefits === void 0 ? void 0 : (_state$benefits$items = _state$benefits.items) === null || _state$benefits$items === void 0 ? void 0 : _state$benefits$items.find(function (item) {
      return item.name === benefit;
    });
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'product_name', cluster);
    lodash_set_default()(payload, 'product', {
      name: cluster,
      business_unit: clusterData === null || clusterData === void 0 ? void 0 : clusterData.businessUnit,
      vertical: vertical === null || vertical === void 0 ? void 0 : vertical.name
    });
    lodash_set_default()(payload, 'fields', fields);
    lodash_set_default()(payload, 'fields.contact_reason', "Inscripcion ".concat(benefit));
    lodash_set_default()(payload, 'fields.discount_rate', "".concat(benefitData === null || benefitData === void 0 ? void 0 : benefitData.name, " - ").concat(benefitData === null || benefitData === void 0 ? void 0 : benefitData.title, " ").concat(benefitData === null || benefitData === void 0 ? void 0 : benefitData.subtitle));
    identify(fields);
    track(constants/* TrackEvents.productApplicationSubmitted */.Um.productApplicationSubmitted, payload, locale, true);
    setShowToast(true);
    reset(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackPayload]);
  (0,react.useEffect)(function () {
    var _state$benefits2, _state$benefits2$sele;

    if (state !== null && state !== void 0 && (_state$benefits2 = state.benefits) !== null && _state$benefits2 !== void 0 && (_state$benefits2$sele = _state$benefits2.selected) !== null && _state$benefits2$sele !== void 0 && _state$benefits2$sele.name) {
      setValue('benefit', state.benefits.selected.name, {
        shouldValidate: true
      });
    }
  }, [state.benefits.selected, setValue]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "bg-gray-900",
      id: (0,common/* slugify */.lV)((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative w-full overflow-hidden",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "bg-black-2 w-full h-full z-10 absolute opacity-90"
        }), ((_slice$primary$image = slice.primary.image) === null || _slice$primary$image === void 0 ? void 0 : _slice$primary$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-full h-full absolute",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: (_slice$primary$image2 = slice.primary.image) === null || _slice$primary$image2 === void 0 ? void 0 : _slice$primary$image2.url,
            alt: (_slice$primary$image3 = slice.primary.image) === null || _slice$primary$image3 === void 0 ? void 0 : _slice$primary$image3.alt,
            layout: "fill",
            objectFit: "cover",
            quality: 70,
            className: "object-cover h-full w-full"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "dh-content z-20 relative",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "bg-black-2 rounded-2xl px-5 sm:px-10 py-5 max-w-2xl w-full m-auto",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("header", {
              className: "mx-auto text-center",
              children: ((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title) && /*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
                id: (0,common/* slugify */.lV)(slice.primary.title),
                className: "dh-title mb-11 text-2xl leading-9 font-semibold text-white",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormContactBenefitSelect_Icon, {
                  icon: "arrow-right-down-solid",
                  className: "inline-block w-8 mr-4 text-primary"
                }), slice.primary.title]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("form", {
              onSubmit: handleSubmit(onSubmit),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "sm:rounded-md text-gray-300",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "py-5 sm:py-6",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "grid sm:grid-cols-2 gap-6",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "space-y-6",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactBenefitSelect_FormInput, {
                          darkSupport: true,
                          label: (0,common/* getDefaultText */.T9)('nameLabel', slice.primary, defaultMessages),
                          placeholder: (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.namePlaceholder,
                          id: "name",
                          required: true,
                          register: register('name', {
                            required: true
                          })
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactBenefitSelect_FormInput, {
                          darkSupport: true,
                          label: (0,common/* getDefaultText */.T9)('lastnameLabel', slice.primary, defaultMessages),
                          placeholder: (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.lastnamePlaceholder,
                          id: "lastname",
                          required: true,
                          register: register('lastname', {
                            required: true
                          })
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactBenefitSelect_FormInput, {
                          darkSupport: true,
                          label: (0,common/* getDefaultText */.T9)('emailLabel', slice.primary, defaultMessages),
                          placeholder: (_slice$primary5 = slice.primary) === null || _slice$primary5 === void 0 ? void 0 : _slice$primary5.emailPlaceholder,
                          id: "email",
                          type: "email",
                          required: true,
                          register: register('email', {
                            required: true,
                            pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i
                          })
                        })
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "space-y-6",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-6",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "flex-none",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactBenefitSelect_FormInput, {
                            label: (0,common/* getDefaultText */.T9)('phoneCodeLabel', slice.primary, defaultMessages),
                            placeholder: (_slice$primary6 = slice.primary) === null || _slice$primary6 === void 0 ? void 0 : _slice$primary6.phoneCodePlaceholder,
                            id: "phonecode",
                            className: "w-20 lg:w-24",
                            register: register('phonecode', {
                              required: false
                            })
                          })
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "grow",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactBenefitSelect_FormInput, {
                            darkSupport: true,
                            label: (0,common/* getDefaultText */.T9)('phoneLabel', slice.primary, defaultMessages),
                            placeholder: (0,common/* getDefaultText */.T9)('phonePlaceholder', slice.primary, defaultMessages),
                            id: "phone",
                            register: register('phone', {
                              required: false
                            })
                          })
                        })]
                      }), !!((_state$benefits3 = state.benefits) !== null && _state$benefits3 !== void 0 && (_state$benefits3$item = _state$benefits3.items) !== null && _state$benefits3$item !== void 0 && _state$benefits3$item.length) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                          htmlFor: "benefit",
                          className: "text-white-3 block text-xs font-semibold mb-2",
                          children: (0,common/* getDefaultText */.T9)('benefitLabel', slice.primary, defaultMessages)
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("select", FormContactBenefitSelect_objectSpread(FormContactBenefitSelect_objectSpread({
                          id: "benefit",
                          defaultValue: "",
                          className: classnames_default()('h-10 block w-full pl-3 pr-10 py-2 text-base sm:text-sm rounded-md border', 'text-gray-900 bg-white placeholder-gray-800 border-black', 'focus:ring-gray-800 focus:border-gray-500'),
                          required: true
                        }, register('benefit', {
                          required: true
                        })), {}, {
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                            value: "",
                            disabled: true,
                            children: (0,common/* getDefaultText */.T9)('benefitPlaceholder', slice.primary, defaultMessages)
                          }, "select"), state.benefits.items.map(function (_ref6) {
                            var name = _ref6.name;
                            return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                              value: name,
                              children: name
                            }, (0,index_browser/* nanoid */.x0)());
                          })]
                        }))]
                      }), !!clustersWithBenefits.length && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                          htmlFor: "cluster",
                          className: "text-white-3 block text-xs font-semibold mb-2",
                          children: (0,common/* getDefaultText */.T9)('clusterLabel', slice.primary, defaultMessages)
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("select", FormContactBenefitSelect_objectSpread(FormContactBenefitSelect_objectSpread({
                          id: "cluster",
                          defaultValue: "",
                          className: classnames_default()('h-10 block w-full pl-3 pr-10 py-2 text-base sm:text-sm rounded-md border', 'text-gray-900 bg-white placeholder-gray-800 border-black', 'focus:ring-gray-800 focus:border-gray-500'),
                          required: true
                        }, register('cluster', {
                          required: true
                        })), {}, {
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                            value: "",
                            disabled: true,
                            children: (0,common/* getDefaultText */.T9)('clusterPlaceholder', slice.primary, defaultMessages)
                          }, "select"), clustersWithBenefits === null || clustersWithBenefits === void 0 ? void 0 : clustersWithBenefits.map(function (_ref7) {
                            var data = _ref7.data;
                            return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                              value: data.name,
                              children: data.name
                            }, (0,index_browser/* nanoid */.x0)());
                          })]
                        }))]
                      })]
                    })]
                  })
                }), !!((_slice$primary7 = slice.primary) !== null && _slice$primary7 !== void 0 && (_slice$primary7$terms = _slice$primary7.termsAndConditionsLink) !== null && _slice$primary7$terms !== void 0 && _slice$primary7$terms.link_type) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "text-right",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "relative flex items-start",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "flex items-center h-5",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", FormContactBenefitSelect_objectSpread({
                        id: "tyc",
                        "aria-describedby": "agree-terms-and-conditions",
                        type: "checkbox",
                        className: "focus:ring-grey-500 h-4 w-4 text-gey-600 border-gray-300 rounded",
                        required: true
                      }, register('tyc', {
                        required: true
                      })))
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "ml-3 text-sm font-normal font-archivo",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                        htmlFor: "tyc",
                        className: "mr-2 text-white",
                        children: intl.formatMessage({
                          id: "1I7zTd",
                          defaultMessage: [{
                            "type": 0,
                            "value": "Aceptar"
                          }]
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormContactBenefitSelect_LinkWithQuery, {
                        href: prismic_reactjs.Link.url(slice.primary.termsAndConditionsLink, common/* prismicLinkResolver */.LT),
                        target: "_blank",
                        className: classnames_default()('underline', color.text),
                        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                          className: "sr-only",
                          children: [intl.formatMessage({
                            id: "1I7zTd",
                            defaultMessage: [{
                              "type": 0,
                              "value": "Aceptar"
                            }]
                          }), ' ']
                        }), intl.formatMessage({
                          id: "o24Y39",
                          defaultMessage: [{
                            "type": 0,
                            "value": "Términos y condiciones"
                          }]
                        })]
                      })]
                    })]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "py-4 flex justify-center",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    type: "submit",
                    className: classnames_default()('dh-button py-2 text-sm w-48 max-w-full', color.bg, color.bgHover, color.textContrast),
                    children: (0,common/* getDefaultText */.T9)('sendButtonLabel', slice.primary, defaultMessages)
                  })
                })]
              })
            })]
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Toast, {
      show: showToast,
      setShow: setShowToast,
      icon: esm/* CheckCircleIcon */.rE2,
      title: intl.formatMessage({
        id: "wD4LRR",
        defaultMessage: [{
          "type": 0,
          "value": "Gracias"
        }]
      }),
      message: intl.formatMessage({
        id: "9u4Psm",
        defaultMessage: [{
          "type": 0,
          "value": "Te contactaremos a la brevedad para asesorarte y acompañarte en la transformación que comenzaste hoy."
        }]
      })
    })]
  });
};

/* harmony default export */ var variations_FormContactBenefitSelect = (FormContactBenefitSelect);
;// CONCATENATED MODULE: ./slices/Form/variations/FormContactClusterSelect.tsx


function FormContactClusterSelect_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function FormContactClusterSelect_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FormContactClusterSelect_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FormContactClusterSelect_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





















var FormContactClusterSelect_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var FormContactClusterSelect_FormInput = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 547).then(__webpack_require__.bind(__webpack_require__, 547));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(547)];
    }
  }
});
var FormContactClusterSelect_Toast = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 123).then(__webpack_require__.bind(__webpack_require__, 4123));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4123)];
    }
  }
});

var FormContactClusterSelect = function FormContactClusterSelect(_ref) {
  var _slice$_verticals, _slice$primary$link, _slice$primary, _slice$primary2, _slice$primary3, _slice$primary4, _slice$primary5, _slice$primary6, _slice$primary7, _slice$primary8, _slice$primary9, _slice$primary9$terms;

  var slice = _ref.slice;

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track,
      identify = _useAnalytics.identify;

  var intl = (0,useIntl/* default */.Z)();
  var locale = (0,useLocale/* default */.Z)();

  var _useState = (0,react.useState)(false),
      showToast = _useState[0],
      setShowToast = _useState[1];

  var clusters = slice._clusters;
  var verticals = slice._verticals;
  var vertical = (_slice$_verticals = slice._verticals) === null || _slice$_verticals === void 0 ? void 0 : _slice$_verticals.data;
  var color = (0,colors/* getColor */.Lq)(vertical === null || vertical === void 0 ? void 0 : vertical.color);

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset;

  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({
    slice: slice,
    vertical: vertical
  });
  var showRules = !!(slice.primary.textAgree && slice.primary.label1 && (_slice$primary$link = slice.primary.link1) !== null && _slice$primary$link !== void 0 && _slice$primary$link.uid);
  var defaultMessages = {
    nameLabel: intl.formatMessage({
      id: "hCOqfl",
      defaultMessage: [{
        "type": 0,
        "value": "Nombre"
      }]
    }),
    lastnameLabel: intl.formatMessage({
      id: "cEArc/",
      defaultMessage: [{
        "type": 0,
        "value": "Apellido"
      }]
    }),
    emailLabel: intl.formatMessage({
      id: "tkwCac",
      defaultMessage: [{
        "type": 0,
        "value": "E-mail"
      }]
    }),
    phoneCodeLabel: intl.formatMessage({
      id: "/0jxhp",
      defaultMessage: [{
        "type": 0,
        "value": "Código de Área"
      }]
    }),
    phoneLabel: intl.formatMessage({
      id: "S6W4PT",
      defaultMessage: [{
        "type": 0,
        "value": "Teléfono"
      }]
    }),
    phonePlaceholder: intl.formatMessage({
      id: "YTgK22",
      defaultMessage: [{
        "type": 0,
        "value": "11 0000 0000"
      }]
    }),
    clusterLabel: intl.formatMessage({
      id: "u2d89y",
      defaultMessage: [{
        "type": 0,
        "value": "Curso de interés"
      }]
    }),
    clusterPlaceholder: intl.formatMessage({
      id: "52QCr9",
      defaultMessage: [{
        "type": 0,
        "value": "Elegir curso"
      }]
    }),
    sendButtonLabel: intl.formatMessage({
      id: "xRNIls",
      defaultMessage: [{
        "type": 0,
        "value": "Aplicar ahora"
      }]
    })
  };
  var formTrack = (0,react.useCallback)(function (localeCountry, firstName, lastName, email, phoneCode, phone, clusterName) {
    var _cluster$data2, _cluster$data3, _cluster$data4, _verticalData$data;

    var fields = {
      locale_country: localeCountry,
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone: "".concat(phoneCode).concat(phone)
    };
    identify(fields);
    var cluster = clusters === null || clusters === void 0 ? void 0 : clusters.find(function (c) {
      var _c$data;

      return ((_c$data = c.data) === null || _c$data === void 0 ? void 0 : _c$data.name) === clusterName;
    });
    var verticalData = verticals === null || verticals === void 0 ? void 0 : verticals.find(function (c) {
      var _cluster$data, _cluster$data$vertica;

      return c.uid === ((_cluster$data = cluster.data) === null || _cluster$data === void 0 ? void 0 : (_cluster$data$vertica = _cluster$data.verticalPage) === null || _cluster$data$vertica === void 0 ? void 0 : _cluster$data$vertica.uid);
    });
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'product_name', cluster === null || cluster === void 0 ? void 0 : (_cluster$data2 = cluster.data) === null || _cluster$data2 === void 0 ? void 0 : _cluster$data2.name);
    lodash_set_default()(payload, 'product.name', cluster === null || cluster === void 0 ? void 0 : (_cluster$data3 = cluster.data) === null || _cluster$data3 === void 0 ? void 0 : _cluster$data3.name);
    lodash_set_default()(payload, 'product.business_unit', cluster === null || cluster === void 0 ? void 0 : (_cluster$data4 = cluster.data) === null || _cluster$data4 === void 0 ? void 0 : _cluster$data4.businessUnit);
    lodash_set_default()(payload, 'product.vertical', verticalData === null || verticalData === void 0 ? void 0 : (_verticalData$data = verticalData.data) === null || _verticalData$data === void 0 ? void 0 : _verticalData$data.name);
    lodash_set_default()(payload, 'fields', fields);
    track(constants/* TrackEvents.productApplicationSubmitted */.Um.productApplicationSubmitted, payload, locale, true); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackPayload]);

  var onSubmit = function onSubmit(_ref2) {
    var name = _ref2.name,
        lastname = _ref2.lastname,
        email = _ref2.email,
        phonecode = _ref2.phonecode,
        phone = _ref2.phone,
        cluster = _ref2.cluster;
    formTrack(locale, name, lastname, email, phonecode, phone, cluster);
    setShowToast(true);
    reset();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "bg-gray-900",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "dh-content grid lg:grid-cols-2",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
          className: "max-w-3xl mx-auto lg:py-20 lg:pr-40 text-left",
          children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            id: (0,common/* slugify */.lV)(slice.primary.title),
            className: "dh-title mb-11 text-3xl text-white",
            children: slice.primary.title
          }), ((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "dh-description mb-14 text-white text-sm font-normal leading-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
              render: slice.primary.description
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "bg-codGray-900 rounded px-5 sm:px-10 py-12",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
            onSubmit: handleSubmit(onSubmit),
            children: [((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.formTitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "text-2xl text-center text-athensGray-100 leading-9 font-bold pb-4",
              children: (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.formTitle
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "sm:rounded-md text-gray-300",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "py-5 sm:py-6",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "grid grid-cols-1 gap-6",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactClusterSelect_FormInput, {
                      darkSupport: true,
                      label: (0,common/* getDefaultText */.T9)('nameLabel', slice.primary, defaultMessages),
                      placeholder: (_slice$primary5 = slice.primary) === null || _slice$primary5 === void 0 ? void 0 : _slice$primary5.namePlaceholder,
                      id: "name",
                      required: true,
                      register: register('name', {
                        required: true
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactClusterSelect_FormInput, {
                      darkSupport: true,
                      label: (0,common/* getDefaultText */.T9)('lastnameLabel', slice.primary, defaultMessages),
                      placeholder: (_slice$primary6 = slice.primary) === null || _slice$primary6 === void 0 ? void 0 : _slice$primary6.lastnamePlaceholder,
                      id: "lastname",
                      required: true,
                      register: register('lastname', {
                        required: true
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactClusterSelect_FormInput, {
                      darkSupport: true,
                      label: (0,common/* getDefaultText */.T9)('emailLabel', slice.primary, defaultMessages),
                      placeholder: (_slice$primary7 = slice.primary) === null || _slice$primary7 === void 0 ? void 0 : _slice$primary7.emailPlaceholder,
                      id: "email",
                      type: "email",
                      required: true,
                      register: register('email', {
                        required: true,
                        pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i
                      })
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "flex gap-6",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "flex-none",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactClusterSelect_FormInput, {
                        label: (0,common/* getDefaultText */.T9)('phoneCodeLabel', slice.primary, defaultMessages),
                        placeholder: (_slice$primary8 = slice.primary) === null || _slice$primary8 === void 0 ? void 0 : _slice$primary8.phoneCodePlaceholder,
                        id: "phonecode",
                        className: "w-20 lg:w-24",
                        register: register('phonecode', {
                          required: false
                        })
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "grow",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactClusterSelect_FormInput, {
                        darkSupport: true,
                        label: (0,common/* getDefaultText */.T9)('phoneLabel', slice.primary, defaultMessages),
                        placeholder: (0,common/* getDefaultText */.T9)('phonePlaceholder', slice.primary, defaultMessages),
                        id: "phone",
                        register: register('phone', {
                          required: false
                        })
                      })
                    })]
                  }), clusters && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                      htmlFor: "cluster",
                      className: "text-white-3 block text-xs font-semibold mb-2",
                      children: (0,common/* getDefaultText */.T9)('clusterLabel', slice.primary, defaultMessages)
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("select", FormContactClusterSelect_objectSpread(FormContactClusterSelect_objectSpread({
                      id: "cluster",
                      defaultValue: "",
                      className: classnames_default()('h-10 block w-full pl-3 pr-10 py-2 text-base sm:text-sm rounded-md border', 'text-gray-900 bg-white placeholder-gray-800 border-black', 'focus:ring-gray-800 focus:border-gray-500'),
                      required: true
                    }, register('cluster', {
                      required: true
                    })), {}, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                        value: "",
                        disabled: true,
                        children: (0,common/* getDefaultText */.T9)('clusterPlaceholder', slice.primary, defaultMessages)
                      }, "select"), clusters === null || clusters === void 0 ? void 0 : clusters.map(function (_ref3) {
                        var data = _ref3.data;
                        return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                          value: data.name,
                          children: data.name
                        }, (0,index_browser/* nanoid */.x0)());
                      })]
                    }))]
                  })]
                })
              }), !!((_slice$primary9 = slice.primary) !== null && _slice$primary9 !== void 0 && (_slice$primary9$terms = _slice$primary9.termsAndConditionsLink) !== null && _slice$primary9$terms !== void 0 && _slice$primary9$terms.link_type) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "py-3 text-right",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "relative flex items-start",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "flex items-center h-5",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", FormContactClusterSelect_objectSpread({
                      id: "tyc",
                      "aria-describedby": "agree-terms-and-conditions",
                      type: "checkbox",
                      className: "focus:ring-grey-500 h-4 w-4 text-gey-600 border-gray-300 rounded",
                      required: true
                    }, register('tyc', {
                      required: true
                    })))
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "ml-3 text-sm font-normal",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                      htmlFor: "tyc",
                      className: "mr-2 text-white",
                      children: intl.formatMessage({
                        id: "1I7zTd",
                        defaultMessage: [{
                          "type": 0,
                          "value": "Aceptar"
                        }]
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormContactClusterSelect_LinkWithQuery, {
                      href: prismic_reactjs.Link.url(slice.primary.termsAndConditionsLink, common/* prismicLinkResolver */.LT),
                      target: "_blank",
                      className: classnames_default()('underline', color.text),
                      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                        className: "sr-only",
                        children: [intl.formatMessage({
                          id: "1I7zTd",
                          defaultMessage: [{
                            "type": 0,
                            "value": "Aceptar"
                          }]
                        }), ' ']
                      }), intl.formatMessage({
                        id: "o24Y39",
                        defaultMessage: [{
                          "type": 0,
                          "value": "Términos y condiciones"
                        }]
                      })]
                    })]
                  })]
                })
              }), showRules && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "py-3 text-right",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "relative flex items-start",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "flex items-center h-5",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", FormContactClusterSelect_objectSpread({
                      id: "ryp",
                      "aria-describedby": "agree-terms-and-conditions",
                      type: "checkbox",
                      className: "focus:ring-grey-500 h-4 w-4 text-gey-600 border-gray-300 rounded",
                      required: true
                    }, register('ryp', {
                      required: true
                    })))
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "ml-3 text-sm font-normal",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                      htmlFor: "ryp",
                      className: "mr-2 text-white",
                      children: slice.primary.textAgree
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactClusterSelect_LinkWithQuery, {
                      href: prismic_reactjs.Link.url(slice.primary.link1, common/* prismicLinkResolver */.LT),
                      target: "_blank",
                      className: classnames_default()('underline', color.text),
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                        children: [slice.primary.label1, ' ']
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                      htmlFor: "ryp",
                      className: "mx-2 text-white-2",
                      children: slice.primary.textConnector
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactClusterSelect_LinkWithQuery, {
                      href: prismic_reactjs.Link.url(slice.primary.link2, common/* prismicLinkResolver */.LT),
                      target: "_blank",
                      className: classnames_default()('underline', color.text),
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                        children: [slice.primary.label2, ' ']
                      })
                    })]
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "py-3 text-right",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  type: "submit",
                  className: classnames_default()('dh-button py-4 text-sm w-full', color.bg, color.bgHover, color.textContrast),
                  children: (0,common/* getDefaultText */.T9)('sendButtonLabel', slice.primary, defaultMessages)
                })
              })]
            })]
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactClusterSelect_Toast, {
      show: showToast,
      setShow: setShowToast,
      icon: esm/* CheckCircleIcon */.rE2,
      title: intl.formatMessage({
        id: "wD4LRR",
        defaultMessage: [{
          "type": 0,
          "value": "Gracias"
        }]
      }),
      message: intl.formatMessage({
        id: "9u4Psm",
        defaultMessage: [{
          "type": 0,
          "value": "Te contactaremos a la brevedad para asesorarte y acompañarte en la transformación que comenzaste hoy."
        }]
      })
    })]
  });
};

/* harmony default export */ var variations_FormContactClusterSelect = (FormContactClusterSelect);
;// CONCATENATED MODULE: ./slices/Form/variations/FormContactCompany.tsx


function FormContactCompany_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function FormContactCompany_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FormContactCompany_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FormContactCompany_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






















var FormContactCompany_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var FormContactCompany_Toast = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 123).then(__webpack_require__.bind(__webpack_require__, 4123));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4123)];
    }
  }
});
var FormContactCompany_FormInput = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 547).then(__webpack_require__.bind(__webpack_require__, 547));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(547)];
    }
  }
});
var FormContactCompany_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});

var FormContactCompany = function FormContactCompany(_ref) {
  var _slice$_cluster, _slice$_vertical, _slice$primary$link, _slice$primary, _slice$primary$intere, _slice$primary$title, _slice$primary2, _slice$primary$image, _slice$primary$image2, _slice$primary$image3, _slice$primary$image4, _slice$primary$image5, _slice$primary$image6, _slice$primary3, _slice$primary4, _slice$primary5, _slice$primary6, _slice$primary7, _slice$primary8, _slice$primary9, _slice$primary10, _slice$primary11, _formState$errors, _formState$errors2, _formState$errors3, _formState$errors4, _formState$errors5, _slice$primary12, _slice$primary12$term;

  var slice = _ref.slice;

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track,
      identify = _useAnalytics.identify;

  var intl = (0,useIntl/* default */.Z)();
  var locale = (0,useLocale/* default */.Z)();

  var _useState = (0,react.useState)(false),
      showToast = _useState[0],
      setShowToast = _useState[1];

  var cluster = (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : _slice$_cluster.data;
  var vertical = (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var color = (0,colors/* getColor */.Lq)(vertical === null || vertical === void 0 ? void 0 : vertical.color);

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      formState = _useForm.formState;

  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({
    slice: slice,
    cluster: cluster,
    vertical: vertical
  });
  var showRules = !!(slice.primary.textAgree && slice.primary.label1 && (_slice$primary$link = slice.primary.link1) !== null && _slice$primary$link !== void 0 && _slice$primary$link.uid);
  var interestTrainingOptions = (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : (_slice$primary$intere = _slice$primary.interestTrainingOptions) === null || _slice$primary$intere === void 0 ? void 0 : _slice$primary$intere.map(function (item) {
    return item === null || item === void 0 ? void 0 : item.text;
  });
  var defaultMessages = {
    nameLabel: intl.formatMessage({
      id: "hCOqfl",
      defaultMessage: [{
        "type": 0,
        "value": "Nombre"
      }]
    }),
    lastnameLabel: intl.formatMessage({
      id: "cEArc/",
      defaultMessage: [{
        "type": 0,
        "value": "Apellido"
      }]
    }),
    companyLabel: intl.formatMessage({
      id: "+5/Kp+",
      defaultMessage: [{
        "type": 0,
        "value": "Nombre de empresa"
      }]
    }),
    positionLabel: intl.formatMessage({
      id: "MgCcTq",
      defaultMessage: [{
        "type": 0,
        "value": "Cargo"
      }]
    }),
    emailLabel: intl.formatMessage({
      id: "tkwCac",
      defaultMessage: [{
        "type": 0,
        "value": "E-mail"
      }]
    }),
    phoneCodeLabel: intl.formatMessage({
      id: "/0jxhp",
      defaultMessage: [{
        "type": 0,
        "value": "Código de Área"
      }]
    }),
    phoneLabel: intl.formatMessage({
      id: "S6W4PT",
      defaultMessage: [{
        "type": 0,
        "value": "Teléfono"
      }]
    }),
    phonePlaceholder: intl.formatMessage({
      id: "YTgK22",
      defaultMessage: [{
        "type": 0,
        "value": "11 0000 0000"
      }]
    }),
    interestTrainingLabel: intl.formatMessage({
      id: "HYkaNH",
      defaultMessage: [{
        "type": 0,
        "value": "Capacitación de interés"
      }]
    }),
    interestTrainingPlaceholder: intl.formatMessage({
      id: "RIXCZ4",
      defaultMessage: [{
        "type": 0,
        "value": "Seleccione una opción"
      }]
    }),
    sendButtonLabel: intl.formatMessage({
      id: "hKJZJR",
      defaultMessage: [{
        "type": 0,
        "value": "Enviar"
      }]
    })
  };
  var onSubmit = (0,react.useCallback)(function (_ref2) {
    var name = _ref2.name,
        lastname = _ref2.lastname,
        company = _ref2.company,
        position = _ref2.position,
        email = _ref2.email,
        phonecode = _ref2.phonecode,
        phone = _ref2.phone,
        interestTraining = _ref2.interestTraining;
    var fields = {
      locale_country: locale,
      first_name: name,
      last_name: lastname,
      company: company,
      company_position: position,
      email: email,
      phone: "".concat(phonecode).concat(phone),
      interest_training: interestTraining
    };
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'fields', fields);
    identify(fields);
    track(constants/* TrackEvents.productApplicationSubmitted */.Um.productApplicationSubmitted, payload, locale, true);
    setShowToast(true);
    reset(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackPayload]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: "bg-gray-2 relative",
      id: (0,common/* slugify */.lV)((_slice$primary$title = (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title) !== null && _slice$primary$title !== void 0 ? _slice$primary$title : ''),
      children: [((_slice$primary$image = slice.primary.image) === null || _slice$primary$image === void 0 ? void 0 : _slice$primary$image.url) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "hidden lg:block w-1/2 h-full absolute z-0",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "bg-black-2 w-full h-full z-10 absolute opacity-90"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: (_slice$primary$image2 = slice.primary.image) === null || _slice$primary$image2 === void 0 ? void 0 : _slice$primary$image2.url,
          alt: (_slice$primary$image3 = slice.primary.image) === null || _slice$primary$image3 === void 0 ? void 0 : _slice$primary$image3.alt,
          layout: "fill",
          objectFit: "cover",
          quality: 70,
          className: "object-cover h-full w-full"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "grid lg:grid-cols-2 relative lg:dh-content",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
          className: "lg:max-w-3xl mx-auto lg:py-20 lg:pr-40 text-left relative",
          children: [((_slice$primary$image4 = slice.primary.image) === null || _slice$primary$image4 === void 0 ? void 0 : _slice$primary$image4.url) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "lg:hidden w-full h-full absolute z-0",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "bg-black-2 w-full h-full z-10 absolute opacity-90"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: (_slice$primary$image5 = slice.primary.image) === null || _slice$primary$image5 === void 0 ? void 0 : _slice$primary$image5.url,
              alt: (_slice$primary$image6 = slice.primary.image) === null || _slice$primary$image6 === void 0 ? void 0 : _slice$primary$image6.alt,
              layout: "fill",
              objectFit: "cover",
              quality: 70,
              className: "object-cover h-full w-full"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "dh-content px-11 lg:p-0 lg:m-0 relative",
            children: [((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.title) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormContactCompany_Icon, {
                icon: "arrow-right-down",
                className: classnames_default()('w-8 mb-2 block', color.text)
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                id: (0,common/* slugify */.lV)(slice.primary.title),
                className: classnames_default()('text-2xl pb-2 md:text-5xl text-white border-b inline-block', color.border),
                children: slice.primary.title
              })]
            }), ((_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: classnames_default()('dh-description mb-14 text-white text-lg text-center font-normal leading-8', 'md:text-left md:text-xl md:leading-9'),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                render: slice.primary.description
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "relative w-full overflow-hidden",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "lg:dh-content relative",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "bg-gray-900 lg:rounded-2xl px-5 sm:px-10 py-5 lg:max-w-2xl w-full m-auto",
              children: [((_slice$primary5 = slice.primary) === null || _slice$primary5 === void 0 ? void 0 : _slice$primary5.formTitle) && /*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
                id: (0,common/* slugify */.lV)(slice.primary.formTitle),
                className: "dh-title mb-4 text-2xl leading-9 font-semibold text-white mx-auto text-center",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormContactCompany_Icon, {
                  icon: "arrow-right-down-solid",
                  className: classnames_default()('inline-block w-8 mr-4', color.text)
                }), slice.primary.formTitle]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("form", {
                onSubmit: handleSubmit(onSubmit),
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "sm:rounded-md text-gray-300",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "py-5 sm:py-6",
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "grid sm:grid-cols-2 gap-6",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactCompany_FormInput, {
                          darkSupport: true,
                          label: (0,common/* getDefaultText */.T9)('nameLabel', slice.primary, defaultMessages),
                          placeholder: (_slice$primary6 = slice.primary) === null || _slice$primary6 === void 0 ? void 0 : _slice$primary6.namePlaceholder,
                          id: "name",
                          required: true,
                          register: register('name', {
                            required: true
                          })
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactCompany_FormInput, {
                          darkSupport: true,
                          label: (0,common/* getDefaultText */.T9)('lastnameLabel', slice.primary, defaultMessages),
                          placeholder: (_slice$primary7 = slice.primary) === null || _slice$primary7 === void 0 ? void 0 : _slice$primary7.lastnamePlaceholder,
                          id: "lastname",
                          required: true,
                          register: register('lastname', {
                            required: true
                          })
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactCompany_FormInput, {
                          darkSupport: true,
                          label: (0,common/* getDefaultText */.T9)('companyLabel', slice.primary, defaultMessages),
                          placeholder: (_slice$primary8 = slice.primary) === null || _slice$primary8 === void 0 ? void 0 : _slice$primary8.companyPlaceholder,
                          id: "company",
                          required: true,
                          register: register('company', {
                            required: true
                          })
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactCompany_FormInput, {
                          darkSupport: true,
                          label: (0,common/* getDefaultText */.T9)('positionLabel', slice.primary, defaultMessages),
                          placeholder: (_slice$primary9 = slice.primary) === null || _slice$primary9 === void 0 ? void 0 : _slice$primary9.positionPlaceholder,
                          id: "position",
                          required: true,
                          register: register('position', {
                            required: true
                          })
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactCompany_FormInput, {
                          darkSupport: true,
                          label: (0,common/* getDefaultText */.T9)('emailLabel', slice.primary, defaultMessages),
                          placeholder: (_slice$primary10 = slice.primary) === null || _slice$primary10 === void 0 ? void 0 : _slice$primary10.emailPlaceholder,
                          id: "email",
                          type: "email",
                          required: true,
                          register: register('email', {
                            required: true,
                            pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i
                          })
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-6",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "flex-none",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactCompany_FormInput, {
                            label: (0,common/* getDefaultText */.T9)('phoneCodeLabel', slice.primary, defaultMessages),
                            placeholder: (_slice$primary11 = slice.primary) === null || _slice$primary11 === void 0 ? void 0 : _slice$primary11.phoneCodePlaceholder,
                            id: "phonecode",
                            className: "w-20 lg:w-24",
                            register: register('phonecode', {
                              required: false
                            })
                          })
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                          className: "grow",
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactCompany_FormInput, {
                            darkSupport: true,
                            label: (0,common/* getDefaultText */.T9)('phoneLabel', slice.primary, defaultMessages),
                            placeholder: (0,common/* getDefaultText */.T9)('phonePlaceholder', slice.primary, defaultMessages),
                            id: "phone",
                            register: register('phone', {
                              required: false
                            })
                          })
                        })]
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "col-span-2",
                        children: !!(interestTrainingOptions !== null && interestTrainingOptions !== void 0 && interestTrainingOptions.length) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                            htmlFor: "interestTraining",
                            className: "text-white-3 block text-p3 lg:text-p2 font-medium mb-1.5",
                            children: [(0,common/* getDefaultText */.T9)('interestTrainingLabel', slice.primary, defaultMessages), !!((_formState$errors = formState.errors) !== null && _formState$errors !== void 0 && _formState$errors.interestTraining) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                              className: "pl-3 inline-block pointer-events-none align-middle",
                              children: /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* ExclamationCircleIcon */.$Ow, {
                                className: "h-5 w-5 text-red-500",
                                "data-testid": "test-error",
                                "aria-hidden": "true"
                              })
                            })]
                          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("select", FormContactCompany_objectSpread(FormContactCompany_objectSpread({
                            id: "interestTraining",
                            defaultValue: "",
                            className: classnames_default()('rounded-md h-[2.875rem] block w-full shadow-sm p-3 border', 'border-white bg-white-2 text-p3', {
                              'text-gray-1 placeholder-gray-7': !((_formState$errors2 = formState.errors) !== null && _formState$errors2 !== void 0 && _formState$errors2.interestTraining),
                              'focus:ring-gray-800 focus:border-gray-500': !((_formState$errors3 = formState.errors) !== null && _formState$errors3 !== void 0 && _formState$errors3.interestTraining),
                              'border-red-300 text-red-500 placeholder-red-500': !!((_formState$errors4 = formState.errors) !== null && _formState$errors4 !== void 0 && _formState$errors4.interestTraining),
                              'focus:ring-red-500 focus:border-red-500 focus:outline-none': !!((_formState$errors5 = formState.errors) !== null && _formState$errors5 !== void 0 && _formState$errors5.interestTraining)
                            }),
                            required: true
                          }, register('interestTraining', {
                            required: true
                          })), {}, {
                            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                              value: "",
                              disabled: true,
                              children: (0,common/* getDefaultText */.T9)('interestTrainingPlaceholder', slice.primary, defaultMessages)
                            }, "select"), interestTrainingOptions.map(function (option) {
                              return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                                value: option,
                                children: option
                              }, "interestTraining_".concat(option));
                            })]
                          }))]
                        })
                      })]
                    })
                  }), !!((_slice$primary12 = slice.primary) !== null && _slice$primary12 !== void 0 && (_slice$primary12$term = _slice$primary12.termsAndConditionsLink) !== null && _slice$primary12$term !== void 0 && _slice$primary12$term.link_type) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "text-right",
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "relative flex items-start",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "flex items-center h-5",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", FormContactCompany_objectSpread({
                          id: "tyc",
                          "aria-describedby": "agree-terms-and-conditions",
                          type: "checkbox",
                          className: "focus:ring-grey-500 h-4 w-4 text-gey-600 border-gray-300 rounded",
                          required: true
                        }, register('tyc', {
                          required: true
                        })))
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "ml-3 text-sm font-normal font-archivo",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                          htmlFor: "tyc",
                          className: "mr-2 text-white",
                          children: intl.formatMessage({
                            id: "1I7zTd",
                            defaultMessage: [{
                              "type": 0,
                              "value": "Aceptar"
                            }]
                          })
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormContactCompany_LinkWithQuery, {
                          href: prismic_reactjs.Link.url(slice.primary.termsAndConditionsLink, common/* prismicLinkResolver */.LT),
                          target: "_blank",
                          className: classnames_default()('underline', color.text),
                          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                            className: "sr-only",
                            children: [intl.formatMessage({
                              id: "1I7zTd",
                              defaultMessage: [{
                                "type": 0,
                                "value": "Aceptar"
                              }]
                            }), ' ']
                          }), intl.formatMessage({
                            id: "o24Y39",
                            defaultMessage: [{
                              "type": 0,
                              "value": "Términos y condiciones"
                            }]
                          })]
                        })]
                      })]
                    })
                  }), showRules && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "py-3 text-right",
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "relative flex items-start",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "flex items-center h-5",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", FormContactCompany_objectSpread({
                          id: "ryp",
                          "aria-describedby": "agree-terms-and-conditions",
                          type: "checkbox",
                          className: "focus:ring-grey-500 h-4 w-4 text-gey-600 border-gray-300 rounded",
                          required: true
                        }, register('ryp', {
                          required: true
                        })))
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "ml-3 text-sm font-normal",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                          htmlFor: "ryp",
                          className: "mr-2 text-white",
                          children: slice.primary.textAgree
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactCompany_LinkWithQuery, {
                          href: prismic_reactjs.Link.url(slice.primary.link1, common/* prismicLinkResolver */.LT),
                          target: "_blank",
                          className: classnames_default()('underline', color.text),
                          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                            children: [slice.primary.label1, ' ']
                          })
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                          htmlFor: "ryp",
                          className: "mx-2 text-white-2",
                          children: slice.primary.textConnector
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactCompany_LinkWithQuery, {
                          href: prismic_reactjs.Link.url(slice.primary.link2, common/* prismicLinkResolver */.LT),
                          target: "_blank",
                          className: classnames_default()('underline', color.text),
                          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                            children: [slice.primary.label2, ' ']
                          })
                        })]
                      })]
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "py-4 flex justify-center",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                      type: "submit",
                      className: classnames_default()('dh-button py-2 text-sm w-48 max-w-full', color.bg, color.bgHover, color.textContrast),
                      children: (0,common/* getDefaultText */.T9)('sendButtonLabel', slice.primary, defaultMessages)
                    })
                  })]
                })
              })]
            })
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactCompany_Toast, {
      show: showToast,
      setShow: setShowToast,
      icon: esm/* CheckCircleIcon */.rE2,
      title: intl.formatMessage({
        id: "wD4LRR",
        defaultMessage: [{
          "type": 0,
          "value": "Gracias"
        }]
      }),
      message: intl.formatMessage({
        id: "9u4Psm",
        defaultMessage: [{
          "type": 0,
          "value": "Te contactaremos a la brevedad para asesorarte y acompañarte en la transformación que comenzaste hoy."
        }]
      })
    })]
  });
};

/* harmony default export */ var variations_FormContactCompany = (FormContactCompany);
// EXTERNAL MODULE: ./utils/checkout.ts + 3 modules
var checkout = __webpack_require__(1746);
// EXTERNAL MODULE: ./hooks/useGeoCountry.ts
var useGeoCountry = __webpack_require__(6958);
;// CONCATENATED MODULE: ./slices/Form/variations/FormContactSchedule.tsx


function FormContactSchedule_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function FormContactSchedule_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FormContactSchedule_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FormContactSchedule_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


























var FormContactSchedule_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var FormContactSchedule_Toast = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 123).then(__webpack_require__.bind(__webpack_require__, 4123));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4123)];
    }
  }
});
var FormContactSchedule_FormInput = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 547).then(__webpack_require__.bind(__webpack_require__, 547));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(547)];
    }
  }
});

var dateFormat = function dateFormat(date, language) {
  return date ? (0,dates/* parseDate */.sG)(date.split('T')[0], (0,dates/* getCurrentDateLocale */.Et)(dates/* DATE_LOCALES */.DJ, language), 'dd/MM/yyyy') : null;
};

var FormContactSchedule_Header = function Header(_ref) {
  var _data$titleImage, _data$titleImage2, _data$titleImage3, _data$titleImage4, _data$titleImage5, _data$fromLogo, _data$fromLogo2, _data$fromLogo3, _data$fromLogo4, _data$fromLogo5, _data$fromLogo6, _data$fromLogo7, _data$fromLogo8, _data$fromLogo9, _data$fromLogo10, _data$byLogo, _data$byLogo2, _data$byLogo3, _data$byLogo4, _data$byLogo5;

  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [data.title && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: "text-white-1 text-h4 lg:text-h2 font-bold mb-4 2xl:text-h1",
      children: data.title
    }), ((_data$titleImage = data.titleImage) === null || _data$titleImage === void 0 ? void 0 : _data$titleImage.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "text-center max-h-72 overflow-hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: (_data$titleImage2 = data.titleImage) === null || _data$titleImage2 === void 0 ? void 0 : _data$titleImage2.url,
        alt: (_data$titleImage3 = data.titleImage) === null || _data$titleImage3 === void 0 ? void 0 : _data$titleImage3.alt,
        width: (_data$titleImage4 = data.titleImage) === null || _data$titleImage4 === void 0 ? void 0 : _data$titleImage4.dimensions.width,
        height: (_data$titleImage5 = data.titleImage) === null || _data$titleImage5 === void 0 ? void 0 : _data$titleImage5.dimensions.height
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "lg:my-4 lg:px-5",
      children: [!!data.fromLabel && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: " hidden lg:flex bg-gray-2 w-full rounded-[2.5rem] text-gray-8 text-p4 px-4 items-center justify-center gap-4 h-14 2xl:h-[3.875rem]",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data.fromLabel
        }), ((_data$fromLogo = data.fromLogo1) === null || _data$fromLogo === void 0 ? void 0 : _data$fromLogo.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "flex-none w-[5.188rem] 2xl:w-[5.625rem] 3xl:w-[5.375rem]",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: (_data$fromLogo2 = data.fromLogo1) === null || _data$fromLogo2 === void 0 ? void 0 : _data$fromLogo2.url,
            alt: (_data$fromLogo3 = data.fromLogo1) === null || _data$fromLogo3 === void 0 ? void 0 : _data$fromLogo3.alt,
            width: (_data$fromLogo4 = data.fromLogo1) === null || _data$fromLogo4 === void 0 ? void 0 : _data$fromLogo4.dimensions.width,
            height: (_data$fromLogo5 = data.fromLogo1) === null || _data$fromLogo5 === void 0 ? void 0 : _data$fromLogo5.dimensions.height
          })
        }), ((_data$fromLogo6 = data.fromLogo2) === null || _data$fromLogo6 === void 0 ? void 0 : _data$fromLogo6.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "flex-none w-[4.375rem] 2xl:w-[4.813rem] 3xl:w-[4.625rem]",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: (_data$fromLogo7 = data.fromLogo2) === null || _data$fromLogo7 === void 0 ? void 0 : _data$fromLogo7.url,
            alt: (_data$fromLogo8 = data.fromLogo2) === null || _data$fromLogo8 === void 0 ? void 0 : _data$fromLogo8.alt,
            width: (_data$fromLogo9 = data.fromLogo2) === null || _data$fromLogo9 === void 0 ? void 0 : _data$fromLogo9.dimensions.width,
            height: (_data$fromLogo10 = data.fromLogo2) === null || _data$fromLogo10 === void 0 ? void 0 : _data$fromLogo10.dimensions.height
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: data.byLabel
        }), ((_data$byLogo = data.byLogo) === null || _data$byLogo === void 0 ? void 0 : _data$byLogo.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "flex-none w-28 2xl:w-[7.438rem] 3xl:w-[7.125rem]",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: (_data$byLogo2 = data.byLogo) === null || _data$byLogo2 === void 0 ? void 0 : _data$byLogo2.url,
            alt: (_data$byLogo3 = data.byLogo) === null || _data$byLogo3 === void 0 ? void 0 : _data$byLogo3.alt,
            width: (_data$byLogo4 = data.byLogo) === null || _data$byLogo4 === void 0 ? void 0 : _data$byLogo4.dimensions.width,
            height: (_data$byLogo5 = data.byLogo) === null || _data$byLogo5 === void 0 ? void 0 : _data$byLogo5.dimensions.height
          })
        })]
      }), (0,prismic/* hasRichText */.M)(data.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-white-2 text-p3 lg:text-p2 text-center pt-6 lg:pt-8 font-medium",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
          render: data.description
        })
      })]
    })]
  });
};

var FormContactSchedule = function FormContactSchedule(_ref2) {
  var _slice$primary$link, _slice$_vertical, _slice$_cluster, _slice$_checkout, _slice$primary, _formState$errors, _slice$primary2, _formState$errors2, _slice$primary3, _formState$errors3, _slice$primary4, _formState$errors4, _formState$errors5, _formState$errors6, _formState$errors7, _formState$errors8, _slice$primary$schedu, _formState$errors9, _formState$errors10;

  var slice = _ref2.slice;

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track,
      identify = _useAnalytics.identify;

  var intl = (0,useIntl/* default */.Z)();
  var locale = (0,useLocale/* default */.Z)();

  var _useState = (0,react.useState)(false),
      showToast = _useState[0],
      setShowToast = _useState[1];

  var showRules = !!(slice.primary.textAgree && slice.primary.label1 && (_slice$primary$link = slice.primary.link1) !== null && _slice$primary$link !== void 0 && _slice$primary$link.uid);
  var vertical = (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var cluster = (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : _slice$_cluster.data;
  var products = (_slice$_checkout = slice._checkout) === null || _slice$_checkout === void 0 ? void 0 : _slice$_checkout.products;
  var geoCountry = (0,useGeoCountry/* default */.Z)();

  var _useState2 = (0,react.useState)(false),
      hasProducts = _useState2[0],
      setHasProducts = _useState2[1];

  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({
    slice: slice,
    cluster: cluster,
    vertical: vertical
  });

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      formState = _useForm.formState;

  var primaryMessages = slice.primary;
  var defaultMessages = {
    nameLabel: intl.formatMessage({
      id: "hCOqfl",
      defaultMessage: [{
        "type": 0,
        "value": "Nombre"
      }]
    }),
    lastnameLabel: intl.formatMessage({
      id: "cEArc/",
      defaultMessage: [{
        "type": 0,
        "value": "Apellido"
      }]
    }),
    emailLabel: intl.formatMessage({
      id: "tkwCac",
      defaultMessage: [{
        "type": 0,
        "value": "E-mail"
      }]
    }),
    phoneCodeLabel: intl.formatMessage({
      id: "/0jxhp",
      defaultMessage: [{
        "type": 0,
        "value": "Código de Área"
      }]
    }),
    phoneLabel: intl.formatMessage({
      id: "S6W4PT",
      defaultMessage: [{
        "type": 0,
        "value": "Teléfono"
      }]
    }),
    phonePlaceholder: intl.formatMessage({
      id: "YTgK22",
      defaultMessage: [{
        "type": 0,
        "value": "11 0000 0000"
      }]
    }),
    scheduleLabel: intl.formatMessage({
      id: "umgKpR",
      defaultMessage: [{
        "type": 0,
        "value": "Horarios"
      }]
    }),
    termsAndConditionsAgree: intl.formatMessage({
      id: "1I7zTd",
      defaultMessage: [{
        "type": 0,
        "value": "Aceptar"
      }]
    }),
    termsAndConditionsLabel: intl.formatMessage({
      id: "o24Y39",
      defaultMessage: [{
        "type": 0,
        "value": "Términos y condiciones"
      }]
    }),
    sendButtonLabel: intl.formatMessage({
      id: "hKJZJR",
      defaultMessage: [{
        "type": 0,
        "value": "Enviar"
      }]
    }),
    morningShift: intl.formatMessage({
      id: "l/HnKq",
      defaultMessage: [{
        "type": 0,
        "value": "Turno Mañana"
      }]
    }),
    afternoonShift: intl.formatMessage({
      id: "oO5ITV",
      defaultMessage: [{
        "type": 0,
        "value": "Turno Tarde"
      }]
    })
  };
  (0,react.useEffect)(function () {
    if (!geoCountry) return;

    var _getLocalePlans = (0,checkout/* getLocalePlans */.Pq)({
      products: products,
      geoCountry: geoCountry,
      locale: locale
    }),
        hasPlans = _getLocalePlans.hasPlans,
        isUnavailable = _getLocalePlans.isUnavailable;

    setHasProducts(!!(hasPlans && !isUnavailable));
  }, [geoCountry, locale, products]);
  var formTrack = (0,react.useCallback)(function (localeCountry, firstName, lastName, email, phoneCode, phone, product) {
    var _product$duration;

    var fields = {
      locale_country: localeCountry,
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone: "".concat(phoneCode).concat(phone)
    };
    identify(fields);
    var schedule = dateFormat(product === null || product === void 0 ? void 0 : product.startsAt, locale);
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'context.next_step', constants/* NextStepFlow.advice */.AH.advice);
    lodash_set_default()(payload, 'fields', fields);
    lodash_set_default()(payload, 'fields.schedule', schedule);
    lodash_set_default()(payload, 'product.start_date', product === null || product === void 0 ? void 0 : product.startsAt);
    lodash_set_default()(payload, 'product.id', product === null || product === void 0 ? void 0 : product.id);
    lodash_set_default()(payload, 'product.business_unit', product === null || product === void 0 ? void 0 : product.defaultOffer.businessUnit);
    lodash_set_default()(payload, 'product.business_unit_id', product === null || product === void 0 ? void 0 : product.defaultOffer.businessUnitId);
    lodash_set_default()(payload, 'product.vertical', product === null || product === void 0 ? void 0 : product.defaultOffer.vertical);
    lodash_set_default()(payload, 'product.vertical_id', product === null || product === void 0 ? void 0 : product.defaultOffer.verticalId);
    lodash_set_default()(payload, 'product.code', product === null || product === void 0 ? void 0 : product.code);
    lodash_set_default()(payload, 'product.duration', product === null || product === void 0 ? void 0 : (_product$duration = product.duration) === null || _product$duration === void 0 ? void 0 : _product$duration.name);
    track(constants/* TrackEvents.productApplicationSubmitted */.Um.productApplicationSubmitted, payload, locale, true);
  }, [trackPayload, locale, identify, track]);

  var onSubmit = function onSubmit(_ref3) {
    var name = _ref3.name,
        lastname = _ref3.lastname,
        email = _ref3.email,
        phonecode = _ref3.phonecode,
        phone = _ref3.phone,
        schedule = _ref3.schedule;
    var product = products === null || products === void 0 ? void 0 : products.find(function (_ref4) {
      var id = _ref4.id;
      return id === schedule;
    });
    formTrack(locale, name, lastname, email, phonecode, phone, product);
    setShowToast(true);
    reset();
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "bg-black-2",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: " dh-content-full flex flex-col p-0 lg:flex-row lg:gap-4 lg:px-[3.875rem] lg:py-[8.75rem]  lg:m-auto lg:max-w-7xl 2xl:max-w-8xl 3xl:max-w-8x5l 3xl:py-[12.5rem] 3xl:gap-20",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        className: "w-full flex justify-center lg:justify-end lg:w-6/12",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: " w-full bg-gray-3 max-w-full lg:rounded-l lg:rounded-r-[5.75rem] lg:w-[35.5rem] lg:h-[35.5rem] py-[4.375rem] px-10.5 flex flex-col justify-center lg:py-0 2xl:px-10 2xl:w-[38rem] 3xl:w-[37.5rem] 3xl:h-[37.5rem]",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactSchedule_Header, {
            data: slice.primary
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full lg:w-6/12 flex justify-start",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
          onSubmit: handleSubmit(onSubmit),
          className: " w-full max-w-full py-8 px-4 bg-gray-1 rounded flex flex-col justify-center lg:w-[35.5rem] lg:h-[35.5rem] lg:px-[3.2rem] lg:py-[4.2rem] 2xl:lg:w-[38rem] 3xl:w-[37.5rem] 3xl:h-[37.5rem]",
          noValidate: true,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-4 lg:gap-6",
            children: [(0,prismic/* hasRichText */.M)(slice.primary.formTitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "text-h7 lg:text-h5 text-white-1 pb-2.5 text-center",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                render: slice.primary.formTitle
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-col gap-4 lg:grid lg:grid-cols-2 lg:gap-3",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormContactSchedule_FormInput, {
                label: (0,common/* getDefaultText */.T9)('nameLabel', primaryMessages, defaultMessages),
                placeholder: (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.namePlaceholder,
                id: "name",
                hasError: !!((_formState$errors = formState.errors) !== null && _formState$errors !== void 0 && _formState$errors.name),
                register: register('name', {
                  required: true
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactSchedule_FormInput, {
                label: (0,common/* getDefaultText */.T9)('lastnameLabel', primaryMessages, defaultMessages),
                placeholder: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.lastnamePlaceholder,
                id: "lastname",
                hasError: !!((_formState$errors2 = formState.errors) !== null && _formState$errors2 !== void 0 && _formState$errors2.lastname),
                register: register('lastname', {
                  required: true
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-col gap-4 lg:gap-3 lg:flex-row",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormContactSchedule_FormInput, {
                className: "w-full lg:w-[12.5rem] 3xl:w-[12.938rem]",
                label: (0,common/* getDefaultText */.T9)('emailLabel', primaryMessages, defaultMessages),
                placeholder: (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.emailPlaceholder,
                id: "email",
                type: "email",
                hasError: !!((_formState$errors3 = formState.errors) !== null && _formState$errors3 !== void 0 && _formState$errors3.email),
                register: register('email', {
                  required: true,
                  pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex gap-3 grow",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "flex-none w-20 lg:w-[5.188rem] 3xl:w-[5.375rem]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactSchedule_FormInput, {
                    label: (0,common/* getDefaultText */.T9)('phoneCodeLabel', primaryMessages, defaultMessages),
                    placeholder: (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.phoneCodePlaceholder,
                    id: "phonecode",
                    className: "w-20 lg:w-[5.188rem] 3xl:w-[5.375rem]",
                    register: register('phonecode', {
                      required: false
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "grow",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactSchedule_FormInput, {
                    label: (0,common/* getDefaultText */.T9)('phoneLabel', primaryMessages, defaultMessages),
                    placeholder: (0,common/* getDefaultText */.T9)('phonePlaceholder', primaryMessages, defaultMessages),
                    id: "phone",
                    register: register('phone', {
                      required: false
                    })
                  })
                })]
              })]
            }), hasProducts && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                htmlFor: "schedule",
                className: "text-white-3 block text-p3 lg:text-p2 font-medium mb-1.5",
                children: [(0,common/* getDefaultText */.T9)('scheduleLabel', primaryMessages, defaultMessages), !!((_formState$errors4 = formState.errors) !== null && _formState$errors4 !== void 0 && _formState$errors4.schedule) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "pl-3 inline-block pointer-events-none align-middle",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* ExclamationCircleIcon */.$Ow, {
                    className: "h-5 w-5 text-red-500",
                    "aria-hidden": "true"
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("select", FormContactSchedule_objectSpread(FormContactSchedule_objectSpread({
                id: "schedule",
                defaultValue: "",
                className: classnames_default()('rounded-md h-[2.875rem] block w-full shadow-sm p-3 border', 'border-white bg-white-2 text-p3', {
                  'text-gray-1 placeholder-gray-7': !((_formState$errors5 = formState.errors) !== null && _formState$errors5 !== void 0 && _formState$errors5.schedule),
                  'focus:ring-gray-800 focus:border-gray-500': !((_formState$errors6 = formState.errors) !== null && _formState$errors6 !== void 0 && _formState$errors6.schedule),
                  'border-red-300 text-red-500 placeholder-red-500': !!((_formState$errors7 = formState.errors) !== null && _formState$errors7 !== void 0 && _formState$errors7.schedule),
                  'focus:ring-red-500 focus:border-red-500 focus:outline-none': !!((_formState$errors8 = formState.errors) !== null && _formState$errors8 !== void 0 && _formState$errors8.schedule)
                }),
                required: true
              }, register('schedule', {
                required: true
              })), {}, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                  value: "",
                  disabled: true,
                  children: (_slice$primary$schedu = slice.primary.schedulePlaceholder) !== null && _slice$primary$schedu !== void 0 ? _slice$primary$schedu : ''
                }, "select"), products === null || products === void 0 ? void 0 : products.map(function (data) {
                  var _data$duration;

                  var startDate = dateFormat(data.startsAt, locale);
                  var shiftDate = !!data.slotFrom && (0,dates/* isMorning */.aG)(data.slotFrom) ? defaultMessages.morningShift : defaultMessages.afternoonShift;
                  var schedule = [(_data$duration = data.duration) === null || _data$duration === void 0 ? void 0 : _data$duration.name, startDate, shiftDate].join(' - ');
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                    value: data.id,
                    children: data.defaultOffer.businessUnitId !== constants/* BusinessUnits.career */.$I.career ? startDate : schedule
                  }, (0,index_browser/* nanoid */.x0)());
                })]
              }))]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "pt-6 text-right",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "relative flex items-start",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex items-center h-5",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", FormContactSchedule_objectSpread({
                  id: "tyc",
                  "aria-describedby": "agree-terms-and-conditions",
                  type: "checkbox",
                  className: "focus:ring-grey-500 h-4 w-4 text-gey-600 border-gray-300 rounded"
                }, register('tyc', {
                  required: true
                })))
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "ml-3 text-p3 lg:text-p2 font-medium",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                  htmlFor: "tyc",
                  className: "mr-2 text-white-2",
                  children: (0,common/* getDefaultText */.T9)('termsAndConditionsAgree', primaryMessages, defaultMessages)
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormContactSchedule_LinkWithQuery, {
                  href: prismic_reactjs.Link.url(slice.primary.termsAndConditionsLink, common/* prismicLinkResolver */.LT),
                  target: "_blank",
                  className: "underline font-bold text-white-2",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    className: "sr-only",
                    children: [(0,common/* getDefaultText */.T9)('termsAndConditionsAgree', primaryMessages, defaultMessages), ' ']
                  }), (0,common/* getDefaultText */.T9)('termsAndConditionsLabel', primaryMessages, defaultMessages)]
                }), !!((_formState$errors9 = formState.errors) !== null && _formState$errors9 !== void 0 && _formState$errors9.tyc) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "pl-3 inline-block pointer-events-none align-middle",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* ExclamationCircleIcon */.$Ow, {
                    className: "h-5 w-5 text-red-500",
                    "aria-hidden": "true"
                  })
                })]
              })]
            })
          }), showRules && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "pt-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "relative flex items-start",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex items-center h-5",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", FormContactSchedule_objectSpread({
                  id: "ryp",
                  "aria-describedby": "agree-terms-and-conditions",
                  type: "checkbox",
                  className: "focus:ring-grey-500 h-4 w-4 text-gey-600 border-gray-300 rounded"
                }, register('ryp', {
                  required: true
                })))
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "ml-3 text-p3 lg:text-p2 font-medium",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                  htmlFor: "ryp",
                  className: "mr-2 text-white-2",
                  children: slice.primary.textAgree
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormContactSchedule_LinkWithQuery, {
                  href: prismic_reactjs.Link.url(slice.primary.link1, common/* prismicLinkResolver */.LT),
                  target: "_blank",
                  className: "underline font-bold text-white-2",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    className: "sr-only",
                    children: [slice.primary.textAgree, ' ']
                  }), slice.primary.label1]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                  htmlFor: "ryp",
                  className: "mx-2 text-white-2",
                  children: slice.primary.textConnector
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormContactSchedule_LinkWithQuery, {
                  href: prismic_reactjs.Link.url(slice.primary.link2, common/* prismicLinkResolver */.LT),
                  target: "_blank",
                  className: "underline font-bold text-white-2",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    className: "sr-only",
                    children: [slice.primary.textAgree, ' ']
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    className: "whitespace-nowrap",
                    children: [slice.primary.label2, !!((_formState$errors10 = formState.errors) !== null && _formState$errors10 !== void 0 && _formState$errors10.ryp) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "pl-3 inline-block pointer-events-none align-middle",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* ExclamationCircleIcon */.$Ow, {
                        className: "h-5 w-5 text-red-500",
                        "aria-hidden": "true"
                      })
                    })]
                  })]
                })]
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "submit",
            className: " dh-button mx-auto mt-8 px-16 py-3 text-p3 font-bold text-black-1 bg-white-1 hover:bg-white-3 lg:mt-10 lg:text-p2 lg:min-w-[19.313rem] 2xl:min-w-[22.375rem] 3xl:text-h7 3xl:min-w-[17.938rem]",
            children: (0,common/* getDefaultText */.T9)('sendButtonLabel', primaryMessages, defaultMessages)
          })]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactSchedule_Toast, {
      show: showToast,
      setShow: setShowToast,
      icon: esm/* CheckCircleIcon */.rE2,
      title: intl.formatMessage({
        id: "wD4LRR",
        defaultMessage: [{
          "type": 0,
          "value": "Gracias"
        }]
      }),
      message: intl.formatMessage({
        id: "9u4Psm",
        defaultMessage: [{
          "type": 0,
          "value": "Te contactaremos a la brevedad para asesorarte y acompañarte en la transformación que comenzaste hoy."
        }]
      })
    })]
  });
};

/* harmony default export */ var variations_FormContactSchedule = (FormContactSchedule);
;// CONCATENATED MODULE: ./slices/Form/variations/FormContactWithLocaltion.tsx


















var FormContactWithLocaltion_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var FormContactWithLocaltion_FormInput = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 547).then(__webpack_require__.bind(__webpack_require__, 547));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(547)];
    }
  }
});
var positions = ['Dueño', 'Representante legal', 'Rector', 'Directivo (primaria)', 'Directivo (secundaria)', 'Coordinador de tecnología', 'Docente', 'Padre de alumno escolar', 'Estudiante'];

var FormContactWithLocaltion = function FormContactWithLocaltion(_ref) {
  var _slice$_vertical, _slice$_cluster, _slice$_product, _slice$primary$link, _slice$primary, _slice$primary2, _slice$primary3, _slice$primary4, _slice$primary5, _slice$primary6, _slice$primary7, _slice$primary8, _slice$primary9, _slice$primary10, _slice$primary10$term;

  var slice = _ref.slice;

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track,
      identify = _useAnalytics.identify;

  var intl = (0,useIntl/* default */.Z)();
  var locale = (0,useLocale/* default */.Z)();

  var _useState = (0,react.useState)(),
      isSending = _useState[0],
      setIsSending = _useState[1];

  var router = (0,next_router.useRouter)();
  var vertical = slice === null || slice === void 0 ? void 0 : (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var cluster = slice === null || slice === void 0 ? void 0 : (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : _slice$_cluster.data;
  var product = slice === null || slice === void 0 ? void 0 : (_slice$_product = slice._product) === null || _slice$_product === void 0 ? void 0 : _slice$_product.data;
  var color = (0,colors/* getColor */.Lq)(vertical === null || vertical === void 0 ? void 0 : vertical.color);
  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({
    slice: slice,
    cluster: cluster,
    vertical: vertical,
    product: product
  });
  var showRules = !!(slice.primary.textAgree && slice.primary.label1 && (_slice$primary$link = slice.primary.link1) !== null && _slice$primary$link !== void 0 && _slice$primary$link.uid);
  var defaultMessages = {
    nameLabel: intl.formatMessage({
      id: "hCOqfl",
      defaultMessage: [{
        "type": 0,
        "value": "Nombre"
      }]
    }),
    lastnameLabel: intl.formatMessage({
      id: "cEArc/",
      defaultMessage: [{
        "type": 0,
        "value": "Apellido"
      }]
    }),
    emailLabel: intl.formatMessage({
      id: "tkwCac",
      defaultMessage: [{
        "type": 0,
        "value": "E-mail"
      }]
    }),
    phoneCodeLabel: intl.formatMessage({
      id: "/0jxhp",
      defaultMessage: [{
        "type": 0,
        "value": "Código de Área"
      }]
    }),
    phoneLabel: intl.formatMessage({
      id: "S6W4PT",
      defaultMessage: [{
        "type": 0,
        "value": "Teléfono"
      }]
    }),
    phonePlaceholder: intl.formatMessage({
      id: "YTgK22",
      defaultMessage: [{
        "type": 0,
        "value": "11 0000 0000"
      }]
    }),
    institutionLabel: intl.formatMessage({
      id: "FugBqF",
      defaultMessage: [{
        "type": 0,
        "value": "Institución"
      }]
    }),
    positionLabel: intl.formatMessage({
      id: "MgCcTq",
      defaultMessage: [{
        "type": 0,
        "value": "Cargo"
      }]
    }),
    stateLabel: intl.formatMessage({
      id: "hfbPMC",
      defaultMessage: [{
        "type": 0,
        "value": "Provincia"
      }]
    }),
    cityLabel: intl.formatMessage({
      id: "/ZNzGW",
      defaultMessage: [{
        "type": 0,
        "value": "Ciudad"
      }]
    }),
    termsAndConditionsAgree: intl.formatMessage({
      id: "1I7zTd",
      defaultMessage: [{
        "type": 0,
        "value": "Aceptar"
      }]
    }),
    termsAndConditionsLabel: intl.formatMessage({
      id: "o24Y39",
      defaultMessage: [{
        "type": 0,
        "value": "Términos y condiciones"
      }]
    }),
    sendButtonLabel: intl.formatMessage({
      id: "hKJZJR",
      defaultMessage: [{
        "type": 0,
        "value": "Enviar"
      }]
    })
  };
  var formTrack = (0,react.useCallback)(function (localeCountry, name, lastname, email, phoneCode, phone, institution, state, city, position) {
    var fields = {
      locale_country: localeCountry,
      first_name: name,
      last_name: lastname,
      email: email,
      phone: "".concat(phoneCode).concat(phone),
      institution: institution,
      company_position: position
    };
    identify(fields);
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'product_name', (cluster === null || cluster === void 0 ? void 0 : cluster.name) || (vertical === null || vertical === void 0 ? void 0 : vertical.name) || 'Unknown');
    lodash_set_default()(payload, 'fields', fields);
    lodash_set_default()(payload, 'fields.state', state);
    lodash_set_default()(payload, 'fields.city', city);
    track(constants/* TrackEvents.productApplicationSubmitted */.Um.productApplicationSubmitted, payload, locale, true); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackPayload]);

  var onSubmit = function onSubmit(event) {
    var _localStorage, _localStorage2, _slice$_vertical2, _slice$_vertical2$dat, _slice$_thankyou, _slice$_thankyou2;

    event.preventDefault();
    setIsSending(true);
    var _event$target = event.target,
        name = _event$target.name,
        lastname = _event$target.lastname,
        email = _event$target.email,
        phonecode = _event$target.phonecode,
        phone = _event$target.phone,
        institution = _event$target.institution,
        state = _event$target.state,
        city = _event$target.city,
        position = _event$target.position;
    (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.setItem('formFirstName', name.value);
    (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.setItem('formVertical', (_slice$_vertical2 = slice._vertical) === null || _slice$_vertical2 === void 0 ? void 0 : (_slice$_vertical2$dat = _slice$_vertical2.data) === null || _slice$_vertical2$dat === void 0 ? void 0 : _slice$_vertical2$dat.color);

    try {
      formTrack(locale, name === null || name === void 0 ? void 0 : name.value, lastname === null || lastname === void 0 ? void 0 : lastname.value, email === null || email === void 0 ? void 0 : email.value, phonecode === null || phonecode === void 0 ? void 0 : phonecode.value, phone === null || phone === void 0 ? void 0 : phone.value, institution === null || institution === void 0 ? void 0 : institution.value, state === null || state === void 0 ? void 0 : state.value, city === null || city === void 0 ? void 0 : city.value, position === null || position === void 0 ? void 0 : position.value);
    } catch (_unused) {
      setIsSending(false);
    }

    var redirectLink = slice._product ? "".concat(__webpack_require__.g.location.pathname, "/").concat(slice === null || slice === void 0 ? void 0 : (_slice$_thankyou = slice._thankyou) === null || _slice$_thankyou === void 0 ? void 0 : _slice$_thankyou.uid) : "".concat(__webpack_require__.g.location.pathname, "/_/_/").concat(slice === null || slice === void 0 ? void 0 : (_slice$_thankyou2 = slice._thankyou) === null || _slice$_thankyou2 === void 0 ? void 0 : _slice$_thankyou2.uid);
    router === null || router === void 0 ? void 0 : router.push({
      pathname: redirectLink
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "dark:bg-gray-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "max-w-xl mx-auto py-24 lg:py-20 lg:px-4",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: "dh-title text-white mb-11 text-2xl font-normal text-center",
        id: (0,common/* slugify */.lV)(slice.primary.title),
        children: slice.primary.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("form", {
          onSubmit: onSubmit,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "overflow-hidden sm:rounded-md text-gray-800 dark:text-gray-300",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "px-4 py-5 sm:p-6",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 gap-6",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactWithLocaltion_FormInput, {
                    label: (0,common/* getDefaultText */.T9)('nameLabel', slice.primary, defaultMessages),
                    placeholder: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.namePlaceholder,
                    name: "name",
                    id: "name",
                    required: true
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactWithLocaltion_FormInput, {
                    label: (0,common/* getDefaultText */.T9)('lastnameLabel', slice.primary, defaultMessages),
                    placeholder: (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.lastnamePlaceholder,
                    name: "lastname",
                    id: "lastname",
                    required: true
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactWithLocaltion_FormInput, {
                    label: (0,common/* getDefaultText */.T9)('emailLabel', slice.primary, defaultMessages),
                    placeholder: (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.emailPlaceholder,
                    name: "email",
                    id: "email",
                    type: "email",
                    required: true
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex gap-6",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "flex-none",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactWithLocaltion_FormInput, {
                      label: (0,common/* getDefaultText */.T9)('phoneCodeLabel', slice.primary, defaultMessages),
                      placeholder: (_slice$primary5 = slice.primary) === null || _slice$primary5 === void 0 ? void 0 : _slice$primary5.phoneCodePlaceholder,
                      name: "phonecode",
                      id: "phonecode",
                      className: "w-20 lg:w-24"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "grow",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactWithLocaltion_FormInput, {
                      label: (0,common/* getDefaultText */.T9)('phoneLabel', slice.primary, defaultMessages),
                      placeholder: (0,common/* getDefaultText */.T9)('phonePlaceholder', slice.primary, defaultMessages),
                      name: "phone",
                      id: "phone"
                    })
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactWithLocaltion_FormInput, {
                    label: (0,common/* getDefaultText */.T9)('institutionLabel', slice.primary, defaultMessages),
                    placeholder: (_slice$primary6 = slice.primary) === null || _slice$primary6 === void 0 ? void 0 : _slice$primary6.institutionPlaceholder,
                    name: "institution",
                    id: "institution",
                    required: true
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                    htmlFor: "position",
                    className: "text-white-3 block text-xs font-semibold mb-2",
                    children: (0,common/* getDefaultText */.T9)('positionLabel', slice.primary, defaultMessages)
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("select", {
                    id: "position",
                    name: "position",
                    defaultValue: "",
                    className: classnames_default()('h-10 block w-full pl-3 pr-10 py-2 text-base sm:text-sm rounded-md border', 'text-gray-900 bg-white placeholder-gray-800 border-black', 'focus:ring-gray-800 focus:border-gray-500'),
                    required: true,
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                      value: "",
                      disabled: true,
                      children: (_slice$primary7 = slice.primary) === null || _slice$primary7 === void 0 ? void 0 : _slice$primary7.positionPlaceholder
                    }, "select"), positions === null || positions === void 0 ? void 0 : positions.map(function (pos) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                        value: pos,
                        children: pos
                      }, (0,index_browser/* nanoid */.x0)());
                    })]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "grid grid-cols-1 sm:grid-cols-2 gap-6",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactWithLocaltion_FormInput, {
                      label: (0,common/* getDefaultText */.T9)('stateLabel', slice.primary, defaultMessages),
                      placeholder: (_slice$primary8 = slice.primary) === null || _slice$primary8 === void 0 ? void 0 : _slice$primary8.statePlaceholder,
                      name: "state",
                      id: "state"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactWithLocaltion_FormInput, {
                      label: (0,common/* getDefaultText */.T9)('cityLabel', slice.primary, defaultMessages),
                      placeholder: (_slice$primary9 = slice.primary) === null || _slice$primary9 === void 0 ? void 0 : _slice$primary9.cityPlaceholder,
                      name: "city",
                      id: "city"
                    })
                  })]
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "grid grid-cols-1 gap-6 px-4 py-3 text-right sm:px-6",
              children: [((_slice$primary10 = slice.primary) === null || _slice$primary10 === void 0 ? void 0 : (_slice$primary10$term = _slice$primary10.termsAndConditionsLink) === null || _slice$primary10$term === void 0 ? void 0 : _slice$primary10$term.type) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "relative flex items-center",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "flex items-center h-5",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                    id: "tyc",
                    "aria-describedby": "agree-terms-and-conditions",
                    name: "tyc",
                    type: "checkbox",
                    className: "focus:ring-grey-500 h-4 w-4 text-gey-600 border-gray-300 rounded",
                    required: true
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "ml-3 text-sm font-normal font-archivo text-left",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                    htmlFor: "tyc",
                    className: "mr-2 text-black dark:text-athensGray",
                    children: (0,common/* getDefaultText */.T9)('termsAndConditionsAgree', slice.primary, defaultMessages)
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormContactWithLocaltion_LinkWithQuery, {
                    href: prismic_reactjs.Link.url(slice.primary.termsAndConditionsLink, common/* prismicLinkResolver */.LT),
                    target: "_blank",
                    className: classnames_default()('underline', color.text),
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: "sr-only",
                      children: [(0,common/* getDefaultText */.T9)('termsAndConditionsAgree', slice.primary, defaultMessages), ' ']
                    }), (0,common/* getDefaultText */.T9)('termsAndConditionsLabel', slice.primary, defaultMessages)]
                  })]
                })]
              }), showRules && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "relative flex items-center",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "flex items-center h-5",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                    id: "ryp",
                    "aria-describedby": "agree-terms-and-conditions",
                    type: "checkbox",
                    className: "focus:ring-grey-500 h-4 w-4 text-gey-600 border-gray-300 rounded",
                    required: true
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "ml-3 text-sm font-normal font-archivo text-left",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                    htmlFor: "ryp",
                    className: "mr-2 text-white",
                    children: slice.primary.textAgree
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactWithLocaltion_LinkWithQuery, {
                    href: prismic_reactjs.Link.url(slice.primary.link1, common/* prismicLinkResolver */.LT),
                    target: "_blank",
                    className: classnames_default()('underline', color.text),
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      children: [slice.primary.label1, ' ']
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                    htmlFor: "ryp",
                    className: "mx-2 text-white-2",
                    children: slice.primary.textConnector
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactWithLocaltion_LinkWithQuery, {
                    href: prismic_reactjs.Link.url(slice.primary.link2, common/* prismicLinkResolver */.LT),
                    target: "_blank",
                    className: classnames_default()('underline', color.text),
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      children: [slice.primary.label2, ' ']
                    })
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                disabled: isSending,
                type: "submit",
                className: classnames_default()('dh-button-sm lg:text-sm row-span-2 my-auto mx-auto px-16 py-3', color.bg, color.bgHover, color.textContrast),
                children: (0,common/* getDefaultText */.T9)('sendButtonLabel', slice.primary, defaultMessages)
              })]
            })]
          })
        })
      })]
    })
  });
};

/* harmony default export */ var variations_FormContactWithLocaltion = (FormContactWithLocaltion);
;// CONCATENATED MODULE: ./slices/Form/variations/FormContactProducts.tsx


function FormContactProducts_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function FormContactProducts_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FormContactProducts_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FormContactProducts_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

























var FormContactProducts_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var FormContactProducts_Toast = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 123).then(__webpack_require__.bind(__webpack_require__, 4123));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4123)];
    }
  }
});
var FormContactProducts_FormInput = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 547).then(__webpack_require__.bind(__webpack_require__, 547));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(547)];
    }
  }
});

var FormContactProducts_dateFormat = function dateFormat(date) {
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'es';
  return date ? (0,dates/* parseDate */.sG)(date, (0,dates/* getCurrentDateLocale */.Et)(dates/* DATE_LOCALES */.DJ, language), 'dd/MM/yyyy') : '';
};

var FormContactProducts_getAvailableItems = function getAvailableItems(items, clusterId) {
  var _items$filter;

  var itemsPage = items === null || items === void 0 ? void 0 : (_items$filter = items.filter(function (product) {
    var _product$data, _product$data$cluster;

    return (product === null || product === void 0 ? void 0 : (_product$data = product.data) === null || _product$data === void 0 ? void 0 : (_product$data$cluster = _product$data.clusterPage) === null || _product$data$cluster === void 0 ? void 0 : _product$data$cluster.id) === clusterId;
  })) === null || _items$filter === void 0 ? void 0 : _items$filter.filter(function (product) {
    var _product$data2, _product$data3;

    return !(product !== null && product !== void 0 && (_product$data2 = product.data) !== null && _product$data2 !== void 0 && _product$data2.startDate) || new Date(product === null || product === void 0 ? void 0 : (_product$data3 = product.data) === null || _product$data3 === void 0 ? void 0 : _product$data3.startDate).getTime() >= new Date().getTime();
  });
  return itemsPage;
};

var FormContactProducts = function FormContactProducts(_ref) {
  var _slice$primary$link, _slice$_vertical, _slice$_cluster, _slice$_cluster2, _slice$primary, _formState$errors, _slice$primary2, _formState$errors2, _slice$primary3, _formState$errors3, _slice$primary4, _slice$_products, _formState$errors4, _formState$errors5, _formState$errors6, _formState$errors7, _formState$errors8, _slice$primary$schedu, _formState$errors9, _formState$errors10;

  var slice = _ref.slice;

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track,
      identify = _useAnalytics.identify;

  var _useContext = (0,react.useContext)(AppContext/* AppContext */.I),
      state = _useContext.state;

  var intl = (0,useIntl/* default */.Z)();
  var locale = (0,useLocale/* default */.Z)();

  var _useState = (0,react.useState)(false),
      showToast = _useState[0],
      setShowToast = _useState[1];

  var showRules = !!(slice.primary.textAgree && slice.primary.label1 && (_slice$primary$link = slice.primary.link1) !== null && _slice$primary$link !== void 0 && _slice$primary$link.uid);
  var vertical = (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var pillColor = (0,colors/* getColor */.Lq)(slice.primary.pillColor || (vertical === null || vertical === void 0 ? void 0 : vertical.color), 500);
  var cluster = (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : _slice$_cluster.data;
  var products = lodash_sortby_default()(FormContactProducts_getAvailableItems(slice._products, (_slice$_cluster2 = slice._cluster) === null || _slice$_cluster2 === void 0 ? void 0 : _slice$_cluster2.id), function (item) {
    return item.data.startDate;
  });
  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({
    slice: slice,
    cluster: cluster,
    vertical: vertical
  });

  var _useForm = (0,index_esm/* useForm */.cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      formState = _useForm.formState,
      setValue = _useForm.setValue;

  var primaryMessages = slice.primary;
  var defaultMessages = {
    nameLabel: intl.formatMessage({
      id: "hCOqfl",
      defaultMessage: [{
        "type": 0,
        "value": "Nombre"
      }]
    }),
    lastnameLabel: intl.formatMessage({
      id: "cEArc/",
      defaultMessage: [{
        "type": 0,
        "value": "Apellido"
      }]
    }),
    emailLabel: intl.formatMessage({
      id: "tkwCac",
      defaultMessage: [{
        "type": 0,
        "value": "E-mail"
      }]
    }),
    phoneCodeLabel: intl.formatMessage({
      id: "/0jxhp",
      defaultMessage: [{
        "type": 0,
        "value": "Código de Área"
      }]
    }),
    phoneLabel: intl.formatMessage({
      id: "S6W4PT",
      defaultMessage: [{
        "type": 0,
        "value": "Teléfono"
      }]
    }),
    phonePlaceholder: intl.formatMessage({
      id: "YTgK22",
      defaultMessage: [{
        "type": 0,
        "value": "11 0000 0000"
      }]
    }),
    scheduleLabel: intl.formatMessage({
      id: "umgKpR",
      defaultMessage: [{
        "type": 0,
        "value": "Horarios"
      }]
    }),
    termsAndConditionsAgree: intl.formatMessage({
      id: "1I7zTd",
      defaultMessage: [{
        "type": 0,
        "value": "Aceptar"
      }]
    }),
    termsAndConditionsLabel: intl.formatMessage({
      id: "o24Y39",
      defaultMessage: [{
        "type": 0,
        "value": "Términos y condiciones"
      }]
    }),
    sendButtonLabel: intl.formatMessage({
      id: "hKJZJR",
      defaultMessage: [{
        "type": 0,
        "value": "Enviar"
      }]
    }),
    morningShift: intl.formatMessage({
      id: "l/HnKq",
      defaultMessage: [{
        "type": 0,
        "value": "Turno Mañana"
      }]
    }),
    afternoonShift: intl.formatMessage({
      id: "oO5ITV",
      defaultMessage: [{
        "type": 0,
        "value": "Turno Tarde"
      }]
    }),
    thankyouTitle: intl.formatMessage({
      id: "wD4LRR",
      defaultMessage: [{
        "type": 0,
        "value": "Gracias"
      }]
    }),
    thankyouMessage: intl.formatMessage({
      id: "9u4Psm",
      defaultMessage: [{
        "type": 0,
        "value": "Te contactaremos a la brevedad para asesorarte y acompañarte en la transformación que comenzaste hoy."
      }]
    })
  };
  var formTrack = (0,react.useCallback)(function (localeCountry, firstName, lastName, email, phoneCode, phone, product) {
    var fields = {
      locale_country: localeCountry,
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone: "".concat(phoneCode).concat(phone)
    };
    identify(fields);
    var schedule = ["".concat(FormContactProducts_dateFormat(product === null || product === void 0 ? void 0 : product.startDate, locale)), product === null || product === void 0 ? void 0 : product.scheduleDays, product === null || product === void 0 ? void 0 : product.scheduleHours].join(' | ');
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'context.next_step', constants/* NextStepFlow.advice */.AH.advice);
    lodash_set_default()(payload, 'fields', fields);
    lodash_set_default()(payload, 'fields.schedule', schedule);
    lodash_set_default()(payload, 'product.start_date', product === null || product === void 0 ? void 0 : product.startDate);
    lodash_set_default()(payload, 'product.end_date', product === null || product === void 0 ? void 0 : product.endDate);
    track(constants/* TrackEvents.productApplicationSubmitted */.Um.productApplicationSubmitted, payload, locale, true); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackPayload]);

  var onSubmit = function onSubmit(_ref2) {
    var name = _ref2.name,
        lastname = _ref2.lastname,
        email = _ref2.email,
        phonecode = _ref2.phonecode,
        phone = _ref2.phone,
        schedule = _ref2.schedule;

    var product = slice._products.find(function (_ref3) {
      var id = _ref3.id;
      return id === schedule;
    });

    formTrack(locale, name, lastname, email, phonecode, phone, product === null || product === void 0 ? void 0 : product.data);
    setShowToast(true);
    reset();
  };

  (0,react.useEffect)(function () {
    if (state.products.selected) {
      setValue('schedule', state.products.selected.id);
    }
  }, [state.products.selected, setValue]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "bg-black-2",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: " dh-content-full flex flex-col p-0 lg:flex-row lg:gap-4 lg:px-[3.875rem] lg:py-[8.75rem] lg:m-auto lg:max-w-7xl 2xl:max-w-8xl 3xl:max-w-8x5l 3xl:py-[12.5rem] 3xl:gap-20",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        className: "w-full flex justify-center lg:justify-end lg:w-6/12",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: " w-full bg-gray-3 items-start max-w-full lg:rounded-l lg:rounded-r-[5.75rem] lg:w-[35.5rem] lg:h-[35.5rem] py-[4.375rem] px-10.5 flex flex-col justify-center lg:py-0 2xl:px-10 2xl:w-[38rem] 3xl:w-[37.5rem] 3xl:h-[37.5rem] 3xl:px-12",
          children: [slice.primary.pillText && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classnames_default()(pillColor.bg, 'text-white-1 rounded-4xl flex items-center font-medium text-center w-fit', 'text-sm justify-center leading-6 px-4 py-1.5 inline-block mb-4', 'lg:text-lg'),
            children: slice.primary.pillText
          }), slice.primary.title && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "text-white-1 text-h4 lg:text-h2 font-bold mb-4 2xl:text-h1",
            children: slice.primary.title
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex gap-3 lg:gap-2 flex-col lg:flex-row",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "bg-transparent text-p3 py-1.5 px-4 text-white-1 border border-white-1 rounded-4xl",
              children: slice.primary.modalityPillText
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "bg-transparent text-p3 py-1.5 px-4 text-white-1 border border-white-1 rounded-4xl",
              children: slice.primary.durationPillText
            })]
          }), (0,prismic/* hasRichText */.M)(slice.primary.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-white-2 text-p3 lg:text-p2 pt-6 lg:pt-8 font-medium 3xl:pt-9",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
              render: slice.primary.description
            })
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full lg:w-6/12 flex justify-start",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
          onSubmit: handleSubmit(onSubmit),
          className: " w-full max-w-full py-8 px-4 bg-gray-1 rounded flex flex-col justify-center lg:w-[35.5rem] lg:h-[35.5rem] lg:px-[3.2rem] lg:py-[4.2rem] 2xl:lg:w-[38rem] 3xl:w-[37.5rem] 3xl:h-[37.5rem]",
          noValidate: true,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col gap-4 lg:gap-6",
            children: [(0,prismic/* hasRichText */.M)(slice.primary.formTitle) && /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "text-h7 lg:text-h5 font-bold text-white-1 pb-2.5 text-center",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                render: slice.primary.formTitle
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-col gap-4 lg:grid lg:grid-cols-2 lg:gap-3",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormContactProducts_FormInput, {
                label: (0,common/* getDefaultText */.T9)('nameLabel', primaryMessages, defaultMessages),
                placeholder: (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.namePlaceholder,
                id: "name",
                hasError: !!((_formState$errors = formState.errors) !== null && _formState$errors !== void 0 && _formState$errors.name),
                register: register('name', {
                  required: true
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactProducts_FormInput, {
                label: (0,common/* getDefaultText */.T9)('lastnameLabel', primaryMessages, defaultMessages),
                placeholder: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.lastnamePlaceholder,
                id: "lastname",
                hasError: !!((_formState$errors2 = formState.errors) !== null && _formState$errors2 !== void 0 && _formState$errors2.lastname),
                register: register('lastname', {
                  required: true
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-col gap-4 lg:gap-3 lg:flex-row",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FormContactProducts_FormInput, {
                className: "w-full lg:w-[12.5rem] 3xl:w-[12.938rem]",
                label: (0,common/* getDefaultText */.T9)('emailLabel', primaryMessages, defaultMessages),
                placeholder: (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.emailPlaceholder,
                id: "email",
                type: "email",
                hasError: !!((_formState$errors3 = formState.errors) !== null && _formState$errors3 !== void 0 && _formState$errors3.email),
                register: register('email', {
                  required: true,
                  pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex gap-3 grow",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "flex-none w-20 lg:w-[5.188rem] 3xl:w-[5.375rem]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactProducts_FormInput, {
                    label: (0,common/* getDefaultText */.T9)('phoneCodeLabel', primaryMessages, defaultMessages),
                    placeholder: (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.phoneCodePlaceholder,
                    id: "phonecode",
                    className: "w-20 lg:w-[5.188rem] 3xl:w-[5.375rem]",
                    register: register('phonecode', {
                      required: false
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "grow",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactProducts_FormInput, {
                    label: (0,common/* getDefaultText */.T9)('phoneLabel', primaryMessages, defaultMessages),
                    placeholder: (0,common/* getDefaultText */.T9)('phonePlaceholder', primaryMessages, defaultMessages),
                    id: "phone",
                    register: register('phone', {
                      required: false
                    })
                  })
                })]
              })]
            }), !!((_slice$_products = slice._products) !== null && _slice$_products !== void 0 && _slice$_products.length) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                htmlFor: "schedule",
                className: "text-white-3 block text-p3 lg:text-p2 font-medium mb-1.5",
                children: [(0,common/* getDefaultText */.T9)('scheduleLabel', primaryMessages, defaultMessages), !!((_formState$errors4 = formState.errors) !== null && _formState$errors4 !== void 0 && _formState$errors4.schedule) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "pl-3 inline-block pointer-events-none align-middle",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* ExclamationCircleIcon */.$Ow, {
                    className: "h-5 w-5 text-red-500",
                    "data-testid": "test-error",
                    "aria-hidden": "true"
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("select", FormContactProducts_objectSpread(FormContactProducts_objectSpread({
                id: "schedule",
                defaultValue: "",
                className: classnames_default()('rounded-md h-[2.875rem] block w-full shadow-sm p-3 border', 'border-white bg-white-2 text-p3', {
                  'text-gray-1 placeholder-gray-7': !((_formState$errors5 = formState.errors) !== null && _formState$errors5 !== void 0 && _formState$errors5.schedule),
                  'focus:ring-gray-800 focus:border-gray-500': !((_formState$errors6 = formState.errors) !== null && _formState$errors6 !== void 0 && _formState$errors6.schedule),
                  'border-red-300 text-red-500 placeholder-red-500': !!((_formState$errors7 = formState.errors) !== null && _formState$errors7 !== void 0 && _formState$errors7.schedule),
                  'focus:ring-red-500 focus:border-red-500 focus:outline-none': !!((_formState$errors8 = formState.errors) !== null && _formState$errors8 !== void 0 && _formState$errors8.schedule)
                }),
                required: true
              }, register('schedule', {
                required: true
              })), {}, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                  value: "",
                  disabled: true,
                  children: (_slice$primary$schedu = slice.primary.schedulePlaceholder) !== null && _slice$primary$schedu !== void 0 ? _slice$primary$schedu : ''
                }, "select"), products.map(function (product) {
                  var schedule = [FormContactProducts_dateFormat(product.data.startDate, locale), product === null || product === void 0 ? void 0 : product.data.scheduleDays, product === null || product === void 0 ? void 0 : product.data.scheduleHours].join(' - ');
                  return schedule && /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                    value: product.id,
                    children: schedule
                  }, (0,index_browser/* nanoid */.x0)());
                })]
              }))]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "pt-6 text-right",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "relative flex items-start",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex items-center h-5",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", FormContactProducts_objectSpread({
                  id: "tyc",
                  "aria-describedby": "agree-terms-and-conditions",
                  type: "checkbox",
                  className: "focus:ring-grey-500 h-4 w-4 text-gey-600 border-gray-300 rounded"
                }, register('tyc', {
                  required: true
                })))
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "ml-3 text-p3 lg:text-p2 font-medium",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                  htmlFor: "tyc",
                  className: "mr-2 text-white-2",
                  children: (0,common/* getDefaultText */.T9)('termsAndConditionsAgree', primaryMessages, defaultMessages)
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormContactProducts_LinkWithQuery, {
                  href: prismic_reactjs.Link.url(slice.primary.termsAndConditionsLink, common/* prismicLinkResolver */.LT),
                  target: "_blank",
                  className: "underline font-bold text-white-2",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    className: "sr-only",
                    children: [(0,common/* getDefaultText */.T9)('termsAndConditionsAgree', primaryMessages, defaultMessages), ' ']
                  }), (0,common/* getDefaultText */.T9)('termsAndConditionsLabel', primaryMessages, defaultMessages)]
                }), !!((_formState$errors9 = formState.errors) !== null && _formState$errors9 !== void 0 && _formState$errors9.tyc) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "pl-3 inline-block pointer-events-none align-middle",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* ExclamationCircleIcon */.$Ow, {
                    className: "h-5 w-5 text-red-500",
                    "aria-hidden": "true",
                    "data-testid": "test-error"
                  })
                })]
              })]
            })
          }), showRules && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "pt-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "relative flex items-start",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex items-center h-5",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("input", FormContactProducts_objectSpread({
                  id: "ryp",
                  "aria-describedby": "agree-terms-and-conditions",
                  type: "checkbox",
                  className: "focus:ring-grey-500 h-4 w-4 text-gey-600 border-gray-300 rounded"
                }, register('ryp', {
                  required: true
                })))
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "ml-3 text-p3 lg:text-p2 font-medium",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                  htmlFor: "ryp",
                  className: "mr-2 text-white-2",
                  children: slice.primary.textAgree
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormContactProducts_LinkWithQuery, {
                  href: prismic_reactjs.Link.url(slice.primary.link1, common/* prismicLinkResolver */.LT),
                  target: "_blank",
                  className: "underline font-bold text-white-2",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    className: "sr-only",
                    children: [slice.primary.textAgree, ' ']
                  }), slice.primary.label1]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
                  htmlFor: "ryp",
                  className: "mx-2 text-white-2",
                  children: slice.primary.textConnector
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FormContactProducts_LinkWithQuery, {
                  href: prismic_reactjs.Link.url(slice.primary.link2, common/* prismicLinkResolver */.LT),
                  target: "_blank",
                  className: "underline font-bold text-white-2",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    className: "sr-only",
                    children: [slice.primary.textAgree, ' ']
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    className: "whitespace-nowrap",
                    children: [slice.primary.label2, !!((_formState$errors10 = formState.errors) !== null && _formState$errors10 !== void 0 && _formState$errors10.ryp) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "pl-3 inline-block pointer-events-none align-middle",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* ExclamationCircleIcon */.$Ow, {
                        className: "h-5 w-5 text-red-500",
                        "aria-hidden": "true",
                        "data-testid": "test-error"
                      })
                    })]
                  })]
                })]
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "submit",
            className: " dh-button mx-auto mt-8 px-16 py-3 text-p3 font-bold text-black-1 bg-white-1 hover:bg-white-3 lg:mt-10 lg:text-p2 lg:min-w-[19.313rem] 2xl:min-w-[22.375rem] 3xl:text-h7 3xl:min-w-[17.938rem]",
            children: (0,common/* getDefaultText */.T9)('sendButtonLabel', primaryMessages, defaultMessages)
          })]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormContactProducts_Toast, {
      show: showToast,
      setShow: setShowToast,
      icon: esm/* CheckCircleIcon */.rE2,
      title: defaultMessages.thankyouTitle,
      message: defaultMessages.thankyouMessage
    })]
  });
};

/* harmony default export */ var variations_FormContactProducts = (FormContactProducts);
;// CONCATENATED MODULE: ./slices/Form/index.tsx











var Form = function Form(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case FormVariations.contactWithLocation:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FormContactWithLocaltion, {
        slice: slice
      });

    case FormVariations.contactClusterSelect:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FormContactClusterSelect, {
        slice: slice
      });

    case FormVariations.contactBenefitSelect:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FormContactBenefitSelect, {
        slice: slice
      });

    case FormVariations.contactCompany:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FormContactCompany, {
        slice: slice
      });

    case FormVariations.contact:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FormContact, {
        slice: slice
      });

    case FormVariations.contactSchedule:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FormContactSchedule, {
        slice: slice
      });

    case FormVariations.contactProducts:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_FormContactProducts, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var slices_Form = (Form);
;// CONCATENATED MODULE: ./slices/GridLists/GridLists.types.ts
var GridListsVariations;

(function (GridListsVariations) {
  GridListsVariations["twoColumnsWithImage"] = "gridListsTwoColumnsWithImage";
  GridListsVariations["withIcon"] = "gridListsWithIcon";
  GridListsVariations["withIconSimple"] = "gridListsWithIconSimple";
  GridListsVariations["withIconDark"] = "gridListsWithIconDark";
  GridListsVariations["withIconLight"] = "gridListsWithIconLight";
  GridListsVariations["withIconCentered"] = "gridListsWithIconCentered";
  GridListsVariations["fiveColumns"] = "gridListsFiveColumns";
  GridListsVariations["withOnlyText"] = "gridListsWithOnlyText";
  GridListsVariations["withImage"] = "gridListsWithImage";
  GridListsVariations["withFilter"] = "gridListsWithFilter";
  GridListsVariations["cardAnimated"] = "gridListsCardAnimated";
  GridListsVariations["cta"] = "gridListsCta";
  GridListsVariations["productsCheckout"] = "gridListsProductsCheckout";
  GridListsVariations["products"] = "gridListsProducts";
  GridListsVariations["profiles"] = "gridListsProfiles";
})(GridListsVariations || (GridListsVariations = {}));
// EXTERNAL MODULE: ./contexts/reducers/benefit.reducer.ts
var benefit_reducer = __webpack_require__(2452);
;// CONCATENATED MODULE: ./slices/GridLists/variations/GridListsTwoColumnsWithImage.tsx













var GridListsTwoColumnsWithImage_Modal = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7310));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(7310)];
    }
  }
});

var GridListsTwoColumnsWithImage = function GridListsTwoColumnsWithImage(_ref) {
  var _slice$primary, _slice$primary2, _slice$items;

  var slice = _ref.slice;

  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var _useContext = (0,react.useContext)(AppContext/* AppContext */.I),
      dispatch = _useContext.dispatch;

  var hasApplyButton = !!((_slice$primary = slice.primary) !== null && _slice$primary !== void 0 && _slice$primary.applyButtonLabel && (_slice$primary2 = slice.primary) !== null && _slice$primary2 !== void 0 && _slice$primary2.applyFragmentIdentifier);

  var hasTyCButton = function hasTyCButton(item) {
    return !!(item.termsAndConditionsLabel && item.termsAndConditionsText);
  };

  var selectBenefit = function selectBenefit(benefit) {
    var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    dispatch({
      type: benefit_reducer/* BenefitActionTypes.select */.y.select,
      item: benefit
    });
    (0,common/* scrollTo */.X5)({
      id: (0,common/* slugify */.lV)(id)
    });
  };

  (0,react.useEffect)(function () {
    return function () {
      return dispatch({
        type: benefit_reducer/* BenefitActionTypes.select */.y.select,
        item: null
      });
    };
  }, [dispatch]);
  (0,react.useEffect)(function () {
    if (hasApplyButton && slice.items) dispatch({
      type: benefit_reducer/* BenefitActionTypes.add */.y.add,
      items: slice.items
    });
  }, [hasApplyButton, slice.items, dispatch]);
  return slice !== null && slice !== void 0 && (_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "bg-gray-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "dh-content grid lg:grid-cols-3 gap-5",
      children: slice.items.map(function (item, key) {
        var _item$image, _item$description, _item$termsAndConditi, _slice$primary4;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-row p-5 gap-5 rounded-lg bg-white",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col flex-initial w-1/2 xl:w-2/5",
            children: [((_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "mb-3 max-w-[6.25rem]",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: item.image.url,
                alt: item.image.alt,
                width: item.image.dimensions.width,
                height: item.image.dimensions.height,
                layout: "responsive",
                objectFit: "cover"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "font-light text-5xl break-words",
              children: item.title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-sm break-words",
              children: item.subtitle
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col grow text-xs w-1/2 xl:w-3/5",
            children: [!!((_item$description = item.description) !== null && _item$description !== void 0 && _item$description.length) && prismic_reactjs.RichText.render(item.description), hasTyCButton(item) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "pt-3 underline text-left",
                onClick: function onClick() {
                  return setOpen(key);
                },
                children: item.termsAndConditionsLabel
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(GridListsTwoColumnsWithImage_Modal, {
                state: open === key,
                setOpen: setOpen,
                size: Modal.ModalSize.md,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  className: "text-2xl font-bold text-black mb-5",
                  children: item.termsAndConditionsLabel
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "text-sm my-richtext-6",
                  children: !!((_item$termsAndConditi = item.termsAndConditionsText) !== null && _item$termsAndConditi !== void 0 && _item$termsAndConditi.length) && prismic_reactjs.RichText.render(item.termsAndConditionsText)
                })]
              })]
            }), hasApplyButton && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              type: "button",
              className: "dh-button-sm h-8 w-36 mt-8 self-end max-w-full",
              onClick: function onClick() {
                var _slice$primary3;

                return selectBenefit(item, (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.applyFragmentIdentifier);
              },
              children: (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.applyButtonLabel
            })]
          })]
        }, (0,index_browser/* nanoid */.x0)());
      })
    })
  }) : null;
};

/* harmony default export */ var variations_GridListsTwoColumnsWithImage = (GridListsTwoColumnsWithImage);
;// CONCATENATED MODULE: ./slices/GridLists/variations/GridListsWithIcon.tsx






var GridListsWithIcon_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});

var GridListsWithIcon = function GridListsWithIcon(_ref) {
  var _slice$items, _slice$primary, _slice$primary2;

  var slice = _ref.slice;
  return slice !== null && slice !== void 0 && (_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-white",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        className: "mb-8 lg:mb-20 text-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "font-bold text-2xl text-gray-800",
          children: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: "grid sm:grid-cols-2 lg:grid-cols-4 gap-5",
        children: slice.items.map(function (_ref2) {
          var icon = _ref2.icon,
              title = _ref2.title,
              description = _ref2.description;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "px-6 py-12 space-y-5 rounded-2xl bg-gray-200",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GridListsWithIcon_Icon, {
              icon: icon,
              className: "w-7 text-primary"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "text-lg font-bold text-gray-800",
              children: title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-sm text-gray-800 leading-6",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                render: description
              })
            })]
          }, (0,index_browser/* nanoid */.x0)());
        })
      })]
    })
  }) : null;
};

/* harmony default export */ var variations_GridListsWithIcon = (GridListsWithIcon);
;// CONCATENATED MODULE: ./slices/GridLists/variations/GridListsWithIconDark.tsx






var GridListsWithIconDark_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});

var GridListsWithIconDark = function GridListsWithIconDark(_ref) {
  var _slice$items, _slice$primary, _slice$primary2;

  var slice = _ref.slice;
  return slice !== null && slice !== void 0 && (_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-black",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        className: "mb-8 lg:mb-20 text-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "font-bold text-2xl text-white",
          children: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: "grid sm:grid-cols-2 lg:grid-cols-4 gap-5",
        children: slice.items.map(function (_ref2) {
          var icon = _ref2.icon,
              title = _ref2.title,
              description = _ref2.description;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "px-6 py-12 space-y-5 rounded-2xl bg-gray-3",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GridListsWithIconDark_Icon, {
              icon: icon,
              className: "w-7 text-primary"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "text-lg font-bold text-athensGray",
              children: title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-sm text-white-2 leading-6",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                render: description
              })
            })]
          }, (0,index_browser/* nanoid */.x0)());
        })
      })]
    })
  }) : null;
};

/* harmony default export */ var variations_GridListsWithIconDark = (GridListsWithIconDark);
;// CONCATENATED MODULE: ./slices/GridLists/variations/GridListsFiveColumns.tsx






var MAX_HEIGHT = 128;

var GridListsFiveColumns = function GridListsFiveColumns(_ref) {
  var _slice$items;

  var slice = _ref.slice;
  return slice !== null && slice !== void 0 && (_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "dh-content bg-white pt-16 pb-32",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
      className: classnames_default()('dh-title text-gray-800 dark:text-gray-800 text-center text-4xl font-bold', 'max-w-xl mx-auto', 'mb-10 lg:mb-20'),
      children: slice.primary.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()('flex flex-wrap gap-x-5 sm:gap-y-11', 'justify-center'),
      children: slice.items.map(function (item) {
        var _item$image;

        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "self-center text-center w-[14rem] p-5",
          children: ((_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: item.image.url,
            alt: item.image.alt,
            width: item.image.dimensions.width,
            height: MAX_HEIGHT,
            layout: "responsive",
            objectFit: "contain"
          })
        }, (0,index_browser/* nanoid */.x0)());
      })
    })]
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "hidden"
  });
};

/* harmony default export */ var variations_GridListsFiveColumns = (GridListsFiveColumns);
;// CONCATENATED MODULE: ./slices/GridLists/variations/GridListsWithIconSimple.tsx







var GridListsWithIconSimple_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});

var GridListsWithIconSimple = function GridListsWithIconSimple(_ref) {
  var _slice$items, _slice$primary, _slice$primary2;

  var slice = _ref.slice;
  return slice !== null && slice !== void 0 && (_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-white",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        className: "mb-8 lg:mb-20 text-left",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "font-bold text-2xl text-black",
          children: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: "grid sm:grid-cols-3 gap-10 sm:gap-24",
        children: slice.items.map(function (_ref2) {
          var icon = _ref2.icon,
              description = _ref2.description;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "space-y-7",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GridListsWithIconSimple_Icon, {
              icon: icon,
              className: "w-9 text-primary"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: classnames_default()('text-sm text-gray-900 font-medium leading-7', 'before:h-3 before:w-1 before:bg-primary before:block before:absolute before:mt-2 before:-ml-3'),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                render: description
              })
            })]
          }, (0,index_browser/* nanoid */.x0)());
        })
      })]
    })
  }) : null;
};

/* harmony default export */ var variations_GridListsWithIconSimple = (GridListsWithIconSimple);
;// CONCATENATED MODULE: ./slices/GridLists/variations/GridListsWithIconCentered.tsx







var GridListsWithIconCentered_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});
var gridOptions = {
  fullWidth: [1, 2, 4],
  displayGrid: [2, 4]
};

var GridListsWithIconCentered = function GridListsWithIconCentered(_ref) {
  var _slice$items$length, _slice$items, _slice$primary, _slice$primary2, _slice$items2;

  var slice = _ref.slice;
  var gridSize = (_slice$items$length = (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.length) !== null && _slice$items$length !== void 0 ? _slice$items$length : 0;
  var isFullWidth = gridOptions.fullWidth.includes(gridSize);
  var isGrid = gridOptions.displayGrid.includes(gridSize);
  return gridSize ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-black",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        className: "mb-8 lg:mb-20 text-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "font-semibold text-3.5xl text-white",
          children: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: classnames_default()('gap-5', {
          'flex flex-wrap justify-center': !isGrid
        }, {
          'grid sm:grid-cols-2': isGrid
        }),
        children: (_slice$items2 = slice.items) === null || _slice$items2 === void 0 ? void 0 : _slice$items2.map(function (_ref2) {
          var icon = _ref2.icon,
              title = _ref2.title,
              description = _ref2.description;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: classnames_default()('p-8 space-y-5 rounded-2xl bg-gray-3 text-center', {
              'w-full md:max-w-[23.563rem]': !isFullWidth
            }, {
              'w-full': isFullWidth
            }),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GridListsWithIconCentered_Icon, {
              icon: icon,
              className: "w-10 text-primary inline-block"
            }), title && /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "text-xl leading-8 font-semibold text-athensGray md:min-h-[4rem]",
              children: title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-sm text-white-2 leading-6 text-left",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                render: description
              })
            })]
          }, (0,index_browser/* nanoid */.x0)());
        })
      })]
    })
  }) : null;
};

/* harmony default export */ var variations_GridListsWithIconCentered = (GridListsWithIconCentered);
;// CONCATENATED MODULE: ./slices/GridLists/variations/GridListsWithOnlyText.tsx







var GridListsWithOnlyText_Card = function Card(_ref) {
  var title = _ref.title,
      description = _ref.description;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
    className: "px-6 py-12 space-y-5 rounded-md bg-white",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      className: "text-lg font-bold text-gray-900 leading-6",
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "text-sm font-normal text-gray-900 leading-5 my-richtext-list-disc",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
        render: description
      })
    })]
  });
};

var CardList = function CardList(_ref2) {
  var items = _ref2.items;
  return items !== null && items !== void 0 && items.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: classnames_default()('grid sm:grid-cols-2 lg:grid-cols-3 gap-10'),
    children: items.slice(0, 3).map(function (_ref3) {
      var title = _ref3.title,
          description = _ref3.description;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(GridListsWithOnlyText_Card, {
        title: title,
        description: description
      }, (0,index_browser/* nanoid */.x0)());
    })
  }) : null;
};

var GridListsWithOnlyText = function GridListsWithOnlyText(_ref4) {
  var _slice$items, _slice$primary, _slice$primary2;

  var slice = _ref4.slice;
  return slice !== null && slice !== void 0 && (_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-gray-900",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        className: "mb-8 lg:mb-10",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "font-bold text-2xl text-athensGray-100",
          children: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CardList, {
        items: slice === null || slice === void 0 ? void 0 : slice.items
      })]
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "hidden"
  });
};

/* harmony default export */ var variations_GridListsWithOnlyText = (GridListsWithOnlyText);
;// CONCATENATED MODULE: ./slices/GridLists/variations/GridListsWithIconLight.tsx






var GridListsWithIconLight_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});

var GridListsWithIconLight = function GridListsWithIconLight(_ref) {
  var _slice$items;

  var slice = _ref.slice;
  return slice !== null && slice !== void 0 && (_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-white-2",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "dh-content",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: "grid sm:grid-cols-1 lg:grid-cols-3 gap-16",
        children: slice.items.map(function (_ref2) {
          var icon = _ref2.icon,
              description = _ref2.description;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "px-8 pt-16 pb-14 space-y-5 rounded-2xl border bg-white border-athensGray-700",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GridListsWithIconLight_Icon, {
              icon: icon,
              className: "text-primary w-9"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-lg text-gray-900 leading-8 font-bold",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                render: description
              })
            })]
          }, (0,index_browser/* nanoid */.x0)());
        })
      })
    })
  }) : null;
};

/* harmony default export */ var variations_GridListsWithIconLight = (GridListsWithIconLight);
;// CONCATENATED MODULE: ./slices/GridLists/variations/GridListsWithImage.tsx








var GridListsWithImage = function GridListsWithImage(_ref) {
  var _slice$items, _slice$primary, _slice$primary2;

  var slice = _ref.slice;
  return slice !== null && slice !== void 0 && (_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: classnames_default()('bg-white text-gray-1', {
      'hidden lg:block': (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.hiddenOnMobile
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [!!((_slice$primary2 = slice.primary) !== null && _slice$primary2 !== void 0 && _slice$primary2.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "text-3.5xl text-center mb-12",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: slice.primary.title
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex flex-wrap justify-center gap-28 lg:gap-10",
        children: slice.items.map(function (item) {
          var _item$image, _item$title, _item$description;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "space-y-4 w-80 lg:w-64",
            children: [((_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "w-25 h-25 m-auto relative rounded-2xl overflow-hidden",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: item.image.url,
                alt: item.image.alt,
                layout: "fill",
                objectFit: "cover"
              })
            }), !!((_item$title = item.title) !== null && _item$title !== void 0 && _item$title.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "font-semibold text-h5",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                render: item.title
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-base leading-7 font-archivo",
              children: !!((_item$description = item.description) !== null && _item$description !== void 0 && _item$description.length) && prismic_reactjs.RichText.render(item.description)
            })]
          }, (0,index_browser/* nanoid */.x0)());
        })
      })]
    })
  }) : null;
};

/* harmony default export */ var variations_GridListsWithImage = (GridListsWithImage);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
;// CONCATENATED MODULE: ./slices/GridLists/variations/GridListsWithFilter.tsx



function GridListsWithFilter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function GridListsWithFilter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { GridListsWithFilter_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { GridListsWithFilter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

















var GridListsWithFilter_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var Filter = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(835), __webpack_require__.e(513)]).then(__webpack_require__.bind(__webpack_require__, 7513));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(7513)];
    }
  }
});
var BlankState = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 800).then(__webpack_require__.bind(__webpack_require__, 7800));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(7800)];
    }
  }
});
var GridListsWithFilter_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});

var dateTimeFormat = function dateTimeFormat(date, language, connector) {
  var format = "d'.'MM '".concat(connector, "' HH'h'");
  var locale = (0,dates/* getCurrentDateLocale */.Et)(dates/* DATE_LOCALES */.DJ, language);
  return (0,dates/* parseDate */.sG)(date, locale, format);
};

var GridListsWithFilter_getAvailableItems = function getAvailableItems(items) {
  return items === null || items === void 0 ? void 0 : items.filter(function (_ref) {
    var dateTime = _ref.dateTime,
        buttonLink = _ref.buttonLink;
    var itemDate = new Date(dateTime).getTime();
    var now = new Date().getTime();
    return now <= itemDate && (buttonLink === null || buttonLink === void 0 ? void 0 : buttonLink.url);
  });
};

var sortBy = function sortBy(items, key) {
  var compare = function compare(a, b) {
    if (a[key] < b[key]) {
      return -1;
    }

    if (a[key] > b[key]) {
      return 1;
    }

    return 0;
  };

  return items === null || items === void 0 ? void 0 : items.sort(compare);
};

var GridListsWithFilter = function GridListsWithFilter(_ref2) {
  var _cloneDeep, _slice$_verticals, _slice$primary;

  var slice = _ref2.slice;
  var availableItems = GridListsWithFilter_getAvailableItems(slice === null || slice === void 0 ? void 0 : slice.items);
  var intl = (0,useIntl/* default */.Z)();
  var dateTimeConnector = intl.formatMessage({
    id: "dHS3hk",
    defaultMessage: [{
      "type": 0,
      "value": "a las"
    }]
  });

  var _useState = (0,react.useState)(''),
      open = _useState[0],
      setOpen = _useState[1];

  var _useState2 = (0,react.useState)((_cloneDeep = lodash_clonedeep_default()(availableItems)) !== null && _cloneDeep !== void 0 ? _cloneDeep : []),
      items = _useState2[0],
      setItems = _useState2[1];

  var _useState3 = (0,react.useState)({
    vertical: '',
    sort: 'asc'
  }),
      filter = _useState3[0],
      setFilter = _useState3[1];

  var locale = (0,useLocale/* default */.Z)();
  var verticals = (_slice$_verticals = slice._verticals) !== null && _slice$_verticals !== void 0 ? _slice$_verticals : [];
  var filters = [{
    id: 'vertical',
    name: 'Categoría',
    options: [{
      value: '',
      label: 'Todas las categorías'
    }].concat((0,toConsumableArray/* default */.Z)(verticals.map(function (_ref3) {
      var data = _ref3.data,
          uid = _ref3.uid;
      return {
        value: uid,
        label: data.name
      };
    }).filter(function (_ref4) {
      var label = _ref4.label;
      return !!label;
    })))
  }, {
    id: 'sort',
    name: 'Sort',
    options: [{
      label: 'Mas próximo',
      value: 'asc'
    }, {
      label: 'Mas lejano',
      value: 'desc'
    }]
  }];

  var handleOpen = function handleOpen(sectionId) {
    return setOpen(function (prev) {
      return prev === sectionId || sectionId === '' ? '' : sectionId;
    });
  };

  var handleFilterChange = (0,react.useCallback)(function (sectionId, optionValue) {
    setOpen('');
    setFilter(function (prev) {
      return GridListsWithFilter_objectSpread(GridListsWithFilter_objectSpread({}, prev), {}, (0,defineProperty/* default */.Z)({}, sectionId, optionValue));
    });
  }, [setFilter, setOpen]);
  (0,react.useEffect)(function () {
    var sortedItems = sortBy(lodash_clonedeep_default()(availableItems), 'dateTime');

    if (filter.vertical) {
      sortedItems = sortedItems.filter(function (_ref5) {
        var verticalPage = _ref5.verticalPage;
        return (verticalPage === null || verticalPage === void 0 ? void 0 : verticalPage.uid) === filter.vertical;
      });
    }

    if (filter.sort === 'desc') {
      sortedItems = sortedItems.reverse();
    }

    setItems(sortedItems);
  }, [filter, setItems]); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-gray-2",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Filter, {
        filters: filters,
        handleFilterChange: handleFilterChange,
        handleOpen: handleOpen,
        open: open,
        filter: filter,
        title: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "text-2xl leading-9 font-semibold",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "gVJL1l",
              defaultMessage: [{
                "type": 0,
                "value": "Lista"
              }]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            className: "font-archivo text-base leading-7 ml-2",
            children: ["(", items.length, ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
              id: "YNofPE",
              defaultMessage: [{
                "type": 0,
                "value": "eventos"
              }]
            }), ")"]
          })]
        })
      }), !(items !== null && items !== void 0 && items.length) ? /*#__PURE__*/(0,jsx_runtime.jsx)(BlankState, {
        className: "text-white max-w-3.5xl",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
          render: (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.blankStateMessage
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: "grid sm:grid-cols-2 lg:grid-cols-4 gap-5",
        children: items.map(function (_ref6) {
          var _logo$dimensions, _logo$dimensions2;

          var verticalPage = _ref6.verticalPage,
              title = _ref6.title,
              description = _ref6.description,
              logo = _ref6.logo,
              dateTime = _ref6.dateTime,
              buttonLink = _ref6.buttonLink,
              buttonLabel = _ref6.buttonLabel;
          var vertical = (0,common/* getVerticalByLink */.SP)(verticalPage, slice._verticals);

          var _getColor = (0,colors/* getColor */.Lq)(vertical === null || vertical === void 0 ? void 0 : vertical.color),
              bgColor = _getColor.bg,
              bgColorHover = _getColor.bgHover;

          var formatedDateTime = dateTime && dateTimeFormat(dateTime, locale, dateTimeConnector);
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "space-y-5 rounded-2xl bg-white-2 flex flex-col",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()('flex flex-row justify-between items-cente rounded-t-2xl py-2 px-4', bgColor),
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row justify-start items-center",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GridListsWithFilter_Icon, {
                  icon: "arrow-right-up-circle",
                  className: "w-4 flex-none text-athensGray mr-2"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  className: "text-sm font-archivo font-normal text-athensGray text-left",
                  children: vertical === null || vertical === void 0 ? void 0 : vertical.name
                })]
              }), (logo === null || logo === void 0 ? void 0 : logo.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "h-6 w-24 relative",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: logo === null || logo === void 0 ? void 0 : logo.url,
                  alt: logo === null || logo === void 0 ? void 0 : logo.alt,
                  height: logo === null || logo === void 0 ? void 0 : (_logo$dimensions = logo.dimensions) === null || _logo$dimensions === void 0 ? void 0 : _logo$dimensions.height,
                  width: logo === null || logo === void 0 ? void 0 : (_logo$dimensions2 = logo.dimensions) === null || _logo$dimensions2 === void 0 ? void 0 : _logo$dimensions2.width,
                  layout: "responsive",
                  objectFit: "contain",
                  className: "h-6 w-24"
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "px-6 pb-6 flex flex-col m-0 justify-between h-full",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: "flex items-center font-bold text-lg leading-6 min-h-[3.125rem]",
                children: title
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "pt-4 pb-7 flex flex-row lg:flex-col font-archivo",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "pr-3 mr-3 border-r border-white-4 lg:pr-0 lg:mr-0 lg:border-0",
                  children: "".concat(formatedDateTime, " ")
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: description
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(GridListsWithFilter_LinkWithQuery, {
                  title: buttonLink.title,
                  href: prismic_reactjs.Link.url(buttonLink, common/* prismicLinkResolver */.LT),
                  target: buttonLink === null || buttonLink === void 0 ? void 0 : buttonLink.target,
                  className: classnames_default()('dh-button', 'w-auto inline-block px-5 py-1 text-center rounded-md', 'font-semibold text-white text-sm leading-6', bgColor, bgColorHover),
                  children: buttonLabel
                })
              })]
            })]
          }, (0,index_browser/* nanoid */.x0)());
        })
      })]
    })
  });
};

/* harmony default export */ var variations_GridListsWithFilter = (GridListsWithFilter);
// EXTERNAL MODULE: ./node_modules/lodash.chunk/index.js
var lodash_chunk = __webpack_require__(2658);
var lodash_chunk_default = /*#__PURE__*/__webpack_require__.n(lodash_chunk);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
;// CONCATENATED MODULE: ./slices/GridLists/variations/GridListsCardAnimated.tsx











var GridListsCardAnimated_HighlightText = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(774), __webpack_require__.e(935), __webpack_require__.e(166)]).then(__webpack_require__.bind(__webpack_require__, 8166));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8166)];
    }
  }
});
var FlipCard = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 203).then(__webpack_require__.bind(__webpack_require__, 1203));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1203)];
    }
  }
});
var GridListsCardAnimated_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});

var ItemDesktop = function ItemDesktop(_ref) {
  var title = _ref.title,
      description = _ref.description,
      image = _ref.image,
      bgColor = _ref.bgColor,
      className = _ref.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()('relative hidden lg:block overflow-hidden rounded-2xl group cursor-default', className),
    children: [!!(image !== null && image !== void 0 && image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "w-full h-161 max-h-full absolute z-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        className: "object-cover h-full w-full absolute rounded-2xl",
        src: image.url,
        alt: image.alt,
        layout: "fill",
        objectFit: "cover"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()('w-full absolute h-full opacity-90 z-0 rounded-2xl', bgColor)
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "h-full relative z-0 text-left px-11 py-9 -top-96 group-hover:top-0 transition-all",
      children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-athensGray text-2xl leading-10 font-semibold mb-2",
        children: title
      }), !!(description !== null && description !== void 0 && description.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "font-archivo text-white-2 text-base leading-7",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
          render: description
        })
      })]
    }), title && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()('text-athensGray text-2xl leading-10 font-semibold p-4 block', 'absolute top-0 flex w-full left-0 h-full items-center justify-center transition-all', 'group-hover:h-0 group-hover:w-0 group-hover:-top-28 overflow-hidden'),
      children: title
    })]
  });
};

var ItemMobile = function ItemMobile(_ref2) {
  var image = _ref2.image,
      title = _ref2.title,
      description = _ref2.description,
      bgColor = _ref2.bgColor;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FlipCard, {
    className: "h-full w-full rounded-2xl lg:hidden",
    front: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "h-full",
      children: [!!(image !== null && image !== void 0 && image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        className: "object-cover h-full w-full absolute rounded-2xl",
        src: image.url,
        alt: image.alt,
        layout: "fill",
        objectFit: "cover"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()('w-full absolute h-full opacity-90 z-0 rounded-2xl', bgColor)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative z-0 space-y-5 h-full w-full p-4 flex items-center justify-center",
        children: title && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-athensGray text-base leading-7 font-bold",
          children: title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(GridListsCardAnimated_Icon, {
        icon: "arrow-right-down-solid",
        className: "absolute w-4 bottom-1 right-1 text-black -rotate-180"
      })]
    }),
    back: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [!!(image !== null && image !== void 0 && image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full h-64 max-h-full absolute z-0",
        style: {
          transform: 'rotateY(180deg)'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: "object-cover h-full w-full absolute rounded-2xl",
          src: image.url,
          alt: image.alt,
          layout: "fill",
          objectFit: "cover"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()('w-full absolute h-full opacity-90 z-0 rounded-2xl', bgColor)
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative z-0 text-left p-4",
        children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-athensGray text-base leading-7 font-bold",
          children: title
        }), !!(description !== null && description !== void 0 && description.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "font-archivo text-white-2 text-sm",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: description
          })
        })]
      })]
    })
  }, (0,index_browser/* nanoid */.x0)());
};

var itemsTemplateModel = [[{
  height: 'min-h-[17.75rem]'
}, {
  height: 'min-h-[11rem]'
}, {
  height: 'min-h-[15rem]'
}], [{
  height: 'min-h-[12.938rem]'
}, {
  height: 'min-h-[15.563rem]'
}, {
  height: 'min-h-[15.3rem]'
}]];

var GridListsCardAnimated = function GridListsCardAnimated(_ref3) {
  var _slice$items, _slice$primary, _slice$primary$video, _slice$primary2, _slice$primary3, _slice$primary4;

  var slice = _ref3.slice;
  if (!(slice !== null && slice !== void 0 && (_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length)) return null;
  var itemsCols = lodash_chunk_default()(slice.items, Math.ceil(slice.items.length / 2));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "relative overflow-hidden bg-gray-1",
    children: [!!((_slice$primary = slice.primary) !== null && _slice$primary !== void 0 && (_slice$primary$video = _slice$primary.video) !== null && _slice$primary$video !== void 0 && _slice$primary$video.url) && /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("video", {
        className: "absolute top-0 left-0 z-0 w-full h-full object-cover",
        preload: "none",
        playsInline: true,
        autoPlay: true,
        muted: true,
        loop: true,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          src: slice.primary.video.url,
          type: slice.primary.video.type
        }), "Your browser does not support the video tag."]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "relative z-0 bg-black/50",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "dh-content",
        children: [!!((_slice$primary2 = slice.primary) !== null && _slice$primary2 !== void 0 && _slice$primary2.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
          className: "mb-9",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "text-xl lg:text-4.5xl text-white text-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(GridListsCardAnimated_HighlightText, {
              text: (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.title,
              highlight: (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.highlightedText,
              isUnderline: true
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "grid lg:grid-cols-2 gap-5",
          children: itemsCols.map(function (items, col) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              className: "flex flex-col gap-5",
              children: items.map(function (_ref4, index) {
                var _itemsTemplateModel$c;

                var title = _ref4.title,
                    description = _ref4.description,
                    image = _ref4.image,
                    color = _ref4.color;

                var _getColor = (0,colors/* getColor */.Lq)(color, 800),
                    bgColor = _getColor.bg;

                return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ItemMobile, {
                    image: image,
                    title: title,
                    description: description,
                    bgColor: bgColor
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemDesktop, {
                    image: image,
                    title: title,
                    description: description,
                    bgColor: bgColor,
                    className: (_itemsTemplateModel$c = itemsTemplateModel[col][index]) === null || _itemsTemplateModel$c === void 0 ? void 0 : _itemsTemplateModel$c.height
                  })]
                }, (0,index_browser/* nanoid */.x0)());
              })
            }, (0,index_browser/* nanoid */.x0)());
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var variations_GridListsCardAnimated = (GridListsCardAnimated);
;// CONCATENATED MODULE: ./slices/GridLists/variations/GridListsCTA.tsx










var GridListsCTA_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var GridListsCTA_HighlightText = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(774), __webpack_require__.e(935), __webpack_require__.e(166)]).then(__webpack_require__.bind(__webpack_require__, 8166));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8166)];
    }
  }
});

var GridListsCTA = function GridListsCTA(_ref) {
  var _slice$items, _slice$primary, _slice$primary2;

  var slice = _ref.slice;
  if (!((_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length)) return null;

  var hasButton = function hasButton(item) {
    return !!(item.buttonLabel && item.buttonLink);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-gray-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content-full text-white-1",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        className: "text-center text-2xl pt-16 mb-20 lg:pt-0 lg:text-4.5xl lg:mb-24 2xl:text-5xl 2xl:mb-28",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(GridListsCTA_HighlightText, {
            richtext: (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title,
            highlight: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.highlightedText,
            isUnderline: true
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "grid gap-x-4 gap-y-3 lg:gap-y-10 lg:grid-cols-3 lg:w-full 2xl:w-9/12 2xl:mx-auto",
        children: slice.items.map(function (item) {
          var _item$image, _item$buttonLink$targ, _item$buttonLink;

          var color = (0,colors/* getColor */.Lq)(item.color);
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()('flex flex-col w-full rounded bg-gray-4 pl-2 pr-4 py-8 gap-x-2 gap-y-6', 'lg:p-6 lg:pt-0 lg:gap-8 xl:p-12 xl:pt-0 3xl:gap-12 3xl:pt-0'),
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-row gap-2 lg:flex-col",
              children: [((_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex-none w-28 h-24 lg:w-60 lg:h-52 lg:-mt-5 lg:mb-3 lg:mx-auto lg:text-center",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: item.image.url,
                  alt: item.image.alt,
                  width: item.image.dimensions.width || 240,
                  height: item.image.dimensions.height || 208,
                  layout: "intrinsic",
                  objectFit: "contain",
                  objectPosition: "center",
                  className: "object-contain mx-auto"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: classnames_default()('flex grow text-left items-center text-sm', 'lg:block lg:flex-none lg:pt-4 lg:items-start lg:text-center lg:text-xl lg:leading-8', '3xl:text-2xl 3xl:leading-9'),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                  render: item.title
                })
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex grow items-end justify-center",
              children: hasButton(item) && /*#__PURE__*/(0,jsx_runtime.jsx)(GridListsCTA_LinkWithQuery, {
                href: prismic_reactjs.Link.url(item.buttonLink, common/* prismicLinkResolver */.LT),
                target: (_item$buttonLink$targ = (_item$buttonLink = item.buttonLink) === null || _item$buttonLink === void 0 ? void 0 : _item$buttonLink.target) !== null && _item$buttonLink$targ !== void 0 ? _item$buttonLink$targ : '_self',
                className: classnames_default()('dh-btn font-semibold text-sm mx-6 lg:text-lg', color.bg, color.textContrast),
                children: item.buttonLabel
              }, (0,index_browser/* nanoid */.x0)())
            })]
          }, (0,index_browser/* nanoid */.x0)());
        })
      })]
    })
  });
};

/* harmony default export */ var variations_GridListsCTA = (GridListsCTA);
// EXTERNAL MODULE: ./contexts/reducers/product.reducer.ts
var product_reducer = __webpack_require__(302);
;// CONCATENATED MODULE: ./slices/GridLists/variations/GridListsProducts.tsx
























var GridListsProducts_getAvailableItems = function getAvailableItems(items, clusterId) {
  var _items$filter;

  var itemsPage = items === null || items === void 0 ? void 0 : (_items$filter = items.filter(function (_ref) {
    var _data$clusterPage;

    var data = _ref.data;
    return (data === null || data === void 0 ? void 0 : (_data$clusterPage = data.clusterPage) === null || _data$clusterPage === void 0 ? void 0 : _data$clusterPage.id) === clusterId;
  })) === null || _items$filter === void 0 ? void 0 : _items$filter.filter(function (_ref2) {
    var data = _ref2.data;
    return data.startDate && new Date(data.startDate).getTime() >= new Date().getTime();
  });
  return itemsPage;
};

var GridListsProducts_dateFormat = function dateFormat(date, language, format) {
  return (0,dates/* parseDate */.sG)(date, (0,dates/* getCurrentDateLocale */.Et)(dates/* DATE_LOCALES */.DJ, language), format);
};

var GridListsProducts = function GridListsProducts(_ref3) {
  var _slice$_vertical, _slice$_cluster, _slice$_cluster2, _slice$primary$dateIc, _slice$primary$schedu, _slice$primary$schedu2;

  var slice = _ref3.slice;
  var vertical = (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var cluster = (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : _slice$_cluster.data;
  var availableProducts = GridListsProducts_getAvailableItems(slice._products, (_slice$_cluster2 = slice._cluster) === null || _slice$_cluster2 === void 0 ? void 0 : _slice$_cluster2.id);
  var products = lodash_sortby_default()(availableProducts, function (item) {
    return item.data.startDate;
  });

  var _useContext = (0,react.useContext)(AppContext/* AppContext */.I),
      dispatch = _useContext.dispatch;

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track;

  var intl = (0,useIntl/* default */.Z)();
  var locale = (0,useLocale/* default */.Z)();
  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({
    slice: slice,
    cluster: cluster,
    vertical: vertical
  });
  var handleClick = (0,react.useCallback)(function (item) {
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'context.label', item.data.linkDetailLabel);
    lodash_set_default()(payload, 'context.next_step', constants/* NextStepFlow.advice */.AH.advice);
    lodash_set_default()(payload, 'context.destination_url', (0,common/* prismicLinkResolver */.LT)(item));
    lodash_set_default()(payload, 'product.start_date', item.data.startDate);
    lodash_set_default()(payload, 'product.end_date', item.data.endDate);
    track(constants/* TrackEvents.productApplicationClicked */.Um.productApplicationClicked, payload, locale);
    dispatch({
      type: product_reducer/* ProductActionTypes.select */.D.select,
      item: item
    });
    if (slice.primary.buttonScrollTo) (0,common/* scrollTo */.X5)({
      id: slice.primary.buttonScrollTo
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackPayload]);
  if (!products.length) return null;
  var color = (0,colors/* getColor */.Lq)(slice.primary.color, 500);
  var primaryMessages = slice.primary;
  var defaultMessages = {
    dateFormat: intl.formatMessage({
      id: "8jlc1R",
      defaultMessage: [{
        "type": 0,
        "value": "dd/MM/yy"
      }]
    }),
    buttonBookLabel: intl.formatMessage({
      id: "YG0xDz",
      defaultMessage: [{
        "type": 0,
        "value": "Reservar"
      }]
    }),
    lastplaceLabel: intl.formatMessage({
      id: "wVMrPN",
      defaultMessage: [{
        "type": 0,
        "value": "¡Ultimos cupos!"
      }]
    }),
    buttonSoldoutLabel: intl.formatMessage({
      id: "spsPUc",
      defaultMessage: [{
        "type": 0,
        "value": "Sold out"
      }]
    })
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-white-1 py-15 px-0 lg:p-4 lg:py-20 3xl:py-20",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "lg:w-10/12 m-auto lg:max-w-7xl 2xl:max-w-8xl",
      children: [slice.primary.title && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-black-1 font-bold px-4 lg:px-0 pb-1.5 text-h4 lg:pb-4 lg:text-h2 3xl:text-h1 3xl:max-w-8xl",
        children: slice.primary.title
      }), (0,prismic/* hasRichText */.M)(slice.primary.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-gray-1 font-medium text-p3 px-4 lg:px-0  3xl:text-p2 3xl:max-w-8xl",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
          render: slice.primary.description
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "pt-4 lg:pt-10 lg:grid 3xl:max-w-8xl",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "hidden gap-4 lg:flex lg:justify-between",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()('flex gap-3 pb-3.5 border-b-2 items-center', '3xl:border-b-3 lg:w-2/10', color.border),
              children: [((_slice$primary$dateIc = slice.primary.dateIcon) === null || _slice$primary$dateIc === void 0 ? void 0 : _slice$primary$dateIc.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "h-6 w-6 3xl:w-10 3xl:h-10 relative",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  className: "h-6 w-6 3xl:w-10 3xl:h-10 relative",
                  src: slice.primary.dateIcon.url,
                  alt: slice.primary.dateIcon.alt,
                  layout: "fill",
                  objectFit: "cover"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-gray-1 font-medium text-p1 3xl:text-h5",
                children: slice === null || slice === void 0 ? void 0 : slice.primary.dateText
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()('flex gap-3 pb-3.5 border-b-2 items-center', '3xl:gap-4 3xl:border-b-3 lg:w-2/10', color.border),
              children: [((_slice$primary$schedu = slice.primary.scheduleDaysIcon) === null || _slice$primary$schedu === void 0 ? void 0 : _slice$primary$schedu.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "h-6 w-6 3xl:w-10 3xl:h-10 relative",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  className: "h-6 w-6 3xl:w-10 3xl:h-10 relative",
                  src: slice.primary.scheduleDaysIcon.url,
                  alt: slice.primary.scheduleDaysIcon.alt,
                  layout: "fill",
                  objectFit: "cover"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-gray-1 font-medium text-p1 3xl:text-h5",
                children: slice === null || slice === void 0 ? void 0 : slice.primary.scheduleDaysText
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()('flex gap-3 pb-3.5 border-b-2 items-center', '3xl:gap-4 3xl:border-b-3 lg:w-2/10', color.border),
              children: [((_slice$primary$schedu2 = slice.primary.scheduleHoursIcon) === null || _slice$primary$schedu2 === void 0 ? void 0 : _slice$primary$schedu2.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "h-6 w-6 3xl:w-10 3xl:h-10 relative",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  className: "h-6 w-6 3xl:w-10 3xl:h-10 relative",
                  src: slice.primary.scheduleHoursIcon.url,
                  alt: slice.primary.scheduleHoursIcon.alt,
                  layout: "fill",
                  objectFit: "cover"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-gray-1 font-medium text-p1 3xl:text-h5",
                children: slice === null || slice === void 0 ? void 0 : slice.primary.scheduleHoursText
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "w-2/10"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classnames_default()('lg:hidden border-t-2 w-4/6 m-auto', color.border)
          }), products === null || products === void 0 ? void 0 : products.map(function (item) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: classnames_default()('border-b border-white-4 lg:border-none py-6 lg:p-0', {
                'pb-2.5': item.data.lastplaces
              }),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: classnames_default()('grid grid-cols-2 px-4 items-start gap-4 lg:px-0', 'lg:flex lg:flex-row lg:py-8 lg:items-center lg:border-b lg:border-white-4 lg:justify-between'),
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex items-center lg:w-2/10",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* CheckCircleIcon */.rE2, {
                    className: classnames_default()('w-6 lg:w-5 flex-none mr-1.5 lg:hidden 3xl:w-6', color.text)
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "text-gray-6 text-p4 font-medium lg:hidden",
                      children: slice.primary.dateText
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                      className: "text-gray-1 w-full text-p3 font-bold 3xl:text-p1",
                      children: [GridListsProducts_dateFormat(item.data.startDate, locale, defaultMessages.dateFormat), ' - ', GridListsProducts_dateFormat(item.data.endDate, locale, defaultMessages.dateFormat)]
                    })]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "lg:w-2/10",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: " text-gray-6 text-p4 font-medium lg:hidden",
                    children: slice.primary.scheduleDaysText
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "text-gray-1 text-p3 font-bold 3xl:text-p1",
                    children: item.data.scheduleDays
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "col-span-2  pl-7.5 lg:pl-0 lg:col-span-1 lg:w-2/10",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: " text-gray-6 text-p4 font-medium lg:hidden",
                    children: slice.primary.scheduleHoursText
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "text-gray-1 text-p3 font-bold 3xl:text-p1",
                    children: item.data.scheduleHours
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "relative col-span-2 lg:col-span-1 lg:flex lg:w-2/10",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    type: "button",
                    onClick: function onClick() {
                      return handleClick(item);
                    },
                    className: classnames_default()('w-full dh-btn font-bold self-stretch text-p3 lg:text-p2 p-3 3xl:text-lg 3xl:p-4', {
                      'bg-black-1 text-white-1 ': !item.data.soldout
                    }, {
                      'pointer-events-none bg-transparent text-gray-6 border-2 border-gray-6': item.data.soldout
                    }),
                    children: item.data.soldout ? (0,common/* getDefaultText */.T9)('buttonSoldoutLabel', primaryMessages, defaultMessages) : (0,common/* getDefaultText */.T9)('buttonBookLabel', primaryMessages, defaultMessages)
                  }), item.data.lastplaces && !item.data.soldout && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: " text-red-1 font-medium text-p4 w-full mt-2.5 lg:text-p3 text-center lg:absolute lg:-bottom-6 lg:m-0",
                    children: (0,common/* getDefaultText */.T9)('lastplaceLabel', primaryMessages, defaultMessages)
                  })]
                })]
              })
            }, (0,index_browser/* nanoid */.x0)());
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var variations_GridListsProducts = (GridListsProducts);
;// CONCATENATED MODULE: ./slices/GridLists/variations/GridListsProfiles.tsx










var GridListsProfiles_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var GridListsProfiles_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});
var GridListsProfiles_ReactCarousel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(957), __webpack_require__.e(892)]).then(__webpack_require__.bind(__webpack_require__, 1892));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1892)];
    }
  }
});
var GridListsProfiles_carouselOptions = {
  isRTL: false
};

var GridListsProfiles_Item = function Item(_ref) {
  var _item$image, _item$company, _item$link, _item$link$target, _item$link2;

  var item = _ref.item;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("article", {
    className: "w-full lg:w-2/10 lg:p-1.5",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "py-8 px-6 bg-gray-3 rounded flex flex-col items-center h-full",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
        className: "flex flex-col items-center text-center",
        children: [((_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex-none w-[7.875rem] h-[7.875rem] rounded-full overflow-hidden mb-6",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: item.image.url,
            alt: item.image.alt,
            width: item.image.dimensions.width,
            height: item.image.dimensions.height,
            layout: "intrinsic",
            objectFit: "contain",
            objectPosition: "center",
            className: "object-contain mx-auto"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
          className: "text-h8 font-bold text-white-1 2xl:text-h7",
          children: item.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
          className: "text-p3 font-medium mt-0.5 text-white-2 2xl:text-p2",
          children: item.role
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: "flex flex-col justify-end h-full",
        children: [((_item$company = item.company) === null || _item$company === void 0 ? void 0 : _item$company.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex-none bg-black px-5 py-1.5 rounded-4xl mt-6 h-9 w-auto",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: item.company.url,
            alt: item.company.alt,
            width: item.company.dimensions.width,
            height: item.company.dimensions.height,
            layout: "intrinsic",
            className: "flex-none"
          })
        }), ((_item$link = item.link) === null || _item$link === void 0 ? void 0 : _item$link.url) && /*#__PURE__*/(0,jsx_runtime.jsxs)(GridListsProfiles_LinkWithQuery, {
          href: prismic_reactjs.Link.url(item.link, common/* prismicLinkResolver */.LT),
          target: (_item$link$target = (_item$link2 = item.link) === null || _item$link2 === void 0 ? void 0 : _item$link2.target) !== null && _item$link$target !== void 0 ? _item$link$target : '_self',
          className: "text-p4 text-white-2 text-center mt-4 font-medium 2xl:text-p3",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "underline",
            children: item.linkLabel
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(GridListsProfiles_Icon, {
            icon: "chevron-right",
            className: "w-3.5 inline-block"
          })]
        }, (0,index_browser/* nanoid */.x0)())]
      })]
    })
  });
};

var GridListsProfiles = function GridListsProfiles(_ref2) {
  var _slice$items, _slice$primary, _slice$primary2;

  var slice = _ref2.slice;
  if (!((_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length)) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-black-2",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content-full py-17.5 text-white-1 3xl:py-[5.938rem] lg:m-auto lg:max-w-7xl 2xl:max-w-8xl 3xl:max-w-8x5l",
      children: [(0,prismic/* hasRichText */.M)((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        className: "text-center mb-15.5 text-h4 lg:text-h2 3xl:text-h1",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-10/12 flex-wrap mx-auto justify-center hidden lg:flex",
        children: slice.items.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(GridListsProfiles_Item, {
            item: item
          }, (0,index_browser/* nanoid */.x0)());
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "lg:hidden",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(GridListsProfiles_ReactCarousel, {
            options: GridListsProfiles_carouselOptions,
            children: slice.items.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(GridListsProfiles_Item, {
                item: item
              }, (0,index_browser/* nanoid */.x0)());
            })
          })
        })
      })]
    })
  });
};

/* harmony default export */ var variations_GridListsProfiles = (GridListsProfiles);
// EXTERNAL MODULE: ./utils/analytics.ts + 1 modules
var analytics = __webpack_require__(4539);
;// CONCATENATED MODULE: ./hooks/useCheckoutQueryParams.ts



var useCheckoutQueryParams = function useCheckoutQueryParams() {
  var _useState = (0,react.useState)({}),
      pathParams = _useState[0],
      setPathParams = _useState[1];

  var _useState2 = (0,react.useState)({}),
      allowedParams = _useState2[0],
      setAllowedParams = _useState2[1];

  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    setPathParams(router === null || router === void 0 ? void 0 : router.query);
  }, [router]);
  (0,react.useEffect)(function () {
    setAllowedParams((0,analytics/* getAllowedQueryString */.cM)(pathParams, true));
  }, [pathParams]);
  return allowedParams;
};
;// CONCATENATED MODULE: ./slices/GridLists/variations/GridListsProductsCheckout.tsx

























var GridListsProductsCheckout_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});

var GridListsProductsCheckout = function GridListsProductsCheckout(_ref) {
  var _slice$_vertical, _slice$_cluster, _slice$primary, _slice$_checkout, _slice$primary2, _slice$primary3, _slice$primary4, _slice$primary$modali, _slice$primary5, _slice$primary$dateSt, _slice$primary6, _slice$primary$shiftI, _slice$primary7, _slice$primary$daysIc, _slice$primary8, _slice$primary$schedu, _slice$primary9;

  var slice = _ref.slice;
  var vertical = (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var cluster = (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : _slice$_cluster.data;

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track;

  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({
    slice: slice,
    cluster: cluster,
    vertical: vertical
  });
  var intl = (0,useIntl/* default */.Z)();
  var queryParams = useCheckoutQueryParams();
  var locale = (0,useLocale/* default */.Z)();
  var color = (0,colors/* getColor */.Lq)((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.color, 800);
  var productsCheckout = (_slice$_checkout = slice._checkout) === null || _slice$_checkout === void 0 ? void 0 : _slice$_checkout.products;
  var products = lodash_sortby_default()(productsCheckout, function (item) {
    var _item$duration;

    return (_item$duration = item.duration) === null || _item$duration === void 0 ? void 0 : _item$duration.name;
  }).reverse();
  var geoCountry = (0,useGeoCountry/* default */.Z)();

  var _useState = (0,react.useState)(false),
      showSlice = _useState[0],
      setShowSlice = _useState[1];

  var _useState2 = (0,react.useState)(''),
      countryCode = _useState2[0],
      setCountryCode = _useState2[1];

  var primaryMessages = slice.primary;
  var defaultMessages = {
    morningShift: intl.formatMessage({
      id: "l/HnKq",
      defaultMessage: [{
        "type": 0,
        "value": "Turno Mañana"
      }]
    }),
    afternoonShift: intl.formatMessage({
      id: "oO5ITV",
      defaultMessage: [{
        "type": 0,
        "value": "Turno Tarde"
      }]
    }),
    dateFormat: intl.formatMessage({
      id: "8jlc1R",
      defaultMessage: [{
        "type": 0,
        "value": "dd/MM/yy"
      }]
    }),
    buttonBookLabel: intl.formatMessage({
      id: "YG0xDz",
      defaultMessage: [{
        "type": 0,
        "value": "Reservar"
      }]
    }),
    lastplaceLabel: intl.formatMessage({
      id: "wVMrPN",
      defaultMessage: [{
        "type": 0,
        "value": "¡Ultimos cupos!"
      }]
    }),
    buttonSoldoutLabel: intl.formatMessage({
      id: "spsPUc",
      defaultMessage: [{
        "type": 0,
        "value": "Sold out"
      }]
    }),
    monday: intl.formatMessage({
      id: "4G4aOc",
      defaultMessage: [{
        "type": 0,
        "value": "Lunes"
      }]
    }),
    tuesday: intl.formatMessage({
      id: "Lsa6bP",
      defaultMessage: [{
        "type": 0,
        "value": "Martes"
      }]
    }),
    wednesday: intl.formatMessage({
      id: "QfXrSR",
      defaultMessage: [{
        "type": 0,
        "value": "Miércoles"
      }]
    }),
    thursday: intl.formatMessage({
      id: "1QslLe",
      defaultMessage: [{
        "type": 0,
        "value": "Jueves"
      }]
    }),
    friday: intl.formatMessage({
      id: "s62NZn",
      defaultMessage: [{
        "type": 0,
        "value": "Viernes"
      }]
    }),
    saturday: intl.formatMessage({
      id: "z3QV06",
      defaultMessage: [{
        "type": 0,
        "value": "Sábado"
      }]
    }),
    sunday: intl.formatMessage({
      id: "r6nHoN",
      defaultMessage: [{
        "type": 0,
        "value": "Domingo"
      }]
    })
  };

  var formatDay = function formatDay(day) {
    var formattedDay;

    switch (day) {
      case 0:
        formattedDay = (0,common/* getDefaultText */.T9)('sunday', primaryMessages, defaultMessages);
        break;

      case 1:
        formattedDay = (0,common/* getDefaultText */.T9)('monday', primaryMessages, defaultMessages);
        break;

      case 2:
        formattedDay = (0,common/* getDefaultText */.T9)('tuesday', primaryMessages, defaultMessages);
        break;

      case 3:
        formattedDay = (0,common/* getDefaultText */.T9)('wednesday', primaryMessages, defaultMessages);
        break;

      case 4:
        formattedDay = (0,common/* getDefaultText */.T9)('thursday', primaryMessages, defaultMessages);
        break;

      case 5:
        formattedDay = (0,common/* getDefaultText */.T9)('friday', primaryMessages, defaultMessages);
        break;

      default:
        formattedDay = (0,common/* getDefaultText */.T9)('saturday', primaryMessages, defaultMessages);
        break;
    }

    return formattedDay;
  };

  (0,react.useEffect)(function () {
    if (!geoCountry) return;

    var _getLocalePlans = (0,checkout/* getLocalePlans */.Pq)({
      products: products,
      geoCountry: geoCountry,
      locale: locale
    }),
        hasPlans = _getLocalePlans.hasPlans,
        isUnavailable = _getLocalePlans.isUnavailable,
        currentLocale = _getLocalePlans.currentLocale;

    setCountryCode(currentLocale.countryCode);
    setShowSlice(!!(hasPlans && !isUnavailable));
  }, [geoCountry, locale, products]);

  var getColumnClassName = function getColumnClassName() {
    var columns = 1;

    if (slice.primary.scheduleText) {
      columns += 1;
    }

    if (slice.primary.dateStartText) {
      columns += 1;
    }

    if (slice.primary.daysText) {
      columns += 1;
    }

    if (slice.primary.modalityText) {
      columns += 1;
    }

    if (slice.primary.shiftText) {
      columns += 1;
    }

    var columnsClass = columns < 4 ? 'lg:grid-cols-3' : 'lg:grid-cols-4';
    return columnsClass;
  };

  var handleClick = (0,react.useCallback)(function (_ref2) {
    var _item$duration2;

    var nextStep = _ref2.nextStep,
        _ref2$label = _ref2.label,
        label = _ref2$label === void 0 ? '' : _ref2$label,
        url = _ref2.url,
        item = _ref2.item;
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'context.next_step', nextStep);
    lodash_set_default()(payload, 'context.label', label);
    lodash_set_default()(payload, 'context.destination_url', url);
    lodash_set_default()(payload, 'product.start_date', item.startsAt);
    lodash_set_default()(payload, 'product.id', item.id);
    lodash_set_default()(payload, 'product.business_unit', item.defaultOffer.businessUnit);
    lodash_set_default()(payload, 'product.business_unit_id', item.defaultOffer.businessUnitId);
    lodash_set_default()(payload, 'product.vertical', item.defaultOffer.vertical);
    lodash_set_default()(payload, 'product.vertical_id', item.defaultOffer.verticalId);
    lodash_set_default()(payload, 'product.code', item.code);
    lodash_set_default()(payload, 'product.duration', (_item$duration2 = item.duration) === null || _item$duration2 === void 0 ? void 0 : _item$duration2.name);
    track(constants/* TrackEvents.productApplicationClicked */.Um.productApplicationClicked, payload, locale);
  }, [trackPayload, locale, track]);
  if (!showSlice) return null;

  var dateFormat = function dateFormat(date, language) {
    return (0,dates/* parseDate */.sG)(date.split('T')[0], (0,dates/* getCurrentDateLocale */.Et)(dates/* DATE_LOCALES */.DJ, language), defaultMessages.dateFormat);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-white-1 py-15 px-0 lg:p-4 lg:py-13 3xl:py-20",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "lg:w-10/12 m-auto lg:m-auto lg:max-w-7xl 2xl:max-w-8xl 3xl:w-full",
      children: [((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-black-1 font-bold px-4 lg:px-0 pb-1.5 text-h4 lg:pb-4 lg:text-h2 3xl:text-h1",
        children: slice.primary.title
      }), (0,prismic/* hasRichText */.M)((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-gray-1 font-medium text-p3 px-4 lg:px-0  3xl:text-p2",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
          render: (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.description
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "pt-4 lg:pt-10 lg:grid",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()('hidden lg:grid lg:visible gap-4', getColumnClassName()),
            children: [slice.primary.modalityText && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()('flex gap-3 pb-3.5 border-b-2 items-center', '3xl:gap-4 3xl:border-b-3', color.border),
              "data-testid": "column",
              children: [((_slice$primary$modali = slice.primary.modalityIcon) === null || _slice$primary$modali === void 0 ? void 0 : _slice$primary$modali.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "h-6 w-6 3xl:w-10 3xl:h-10 relative",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  className: "h-6 w-6 3xl:w-10 3xl:h-10 relative",
                  src: slice.primary.modalityIcon.url,
                  alt: slice.primary.modalityIcon.alt,
                  layout: "fill",
                  objectFit: "cover"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-gray-1 font-medium text-p1 3xl:text-h5",
                children: slice === null || slice === void 0 ? void 0 : (_slice$primary5 = slice.primary) === null || _slice$primary5 === void 0 ? void 0 : _slice$primary5.modalityText
              })]
            }), slice.primary.dateStartText && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()('flex gap-3 pb-3.5 border-b-2 items-center', '3xl:gap-4 3xl:border-b-3', color.border),
              "data-testid": "column",
              children: [((_slice$primary$dateSt = slice.primary.dateStartIcon) === null || _slice$primary$dateSt === void 0 ? void 0 : _slice$primary$dateSt.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "h-6 w-6 3xl:w-10 3xl:h-10 relative",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  className: "h-6 w-6 3xl:w-10 3xl:h-10 relative",
                  src: slice.primary.dateStartIcon.url,
                  alt: slice.primary.dateStartIcon.alt,
                  layout: "fill",
                  objectFit: "cover"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-gray-1 font-medium text-p1 3xl:text-h5",
                children: slice === null || slice === void 0 ? void 0 : (_slice$primary6 = slice.primary) === null || _slice$primary6 === void 0 ? void 0 : _slice$primary6.dateStartText
              })]
            }), slice.primary.shiftText && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()('flex gap-3 pb-3.5 border-b-2 items-center', '3xl:gap-4 3xl:border-b-3', color.border),
              "data-testid": "column",
              children: [((_slice$primary$shiftI = slice.primary.shiftIcon) === null || _slice$primary$shiftI === void 0 ? void 0 : _slice$primary$shiftI.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "h-6 w-6 3xl:w-10 3xl:h-10 relative",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  className: "h-6 w-6 3xl:w-10 3xl:h-10 relative",
                  src: slice.primary.shiftIcon.url,
                  alt: slice.primary.shiftIcon.alt,
                  layout: "fill",
                  objectFit: "cover"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-gray-1 font-medium text-p1 3xl:text-h5",
                children: slice === null || slice === void 0 ? void 0 : (_slice$primary7 = slice.primary) === null || _slice$primary7 === void 0 ? void 0 : _slice$primary7.shiftText
              })]
            }), slice.primary.daysText && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()('flex gap-3 pb-3.5 border-b-2 items-center', '3xl:gap-4 3xl:border-b-3', color.border),
              "data-testid": "column",
              children: [((_slice$primary$daysIc = slice.primary.daysIcon) === null || _slice$primary$daysIc === void 0 ? void 0 : _slice$primary$daysIc.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "h-6 w-6 3xl:w-10 3xl:h-10 relative",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  className: "h-6 w-6 3xl:w-10 3xl:h-10 relative",
                  src: slice.primary.daysIcon.url,
                  alt: slice.primary.daysIcon.alt,
                  layout: "fill",
                  objectFit: "cover"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-gray-1 font-medium text-p1 3xl:text-h5",
                children: slice === null || slice === void 0 ? void 0 : (_slice$primary8 = slice.primary) === null || _slice$primary8 === void 0 ? void 0 : _slice$primary8.daysText
              })]
            }), slice.primary.scheduleText && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()('flex gap-3 pb-3.5 border-b-2 items-center', '3xl:gap-4 3xl:border-b-3', color.border),
              "data-testid": "column",
              children: [((_slice$primary$schedu = slice.primary.scheduleIcon) === null || _slice$primary$schedu === void 0 ? void 0 : _slice$primary$schedu.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "h-6 w-6 3xl:w-10 3xl:h-10 relative",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  className: "h-6 w-6 3xl:w-10 3xl:h-10 relative",
                  src: slice.primary.scheduleIcon.url,
                  alt: slice.primary.scheduleIcon.alt,
                  layout: "fill",
                  objectFit: "cover"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-gray-1 font-medium text-p1 3xl:text-h5",
                children: slice === null || slice === void 0 ? void 0 : (_slice$primary9 = slice.primary) === null || _slice$primary9 === void 0 ? void 0 : _slice$primary9.scheduleText
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classnames_default()('lg:hidden border-t-2 w-4/6 m-auto', color.border)
          }), products === null || products === void 0 ? void 0 : products.map(function (item) {
            var _slice$primary10, _item$duration3, _slice$primary11, _slice$primary12, _slice$_checkout2;

            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: classnames_default()('border-b border-white-4 lg:border-none py-6 lg:p-0', {
                'pb-2.5': item.lastplaces
              }),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: classnames_default()('grid grid-cols-2  px-4 lg:px-0 ', 'gap-4 lg:py-8 items-center lg:border-b lg:border-white-4', getColumnClassName()),
                children: [slice.primary.modalityText && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex items-center",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* CheckCircleIcon */.rE2, {
                    className: classnames_default()('w-6 lg:w-5 flex-none mr-1.5 3xl:w-6', color.text)
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: " text-gray-6 text-p4 font-medium lg:hidden",
                      children: (_slice$primary10 = slice.primary) === null || _slice$primary10 === void 0 ? void 0 : _slice$primary10.modalityText
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "text-gray-1 text-p3 font-bold 3xl:text-p1",
                      children: (_item$duration3 = item.duration) === null || _item$duration3 === void 0 ? void 0 : _item$duration3.name
                    })]
                  })]
                }), slice.primary.dateStartText && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  "data-testid": "column",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: " text-gray-6 text-p4 font-medium lg:hidden",
                    children: (_slice$primary11 = slice.primary) === null || _slice$primary11 === void 0 ? void 0 : _slice$primary11.dateStartText
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                    className: "text-gray-1 w-full text-p3 font-bold 3xl:text-p1",
                    children: [dateFormat(item.startsAt.split('T')[0], locale), item.endsAt && " - ".concat(dateFormat(item.endsAt.split('T')[0], locale))]
                  })]
                }), slice.primary.shiftText && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "pl-7.5 lg:pl-0",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: " text-gray-6 text-p4 font-medium lg:hidden",
                    children: (_slice$primary12 = slice.primary) === null || _slice$primary12 === void 0 ? void 0 : _slice$primary12.shiftText
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "text-gray-1 text-p3 font-bold 3xl:text-p1",
                    children: item.slotFrom && ((0,dates/* isMorning */.aG)(item.slotFrom) ? defaultMessages.morningShift : defaultMessages.afternoonShift)
                  })]
                }), slice.primary.daysText && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "",
                  children: (0,dates/* groupBySchedules */.jK)(item === null || item === void 0 ? void 0 : item.schedules, formatDay).map(function (schedule) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "text-gray-1 text-p3 font-bold 3xl:text-p1",
                      children: schedule
                    }, (0,index_browser/* nanoid */.x0)());
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "relative col-span-2 lg:col-span-1 lg:flex",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GridListsProductsCheckout_LinkWithQuery, {
                    href: (0,checkout/* getCheckoutUrl */.Zs)(item, item.code, queryParams, (_slice$_checkout2 = slice._checkout) === null || _slice$_checkout2 === void 0 ? void 0 : _slice$_checkout2.sandbox, countryCode),
                    onClick: function onClick(e) {
                      var _slice$_checkout3;

                      return item.soldout ? e.preventDefault() : handleClick({
                        nextStep: constants/* NextStepFlow.checkout */.AH.checkout,
                        label: (0,common/* getDefaultText */.T9)('buttonBookLabel', primaryMessages, defaultMessages),
                        url: (0,checkout/* getCheckoutUrl */.Zs)(item, item.code, queryParams, (_slice$_checkout3 = slice._checkout) === null || _slice$_checkout3 === void 0 ? void 0 : _slice$_checkout3.sandbox, countryCode),
                        item: item
                      });
                    },
                    target: "_self",
                    className: classnames_default()('w-full dh-btn font-bold self-stretch text-p3 lg:text-p2 p-3 3xl:text-lg 3xl:p-4', {
                      ' bg-black-1 text-white-1 ': !item.soldout
                    }, {
                      'pointer-events-none bg-transparent text-gray-6 border-2 border-gray-6': item.soldout
                    }),
                    children: item.soldout ? (0,common/* getDefaultText */.T9)('buttonSoldoutLabel', primaryMessages, defaultMessages) : (0,common/* getDefaultText */.T9)('buttonBookLabel', primaryMessages, defaultMessages)
                  }, (0,index_browser/* nanoid */.x0)()), item.lastplaces && !item.soldout && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: " text-red-1 font-medium text-p4 w-full  mt-2.5 lg:text-p3 text-center lg:absolute lg:-bottom-6",
                    children: (0,common/* getDefaultText */.T9)('lastplaceLabel', primaryMessages, defaultMessages)
                  })]
                })]
              })
            }, (0,index_browser/* nanoid */.x0)());
          })]
        })
      })]
    })
  });
};

/* harmony default export */ var variations_GridListsProductsCheckout = (GridListsProductsCheckout);
;// CONCATENATED MODULE: ./slices/GridLists/index.tsx



















var GridLists_GridLists = function GridLists(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case GridListsVariations.withIcon:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_GridListsWithIcon, {
        slice: slice
      });

    case GridListsVariations.withIconSimple:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_GridListsWithIconSimple, {
        slice: slice
      });

    case GridListsVariations.withIconDark:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_GridListsWithIconDark, {
        slice: slice
      });

    case GridListsVariations.withIconLight:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_GridListsWithIconLight, {
        slice: slice
      });

    case GridListsVariations.withIconCentered:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_GridListsWithIconCentered, {
        slice: slice
      });

    case GridListsVariations.fiveColumns:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_GridListsFiveColumns, {
        slice: slice
      });

    case GridListsVariations.withOnlyText:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_GridListsWithOnlyText, {
        slice: slice
      });

    case GridListsVariations.twoColumnsWithImage:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_GridListsTwoColumnsWithImage, {
        slice: slice
      });

    case GridListsVariations.withImage:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_GridListsWithImage, {
        slice: slice
      });

    case GridListsVariations.withFilter:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_GridListsWithFilter, {
        slice: slice
      });

    case GridListsVariations.cardAnimated:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_GridListsCardAnimated, {
        slice: slice
      });

    case GridListsVariations.cta:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_GridListsCTA, {
        slice: slice
      });

    case GridListsVariations.productsCheckout:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_GridListsProductsCheckout, {
        slice: slice
      });

    case GridListsVariations.products:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_GridListsProducts, {
        slice: slice
      });

    case GridListsVariations.profiles:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_GridListsProfiles, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var slices_GridLists = (GridLists_GridLists);
;// CONCATENATED MODULE: ./slices/Header/Header.types.ts
var HeaderVariations;

(function (HeaderVariations) {
  HeaderVariations["centered"] = "headerCentered";
  HeaderVariations["centeredSmall"] = "headerCenteredSmall";
  HeaderVariations["left"] = "headerLeft";
  HeaderVariations["leftDark"] = "headerLeftDark";
  HeaderVariations["inner"] = "headerInner";
})(HeaderVariations || (HeaderVariations = {}));
;// CONCATENATED MODULE: ./slices/Header/variations/HeaderCentered.tsx







var HeaderCentered = function HeaderCentered(_ref) {
  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "bg-white",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "dh-content",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "text-center",
        children: [slice.primary.subtitle && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "text-base font-semibold text-primary-600 tracking-wide uppercase",
          children: slice.primary.subtitle
        }), (0,prismic/* hasRichText */.M)(slice.primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: classnames_default()('mt-1 max-w-3xl mx-auto text-4xl font-extrabold text-gray-900', 'sm:text-5xl sm:tracking-tight lg:text-6xl'),
          children: prismic_reactjs.RichText.asText(slice.primary.title)
        }), (0,prismic/* hasRichText */.M)(slice.primary.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "max-w-2xl mt-5 mx-auto text-xl text-gray-500",
          children: prismic_reactjs.RichText.asText(slice.primary.description)
        })]
      })
    })
  });
};

/* harmony default export */ var variations_HeaderCentered = (HeaderCentered);
;// CONCATENATED MODULE: ./slices/Header/variations/HeaderCenteredSmall.tsx







var HeaderCenteredSmall = function HeaderCenteredSmall(_ref) {
  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "bg-white",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "text-center mb-2 mt-24",
      children: [(0,prismic/* hasRichText */.M)(slice.primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: classnames_default()('mt-1 max-w-3xl mx-auto text-2xl font-bold text-gray-900', 'sm:text-2xl sm:tracking-tight lg:text-2xl'),
        children: prismic_reactjs.RichText.asText(slice.primary.title)
      }), (0,prismic/* hasRichText */.M)(slice.primary.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "max-w-2xl mt-5 mx-auto text-base text-gray-900",
        children: prismic_reactjs.RichText.asText(slice.primary.description)
      })]
    })
  });
};

/* harmony default export */ var variations_HeaderCenteredSmall = (HeaderCenteredSmall);
;// CONCATENATED MODULE: ./slices/Header/variations/HeaderLeft.tsx







var HeaderLeft = function HeaderLeft(_ref) {
  var _slice$primary;

  var slice = _ref.slice;
  var dark = slice.variation.endsWith('Dark');
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()(dark ? 'bg-gray-2' : 'bg-white', {
      'hidden lg:block': (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.hideMobile
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "dh-content lg:flex lg:justify-between",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "max-w-xl",
        children: [(0,prismic/* hasRichText */.M)(slice.primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: classnames_default()(dark ? 'text-white' : 'text-gray-900', 'text-4xl font-extrabold sm:text-5xl sm:tracking-tight lg:text-6xl'),
          children: prismic_reactjs.RichText.asText(slice.primary.title)
        }), (0,prismic/* hasRichText */.M)(slice.primary.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: classnames_default()(dark ? 'text-white' : 'text-gray-500', 'mt-5 text-xl lg:text-sm'),
          children: prismic_reactjs.RichText.asText(slice.primary.description)
        })]
      })
    })
  });
};

/* harmony default export */ var variations_HeaderLeft = (HeaderLeft);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6835);
;// CONCATENATED MODULE: ./hooks/useOnScreenByKeys.ts



function useOnScreenByKeys_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function useOnScreenByKeys_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { useOnScreenByKeys_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { useOnScreenByKeys_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var useOnScreenByKeys = function useOnScreenByKeys(keys) {
  var rootMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0px';

  var _useState = (0,react.useState)({}),
      onScreen = _useState[0],
      setOnScreen = _useState[1];

  var _useState2 = (0,react.useState)({}),
      observers = _useState2[0],
      setObservers = _useState2[1];

  (0,react.useEffect)(function () {
    keys.forEach(function (key) {
      var currentRef = (0,common/* getElementByKey */.b_)(key);
      var observer = new IntersectionObserver(function (_ref) {
        var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 1),
            entry = _ref2[0];

        setOnScreen(function (prev) {
          return useOnScreenByKeys_objectSpread(useOnScreenByKeys_objectSpread({}, prev), {}, (0,defineProperty/* default */.Z)({}, key, entry.isIntersecting));
        });
      }, {
        rootMargin: rootMargin
      });

      if (currentRef) {
        observer.observe(currentRef);
        setObservers(function (prev) {
          return useOnScreenByKeys_objectSpread(useOnScreenByKeys_objectSpread({}, prev), {}, (0,defineProperty/* default */.Z)({}, key, observer));
        });
      }
    });
    return function () {
      if (observers) {
        Object.keys(observers).forEach(function (key) {
          var currentRef = (0,common/* getElementByKey */.b_)(key);
          if (currentRef && observers[key]) observers[key].unobserve(currentRef);
        });
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return onScreen;
};

/* harmony default export */ var hooks_useOnScreenByKeys = (useOnScreenByKeys);
;// CONCATENATED MODULE: ./slices/Header/variations/HeaderInner.tsx








var HeaderInner = function HeaderInner(_ref) {
  var slice = _ref.slice;
  var onScreen = hooks_useOnScreenByKeys(slice.items.map(function (item) {
    return item.textScrollTo;
  }), '-50%');
  var activeSection = Object.keys(onScreen).filter(function (key) {
    return onScreen[key];
  })[0];
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "px-15 py-4 hidden lg:block bg-gray-1 border border-gray-2 sticky top-[60px] z-50",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex justify-between items-center lg:m-auto lg:max-w-7xl 2xl:max-w-8xl 3xl:max-w-8x5l",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex w-full xl:w-[70%] 3xl:justify-start",
        children: slice.items.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "button",
            className: classnames_default()('text-base hover:font-bold text-white-1 pr-10 cursor-pointer', {
              'font-bold': item.textScrollTo === activeSection
            }),
            onClick: function onClick() {
              return (0,common/* scrollTo */.X5)({
                id: item.textScrollTo
              });
            },
            children: item.text
          }, (0,index_browser/* nanoid */.x0)());
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "button",
          className: " bg-white-1 font-bold rounded-x text-black-1 px-[2.188rem] py-2.5 text-sm cursor-pointer 2xl:px-[3.906rem] 3xl:px-[5.5rem]",
          onClick: function onClick() {
            return (0,common/* scrollTo */.X5)({
              id: slice.primary.buttonScrollTo
            });
          },
          children: slice.primary.button
        })
      })]
    })
  });
};

/* harmony default export */ var variations_HeaderInner = (HeaderInner);
;// CONCATENATED MODULE: ./slices/Header/index.tsx








var Header_Header = function Header(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case HeaderVariations.centered:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_HeaderCentered, {
        slice: slice
      });

    case HeaderVariations.centeredSmall:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_HeaderCenteredSmall, {
        slice: slice
      });

    case HeaderVariations.left:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_HeaderLeft, {
        slice: slice
      });

    case HeaderVariations.leftDark:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_HeaderLeft, {
        slice: slice
      });

    case HeaderVariations.inner:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_HeaderInner, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var slices_Header = (Header_Header);
;// CONCATENATED MODULE: ./slices/Hero/Hero.types.ts
var HeroVariations;

(function (HeroVariations) {
  HeroVariations["cardBackgroundImage"] = "heroCardBackgroundImage";
  HeroVariations["left"] = "heroLeft";
  HeroVariations["leftWithBtnDownload"] = "heroLeftWithBtnDownload";
  HeroVariations["leftWithImageTitle"] = "heroLeftWithImageTitle";
  HeroVariations["leftProduct"] = "heroLeftProduct";
  HeroVariations["onlyImage"] = "heroOnlyImage";
  HeroVariations["imageSectionText"] = "heroImageSectionText";
  HeroVariations["imageTitleButton"] = "heroImageTitleButton";
  HeroVariations["carousel"] = "heroCarousel";
  HeroVariations["ctd"] = "heroCtd";
  HeroVariations["withPills"] = "heroWithPills";
})(HeroVariations || (HeroVariations = {}));
;// CONCATENATED MODULE: ./slices/Hero/variants/HeroLeft.tsx


















var HeroLeft_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var HeroLeft_HighlightText = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(774), __webpack_require__.e(935), __webpack_require__.e(166)]).then(__webpack_require__.bind(__webpack_require__, 8166));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8166)];
    }
  }
});
var HeroLeft_DialogDownload = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 70).then(__webpack_require__.bind(__webpack_require__, 4070));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4070)];
    }
  }
});

var HeroLeft = function HeroLeft(_ref) {
  var _slice$_vertical, _slice$_cluster, _slice$primary$button, _slice$primary, _slice$primary2, _slice$primary3, _slice$primary$titleI, _slice$primary4, _slice$primary7, _slice$primary8, _slice$primary8$image, _slice$primary9, _slice$primary10, _slice$primary11;

  var slice = _ref.slice;

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track;

  var locale = (0,useLocale/* default */.Z)();

  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var vertical = slice === null || slice === void 0 ? void 0 : (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var cluster = slice === null || slice === void 0 ? void 0 : (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : _slice$_cluster.data;
  var verticalColor = (0,colors/* getColor */.Lq)(vertical === null || vertical === void 0 ? void 0 : vertical.color);
  var buttonColor = (0,colors/* getColor */.Lq)((_slice$primary$button = slice === null || slice === void 0 ? void 0 : (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.buttonColor) !== null && _slice$primary$button !== void 0 ? _slice$primary$button : verticalColor);
  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({
    slice: slice,
    cluster: cluster,
    vertical: vertical
  });
  var handleClick = (0,react.useCallback)(function (event) {
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'label', 'Hero CTA');
    lodash_set_default()(payload, 'url', event.target.href);
    lodash_set_default()(payload, 'context.label', 'Hero CTA');
    lodash_set_default()(payload, 'context.destination_url', event.target.href);
    track(constants/* TrackEvents.buttonClicked */.Um.buttonClicked, payload, locale);
  }, [trackPayload, locale, track]);
  var handleClickBtnApply = (0,react.useCallback)(function (id, label, event) {
    event.preventDefault();
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'context.label', label);
    lodash_set_default()(payload, 'context.next_step', 'MoreInfoFlow');
    track(constants/* TrackEvents.productApplicationClicked */.Um.productApplicationClicked, payload, locale);
    (0,common/* scrollTo */.X5)({
      id: (0,common/* slugify */.lV)(id)
    });
  }, [trackPayload, locale, track]);
  var handleClickBtnDownload = (0,react.useCallback)(function (label) {
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'context.label', label);
    setOpen(true);
    track(constants/* TrackEvents.brochureDownloadedClicked */.Um.brochureDownloadedClicked, payload, locale);
  }, [trackPayload, locale, track]);
  if (!slice.primary) return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "hidden",
    "data-testid": "empty-slice"
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "lg:overflow-hidden dark:bg-gray-2",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "dh-content",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "lg:grid lg:grid-cols-2 lg:gap-8",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()('mx-auto max-w-md sm:max-w-2xl sm:text-center lg:text-left lg:flex lg:items-center pb-10 lg:pb-0'),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "lg:py-32",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "mx-auto sm:max-w-xl lg:mx-0",
              children: [((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.titleLine1) && /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                className: "font-semibold text-3.5xl leading-15 dark:text-athensGray",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeroLeft_HighlightText, {
                  text: prismic_reactjs.RichText.asText(slice.primary.titleLine1),
                  highlight: (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.highlightedText,
                  className: classnames_default()(buttonColor.textContrast, buttonColor.bg)
                })
              }), ((_slice$primary$titleI = slice.primary.titleImage) === null || _slice$primary$titleI === void 0 ? void 0 : _slice$primary$titleI.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "w-full",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: slice.primary.titleImage.url,
                  alt: slice.primary.titleImage.alt,
                  width: slice.primary.titleImage.dimensions.width,
                  height: slice.primary.titleImage.dimensions.height,
                  layout: "responsive",
                  objectFit: "cover",
                  priority: true
                })
              }), (0,prismic/* hasRichText */.M)((_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: classnames_default()('font-normal mt-3 text-base text-gray-50 dark:text-white-2 sm:mt-5', 'sm:max-w-xl sm:mx-auto lg:mx-0 font-archivo leading-7'),
                children: prismic_reactjs.RichText.asText(slice.primary.description)
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()('mt-10 sm:flex sm:justify-center lg:justify-start space-y-3 sm:space-y-0 sm:space-x-3'),
              children: [slice.primary.buttonLabel && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeroLeft_LinkWithQuery, {
                  onClick: function onClick(e) {
                    var _slice$primary5, _slice$primary6;

                    return (_slice$primary5 = slice.primary) !== null && _slice$primary5 !== void 0 && _slice$primary5.fragmentIdentifier ? handleClickBtnApply((_slice$primary6 = slice.primary) === null || _slice$primary6 === void 0 ? void 0 : _slice$primary6.fragmentIdentifier, slice.primary.buttonLabel, e) : handleClick(e);
                  },
                  href: (_slice$primary7 = slice.primary) !== null && _slice$primary7 !== void 0 && _slice$primary7.buttonLink ? prismic_reactjs.Link.url(slice.primary.buttonLink, common/* prismicLinkResolver */.LT) : null,
                  className: classnames_default()('dh-button-lg', buttonColor.textContrast, buttonColor.bg, buttonColor.bgHover),
                  children: slice.primary.buttonLabel
                })
              }), !!slice.primary.buttonDownloadLabel && !!slice.primary.buttonDownloadFile && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  type: "button",
                  onClick: function onClick() {
                    return handleClickBtnDownload(slice.primary.buttonDownloadLabel);
                  },
                  className: classnames_default()('dh-button-lg bg-transparent hover:bg-transparent', buttonColor.border),
                  children: slice.primary.buttonDownloadLabel
                })
              })]
            })]
          })
        }), ((_slice$primary8 = slice.primary) === null || _slice$primary8 === void 0 ? void 0 : (_slice$primary8$image = _slice$primary8.image) === null || _slice$primary8$image === void 0 ? void 0 : _slice$primary8$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:ml-8 lg:relative lg:overflow-hidden md:rounded-2xl",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mx-auto max-w-md sm:max-w-2xl sm:px-6 lg:max-w-none lg:px-0",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "w-full rounded-lg md:rounded-2xl overflow-hidden lg:hidden",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: slice.primary.image.url,
                alt: slice.primary.image.alt,
                width: slice.primary.image.dimensions.width,
                height: slice.primary.image.dimensions.height,
                layout: "responsive",
                objectFit: "cover",
                priority: true
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "hidden lg:block w-auto h-full max-w-none rounded-2xl inset-y-0 overflow-hidden",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: slice.primary.image.url,
                alt: slice.primary.image.alt,
                layout: "fill",
                objectFit: "cover",
                objectPosition: "left top",
                priority: true
              })
            })]
          })
        })]
      })
    }), [HeroVariations.leftWithBtnDownload, HeroVariations.leftWithImageTitle].includes(slice.variation) && /*#__PURE__*/(0,jsx_runtime.jsx)(HeroLeft_DialogDownload, {
      color: buttonColor,
      close: function close() {
        return setOpen(false);
      },
      open: open,
      termsAndConditionsLink: (_slice$primary9 = slice.primary) === null || _slice$primary9 === void 0 ? void 0 : _slice$primary9.termsAndConditionsLink,
      buttonLabel: (_slice$primary10 = slice.primary) === null || _slice$primary10 === void 0 ? void 0 : _slice$primary10.buttonDownloadLabel,
      downloadFile: (_slice$primary11 = slice.primary) === null || _slice$primary11 === void 0 ? void 0 : _slice$primary11.buttonDownloadFile,
      cluster: slice === null || slice === void 0 ? void 0 : slice._cluster,
      trackPayload: trackPayload
    })]
  });
};

/* harmony default export */ var variants_HeroLeft = (HeroLeft);
;// CONCATENATED MODULE: ./slices/Hero/variants/HeroCardBackgroundImage.tsx








var HeroCardBackgroundImage_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});

var HeroCardBackgroundImage = function HeroCardBackgroundImage(_ref) {
  var slice = _ref.slice;

  var renderButton = function renderButton(label, link, scrollToText, className) {
    return (0,prismic/* hasLink */.A)(link) ? /*#__PURE__*/(0,jsx_runtime.jsx)(HeroCardBackgroundImage_LinkWithQuery, {
      href: prismic_reactjs.Link.url(link, common/* prismicLinkResolver */.LT),
      className: className,
      children: label
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      type: "button",
      onClick: function onClick() {
        return (0,common/* scrollTo */.X5)({
          id: scrollToText
        });
      },
      className: className,
      children: label
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "relative bg-black-2",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative sm:overflow-hidden",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "absolute inset-0",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: "h-full w-full object-cover",
          src: slice.primary.image.url,
          alt: slice.primary.image.alt,
          layout: "fill",
          objectFit: "cover",
          priority: true
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "absolute inset-0 bg-black/40 mix-blend-multiply"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-8",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h1", {
          className: "text-center text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "block text-white",
            children: prismic_reactjs.RichText.asText(slice.primary.titleLine1)
          }), slice.primary.titleLine2 && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "block text-white",
            children: prismic_reactjs.RichText.asText(slice.primary.titleLine2)
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mt-6 mx-auto text-center text-xl text-white sm:max-w-3xl font-archivo",
          children: prismic_reactjs.RichText.asText(slice.primary.description)
        }), (slice.primary.buttonLabel || slice.primary.secondaryButtonLabel) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mt-5 max-w-md mx-auto sm:flex sm:justify-center md:mt-8",
          children: [slice.primary.secondaryButtonLabel && renderButton(slice.primary.buttonLabel, slice.primary.buttonLink, slice.primary.buttonScrollTo, 'dh-button-lg'), slice.primary.secondaryButtonLabel && renderButton(slice.primary.secondaryButtonLabel, slice.primary.secondaryButtonLink, slice.primary.secondaryButtonScrollTo, 'dh-button-lg text-primary-700 bg-white hover:bg-primary-50 sm:px-8 sm:mt-0 sm:ml-3 mt-3 sm:mt-0')]
        })]
      })]
    })
  });
};

/* harmony default export */ var variants_HeroCardBackgroundImage = (HeroCardBackgroundImage);
;// CONCATENATED MODULE: ./slices/Hero/variants/HeroImageSectionText.tsx






var HeroImageSectionText_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});

var HeroImageSectionText = function HeroImageSectionText(_ref) {
  var _slice$primary, _slice$primary$image;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "relative overflow-hidden h-screen md:h-101",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "w-full absolute top-0 left-0 max-h-161",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : (_slice$primary$image = _slice$primary.image) === null || _slice$primary$image === void 0 ? void 0 : _slice$primary$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full h-screen absolute md:h-101",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: "object-cover h-screen w-full",
          src: slice.primary.image.url,
          alt: slice.primary.image.alt,
          layout: "fill",
          objectFit: "cover",
          priority: true
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full absolute top-0 left-0 z-0 bg-black-2/80 h-screen md:h-101"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content pt-0 relative z-0 text-athensGray text-center",
      children: [slice.primary.sectionName && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()('text-white-3 font-semibold text-2xl leading-9 pt-40 px-4', 'md:text-4xl md:pt-20 md:leading-15'),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeroImageSectionText_Icon, {
          icon: "arrow-right-down-solid",
          className: "inline mr-3 lg:mr-2 w-6 lg:w-8 -rotate-45 opacity-60 text-green"
        }), slice.primary.sectionName]
      }), slice.primary.title && /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        className: classnames_default()('text-4xl font-semibold leading-15 pt-4', 'md:text-5xl md:font-bold'),
        children: slice.primary.title
      })]
    }), slice.primary.description && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "z-0 absolute w-full bottom-0 left-0 bg-gray-1/60 p-8",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: classnames_default()('dh-content p-0 text-sm text-athensGray text-center leading-6 font-semibold font-archivo relative', 'md:text-xl md:font-normal md:leading-9'),
        children: slice.primary.description
      })
    })]
  });
};

/* harmony default export */ var variants_HeroImageSectionText = (HeroImageSectionText);
;// CONCATENATED MODULE: ./slices/Hero/variants/HeroOnlyImage.tsx






var HeroOnlyImage = function HeroOnlyImage(_ref) {
  var _slice$primary, _slice$primary2, _slice$primary3, _slice$primary3$image, _slice$primary4;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: classnames_default()('relative pt-60 bg-white', (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.classname, {
      'lg:hidden': (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.hideDesktop
    }),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "h-screen w-full absolute top-0 left-0 z-0",
      children: [((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : (_slice$primary3$image = _slice$primary3.image) === null || _slice$primary3$image === void 0 ? void 0 : _slice$primary3$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        className: "w-full h-full object-center object-cover relative",
        src: slice.primary.image.url,
        alt: slice.primary.image.alt,
        layout: "fill",
        objectFit: "cover",
        priority: true
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()('absolute left-0 bottom-0 w-full h-3/4 z-10 mx-auto max-w-full bg-gradient-to-t dark:from-black from-white', (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.classname)
      })]
    })
  });
};

/* harmony default export */ var variants_HeroOnlyImage = (HeroOnlyImage);
;// CONCATENATED MODULE: ./slices/Hero/variants/HeroImageTitleButton.tsx








var HeroImageTitleButton_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});

var HeroImageTitleButton = function HeroImageTitleButton(_ref) {
  var _slice$primary, _slice$primary$image, _slice$primary2, _slice$primary3;

  var slice = _ref.slice;

  var handleClick = function handleClick(id) {
    return function (event) {
      event.preventDefault();
      (0,common/* scrollTo */.X5)({
        id: (0,common/* slugify */.lV)(id)
      });
    };
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "relative overflow-hidden h-screen md:h-101",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "w-full absolute top-0 left-0 max-h-161",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : (_slice$primary$image = _slice$primary.image) === null || _slice$primary$image === void 0 ? void 0 : _slice$primary$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full h-screen absolute z-0 md:h-101",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: "object-cover h-screen w-full",
          src: slice.primary.image.url,
          alt: slice.primary.image.alt,
          layout: "fill",
          objectFit: "cover",
          priority: true
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full absolute top-0 left-0 z-0 bg-black-2/80 h-screen md:h-101"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content relative z-0 flex flex-col justify-center items-center h-full",
      children: [((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        className: classnames_default()('text-athensGray text-center text-4xl font-semibold leading-15', 'md:text-5xl md:font-bold'),
        children: slice.primary.title
      }), !!(slice.primary.buttonLink || slice.primary.fragmentIdentifier) && ((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.buttonLabel) && /*#__PURE__*/(0,jsx_runtime.jsx)(HeroImageTitleButton_LinkWithQuery, {
        onClick: slice.primary.fragmentIdentifier ? handleClick(slice.primary.fragmentIdentifier) : function () {
          return null;
        },
        href: slice.primary.buttonLink ? prismic_reactjs.Link.url(slice.primary.buttonLink, common/* prismicLinkResolver */.LT) : null,
        className: classnames_default()('max-w-sm px-10 py-2 border border-transparent text-center m-x-auto mt-20 text-base leading-7', 'font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700'),
        children: slice.primary.buttonLabel
      })]
    })]
  });
};

/* harmony default export */ var variants_HeroImageTitleButton = (HeroImageTitleButton);
;// CONCATENATED MODULE: ./slices/Hero/variants/HeroCarousel.tsx











var HeroCarousel_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var HeroCarousel_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});
var HeroCarousel_HighlightText = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(774), __webpack_require__.e(935), __webpack_require__.e(166)]).then(__webpack_require__.bind(__webpack_require__, 8166));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8166)];
    }
  }
});
var HeroCarousel_ReactCarousel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(957), __webpack_require__.e(892)]).then(__webpack_require__.bind(__webpack_require__, 1892));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1892)];
    }
  }
});
var HeroCarousel_carouselOptions = {
  isRTL: false,
  pagination: false,
  itemPadding: [0, 0, 0, 0],
  itemsToShow: 1,
  showArrows: false,
  enableAutoPlay: true,
  infiniteLoop: true,
  breakPoints: []
};

var HeroCarousel = function HeroCarousel(_ref) {
  var _slice$_vertical, _slice$primary, _slice$items, _slice$_vertical2, _slice$_vertical2$dat;

  var slice = _ref.slice;
  var vertical = slice === null || slice === void 0 ? void 0 : (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var color = (0,colors/* getColor */.Lq)(vertical === null || vertical === void 0 ? void 0 : vertical.color);
  var color200 = (0,colors/* getColor */.Lq)(vertical === null || vertical === void 0 ? void 0 : vertical.color, 200);
  var carouselRef = (0,react.useRef)(null);
  HeroCarousel_carouselOptions.ref = carouselRef;
  HeroCarousel_carouselOptions.totalPages = slice.items.length;

  var handleClick = function handleClick(id) {
    return function (event) {
      event.preventDefault();
      (0,common/* scrollTo */.X5)({
        id: id
      });
    };
  };

  return slice.primary ? /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "relative overflow-hidden text-gray-1 lg:pl-16",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()('absolute left-0 w-1 lg:w-4 h-full rounded-br', color200.bg)
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col-reverse lg:flex-row gap-14 lg:gap-8",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "px-4 w-full lg:px-0 lg:w-5/12 3xl:w-4/12 lg:flex lg:items-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-col gap-8 lg:gap-10",
          children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            className: "text-2xl lg:text-4.5xl 2xl:text-5xl 3xl:text-6xl",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeroCarousel_HighlightText, {
              richtext: slice.primary.title,
              highlight: slice.primary.highlightedText,
              isUnderline: true
            })
          }), !!(slice.primary.buttonLink || slice.primary.buttonFragmentLink) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeroCarousel_LinkWithQuery, {
              onClick: slice.primary.buttonFragmentLink ? handleClick(slice.primary.buttonFragmentLink) : function () {
                return null;
              },
              href: slice.primary.buttonLink ? prismic_reactjs.Link.url(slice.primary.buttonLink, common/* prismicLinkResolver */.LT) : null,
              className: classnames_default()('dh-btn', color.textContrast, color.bg, color.bgHover),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: "flex flex-row items-center justify-center gap-2",
                children: [slice.primary.buttonLabel, slice.primary.buttonIcon && /*#__PURE__*/(0,jsx_runtime.jsx)(HeroCarousel_Icon, {
                  icon: slice.primary.buttonIcon,
                  className: "hidden lg:block w-6 h-6"
                })]
              })
            })
          })]
        })
      }), !!((_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "pl-4 w-full lg:w-7/12 3xl:w-8/12 lg:pl-0 overflow-hidden dh-rounded-bl",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeroCarousel_ReactCarousel, {
          options: HeroCarousel_carouselOptions,
          color: (_slice$_vertical2 = slice._vertical) === null || _slice$_vertical2 === void 0 ? void 0 : (_slice$_vertical2$dat = _slice$_vertical2.data) === null || _slice$_vertical2$dat === void 0 ? void 0 : _slice$_vertical2$dat.color,
          children: slice.items.map(function (_ref2) {
            var image = _ref2.image;
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "h-69 lg:h-142 2xl:h-175 3xl:h-200 w-full relative",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                className: "object-cover w-full h-full",
                src: image.url,
                alt: image.alt,
                layout: "fill",
                objectFit: "cover",
                priority: true
              })
            }, (0,index_browser/* nanoid */.x0)());
          })
        })
      })]
    })]
  }) : null;
};

/* harmony default export */ var variants_HeroCarousel = (HeroCarousel);
;// CONCATENATED MODULE: ./slices/Hero/variants/HeroCtd.tsx









var HeroCtd = function HeroCtd(_ref) {
  var _slice$primary, _slice$primary$brackg, _slice$primary2, _slice$items, _slice$primary3, _slice$primary4, _slice$primary5, _slice$primary6, _slice$primary7, _slice$primary8;

  var slice = _ref.slice;
  var color = (0,colors/* getColor */.Lq)(slice.primary.pillColor, 600);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "relative overflow-hidden",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "w-full top-0 left-0 ",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : (_slice$primary$brackg = _slice$primary.brackgroundImage) === null || _slice$primary$brackg === void 0 ? void 0 : _slice$primary$brackg.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: "object-cover w-full",
          src: slice.primary.brackgroundImage.url,
          alt: slice.primary.brackgroundImage.alt,
          layout: "fill",
          objectFit: "cover",
          objectPosition: "center center",
          priority: true
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full h-screen absolute top-0 left-0 z-0 bg-black-1/85"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative flex flex-col items-center lg:ml-60 lg:my-14 lg:items-start 2xl:ml-[19.313rem] 2xl:my-[6.563rem] 3xl:ml-[22.688rem] 3xl:my-28",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative flex flex-col px-4 pt-14 items-center lg:p-0 lg:items-start w-full lg:m-auto lg:max-w-7xl 2xl:max-w-8xl 3xl:max-w-8x5l",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(color.bg, color.textContrast, 'rounded-4xl flex items-center font-medium text-center', 'text-sm h-8 justify-center leading-6 px-4 py-[0.375rem] inline-block', 'lg:h-9 lg:text-lg', '3xl:px-5 3xl:py-2 3xl:text-2xl 3xl:h-[2.938rem]'),
          children: slice.primary.pillText
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: " mt-4 mb-8 w-72 h-auto lg:mb-4 lg:mt-6 lg:w-[31.625rem] lg:ml-[-5.813rem] 2xl:w-[40.938rem] 2xl:ml-[-7.438rem] 3xl:w-[51.938rem] 3xl:ml-[-9.313rem]",
          children: ((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            width: slice.primary.title.dimensions.width,
            height: slice.primary.title.dimensions.height,
            src: slice.primary.title.url,
            alt: slice.primary.title.alt,
            layout: "responsive",
            priority: true
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex flex-col items-center lg:flex-row",
          children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (item) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-white-1 rounded-4xl border-white-1 text-xs border mb-[0.375rem] px-[0.875rem] py-[0.313rem] text-center inline-block lg:mb-0 lg:mr-2 lg:text-sm lg:px-4 lg:py-[0.375rem]",
              children: item.repeatablePillText
            }, (0,index_browser/* nanoid */.x0)());
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mt-14 w-full lg:w-auto flex flex-col lg:flex-row items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "button",
            onClick: function onClick() {
              return (0,common/* scrollTo */.X5)({
                id: slice.primary.button1ScrollTo
              });
            },
            className: classnames_default()('font-bold bg-white-1 gap-3 text-black-1 rounded-[0.625rem] inline-block', 'flex-none leading-5 py-3 text-base w-full text-center mb-4', 'lg:mb-0 lg:mr-4 lg:w-auto lg:px-8', '2xl:px-[3.594rem] 2xl:py-3w', '3xl:text-lg 3xl:px-[4.781rem] 3xl:py-4'),
            children: slice.primary.buttonLabel
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "button",
            onClick: function onClick() {
              return (0,common/* scrollTo */.X5)({
                id: slice.primary.button2ScrollTo
              });
            },
            className: classnames_default()('font-bold bg-transparent border-white-1 border-2 text-white-1 rounded-[0.625rem] inline-block', 'flex-none leading-5 py-3 text-base w-full text-center mb-8 gap-3', ' lg:m-0 lg:w-auto lg:px-8', '2xl:px-[3.594rem] 2xl:py-3w', '3xl:text-lg 3xl:px-[4.781rem] 3xl:py-4'),
            children: slice.primary.buttonLabel2
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "bg-black-1 justify-evenly h-10 w-full items-center hidden lg:flex lg:h-14 lg:mt-8 lg:rounded-[2.5rem] lg:py-4 lg:px-6 lg:w-auto lg:gap-4 ",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "text-gray-8 text-xs",
            children: slice.primary.textFrom
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-14 h-[1.125rem] lg:w-20 lg:h-6",
            children: ((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.logo1.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              width: slice.primary.logo1.dimensions.width,
              height: slice.primary.logo1.dimensions.height,
              src: slice.primary.logo1.url,
              alt: slice.primary.logo1.alt,
              priority: true
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-14 h-[1.125rem] lg:w-20 lg:h-6",
            children: ((_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.logo2.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              width: slice.primary.logo2.dimensions.width,
              height: slice.primary.logo2.dimensions.height,
              src: slice.primary.logo2.url,
              alt: slice.primary.logo2.alt,
              priority: true
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "text-gray-8 text-xs",
            children: slice.primary.textBy
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-20 h-[1.125rem] lg:w-28 lg:h-6",
            children: ((_slice$primary5 = slice.primary) === null || _slice$primary5 === void 0 ? void 0 : _slice$primary5.logo3.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              width: slice.primary.logo3.dimensions.width,
              height: slice.primary.logo3.dimensions.height,
              src: slice.primary.logo3.url,
              alt: slice.primary.logo3.alt,
              priority: true
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex bg-black-1 justify-evenly h-10 w-full items-center lg:hidden lg:h-14 lg:mt-8 lg:rounded-[2.5rem] lg:py-4 lg:px-6 lg:w-auto lg:gap-4 4.5xl:ml-28 5xl:ml-36",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-gray-8 text-xs",
          children: slice.primary.textFrom
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-14 h-[1.125rem] lg:w-20 lg:h-6",
          children: ((_slice$primary6 = slice.primary) === null || _slice$primary6 === void 0 ? void 0 : _slice$primary6.logo1.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            width: slice.primary.logo1.dimensions.width,
            height: slice.primary.logo1.dimensions.height,
            src: slice.primary.logo1.url,
            alt: slice.primary.logo1.alt,
            priority: true
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-14 h-[1.125rem] lg:w-20 lg:h-6",
          children: ((_slice$primary7 = slice.primary) === null || _slice$primary7 === void 0 ? void 0 : _slice$primary7.logo2.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            width: slice.primary.logo2.dimensions.width,
            height: slice.primary.logo2.dimensions.height,
            src: slice.primary.logo2.url,
            alt: slice.primary.logo2.alt,
            priority: true
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-gray-8 text-xs",
          children: slice.primary.textBy
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "w-20 h-[1.125rem] lg:w-28 lg:h-6",
          children: ((_slice$primary8 = slice.primary) === null || _slice$primary8 === void 0 ? void 0 : _slice$primary8.logo3.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            width: slice.primary.logo3.dimensions.width,
            height: slice.primary.logo3.dimensions.height,
            src: slice.primary.logo3.url,
            alt: slice.primary.logo3.alt,
            priority: true
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {})]
    })]
  });
};

/* harmony default export */ var variants_HeroCtd = (HeroCtd);
;// CONCATENATED MODULE: ./slices/Hero/variants/HeroWithPills.tsx









var HeroWithPills = function HeroWithPills(_ref) {
  var _slice$_vertical, _slice$primary, _slice$primary$backgr, _slice$items;

  var slice = _ref.slice;
  var vertical = slice === null || slice === void 0 ? void 0 : (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var pillColor = (0,colors/* getColor */.Lq)(slice.primary.pillColor || (vertical === null || vertical === void 0 ? void 0 : vertical.color));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "relative overflow-hidden",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "w-full top-0 left-0",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : (_slice$primary$backgr = _slice$primary.backgroundImage) === null || _slice$primary$backgr === void 0 ? void 0 : _slice$primary$backgr.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: "object-cover w-full",
          src: slice.primary.backgroundImage.url,
          alt: slice.primary.backgroundImage.alt,
          layout: "fill",
          objectFit: "cover",
          objectPosition: "center center",
          priority: true
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full h-screen absolute top-0 left-0 z-0 bg-black-1/85"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "lg:m-auto lg:max-w-7xl 2xl:max-w-8xl 3xl:max-w-8x5l",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative flex flex-col items-center py-17.5 px-4 lg:p-0 lg:w-8/12 lg:m-auto lg:my-20 lg:items-start 2xl:my-37 2xl:w-6/12 2xl:ml-77 3xl:my-47 3xl:w-5/12 3xl:ml-91",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()(pillColor.bg, pillColor.textContrast, 'rounded-4xl flex items-center font-medium text-center', 'text-sm h-8 justify-center leading-6 px-4 py-1.5 inline-block', 'lg:text-lg', '3xl:px-5 3xl:py-2 3xl:text-2xl 3xl:min-h-[2.938rem]'),
          children: slice.primary.pillText
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-white-1 text-h4 text-center font-bold pt-4 pb-8 lg:text-left lg:text-6.7xl lg:py-6",
          children: slice.primary.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex flex-col items-center lg:flex-row",
          children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (item) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-white-2 rounded-4xl border-white-1 font-medium text-xs border mb-1.5 px-3.5 py-1.25 text-center inline-block lg:mb-0 lg:mr-3.7 lg:text-sm lg:px-4 lg:py-1.5",
              children: item.repeatablePillText
            }, (0,index_browser/* nanoid */.x0)());
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mt-15.5 w-full lg:w-auto flex flex-col lg:flex-row items-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "button",
            onClick: function onClick() {
              return (0,common/* scrollTo */.X5)({
                id: slice.primary.buttonScrollTo
              });
            },
            className: classnames_default()('font-bold bg-white-1 gap-3 text-black-1 rounded-x inline-block', 'flex-none leading-5 py-3 px-6 text-base w-full text-center mb-4', 'lg:mb-0 lg:mr-3 lg:w-auto lg:min-w-20', '3xl:text-lg 3xl:min-w-25 3xl:py-4 3xl:mr-4'),
            children: slice.primary.buttonLabel
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            type: "button",
            onClick: function onClick() {
              return (0,common/* scrollTo */.X5)({
                id: slice.primary.button2ScrollTo
              });
            },
            className: classnames_default()('font-bold bg-transparent border-white-1 border-2 text-white-1 rounded-x inline-block', 'flex-none leading-5 py-3 px-6 text-base w-full text-center gap-3', 'lg:w-auto lg:min-w-20', '2xl:py-3', '3xl:text-lg 3xl:min-w-25 3xl:py-4'),
            children: slice.primary.button2Label
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ var variants_HeroWithPills = (HeroWithPills);
;// CONCATENATED MODULE: ./slices/Hero/index.tsx











var heroTypeId = 'hero';

var Hero = function Hero(_ref) {
  var _slice$_cluster, _slice$_cluster$data, _slice$_cluster$data$;

  var slice = _ref.slice;
  var clusterSlice = (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : (_slice$_cluster$data = _slice$_cluster.data) === null || _slice$_cluster$data === void 0 ? void 0 : (_slice$_cluster$data$ = _slice$_cluster$data.slices) === null || _slice$_cluster$data$ === void 0 ? void 0 : _slice$_cluster$data$.find(function (_ref2) {
    var sliceType = _ref2.slice_type;
    return sliceType === heroTypeId;
  });

  switch (slice.variation) {
    case HeroVariations.carousel:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variants_HeroCarousel, {
        slice: slice
      });

    case HeroVariations.imageSectionText:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variants_HeroImageSectionText, {
        slice: slice
      });

    case HeroVariations.imageTitleButton:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variants_HeroImageTitleButton, {
        slice: slice
      });

    case HeroVariations.onlyImage:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variants_HeroOnlyImage, {
        slice: slice
      });

    case HeroVariations.cardBackgroundImage:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variants_HeroCardBackgroundImage, {
        slice: slice
      });

    case HeroVariations.leftProduct:
      if (clusterSlice !== null && clusterSlice !== void 0 && clusterSlice.primary) {
        clusterSlice._vertical = slice === null || slice === void 0 ? void 0 : slice._vertical;
        clusterSlice.primary.buttonLabel = null;
        clusterSlice.primary.buttonLink = null;
        clusterSlice.primary.fragmentIdentifier = null;
        clusterSlice.primary.buttonDownloadFile = null;
      }

      return /*#__PURE__*/(0,jsx_runtime.jsx)(variants_HeroLeft, {
        slice: clusterSlice || {}
      });

    case HeroVariations.left:
    case HeroVariations.leftWithBtnDownload:
    case HeroVariations.leftWithImageTitle:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variants_HeroLeft, {
        slice: slice
      });

    case HeroVariations.ctd:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variants_HeroCtd, {
        slice: slice
      });

    case HeroVariations.withPills:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variants_HeroWithPills, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var slices_Hero = (Hero);
;// CONCATENATED MODULE: ./slices/Incentives/Incentives.types.ts
var IncentivesVariations;

(function (IncentivesVariations) {
  IncentivesVariations["cards"] = "default-slice";
  IncentivesVariations["twoCards"] = "incentivesTwoCards";
  IncentivesVariations["threeColumns"] = "incentivesThreeColumns";
})(IncentivesVariations || (IncentivesVariations = {}));
;// CONCATENATED MODULE: ./slices/Incentives/variations/IncentivesCards.tsx








var IncentivesCards_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});

var IncentivesCards = function IncentivesCards(_ref) {
  var _slice$_vertical, _slice$_vertical$data, _slice$items;

  var slice = _ref.slice;
  var color = (0,colors/* getColor */.Lq)(slice === null || slice === void 0 ? void 0 : (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : (_slice$_vertical$data = _slice$_vertical.data) === null || _slice$_vertical$data === void 0 ? void 0 : _slice$_vertical$data.color);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "dark:bg-gray-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "dh-content",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "max-w-2xl mx-auto px-4 grid grid-cols-1 gap-y-10 gap-x-8 lg:max-w-none lg:grid-cols-3",
        children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (_ref2) {
          var title = _ref2.title,
              description = _ref2.description,
              icon = _ref2.icon;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "text-center lg:block lg:text-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "lg:shrink-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flow-root",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(IncentivesCards_Icon, {
                  icon: icon,
                  className: classnames_default()('w-12 h-14 mx-auto', color.text)
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "mt-3 lg:mt-3 lg:ml-0 dark:text-white",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "text-lg font-bold",
                children: title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mt-2 text-lg font-semibold dark:text-gray-300",
                children: prismic_reactjs.RichText.asText(description)
              })]
            })]
          }, (0,index_browser/* nanoid */.x0)());
        })
      })
    })
  });
};

/* harmony default export */ var variations_IncentivesCards = (IncentivesCards);
;// CONCATENATED MODULE: ./slices/Incentives/variations/IncentivesThreeColumns.tsx






var IncentivesThreeColumns_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});

var IncentivesThreeColumns = function IncentivesThreeColumns(_ref) {
  var _slice$items;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "bg-gray-1 text-white",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: "text-[2.125rem] text-center font-semibold leading-[3.375rem] mb-1",
        children: slice.primary.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-base text-center font-semibold leading-7",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
          render: slice.primary.description
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "max-w-2xl mx-auto mt-14 px-4 grid grid-cols-1 gap-y-10 gap-x-8 lg:max-w-none lg:grid-cols-3",
        children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (_ref2) {
          var title = _ref2.title,
              description = _ref2.description,
              icon = _ref2.icon;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "text-center lg:block lg:text-center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "lg:shrink-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flow-root",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(IncentivesThreeColumns_Icon, {
                  icon: icon,
                  className: "w-12 h-14 mx-auto text-white"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "mt-3 lg:mt-3 lg:ml-0",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "text-base leading-5 font-semibold mb-4",
                children: title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "mt-2 text-base leading-7 font-normal font-archivo",
                children: prismic_reactjs.RichText.asText(description)
              })]
            })]
          }, (0,index_browser/* nanoid */.x0)());
        })
      })]
    })
  });
};

/* harmony default export */ var variations_IncentivesThreeColumns = (IncentivesThreeColumns);
;// CONCATENATED MODULE: ./slices/Incentives/variations/IncentivesTwoCards.tsx








var IncentivesTwoCards_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});

var IncentivesTwoCards_Card = function Card(_ref) {
  var title = _ref.title,
      items = _ref.items,
      color = _ref.color;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "bg-gray-200 p-6 sm:py-11 sm:px-12 rounded-lg w-full max-w-md block dark:bg-gray-4",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("header", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        className: "dark:text-gray-100 font-heading font-bold mb-6 text-lg sm:text-2xl sm:font-semibold",
        children: title
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "grid gap-7",
      children: items === null || items === void 0 ? void 0 : items.map(function (_ref2) {
        var itemTitle = _ref2.title,
            description = _ref2.description,
            icon = _ref2.icon;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "flex gap-x-3 justify-start items-start dark:text-gray-200",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IncentivesTwoCards_Icon, {
            icon: icon,
            className: classnames_default()('w-8 flex-none', color.text)
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "grow",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-base sm:text-lg font-heading font-bold",
              children: itemTitle
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "font-description text-sm sm:text-base",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                render: description
              })
            })]
          })]
        }, (0,index_browser/* nanoid */.x0)());
      })
    })]
  });
};

var CardPosition;

(function (CardPosition) {
  CardPosition["left"] = "left";
  CardPosition["right"] = "right";
})(CardPosition || (CardPosition = {}));

var IncentivesTwoCards = function IncentivesTwoCards(_ref3) {
  var _slice$_vertical, _slice$_vertical$data, _slice$items, _slice$items2, _slice$primary, _slice$primary2, _slice$primary3, _slice$primary4;

  var slice = _ref3.slice;
  var color = (0,colors/* getColor */.Lq)((_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : (_slice$_vertical$data = _slice$_vertical.data) === null || _slice$_vertical$data === void 0 ? void 0 : _slice$_vertical$data.color);
  var itemsLeft = (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.filter(function (_ref4) {
    var card = _ref4.card;
    return card === CardPosition.left;
  });
  var itemsRight = (_slice$items2 = slice.items) === null || _slice$items2 === void 0 ? void 0 : _slice$items2.filter(function (_ref5) {
    var card = _ref5.card;
    return card === CardPosition.right;
  });
  return slice.items.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "dark:bg-woodsmoke-800",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
        className: "text-center",
        children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "font-heading font-bold text-2xl sm:text-3.5xl sm:font-semibold dark:text-white-2",
          children: slice.primary.title
        }), ((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "font-heading font-semibold text-base dark:text-gray-100",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: slice.primary.description
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "grid gap-8 mt-8 justify-items-center sm:grid-cols-2 sm:gap-5",
        children: [!!itemsLeft.length && /*#__PURE__*/(0,jsx_runtime.jsx)(IncentivesTwoCards_Card, {
          title: (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.titleCardLeft,
          items: itemsLeft,
          color: color
        }), !!itemsRight.length && /*#__PURE__*/(0,jsx_runtime.jsx)(IncentivesTwoCards_Card, {
          title: (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.titleCardRight,
          items: itemsRight,
          color: color
        })]
      })]
    })
  }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "hidden"
  });
};

/* harmony default export */ var variations_IncentivesTwoCards = (IncentivesTwoCards);
;// CONCATENATED MODULE: ./slices/Incentives/index.tsx







var Incentives = function Incentives(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case IncentivesVariations.twoCards:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_IncentivesTwoCards, {
        slice: slice
      });

    case IncentivesVariations.threeColumns:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_IncentivesThreeColumns, {
        slice: slice
      });

    case IncentivesVariations.cards:
    default:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_IncentivesCards, {
        slice: slice
      });
  }
};

/* harmony default export */ var slices_Incentives = (Incentives);
;// CONCATENATED MODULE: ./slices/LogoCloud/LogoCloud.types.ts
var LogoCloudVariations;

(function (LogoCloudVariations) {
  LogoCloudVariations["WithTitle"] = "logoCloudWithTitle";
  LogoCloudVariations["multipleCentered"] = "logoCloudMultipleCentered";
})(LogoCloudVariations || (LogoCloudVariations = {}));
;// CONCATENATED MODULE: ./slices/LogoCloud/variations/LogoCloudWithTitle.tsx







var LogoCloudWithTitle = function LogoCloudWithTitle(_ref) {
  var _slice$items;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "dh-content",
    children: [slice.primary.title && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: classnames_default()({
        'text-center': slice.primary.titlePosition === 'center',
        'text-right': slice.primary.titlePosition === 'right'
      }, 'dh-title dark:text-gray-900'),
      children: slice.primary.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flow-root mt-6 lg:mt-8",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex flex-wrap justify-between",
        children: slice === null || slice === void 0 ? void 0 : (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (item) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "my-4 mx-4 flex grow shrink-0 justify-center lg:grow-0 md:mx-8",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: item.logo.url,
                alt: item.logo.alt,
                width: item.logo.dimensions.width || '100%',
                height: item.logo.dimensions.height || '100%',
                layout: "intrinsic"
              })
            })
          }, (0,index_browser/* nanoid */.x0)());
        })
      })
    })]
  });
};

/* harmony default export */ var variations_LogoCloudWithTitle = (LogoCloudWithTitle);
;// CONCATENATED MODULE: ./slices/LogoCloud/variations/LogoCloudMultipleCentered.tsx







var LogoCloudMultipleCentered = function LogoCloudMultipleCentered(_ref) {
  var _slice$items;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "bg-gray-800 dark:bg-gray-800",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [slice.primary.title && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: classnames_default()({
          'text-center': slice.primary.titlePosition === 'center',
          'text-right': slice.primary.titlePosition === 'right'
        }, 'dh-title text-white dark:text-white'),
        children: slice.primary.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flow-root mt-6 lg:mt-8",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex flex-wrap justify-center -mx-4 overflow-hidden",
          children: slice === null || slice === void 0 ? void 0 : (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (item) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex my-6 px-2 w-full max-w-screen-lg overflow-hidden sm:w-1/5 justify-center items-center",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: item.logo.url,
                  alt: item.logo.alt,
                  width: item.logo.dimensions.width || '100%',
                  height: item.logo.dimensions.height || '100%',
                  layout: "intrinsic"
                })
              })
            }, (0,index_browser/* nanoid */.x0)());
          })
        })
      })]
    })
  });
};

/* harmony default export */ var variations_LogoCloudMultipleCentered = (LogoCloudMultipleCentered);
;// CONCATENATED MODULE: ./slices/LogoCloud/index.tsx






var LogoCloud = function LogoCloud(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case LogoCloudVariations.WithTitle:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_LogoCloudWithTitle, {
        slice: slice
      });

    default:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_LogoCloudMultipleCentered, {
        slice: slice
      });
  }
};

/* harmony default export */ var slices_LogoCloud = (LogoCloud);
;// CONCATENATED MODULE: ./slices/Marquee/Marquee.types.ts
var MarqueeVariations;

(function (MarqueeVariations) {
  MarqueeVariations["images"] = "marqueeImages";
  MarqueeVariations["imagesWithGrid"] = "marqueeImagesWithGrid";
  MarqueeVariations["testimonials"] = "marqueeTestimonials";
})(MarqueeVariations || (MarqueeVariations = {}));
// EXTERNAL MODULE: ./node_modules/react-easy-marquee/dist/index.es.js
var index_es = __webpack_require__(5111);
;// CONCATENATED MODULE: ./slices/Marquee/variations/MarqueeImages.tsx


function MarqueeImages_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function MarqueeImages_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MarqueeImages_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MarqueeImages_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var MarqueeImages_Item = function Item(_ref) {
  var image = _ref.image;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "w-64 p-x-4 text-center",
    children: !!(image !== null && image !== void 0 && image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "w-40 relative",
      children: (image === null || image === void 0 ? void 0 : image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: image.url,
        alt: image.alt,
        width: "150",
        height: "120",
        layout: "responsive",
        objectFit: "contain"
      })
    }, (0,index_browser/* nanoid */.x0)())
  });
};

var RowsDefault = 3;
var marqueeOptions = {
  duration: 30000,
  height: '128px'
};

var MarqueeImages = function MarqueeImages(_ref2) {
  var _slice$items, _slice$primary, _slice$primary2, _slice$primary2$title;

  var slice = _ref2.slice;
  if (!((_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length)) return null;
  var rows = ((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.rows) || RowsDefault;
  var itemsGrouped = lodash_chunk_default()(slice.items, Math.ceil(slice.items.length / rows));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "dh-content",
    children: [!!((_slice$primary2 = slice.primary) !== null && _slice$primary2 !== void 0 && (_slice$primary2$title = _slice$primary2.title) !== null && _slice$primary2$title !== void 0 && _slice$primary2$title.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: "text-2xl mb-10 text-center md:text-4.5xl md:mb-16",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
          render: slice.primary.title
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "sm:hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* default */.Z, MarqueeImages_objectSpread(MarqueeImages_objectSpread({}, marqueeOptions), {}, {
        duration: 50000,
        reverse: true,
        children: slice.items.map(function (_ref3) {
          var image = _ref3.image;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(MarqueeImages_Item, {
            image: image
          }, (0,index_browser/* nanoid */.x0)());
        })
      }))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hidden sm:block space-y-14",
      children: itemsGrouped.map(function (items, index) {
        return /*#__PURE__*/(0,react.createElement)(index_es/* default */.Z, MarqueeImages_objectSpread(MarqueeImages_objectSpread({}, marqueeOptions), {}, {
          axis: "X",
          reverse: !(index % 2 === 1),
          key: (0,index_browser/* nanoid */.x0)()
        }), items.map(function (_ref4) {
          var image = _ref4.image;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(MarqueeImages_Item, {
            image: image
          }, (0,index_browser/* nanoid */.x0)());
        }));
      })
    })]
  });
};

/* harmony default export */ var variations_MarqueeImages = (MarqueeImages);
;// CONCATENATED MODULE: ./slices/Marquee/variations/MarqueeImagesWithGrid.tsx


function MarqueeImagesWithGrid_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function MarqueeImagesWithGrid_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MarqueeImagesWithGrid_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MarqueeImagesWithGrid_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var MarqueeImagesWithGrid_Item = function Item(_ref) {
  var image = _ref.image;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "lg:w-80 text-center",
    children: !!(image !== null && image !== void 0 && image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "max-w-full lg:w-56 relative",
      children: (image === null || image === void 0 ? void 0 : image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: image.url,
        alt: image.alt,
        width: image.dimensions.width || '100%',
        height: image.dimensions.height || '100%',
        layout: "intrinsic",
        objectFit: "contain"
      })
    })
  });
};

var MarqueeImagesWithGrid_RowsDefault = 1;
var MarqueeImagesWithGrid_marqueeOptions = {
  duration: 30000
};

var MarqueeImagesWithGrid = function MarqueeImagesWithGrid(_ref2) {
  var _slice$items, _slice$primary, _slice$primary2, _slice$primary2$title;

  var slice = _ref2.slice;
  if (!((_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length)) return null;
  var rows = ((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.rows) || MarqueeImagesWithGrid_RowsDefault;
  var itemsGrouped = lodash_chunk_default()(slice.items, Math.ceil(slice.items.length / rows));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "dh-content-full py-30 lg:px-0 lg:py-24 2xl:py-40 3xl:py-52",
    children: [!!((_slice$primary2 = slice.primary) !== null && _slice$primary2 !== void 0 && (_slice$primary2$title = _slice$primary2.title) !== null && _slice$primary2$title !== void 0 && _slice$primary2$title.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: "text-2xl mb-16 text-center lg:text-4.5xl lg:mb-20 3xl:text-5xl 3xl:mb-40",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
          render: slice.primary.title
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "grid grid-cols-2 gap-x-6 gap-y-8 lg:hidden",
      children: slice.items.map(function (_ref3) {
        var image = _ref3.image;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(MarqueeImagesWithGrid_Item, {
          image: image
        }, (0,index_browser/* nanoid */.x0)());
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hidden lg:block space-y-14",
      children: itemsGrouped.map(function (items, index) {
        return /*#__PURE__*/(0,react.createElement)(index_es/* default */.Z, MarqueeImagesWithGrid_objectSpread(MarqueeImagesWithGrid_objectSpread({}, MarqueeImagesWithGrid_marqueeOptions), {}, {
          axis: "X",
          reverse: !(index % 2 === 1),
          key: (0,index_browser/* nanoid */.x0)()
        }), items.map(function (_ref4) {
          var image = _ref4.image;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(MarqueeImagesWithGrid_Item, {
            image: image
          }, (0,index_browser/* nanoid */.x0)());
        }));
      })
    })]
  });
};

/* harmony default export */ var variations_MarqueeImagesWithGrid = (MarqueeImagesWithGrid);
;// CONCATENATED MODULE: ./slices/Marquee/variations/MarqueeTestimonials.tsx


function MarqueeTestimonials_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function MarqueeTestimonials_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MarqueeTestimonials_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MarqueeTestimonials_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var MarqueeTestimonials_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var MarqueeTestimonials_ReactCarousel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(957), __webpack_require__.e(892)]).then(__webpack_require__.bind(__webpack_require__, 1892));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1892)];
    }
  }
});
var MarqueeTestimonials_flagsBasePath = 'assets/flags';
var MarqueeTestimonials_flags = {
  argentina: "".concat(MarqueeTestimonials_flagsBasePath, "/ar.svg"),
  brasil: "".concat(MarqueeTestimonials_flagsBasePath, "/br.svg"),
  chile: "".concat(MarqueeTestimonials_flagsBasePath, "/cl.svg"),
  colombia: "".concat(MarqueeTestimonials_flagsBasePath, "/co.svg"),
  mexico: "".concat(MarqueeTestimonials_flagsBasePath, "/mx.svg"),
  peru: "".concat(MarqueeTestimonials_flagsBasePath, "/pe.svg"),
  uruguay: "".concat(MarqueeTestimonials_flagsBasePath, "/uy.svg")
};
var MarqueeTestimonials_carouselOptions = {
  isRTL: false,
  pagination: true,
  itemPadding: [0, 0, 0, 0],
  itemsToShow: 1,
  showArrows: false,
  breakPoints: []
};

var MarqueeTestimonials_Item = function Item(_ref) {
  var photo = _ref.photo,
      testimonial = _ref.testimonial,
      name = _ref.name,
      role = _ref.role,
      country = _ref.country,
      badgeColor = _ref.badgeColor,
      badgeLabel = _ref.badgeLabel;
  var color = (0,colors/* getColor */.Lq)(badgeColor, 200);
  var countryFlag = MarqueeTestimonials_flags[country];
  var locale = (0,useLocale/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()('w-full flex my-1 lg:my-6 flex-row lg:justify-end lg:items-end lg:pr-[12.5%]', 'lg:odd:flex-row-reverse lg:odd:justify-start lg:odd:pr-0'),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()('hidden lg:block flex-none h-[max-content] fit w-48 py-6 px-7 rounded-full shadow-md', 'text-gray-1 text-base text-center', '2xl:text-xl 2xl:w-60', '3xl:text-2xl 3xl:w-72', color.bg, {
        invisible: !badgeLabel
      }),
      children: badgeLabel
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "w-full lg:w-6/12 bg-white-1 border-white-3 rounded py-8 px-6 drop-shadow-md lg:mx-4",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "font-archivo text-base leading-7 text-gray-4 mb-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
          render: testimonial
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex gap-4",
        children: [!!(photo !== null && photo !== void 0 && photo.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex-none w-10 h-10 lg:w-16 lg:h-16 relative",
          children: (photo === null || photo === void 0 ? void 0 : photo.url) && /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: photo.url,
            alt: photo.alt,
            layout: "fill",
            objectFit: "cover",
            className: "object-cover w-16 h-16 dh-rounded-tr dh-rounded-br"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "grow",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "font-bold text-sm lg:text-lg",
            children: name
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "text-primary-400 text-sm lg:text-base left-7",
            children: role
          })]
        }), !!countryFlag && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex-none flex text-5xl items-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            width: 48,
            height: 48,
            src: "".concat((0,common/* getLocale */.Kd)(locale).path).concat(countryFlag),
            alt: country,
            layout: "intrinsic"
          })
        })]
      })]
    })]
  });
};

var MarqueeTestimonials = function MarqueeTestimonials(_ref2) {
  var _slice$items, _slice$primary, _slice$primary$title, _slice$primary$button, _slice$_vertical, _slice$_vertical$data;

  var slice = _ref2.slice;
  if (!((_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length)) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()('dh-content-full bg-white-2 lg:gap-4', 'flex flex-col lg:bg-white lg:pr-0 lg:pt-0 lg:pb-0 lg:mt-24', 'lg:grid lg:grid-cols-4/12'),
    children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : (_slice$primary$title = _slice$primary.title) === null || _slice$primary$title === void 0 ? void 0 : _slice$primary$title.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
      className: "w-full flex flex-col justify-end mt-12 mb-8 lg:m-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: "text-2xl lg:text-4.5xl 2xl:text-5xl 3xl:text-6xl",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
          render: slice.primary.title
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "order-last lg:order-none lg:row-start-2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mt-4 text-lg lg:text-2xl 2xl:text-3.5xl",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
          render: slice.primary.description
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MarqueeTestimonials_LinkWithQuery, {
        href: prismic_reactjs.Link.url(slice.primary.buttonLink, common/* prismicLinkResolver */.LT),
        className: "dh-btn text-base lg:text-lg mt-3 lg:mt-8 lg:w-[max-content]",
        target: (_slice$primary$button = slice.primary.buttonLink) === null || _slice$primary$button === void 0 ? void 0 : _slice$primary$button.target,
        children: slice.primary.buttonLabel
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "lg:hidden",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(MarqueeTestimonials_ReactCarousel, {
        options: MarqueeTestimonials_carouselOptions,
        color: (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : (_slice$_vertical$data = _slice$_vertical.data) === null || _slice$_vertical$data === void 0 ? void 0 : _slice$_vertical$data.color,
        children: slice.items.map(function (item) {
          return /*#__PURE__*/(0,react.createElement)(MarqueeTestimonials_Item, MarqueeTestimonials_objectSpread(MarqueeTestimonials_objectSpread({}, item), {}, {
            key: (0,index_browser/* nanoid */.x0)()
          }));
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()('hidden lg:block space-y-14 grow overflow-hidden rounded-tl-[132px] bg-white-2', 'h-[1000px] xl:pl-24 xl:pr-15 lg:row-span-2'),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_es/* default */.Z, {
        duration: 70000,
        height: "100%",
        axis: "Y",
        reverse: true,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-full pr-2 pl-2 whitespace-normal",
            children: slice.items.map(function (item) {
              return /*#__PURE__*/(0,react.createElement)(MarqueeTestimonials_Item, MarqueeTestimonials_objectSpread(MarqueeTestimonials_objectSpread({}, item), {}, {
                key: (0,index_browser/* nanoid */.x0)()
              }));
            })
          })
        })
      })
    })]
  });
};

/* harmony default export */ var variations_MarqueeTestimonials = (MarqueeTestimonials);
;// CONCATENATED MODULE: ./slices/Marquee/index.tsx







var Marquee = function Marquee(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case MarqueeVariations.images:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_MarqueeImages, {
        slice: slice
      });

    case MarqueeVariations.imagesWithGrid:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_MarqueeImagesWithGrid, {
        slice: slice
      });

    case MarqueeVariations.testimonials:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_MarqueeTestimonials, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var slices_Marquee = (Marquee);
;// CONCATENATED MODULE: ./slices/Pricing/Pricing.types.ts
var EPricingVariations;

(function (EPricingVariations) {
  EPricingVariations["pricingCards"] = "pricingCards";
  EPricingVariations["pricingCardDynamic"] = "pricingCardDynamic";
})(EPricingVariations || (EPricingVariations = {}));
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./slices/Pricing/variations/helpers.ts



function helpers_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function helpers_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { helpers_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { helpers_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var reducePlans = function reducePlans(products) {
  return products.reduce(function (acumulate, product) {
    var _product$defaultOffer;

    var plansMap = product === null || product === void 0 ? void 0 : (_product$defaultOffer = product.defaultOffer) === null || _product$defaultOffer === void 0 ? void 0 : _product$defaultOffer.plans.map(function (p) {
      var _product$defaultOffer2;

      return helpers_objectSpread(helpers_objectSpread({}, p), {}, {
        installmentOfferKey: "".concat(product === null || product === void 0 ? void 0 : product.wareId).concat(p.installmentCount),
        wareId: product === null || product === void 0 ? void 0 : product.wareId,
        code: product === null || product === void 0 ? void 0 : product.code,
        defaultOffer: {
          token: product === null || product === void 0 ? void 0 : (_product$defaultOffer2 = product.defaultOffer) === null || _product$defaultOffer2 === void 0 ? void 0 : _product$defaultOffer2.token
        }
      });
    });
    var newPlans = [].concat((0,toConsumableArray/* default */.Z)(acumulate), (0,toConsumableArray/* default */.Z)(plansMap !== null && plansMap !== void 0 ? plansMap : []));
    return newPlans;
  }, []);
};
var sortPlans = function sortPlans(plans, order) {
  var sortedPlans = [];
  order.forEach(function (number) {
    var _plans$filter;

    var orderPlans = (_plans$filter = plans.filter(function (p) {
      return p.installmentCount === number || "".concat(p.wareId).concat(p.installmentCount) === "".concat(number);
    })) !== null && _plans$filter !== void 0 ? _plans$filter : [];
    sortedPlans = [].concat((0,toConsumableArray/* default */.Z)(sortedPlans), [orderPlans]);
  });
  return sortedPlans.reduce(function (acumulate, plan) {
    var newPlans = [].concat((0,toConsumableArray/* default */.Z)(acumulate), (0,toConsumableArray/* default */.Z)(plan));
    return newPlans;
  }, []);
};
var plansByCurrency = function plansByCurrency(plans, currency) {
  return plans.filter(function (plan) {
    return plan.currency === currency;
  });
};
;// CONCATENATED MODULE: ./slices/Pricing/variations/PricingEmpty.tsx







var PricingEmpty = function PricingEmpty(_ref) {
  var _slice$primary, _slice$primary$image, _slice$primary2, _slice$primary$urlAlt, _slice$primary$urlAlt2, _slice$primary$urlAlt3;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "relative overflow-hidden h-screen md:h-101",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "w-full absolute top-0 left-0 max-h-161",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : (_slice$primary$image = _slice$primary.image) === null || _slice$primary$image === void 0 ? void 0 : _slice$primary$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full h-screen absolute z-0 md:h-101",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: "object-cover h-screen w-full",
          src: slice.primary.image.url,
          alt: slice.primary.image.alt,
          layout: "fill",
          objectFit: "cover",
          priority: true
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full absolute top-0 left-0 z-0 bg-black-2/80 h-screen md:h-101"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content relative z-0 flex flex-col justify-center items-center h-full",
      children: [((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.titleAlt) && /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        className: classnames_default()('text-athensGray text-center text-4xl font-semibold leading-15', 'md:text-5xl md:font-bold'),
        children: slice.primary.titleAlt
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery["default"], {
        href: (_slice$primary$urlAlt = slice.primary.urlAlt) === null || _slice$primary$urlAlt === void 0 ? void 0 : _slice$primary$urlAlt.url,
        target: (_slice$primary$urlAlt2 = (_slice$primary$urlAlt3 = slice.primary.urlAlt) === null || _slice$primary$urlAlt3 === void 0 ? void 0 : _slice$primary$urlAlt3.target) !== null && _slice$primary$urlAlt2 !== void 0 ? _slice$primary$urlAlt2 : '_blank',
        className: classnames_default()('max-w-sm px-10 py-2 border border-transparent text-center m-x-auto mt-20 text-base leading-7', 'font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700'),
        children: slice.primary.btnLabelAlt
      })]
    })]
  });
};

/* harmony default export */ var variations_PricingEmpty = (PricingEmpty);
;// CONCATENATED MODULE: ./slices/Pricing/variations/PricingCards.tsx


function PricingCards_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function PricingCards_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PricingCards_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PricingCards_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


























var GRID_COLS = {
  1: 'lg:!grid-cols-1 lg:max-w-[400px] lg:mx-auto',
  2: 'lg:!grid-cols-2 lg:max-w-[800px] lg:mx-auto',
  3: 'lg:!grid-cols-3',
  4: 'lg:!grid-cols-4',
  5: 'lg:!grid-cols-5',
  6: 'lg:!grid-cols-6'
};

var PricingCards_formatCurrency = function formatCurrency(symbol, number, locale) {
  var numberFormatted = new Intl.NumberFormat(locale).format(number);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("small", {
      children: symbol
    }), ' ', numberFormatted]
  });
};

var PricingCards = function PricingCards(_ref) {
  var _slice$_checkout4, _slice$_vertical, _slice$_cluster;

  var slice = _ref.slice;

  var _useContext = (0,react.useContext)(AppContext/* AppContext */.I),
      state = _useContext.state;

  if (slice.primary.isAsync) {
    var _slice$_checkout, _slice$_checkout$allP, _slice$_checkout2;

    var allProducts = (_slice$_checkout = slice._checkout) === null || _slice$_checkout === void 0 ? void 0 : (_slice$_checkout$allP = _slice$_checkout.allProducts) === null || _slice$_checkout$allP === void 0 ? void 0 : _slice$_checkout$allP.map(function (p) {
      return PricingCards_objectSpread(PricingCards_objectSpread({}, p), {}, {
        startsAt: '',
        endsAt: ''
      });
    }); // eslint-disable-next-line no-param-reassign

    if ((_slice$_checkout2 = slice._checkout) !== null && _slice$_checkout2 !== void 0 && _slice$_checkout2.products) slice._checkout.products = allProducts;
  }

  var products = (0,react.useMemo)(function () {
    var _slice$_checkout3;

    return (_slice$_checkout3 = slice._checkout) === null || _slice$_checkout3 === void 0 ? void 0 : _slice$_checkout3.products;
  }, [(_slice$_checkout4 = slice._checkout) === null || _slice$_checkout4 === void 0 ? void 0 : _slice$_checkout4.products]);
  var vertical = (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var cluster = (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : _slice$_cluster.data;
  var locale = (0,useLocale/* default */.Z)();
  var geoCountry = (0,useGeoCountry/* default */.Z)();

  var _useState = (0,react.useState)(false),
      showSlice = _useState[0],
      setShowSlice = _useState[1];

  var _useState2 = (0,react.useState)(),
      currencyCode = _useState2[0],
      setCurrencyCode = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      countryCode = _useState3[0],
      setCountryCode = _useState3[1];

  var queryParams = useCheckoutQueryParams();

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track;

  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({
    slice: slice,
    cluster: cluster,
    vertical: vertical
  });
  var intl = (0,useIntl/* default */.Z)();
  var primaryMessages = slice.primary;
  var defaultMessages = {
    checkoutButtonLabel: intl.formatMessage({
      id: "YG0xDz",
      defaultMessage: [{
        "type": 0,
        "value": "Reservar"
      }]
    }),
    checkoutButtonLastplaceLabel: intl.formatMessage({
      id: "wVMrPN",
      defaultMessage: [{
        "type": 0,
        "value": "¡Ultimos cupos!"
      }]
    }),
    checkoutButtonSoldoutLabel: intl.formatMessage({
      id: "spsPUc",
      defaultMessage: [{
        "type": 0,
        "value": "Sold out"
      }]
    })
  };
  var hasMounted = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var _getLocalePlans = (0,checkout/* getLocalePlans */.Pq)({
      products: products,
      geoCountry: geoCountry,
      locale: locale,
      currency: state.currency.selected,
      allCurrencies: state.currency.all
    }),
        currentLocale = _getLocalePlans.currentLocale,
        currentCurrency = _getLocalePlans.currentCurrency,
        hasPlans = _getLocalePlans.hasPlans,
        isUnavailable = _getLocalePlans.isUnavailable;

    setShowSlice(!!(hasPlans && !isUnavailable));
    setCountryCode(currentLocale.countryCode);
    setCurrencyCode(currentCurrency);
  }, [geoCountry, locale, products, state.currency]);
  (0,react.useEffect)(function () {
    if (hasMounted.current) {
      (0,common/* scrollTo */.X5)({
        id: slice.primary.title
      });
    } else {
      setTimeout(function () {
        hasMounted.current = true;
      }, 1000);
    }
  }, [state.currency.selected]); // eslint-disable-line react-hooks/exhaustive-deps

  var plans = (0,react.useMemo)(function () {
    var getPlans = function getPlans(pSlice, pProducts, pCurrencyCode) {
      var _pSlice$items$map, _pSlice$items;

      if (!pCurrencyCode) return [];
      var productsReduced = reducePlans(pProducts);
      var productsSorted = sortPlans(productsReduced, (_pSlice$items$map = (_pSlice$items = pSlice.items) === null || _pSlice$items === void 0 ? void 0 : _pSlice$items.map(function (i) {
        var _i$installments;

        return (_i$installments = i.installments) !== null && _i$installments !== void 0 ? _i$installments : 0;
      })) !== null && _pSlice$items$map !== void 0 ? _pSlice$items$map : []);
      var p = plansByCurrency(productsSorted, pCurrencyCode);
      return p;
    };

    return getPlans(slice, products, currencyCode);
  }, [slice, products, currencyCode]);
  var handleClick = (0,react.useCallback)(function (_ref2) {
    var _item$duration;

    var nextStep = _ref2.nextStep,
        _ref2$label = _ref2.label,
        label = _ref2$label === void 0 ? '' : _ref2$label,
        url = _ref2.url,
        item = _ref2.item;
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'context.next_step', nextStep);
    lodash_set_default()(payload, 'context.label', label);
    lodash_set_default()(payload, 'context.destination_url', url);
    lodash_set_default()(payload, 'product.start_date', item.startsAt);
    lodash_set_default()(payload, 'product.id', item.id);
    lodash_set_default()(payload, 'product.business_unit', item.defaultOffer.businessUnit);
    lodash_set_default()(payload, 'product.business_unit_id', item.defaultOffer.businessUnitId);
    lodash_set_default()(payload, 'product.vertical', item.defaultOffer.vertical);
    lodash_set_default()(payload, 'product.vertical_id', item.defaultOffer.verticalId);
    lodash_set_default()(payload, 'product.code', item.code);
    lodash_set_default()(payload, 'product.duration', (_item$duration = item.duration) === null || _item$duration === void 0 ? void 0 : _item$duration.name);
    track(constants/* TrackEvents.productApplicationClicked */.Um.productApplicationClicked, payload, locale);
  }, [trackPayload, locale, track]);
  var color = (0,colors/* getColor */.Lq)(slice.primary.color);
  if (!(plans !== null && plans !== void 0 && plans.length) && slice.primary.btnLabelAlt && slice.primary.urlAlt) return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_PricingEmpty, {
    slice: slice
  });
  if (!showSlice) return null;
  if (!currencyCode) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "isolate overflow-hidden",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "pricing-cards",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "dh-content",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "relative z-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "pricing-cards__title",
            children: slice.primary.title
          }), (0,prismic/* hasRichText */.M)(slice.primary.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "pricing-cards__description",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
              render: slice.primary.description
            })
          })]
        }), !!(plans !== null && plans !== void 0 && plans.length) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()('pricing-cards__plan', GRID_COLS[plans.length]),
          children: plans.map(function (item) {
            var _products$find, _ref4, _slice$items$find, _slice$items, _slice$items2, _item$installmentAmou, _slice$_checkout5, _installmentProps$che, _installmentProps$tit, _classNames, _classNames2, _installmentProps$des;

            if (item.currency !== currencyCode) return null;
            var product = (_products$find = products === null || products === void 0 ? void 0 : products.find(function (_ref3) {
              var code = _ref3.code;
              return code === item.code;
            })) !== null && _products$find !== void 0 ? _products$find : {};
            var installmentProps = (_ref4 = (_slice$items$find = (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.find(function (i) {
              return "".concat(i.installments) === item.installmentOfferKey;
            })) !== null && _slice$items$find !== void 0 ? _slice$items$find : (_slice$items2 = slice.items) === null || _slice$items2 === void 0 ? void 0 : _slice$items2.find(function (i) {
              return i.installments === +item.installmentCount;
            })) !== null && _ref4 !== void 0 ? _ref4 : {};
            var installmentAmount = (_item$installmentAmou = item === null || item === void 0 ? void 0 : item.installmentAmount) !== null && _item$installmentAmou !== void 0 ? _item$installmentAmou : item === null || item === void 0 ? void 0 : item.remarkedInstallmentAmount;
            var checkoutLink = (0,checkout/* getCheckoutUrl */.Zs)(item, item.code, queryParams, (_slice$_checkout5 = slice._checkout) === null || _slice$_checkout5 === void 0 ? void 0 : _slice$_checkout5.sandbox, countryCode, item.id, (_installmentProps$che = installmentProps.checkoutVersion) !== null && _installmentProps$che !== void 0 ? _installmentProps$che : 'legacy');
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: classnames_default()('pricing-plan', {
                'pricing-plan_featured': installmentProps.featured,
                'pricing-plan_standar': !installmentProps.featured,
                'pricing-plan_soldout': product.soldout
              }),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "pricing-plan__wrapper",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                  id: item.id,
                  className: classnames_default()('pricing-plan__installments', {
                    'pricing-plan__installments_featured': installmentProps.featured
                  }),
                  children: (_installmentProps$tit = installmentProps.title) === null || _installmentProps$tit === void 0 ? void 0 : _installmentProps$tit.replace('_installments_', item.installmentCount)
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "pricing-plan__price",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "pricing-plan-price",
                    children: [!!item.discount && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "pricing-plan-discount",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                        className: classnames_default()('pricing-plan-discount__percentage', {
                          'pricing-plan-discount__percentage_soldout': product.soldout
                        }),
                        children: ["-", item.discount, "%"]
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: classnames_default()('pricing-plan-discount__original-price', {
                          'pricing-plan-discount__original-price_featured': installmentProps.featured
                        }),
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          className: "line-through text-xs",
                          children: PricingCards_formatCurrency(currencyCode, item.remarkedInstallmentAmount, locale)
                        })
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: classnames_default()('pricing-plan-price__final-price', {
                        'pricing-plan-price__final-price_featured': installmentProps.featured
                      }),
                      children: PricingCards_formatCurrency(currencyCode, installmentAmount, locale)
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                    href: checkoutLink,
                    onClick: function onClick(e) {
                      return product.soldout ? e.preventDefault() : handleClick({
                        nextStep: constants/* NextStepFlow.checkout */.AH.checkout,
                        label: (0,common/* getDefaultText */.T9)('checkoutButtonLabel', primaryMessages, defaultMessages),
                        url: checkoutLink,
                        item: product
                      });
                    },
                    target: "_self",
                    passHref: true,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                      href: checkoutLink,
                      className: classnames_default()('pricing-plan-price__button', (_classNames = {}, (0,defineProperty/* default */.Z)(_classNames, color.bg, !product.soldout), (0,defineProperty/* default */.Z)(_classNames, color.textContrast, !product.soldout), (0,defineProperty/* default */.Z)(_classNames, 'pricing-plan-price__button_soldout', product.soldout), _classNames)),
                      children: product.soldout ? (0,common/* getDefaultText */.T9)('checkoutButtonSoldoutLabel', primaryMessages, defaultMessages) : (0,common/* getDefaultText */.T9)('checkoutButtonLabel', primaryMessages, defaultMessages)
                    })
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "pricing-plan__benefits",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                    className: classnames_default()('pricing-plan-bullets', {
                      'pricing-plan-bullets_featured': installmentProps.featured,
                      'pricing-plan-bullets_standar': !installmentProps.featured
                    }),
                    children: [product.lastplaces && /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                      className: classnames_default()('pricing-plan-bullets__item pricing-plan-bullets__last-places', {
                        'pricing-plan-bullets__last-places_featured': installmentProps.featured
                      }),
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* FireIcon */.YqE, {
                        className: classnames_default()('pricing-plan-bullets__icon', (_classNames2 = {}, (0,defineProperty/* default */.Z)(_classNames2, color.text, !product.soldout), (0,defineProperty/* default */.Z)(_classNames2, 'pricing-plan-bullets__icon_soldout', product.soldout), _classNames2)),
                        "aria-hidden": "true"
                      }), (0,common/* getDefaultText */.T9)('checkoutLastPlacesLabel', primaryMessages, defaultMessages)]
                    }), (_installmentProps$des = installmentProps.description) === null || _installmentProps$des === void 0 ? void 0 : _installmentProps$des.map(function (_ref5) {
                      var _classNames3;

                      var text = _ref5.text;
                      return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                        className: classnames_default()('pricing-plan-bullets__item', {
                          'pricing-plan-bullets__item_featured': installmentProps.featured
                        }),
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* CheckIcon */.nQG, {
                          className: classnames_default()('pricing-plan-bullets__icon', (_classNames3 = {}, (0,defineProperty/* default */.Z)(_classNames3, color.text, !product.soldout), (0,defineProperty/* default */.Z)(_classNames3, 'pricing-plan-bullets__icon_soldout', product.soldout), _classNames3)),
                          "aria-hidden": "true"
                        }), text]
                      }, text);
                    })]
                  })
                })]
              })
            }, item.id);
          })
        })]
      })
    })
  }, currencyCode);
};

/* harmony default export */ var variations_PricingCards = (PricingCards);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./components/Icon.tsx + 4 modules
var components_Icon = __webpack_require__(682);
;// CONCATENATED MODULE: ./components/BulletList.tsx






var BulletList = function BulletList(_ref) {
  var bullets = _ref.bullets,
      className = _ref.className;

  var parseBulletText = function parseBulletText(text) {
    var regex = /\{\{(.*?)\}\}/;
    var match = regex.exec(text);
    return {
      icon: match === null || match === void 0 ? void 0 : match[1],
      text: text.replace(regex, '').trim()
    };
  };

  var getIconClassName = function getIconClassName(icon) {
    var baseClasses = 'h-4 w-4 flex-shrink-0';
    var colorClass = icon === 'cross' ? 'text-[#757575]' : 'text-[#62B571]';
    return classnames_default()(baseClasses, colorClass);
  };

  var getTextClassName = function getTextClassName(icon) {
    var baseClasses = 'text-base font-normal leading-relaxed';
    var colorClass = icon === 'cross' ? 'text-[#757575]' : 'text-white';
    return classnames_default()(baseClasses, colorClass);
  };

  if (!(bullets !== null && bullets !== void 0 && bullets.length)) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: classnames_default()('pt-4 font-archivo', className),
    children: bullets.map(function (block) {
      var _block$text;

      var _parseBulletText = parseBulletText((_block$text = block.text) !== null && _block$text !== void 0 ? _block$text : ''),
          icon = _parseBulletText.icon,
          text = _parseBulletText.text;

      if (!text) return null;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        className: "flex items-center gap-4 mt-4",
        children: [icon && /*#__PURE__*/(0,jsx_runtime.jsx)(components_Icon["default"], {
          icon: icon,
          className: getIconClassName(icon),
          "aria-hidden": "true"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: getTextClassName(icon !== null && icon !== void 0 ? icon : ''),
          children: text
        })]
      }, "bullet-".concat(icon));
    })
  });
};

/* harmony default export */ var components_BulletList = (BulletList);
;// CONCATENATED MODULE: ./components/BackgroundTheme/patterns/Pattern1.tsx




var Pattern1 = function Pattern1(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
    className: className,
    width: "1920",
    height: "857",
    viewBox: "0 0 1920 857",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      filter: "url(#filter0_f_577_19317)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("ellipse", {
        cx: "2119.7",
        cy: "531.864",
        rx: "197.864",
        ry: "197.864",
        transform: "rotate(-90 2119.7 531.864)",
        fill: "currentColor",
        fillOpacity: "0.4"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
      id: "mask0_577_19317",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: "1329",
      y: "386",
      width: "1671",
      height: "673",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1329",
        y: "386.375",
        width: "1670.1",
        height: "672",
        fill: "url(#paint0_radial_577_19317)"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      mask: "url(#mask0_577_19317)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1259.42",
        y: "328.255",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1391.43",
        y: "328.255",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1523.44",
        y: "328.255",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1655.45",
        y: "328.255",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1787.45",
        y: "328.255",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1919.46",
        y: "328.255",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1259.42",
        y: "460.262",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1391.43",
        y: "460.262",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1523.44",
        y: "460.262",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1655.45",
        y: "460.262",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1787.45",
        y: "460.262",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1919.46",
        y: "460.262",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1259.42",
        y: "592.27",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1391.43",
        y: "592.27",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1523.44",
        y: "592.27",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1655.45",
        y: "592.27",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1787.45",
        y: "592.27",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1919.46",
        y: "592.27",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1259.42",
        y: "724.278",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1391.43",
        y: "724.278",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1523.44",
        y: "724.278",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1655.45",
        y: "724.278",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1787.45",
        y: "724.278",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1919.46",
        y: "724.278",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1259.42",
        y: "856.285",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1391.43",
        y: "856.285",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1523.44",
        y: "856.285",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1655.45",
        y: "856.285",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1787.45",
        y: "856.285",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeOpacity: "0.8",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "1919.21",
        y: "856.038",
        width: "132",
        height: "131",
        fill: "url(#paint1_linear_577_19317)"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      style: {
        mixBlendMode: 'screen'
      },
      filter: "url(#filter1_f_577_19317)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: "121.5",
        cy: "723.5",
        r: "271.5",
        fill: "url(#paint2_radial_577_19317)",
        fillOpacity: "0.4"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("mask", {
      id: "mask1_577_19317",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: "-593",
      y: "548",
      width: "1671",
      height: "672",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "-593",
        y: "548",
        width: "1670.1",
        height: "672",
        fill: "url(#paint3_radial_577_19317)"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      mask: "url(#mask1_577_19317)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "-2.53895",
        y: "489.88",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "129.469",
        y: "489.88",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "261.476",
        y: "489.88",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "393.484",
        y: "489.88",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "525.492",
        y: "489.88",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "657.5",
        y: "489.88",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "789.507",
        y: "489.88",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "921.515",
        y: "489.88",
        width: "131.514",
        height: "131.514",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "-2.57716",
        y: "621.888",
        width: "131.506",
        height: "109.506",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "129.423",
        y: "621.888",
        width: "131.506",
        height: "109.506",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "261.423",
        y: "621.888",
        width: "131.506",
        height: "109.506",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "393.423",
        y: "621.888",
        width: "131.506",
        height: "109.506",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "525.423",
        y: "621.888",
        width: "131.506",
        height: "109.506",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "657.423",
        y: "621.888",
        width: "131.506",
        height: "109.506",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "789.423",
        y: "621.888",
        width: "131.506",
        height: "109.506",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "921.423",
        y: "621.888",
        width: "131.506",
        height: "109.506",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "-2.57716",
        y: "731.888",
        width: "131.506",
        height: "149.506",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "129.423",
        y: "731.888",
        width: "131.506",
        height: "149.506",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "261.423",
        y: "731.888",
        width: "131.506",
        height: "149.506",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "393.423",
        y: "731.888",
        width: "131.506",
        height: "149.506",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "525.423",
        y: "731.888",
        width: "131.506",
        height: "149.506",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "657.423",
        y: "731.888",
        width: "131.506",
        height: "149.506",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "789.423",
        y: "731.888",
        width: "131.506",
        height: "149.506",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        x: "921.423",
        y: "731.888",
        width: "131.506",
        height: "149.506",
        stroke: "#C3C3C3",
        strokeWidth: "0.494118"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "filter0_f_577_19317",
        x: "1587.89",
        y: "0.0520325",
        width: "1063.62",
        height: "1063.62",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          stdDeviation: "166.974",
          result: "effect1_foregroundBlur_577_19317"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "filter1_f_577_19317",
        x: "-257.898",
        y: "344.102",
        width: "758.796",
        height: "758.796",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: "0",
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          mode: "normal",
          "in": "SourceGraphic",
          in2: "BackgroundImageFix",
          result: "shape"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          stdDeviation: "53.949",
          result: "effect1_foregroundBlur_577_19317"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
        id: "paint0_radial_577_19317",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(2164.05 722.375) rotate(90) scale(414.212 1029.43)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#D9D9D9",
          stopOpacity: "0.4"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "0.793667",
          stopColor: "#D9D9D9",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "paint1_linear_577_19317",
        x1: "2051.21",
        y1: "987.038",
        x2: "1918.23",
        y2: "857.05",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#D9D9D9"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "1",
          stopColor: "#D9D9D9",
          stopOpacity: "0.5"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
        id: "paint2_radial_577_19317",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(121.5 723.5) rotate(90) scale(271.5)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "currentColor"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "1",
          stopColor: "currentColor",
          stopOpacity: "0"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("radialGradient", {
        id: "paint3_radial_577_19317",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(-55.0001 884) rotate(90.3215) scale(534.634 1328.71)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#D9D9D9",
          stopOpacity: "0.6"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: "0.468518",
          stopColor: "#D9D9D9",
          stopOpacity: "0"
        })]
      })]
    })]
  });
};

/* harmony default export */ var patterns_Pattern1 = (Pattern1);
;// CONCATENATED MODULE: ./components/BackgroundTheme/model/BackgroundTheme.model.ts
var EBackgroundPattern;

(function (EBackgroundPattern) {
  EBackgroundPattern["pattern1"] = "pattern1";
})(EBackgroundPattern || (EBackgroundPattern = {}));
;// CONCATENATED MODULE: ./components/BackgroundTheme/patterns/index.ts




var Patterns = (0,defineProperty/* default */.Z)({}, EBackgroundPattern.pattern1, patterns_Pattern1);

/* harmony default export */ var patterns = (Patterns);
;// CONCATENATED MODULE: ./components/BackgroundTheme/BackgroundTheme.tsx







var BackgroundTheme = function BackgroundTheme(_ref) {
  var _ref$pattern = _ref.pattern,
      pattern = _ref$pattern === void 0 ? EBackgroundPattern.pattern1 : _ref$pattern,
      theme = _ref.theme,
      children = _ref.children;
  var color = (0,colors/* getColor */.Lq)(theme);
  var PatternComponent = patterns[pattern];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "background-main relative",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "background",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(PatternComponent, {
        className: "background__pattern ".concat(color.text)
      })
    }), children]
  });
};

/* harmony default export */ var BackgroundTheme_BackgroundTheme = (BackgroundTheme);
// EXTERNAL MODULE: ./utils/optimize.ts
var optimize = __webpack_require__(5220);
;// CONCATENATED MODULE: ./slices/Pricing/variations/PricingCardDynamic.tsx




function PricingCardDynamic_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function PricingCardDynamic_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { PricingCardDynamic_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { PricingCardDynamic_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }























var PricingCardDynamic_formatCurrency = function formatCurrency(alias, amount, locale) {
  var formattedAmount = new Intl.NumberFormat(locale, {
    style: 'decimal'
  }).format(amount);
  return "".concat(alias, " ").concat(formattedAmount);
};
var CURRENCY_CODE_USD = 'USD';

var replaceVars = function replaceVars(input, plan, locale, currency) {
  var replaceTemplate = function replaceTemplate(text) {
    return text.replace(/{{(.*?)}}/g, function (_, key) {
      var _value$toString;

      var value = plan[key];

      if (typeof value === 'number' && key !== 'discount') {
        return PricingCardDynamic_formatCurrency(currency, value, locale);
      }

      return (_value$toString = value === null || value === void 0 ? void 0 : value.toString()) !== null && _value$toString !== void 0 ? _value$toString : '';
    });
  };

  if (typeof input === 'string') {
    return replaceTemplate(input);
  }

  return input.map(function (block) {
    return block.text ? PricingCardDynamic_objectSpread(PricingCardDynamic_objectSpread({}, block), {}, {
      text: replaceTemplate(block.text)
    }) : block;
  });
};

var PricingCardDynamic = function PricingCardDynamic(_ref) {
  var _slice$primary, _slice$primary2, _slice$items2;

  var slice = _ref.slice;

  var _useContext = (0,react.useContext)(AppContext/* AppContext */.I),
      state = _useContext.state;

  var currencySelected = state.currency.selected;

  var _useState = (0,react.useState)({}),
      offers = _useState[0],
      setOffers = _useState[1];

  var _useState2 = (0,react.useState)([]),
      plans = _useState2[0],
      setPlans = _useState2[1];

  var locale = (0,useLocale/* default */.Z)();
  var color = (0,colors/* getColor */.Lq)(slice.primary.color);

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track;

  var geoCountry = (0,useGeoCountry/* default */.Z)();
  var experiments = (0,optimize/* getExperiments */.g)();
  var router = (0,next_router.useRouter)();
  var utm = (0,analytics/* getUtm */.PB)();
  var queryParams = useCheckoutQueryParams();
  (0,react.useEffect)(function () {
    if (!currencySelected) return;
    setOffers({});
    setPlans([]);

    var fetchPlanByShowcase = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var _slice$items;

        var offerPromises, offerResults, offerMap;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                offerPromises = slice === null || slice === void 0 ? void 0 : (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map( /*#__PURE__*/function () {
                  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(item) {
                    var _offerData$plans;

                    var offerData;
                    return regenerator_default().wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return (0,checkout/* getPlansByShowcase */.j_)({
                              ware: item.wareId,
                              token: item.token,
                              currency: currencySelected,
                              showcase: item.showcase
                            });

                          case 2:
                            offerData = _context.sent;
                            setPlans((_offerData$plans = offerData === null || offerData === void 0 ? void 0 : offerData.plans) !== null && _offerData$plans !== void 0 ? _offerData$plans : []);
                            return _context.abrupt("return", {
                              key: "".concat(item.wareId, "-").concat(item.token),
                              offer: offerData
                            });

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }());

                if (!offerPromises) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return Promise.all(offerPromises);

              case 4:
                offerResults = _context2.sent;
                offerMap = offerResults.reduce(function (acc, _ref4) {
                  var key = _ref4.key,
                      offer = _ref4.offer;
                  return PricingCardDynamic_objectSpread(PricingCardDynamic_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, offer));
                }, {});
                setOffers(offerMap);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function fetchPlanByShowcase() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchPlanByShowcase();
  }, [slice.items, currencySelected]);

  var getVariantCss = function getVariantCss(variant) {
    switch (variant) {
      case 'primary':
        return 'pricing-card-dynamic-card__button--primary';

      case 'secondary':
        return 'pricing-card-dynamic-card__button--secondary';

      case 'tertiary':
        return 'pricing-card-dynamic-card__button--tertiary';

      default:
        return '';
    }
  };

  var handleClick = (0,react.useCallback)(function (_ref5) {
    var _offer$plans$0$checko, _offer$plans$, _offer$name, _offer$startAt, _offer$endAt, _offer$plans$0$id, _offer$plans$2, _offer$ware$product$, _offer$ware, _offer$ware$product$2, _offer$ware$product$3, _offer$ware2, _offer$ware2$product$, _offer$ware2$product$2, _offer$ware2$product$3, _offer$ware$product$4, _offer$ware3, _offer$ware3$product$, _offer$ware3$product$2, _offer$ware3$product$3, _offer$ware$product$5, _offer$ware4, _offer$ware4$product$, _offer$ware4$product$2, _offer$ware4$product$3, _offer$ware$product$6, _offer$ware5, _offer$ware5$product$, _offer$ware5$product$2, _offer$ware5$product$3, _offer$plans$3;

    var offer = _ref5.offer,
        _ref5$label = _ref5.label,
        label = _ref5$label === void 0 ? '' : _ref5$label;
    var trackingContext = {
      platform: 'Web',
      slice: 'pricing',
      slice_variant: 'pricingCardDynamic',
      next_step: constants/* NextStepFlow.checkout */.AH.checkout,
      label: label,
      destination_url: (_offer$plans$0$checko = offer === null || offer === void 0 ? void 0 : (_offer$plans$ = offer.plans[0]) === null || _offer$plans$ === void 0 ? void 0 : _offer$plans$.checkoutUrl) !== null && _offer$plans$0$checko !== void 0 ? _offer$plans$0$checko : ''
    };
    var trackingProduct = {
      name: (_offer$name = offer === null || offer === void 0 ? void 0 : offer.name) !== null && _offer$name !== void 0 ? _offer$name : '',
      start_date: (_offer$startAt = offer === null || offer === void 0 ? void 0 : offer.startAt) !== null && _offer$startAt !== void 0 ? _offer$startAt : '',
      end_date: (_offer$endAt = offer === null || offer === void 0 ? void 0 : offer.endAt) !== null && _offer$endAt !== void 0 ? _offer$endAt : '',
      id: (_offer$plans$0$id = offer === null || offer === void 0 ? void 0 : (_offer$plans$2 = offer.plans[0]) === null || _offer$plans$2 === void 0 ? void 0 : _offer$plans$2.id) !== null && _offer$plans$0$id !== void 0 ? _offer$plans$0$id : '',
      code: (_offer$ware$product$ = offer === null || offer === void 0 ? void 0 : (_offer$ware = offer.ware) === null || _offer$ware === void 0 ? void 0 : (_offer$ware$product$2 = _offer$ware.product[0]) === null || _offer$ware$product$2 === void 0 ? void 0 : _offer$ware$product$2.cluster.alias) !== null && _offer$ware$product$ !== void 0 ? _offer$ware$product$ : '',
      vertical_id: (_offer$ware$product$3 = offer === null || offer === void 0 ? void 0 : (_offer$ware2 = offer.ware) === null || _offer$ware2 === void 0 ? void 0 : (_offer$ware2$product$ = _offer$ware2.product[0]) === null || _offer$ware2$product$ === void 0 ? void 0 : (_offer$ware2$product$2 = _offer$ware2$product$.cluster) === null || _offer$ware2$product$2 === void 0 ? void 0 : (_offer$ware2$product$3 = _offer$ware2$product$2.vertical) === null || _offer$ware2$product$3 === void 0 ? void 0 : _offer$ware2$product$3.id) !== null && _offer$ware$product$3 !== void 0 ? _offer$ware$product$3 : '',
      vertical: (_offer$ware$product$4 = offer === null || offer === void 0 ? void 0 : (_offer$ware3 = offer.ware) === null || _offer$ware3 === void 0 ? void 0 : (_offer$ware3$product$ = _offer$ware3.product[0]) === null || _offer$ware3$product$ === void 0 ? void 0 : (_offer$ware3$product$2 = _offer$ware3$product$.cluster) === null || _offer$ware3$product$2 === void 0 ? void 0 : (_offer$ware3$product$3 = _offer$ware3$product$2.vertical) === null || _offer$ware3$product$3 === void 0 ? void 0 : _offer$ware3$product$3.name) !== null && _offer$ware$product$4 !== void 0 ? _offer$ware$product$4 : '',
      business_unit_id: (_offer$ware$product$5 = offer === null || offer === void 0 ? void 0 : (_offer$ware4 = offer.ware) === null || _offer$ware4 === void 0 ? void 0 : (_offer$ware4$product$ = _offer$ware4.product[0]) === null || _offer$ware4$product$ === void 0 ? void 0 : (_offer$ware4$product$2 = _offer$ware4$product$.cluster) === null || _offer$ware4$product$2 === void 0 ? void 0 : (_offer$ware4$product$3 = _offer$ware4$product$2.businessUnit) === null || _offer$ware4$product$3 === void 0 ? void 0 : _offer$ware4$product$3.id) !== null && _offer$ware$product$5 !== void 0 ? _offer$ware$product$5 : '',
      business_unit: (_offer$ware$product$6 = offer === null || offer === void 0 ? void 0 : (_offer$ware5 = offer.ware) === null || _offer$ware5 === void 0 ? void 0 : (_offer$ware5$product$ = _offer$ware5.product[0]) === null || _offer$ware5$product$ === void 0 ? void 0 : (_offer$ware5$product$2 = _offer$ware5$product$.cluster) === null || _offer$ware5$product$2 === void 0 ? void 0 : (_offer$ware5$product$3 = _offer$ware5$product$2.businessUnit) === null || _offer$ware5$product$3 === void 0 ? void 0 : _offer$ware5$product$3.name) !== null && _offer$ware$product$6 !== void 0 ? _offer$ware$product$6 : ''
    };
    var gclidKey = 'gclid';
    var gclid = (router === null || router === void 0 ? void 0 : router.query[gclidKey]) || undefined;
    var trackingPayload = {
      context: trackingContext,
      experiments: experiments,
      geo_country: geoCountry,
      product: trackingProduct,
      tracking: {
        gclid: gclid,
        utm: Object.keys(utm).length ? utm : undefined
      }
    };
    track(constants/* TrackEvents.productApplicationClicked */.Um.productApplicationClicked, trackingPayload, locale);
    var checkoutUrl = offer === null || offer === void 0 ? void 0 : (_offer$plans$3 = offer.plans[0]) === null || _offer$plans$3 === void 0 ? void 0 : _offer$plans$3.checkoutUrl;

    if (checkoutUrl) {
      var checkoutUrlWithParams = (0,checkout/* addQueryParamsToCheckoutUrl */.yH)(checkoutUrl, queryParams);
      window.location.href = checkoutUrlWithParams;
    }
  }, [experiments, geoCountry, locale, track, router === null || router === void 0 ? void 0 : router.query, utm, queryParams]);
  if (!plans.length && slice !== null && slice !== void 0 && (_slice$primary = slice.primary) !== null && _slice$primary !== void 0 && _slice$primary.btnLabelAlt && slice !== null && slice !== void 0 && (_slice$primary2 = slice.primary) !== null && _slice$primary2 !== void 0 && _slice$primary2.urlAlt && CURRENCY_CODE_USD === currencySelected) return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_PricingEmpty, {
    slice: slice
  });
  if (!plans.length) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BackgroundTheme_BackgroundTheme, {
    pattern: "pattern1",
    theme: slice.primary.color,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: "pricing-card-dynamic dh-content-full",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [slice.primary.title && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "pricing-card-dynamic__title",
          children: slice.primary.title
        }), slice.primary.description && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "pricing-card-dynamic__description",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: slice.primary.description
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "pricing-card-dynamic-layout",
        children: slice === null || slice === void 0 ? void 0 : (_slice$items2 = slice.items) === null || _slice$items2 === void 0 ? void 0 : _slice$items2.map(function (item) {
          var _offer$plans, _mappedItem$buttonVar, _mappedItem$logo, _mappedItem$logo2, _mappedItem$logo2$dim, _mappedItem$logo3, _mappedItem$logo3$dim, _mappedItem$logo4, _mappedItem$logo5, _mappedItem$total;

          var offer = offers["".concat(item.wareId, "-").concat(item.token)];
          if (!offer) return null;
          var plan = offer === null || offer === void 0 ? void 0 : (_offer$plans = offer.plans) === null || _offer$plans === void 0 ? void 0 : _offer$plans[0];
          if (!plan) return null;
          var installments = plan.financialInstallments;

          var mappedItem = PricingCardDynamic_objectSpread(PricingCardDynamic_objectSpread({}, item), {}, {
            pill: item.pill ? replaceVars(item.pill, plan, locale, currencySelected) : '',
            discount: item.discount ? replaceVars(item.discount, plan, locale, currencySelected) : '',
            total: item.total ? replaceVars(item.total, plan, locale, currencySelected) : [],
            installments: item.installments ? replaceVars(item.installments, plan, locale, currencySelected) : '',
            totalFinal: item.totalFinal && installments ? replaceVars(item.totalFinal, plan, locale, currencySelected) : PricingCardDynamic_formatCurrency(currencySelected, plan.totalAmount, locale),
            installmentsAmount: item.installmentsAmount ? replaceVars(item.installmentsAmount, plan, locale, currencySelected) : ''
          });

          var isHighlighted = mappedItem === null || mappedItem === void 0 ? void 0 : mappedItem.highlighted;
          var buttonClass = isHighlighted ? 'pricing-card-dynamic-card__button--selected' : 'pricing-card-dynamic-card__button--not-selected';
          var variantButton = getVariantCss((_mappedItem$buttonVar = mappedItem === null || mappedItem === void 0 ? void 0 : mappedItem.buttonVariant) !== null && _mappedItem$buttonVar !== void 0 ? _mappedItem$buttonVar : '');
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classnames_default()('pricing-card-dynamic-card', isHighlighted ? "pricing-card-dynamic-card--selected ".concat(color.border, " ").concat(color.bg) : 'pricing-card-dynamic-card--not-selected'),
              children: [isHighlighted && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: classnames_default()('pricing-card-dynamic-card__recommended', color.textContrast, color.bg),
                children: mappedItem === null || mappedItem === void 0 ? void 0 : mappedItem.highlightedLabel
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: classnames_default()('pricing-card-dynamic-card__content', isHighlighted ? 'pricing-card-dynamic-card__content--selected' : 'pricing-card-dynamic-card__content--not-selected'),
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row justify-between",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "flex flex-col items-baseline",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: "pricing-card-dynamic-card__type",
                        children: mappedItem === null || mappedItem === void 0 ? void 0 : mappedItem.type
                      }), (_mappedItem$logo = mappedItem.logo) !== null && _mappedItem$logo !== void 0 && _mappedItem$logo.url ? /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                        width: mappedItem === null || mappedItem === void 0 ? void 0 : (_mappedItem$logo2 = mappedItem.logo) === null || _mappedItem$logo2 === void 0 ? void 0 : (_mappedItem$logo2$dim = _mappedItem$logo2.dimensions) === null || _mappedItem$logo2$dim === void 0 ? void 0 : _mappedItem$logo2$dim.width,
                        height: mappedItem === null || mappedItem === void 0 ? void 0 : (_mappedItem$logo3 = mappedItem.logo) === null || _mappedItem$logo3 === void 0 ? void 0 : (_mappedItem$logo3$dim = _mappedItem$logo3.dimensions) === null || _mappedItem$logo3$dim === void 0 ? void 0 : _mappedItem$logo3$dim.height,
                        src: mappedItem === null || mappedItem === void 0 ? void 0 : (_mappedItem$logo4 = mappedItem.logo) === null || _mappedItem$logo4 === void 0 ? void 0 : _mappedItem$logo4.url,
                        alt: mappedItem === null || mappedItem === void 0 ? void 0 : (_mappedItem$logo5 = mappedItem.logo) === null || _mappedItem$logo5 === void 0 ? void 0 : _mappedItem$logo5.alt,
                        className: "pricing-card-dynamic-card__icon"
                      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                        className: "pricing-card-dynamic-card__title",
                        children: mappedItem === null || mappedItem === void 0 ? void 0 : mappedItem.title
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "flex flex-col justify-start",
                      children: mappedItem.pill && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        className: "pricing-card-dynamic-card__discount ".concat(color.textContrast, " ").concat(color.bg),
                        children: mappedItem === null || mappedItem === void 0 ? void 0 : mappedItem.pill
                      })
                    })]
                  }), (mappedItem === null || mappedItem === void 0 ? void 0 : mappedItem.description) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col justify-start items-start gap-4 py-4",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "pricing-card-dynamic-card__text-muted-item-white",
                      children: mappedItem === null || mappedItem === void 0 ? void 0 : mappedItem.description
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "pricing-card-dynamic-card__divider"
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "space-y-2 ",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "pricing-card-dynamic-card__text-muted",
                      children: mappedItem === null || mappedItem === void 0 ? void 0 : (_mappedItem$total = mappedItem.total) === null || _mappedItem$total === void 0 ? void 0 : _mappedItem$total.map(function (block) {
                        return block.text ? block.text.split(new RegExp("(".concat(currencySelected, " \\d+[\\d.,]*)"))).map(function (part) {
                          return new RegExp("^".concat(currencySelected, " \\d+[\\d.,]*$")).test(part) ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "line-through",
                            children: part
                          }, "".concat(block.text)) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            children: part
                          }, "".concat(block.text));
                        }) : null;
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "pricing-card-dynamic-card__text-highlight",
                      children: mappedItem === null || mappedItem === void 0 ? void 0 : mappedItem.discount
                    }), installments && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: "pricing-card-dynamic-card__text-muted-item-white",
                        children: mappedItem === null || mappedItem === void 0 ? void 0 : mappedItem.installments
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: "pricing-card-dynamic-card__text-bold",
                        children: mappedItem === null || mappedItem === void 0 ? void 0 : mappedItem.installmentsAmount
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: classnames_default()(installments ? 'pricing-card-dynamic-card__text-muted-item' : 'pricing-card-dynamic-card__text-bold'),
                      children: mappedItem === null || mappedItem === void 0 ? void 0 : mappedItem.totalFinal
                    })]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                  type: "button",
                  className: "pricing-card-dynamic-card__button ".concat(mappedItem !== null && mappedItem !== void 0 && mappedItem.buttonVariant ? "".concat(variantButton) : "".concat(buttonClass)),
                  onClick: function onClick() {
                    return handleClick({
                      offer: offer,
                      label: mappedItem.buttonLabel
                    });
                  },
                  children: mappedItem.buttonLabel
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_BulletList, {
                  bullets: mappedItem === null || mappedItem === void 0 ? void 0 : mappedItem.bullets
                })]
              })]
            }), (mappedItem === null || mappedItem === void 0 ? void 0 : mappedItem.disclaimer) && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "pricing-card-dynamic-card__disclaimer",
              children: mappedItem === null || mappedItem === void 0 ? void 0 : mappedItem.disclaimer
            })]
          }, item.wareId + item.token);
        })
      })]
    })
  });
};

/* harmony default export */ var variations_PricingCardDynamic = (PricingCardDynamic);
;// CONCATENATED MODULE: ./slices/Pricing/index.tsx






var Pricing_Marquee = function Marquee(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case EPricingVariations.pricingCards:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_PricingCards, {
        slice: slice
      });

    case EPricingVariations.pricingCardDynamic:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_PricingCardDynamic, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var Pricing = (Pricing_Marquee);
;// CONCATENATED MODULE: ./slices/ProductOverviews/ProductOverviews.types.ts
var ProductsOverviewsVariations;

(function (ProductsOverviewsVariations) {
  ProductsOverviewsVariations["withTwoColumns"] = "productsOverviewsWithTwoColumns";
})(ProductsOverviewsVariations || (ProductsOverviewsVariations = {}));
;// CONCATENATED MODULE: ./slices/ProductOverviews/variations/ProductOverviewsWithTwoColumns.tsx








var ProductOverviewsWithTwoColumns_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var ProductOverviewsWithTwoColumns_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});

var ProductOverviewsWithTwoColumns_Card = function Card(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "lg:py-4 w-full",
    children: children
  });
};

var ProductOverviewsWithTwoColumns_Divider = function Divider() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()('bg-white h-[1px] w-[144px] mx-auto mt-5', 'lg:absolute lg:h-[144px] lg:w-[1px] lg:left-1/2 lg:top-1/2 lg:mt-[-72px]')
  });
};

var ProductOverviewsWithTwoColumns = function ProductOverviewsWithTwoColumns(_ref2) {
  var _slice$primary, _slice$primary2, _slice$items, _slice$primary3, _slice$primary4;

  var slice = _ref2.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-gray-100 text-black relative",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
      className: "dh-content grid lg:grid-cols-2 relative lg:gap-48",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ProductOverviewsWithTwoColumns_Card, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("header", {
          children: ((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            className: "text-2xl font-bold text-gray-900",
            children: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title
          })
        }), !!slice.items.length && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: "mt-6 grid grid-cols-2 gap-x-6 gap-y-4",
          children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (_ref3) {
            var label = _ref3.label,
                icon = _ref3.icon;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
              className: "text-gray-800 text-xs font-normal flex items-start",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProductOverviewsWithTwoColumns_Icon, {
                icon: icon,
                className: "w-4 mr-3 flex-none text-primary"
              }), label]
            }, (0,index_browser/* nanoid */.x0)());
          })
        }), ((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-gray-800 text-xs font-normal mt-6",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.description
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductOverviewsWithTwoColumns_Divider, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductOverviewsWithTwoColumns_Card, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "font-medium text-xs mt-5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "font-bold mr-1",
            children: slice.primary.totalPriceLabel
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "line-through",
            children: slice.primary.totalPrice
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex items-start mt-5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "font-bold text-2xl mr-2",
            children: slice.primary.totalPriceDiscount
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "bg-primary text-white text-xs font-semibold p-1 rounded-sm",
            children: slice.primary.totalPriceDiscountPercentage
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "text-gray-800 font-medium text-xs mt-3",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "mr-1",
            children: slice.primary.fixedInstallmentsLabel
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "font-semibold",
            children: slice.primary.fixedInstallments
          })]
        }), slice.primary.buttonLink && slice.primary.buttonLabel && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductOverviewsWithTwoColumns_LinkWithQuery, {
          title: slice.primary.buttonLabel,
          href: prismic_reactjs.Link.url(slice.primary.buttonLink, common/* prismicLinkResolver */.LT),
          className: classnames_default()('dh-button bg-transparent border border-primary inline-block mt-8 text-center', 'font-semibold text-xs text-gray-800 leading-5 hover:bg-gray-300'),
          children: slice.primary.buttonLabel
        })]
      })]
    })
  });
};

/* harmony default export */ var variations_ProductOverviewsWithTwoColumns = (ProductOverviewsWithTwoColumns);
;// CONCATENATED MODULE: ./slices/ProductOverviews/index.tsx





var ProductOverviews = function ProductOverviews(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case ProductsOverviewsVariations.withTwoColumns:
    default:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_ProductOverviewsWithTwoColumns, {
        slice: slice
      });
  }
};

/* harmony default export */ var slices_ProductOverviews = (ProductOverviews);
;// CONCATENATED MODULE: ./hooks/useOnScreen.ts



var useOnScreen = function useOnScreen(ref) {
  var rootMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0px';

  var _useState = (0,react.useState)(false),
      isIntersecting = _useState[0],
      setIntersecting = _useState[1];

  (0,react.useEffect)(function () {
    var currentRef = ref === null || ref === void 0 ? void 0 : ref.current;
    var observer = new IntersectionObserver(function (_ref) {
      var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 1),
          entry = _ref2[0];

      setIntersecting(entry.isIntersecting);
    }, {
      rootMargin: rootMargin
    });

    if (currentRef) {
      observer.observe(currentRef);
    }

    return function () {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return isIntersecting;
};

/* harmony default export */ var hooks_useOnScreen = (useOnScreen);
;// CONCATENATED MODULE: ./slices/Stats/variations/StatsAnimatedCounter.tsx










var AnimatedCounter = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 932).then(__webpack_require__.bind(__webpack_require__, 1932));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1932)];
    }
  }
});

var StatsAnimatedCounter = function StatsAnimatedCounter(_ref) {
  var slice = _ref.slice;
  var items = slice.items;
  var size = items === null || items === void 0 ? void 0 : items.length;
  var ref = (0,react.useRef)(null);
  var onScreen = hooks_useOnScreen(ref, '0px');
  var locale = (0,useLocale/* default */.Z)();
  var hasThreeCards = size === 3;

  var formatNumber = function formatNumber(number) {
    return new Intl.NumberFormat(locale).format(number);
  };

  return size ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    ref: ref,
    className: "bg-gray-3 text-white",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "dh-content",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classnames_default()('grid md:flex md:flex-wrap md:justify-center font-bold text-center gap-9 md:gap-0', {
          'lg:flex lg:justify-evenly lg:flex-row': hasThreeCards
        }),
        children: items === null || items === void 0 ? void 0 : items.map(function (_ref2) {
          var number = _ref2.number,
              description = _ref2.description,
              prefix = _ref2.prefix,
              suffix = _ref2.suffix;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: classnames_default()('justify-center self-center flex flex-col text-center md:w-1/2 md:p-8', 'odd:border-none md:border-l-4 border-white lg:items-center', {
              'lg:w-1/3 lg:even:border-x-4': hasThreeCards
            }),
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "whitespace-nowrap overflow-hidden text-ellipsis max-w-full text-6xl leading-[5.25rem] font-normal  break-words lg:text-5xl lg:font-bold lg:leading-[4.375rem] 3xl:text-[5rem] 3xl:leading-[7.625rem]",
              children: [prefix, /*#__PURE__*/(0,jsx_runtime.jsx)(AnimatedCounter, {
                number: number || 0,
                duration: 2000,
                onScreen: onScreen,
                formatNumber: formatNumber
              }), suffix]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-sm font-bold leading-5 pt-4 text-center text-athensGray inline-block lg:font-normal lg:text-xl lg:leading-8 lg:h-16 lg:w-64",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                render: description
              })
            })]
          }, (0,index_browser/* nanoid */.x0)());
        })
      })
    })
  }) : null;
};

/* harmony default export */ var variations_StatsAnimatedCounter = (StatsAnimatedCounter);
;// CONCATENATED MODULE: ./slices/Stats/variations/StatsImageLight.tsx








var StatsImageLight = function StatsImageLight(_ref) {
  var _slice$items;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "relative bg-gray-50 dark:bg-gray-1",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "h-80 w-full absolute bottom-0 xl:inset-0 xl:h-full",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "h-full w-full xl:grid xl:grid-cols-2",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "h-full xl:relative xl:col-start-2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-full opacity-25 xl:absolute xl:inset-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: slice.primary.image.url,
              alt: slice.primary.image.alt,
              width: slice.primary.image.dimensions.width,
              height: slice.primary.image.dimensions.height,
              layout: "fill",
              objectFit: "cover",
              className: "w-full h-full object-cover"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            "aria-hidden": "true",
            className: classnames_default()('absolute inset-x-0 top-0 h-32 bg-gradient-to-b', 'from-gray-50 xl:inset-y-0 xl:left-0 xl:h-full xl:w-32 xl:bg-gradient-to-r')
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()('max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8', 'xl:grid xl:grid-cols-2 xl:grid-flow-col-dense xl:gap-x-8'),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative pt-12 pb-64 sm:pt-24 sm:pb-64 xl:col-start-1 xl:pb-24",
        children: [slice.primary.topTitle && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "text-sm font-semibold text-primary-600 tracking-wide uppercase",
          children: slice.primary.topTitle
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "dh-title mt-3",
          children: prismic_reactjs.RichText.asText(slice.primary.title)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "dh-description",
          children: prismic_reactjs.RichText.asText(slice.primary.description)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-12 grid grid-cols-1 gap-y-12 gap-x-6 sm:grid-cols-2",
          children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (item) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "block text-2xl font-bold text-gray-900",
                children: item.metric
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: "mt-1 block text-base text-gray-500",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "font-medium",
                  children: item.emphasis
                }), ' ', item.rest]
              })]
            }, (0,index_browser/* nanoid */.x0)());
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var variations_StatsImageLight = (StatsImageLight);
;// CONCATENATED MODULE: ./slices/Stats/variations/StatsImageDark.tsx








var StatsImageDark = function StatsImageDark(_ref) {
  var _slice$items;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "relative bg-gray-900",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "h-80 w-full absolute bottom-0 xl:inset-0 xl:h-full",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "h-full w-full xl:grid xl:grid-cols-2",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "h-full xl:relative xl:col-start-2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "w-full opacity-25 xl:absolute xl:inset-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: slice.primary.image.url,
              alt: slice.primary.image.alt,
              width: slice.primary.image.dimensions.width,
              height: slice.primary.image.dimensions.height,
              layout: "fill",
              objectFit: "cover",
              className: "w-full h-full object-cover"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            "aria-hidden": "true",
            className: classnames_default()('absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-gray-900', 'xl:inset-y-0 xl:left-0 xl:h-full xl:w-32 xl:bg-gradient-to-r')
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()('max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8', 'xl:grid xl:grid-cols-2 xl:grid-flow-col-dense xl:gap-x-8'),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative pt-12 pb-64 sm:pt-24 sm:pb-64 xl:col-start-1 xl:pb-24",
        children: [slice.primary.topTitle && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "text-sm font-semibold text-primary-300 tracking-wide uppercase",
          children: slice.primary.topTitle
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mt-3 text-3xl font-extrabold text-white",
          children: prismic_reactjs.RichText.asText(slice.primary.title)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mt-5 text-lg text-gray-300",
          children: prismic_reactjs.RichText.asText(slice.primary.description)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-12 grid grid-cols-1 gap-y-12 gap-x-6 sm:grid-cols-2",
          children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (item) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "block text-2xl font-bold text-white",
                children: item.metric
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: "mt-1 block text-base text-gray-300",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "font-medium text-white",
                  children: item.emphasis
                }), ' ', item.rest]
              })]
            }, (0,index_browser/* nanoid */.x0)());
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var variations_StatsImageDark = (StatsImageDark);
;// CONCATENATED MODULE: ./slices/Stats/variations/StatsBackgroundColor.tsx





var StatsBackgroundColor = function StatsBackgroundColor(_ref) {
  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "bg-primary-800",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8 lg:py-20",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "max-w-4xl mx-auto text-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "text-3xl font-extrabold text-white sm:text-4xl",
          children: prismic_reactjs.RichText.asText(slice.primary.title)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mt-3 text-xl text-primary-200 sm:mt-4",
          children: prismic_reactjs.RichText.asText(slice.primary.description)
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("dl", {
        className: "mt-10 text-center sm:max-w-3xl sm:mx-auto sm:grid sm:grid-cols-3 sm:gap-8",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-col",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
            className: "order-2 mt-2 text-lg leading-6 font-medium text-primary-200",
            children: slice.primary.metric1Label
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
            className: "order-1 text-5xl font-extrabold text-white",
            children: slice.primary.metric1Number
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-col mt-10 sm:mt-0",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
            className: "order-2 mt-2 text-lg leading-6 font-medium text-primary-200",
            children: slice.primary.metric2Label
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
            className: "order-1 text-5xl font-extrabold text-white",
            children: slice.primary.metric2Number
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-col mt-10 sm:mt-0",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
            className: "order-2 mt-2 text-lg leading-6 font-medium text-primary-200",
            children: slice.primary.metric3Label
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
            className: "order-1 text-5xl font-extrabold text-white",
            children: slice.primary.metric3Number
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var variations_StatsBackgroundColor = (StatsBackgroundColor);
;// CONCATENATED MODULE: ./slices/Stats/variations/StatsInCard.tsx






var StatsInCard = function StatsInCard(_ref) {
  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "bg-gray-50 pt-12 sm:pt-16",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "max-w-4xl mx-auto text-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "text-3xl font-extrabold text-gray-900 sm:text-4xl",
          children: prismic_reactjs.RichText.asText(slice.primary.title)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mt-3 text-xl text-gray-500 sm:mt-4",
          children: prismic_reactjs.RichText.asText(slice.primary.description)
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mt-10 pb-12 bg-white sm:pb-16",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "absolute inset-0 h-1/2 bg-gray-50"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "max-w-4xl mx-auto",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("dl", {
              className: "rounded-lg bg-white shadow-lg sm:grid sm:grid-cols-3",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col border-b border-gray-100 p-6 text-center sm:border-0 sm:border-r",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
                  className: "order-2 mt-2 text-lg leading-6 font-medium text-gray-500",
                  children: slice.primary.metric1Label
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
                  className: "order-1 text-5xl font-extrabold text-primary-600",
                  children: slice.primary.metric1Number
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: classnames_default()('flex flex-col border-t border-b border-gray-100 p-6', 'text-center sm:border-0 sm:border-l sm:border-r'),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
                  className: "order-2 mt-2 text-lg leading-6 font-medium text-gray-500",
                  children: slice.primary.metric2Label
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
                  className: "order-1 text-5xl font-extrabold text-primary-600",
                  children: slice.primary.metric2Number
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col border-t border-gray-100 p-6 text-center sm:border-0 sm:border-l",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
                  className: "order-2 mt-2 text-lg leading-6 font-medium text-gray-500",
                  children: slice.primary.metric3Label
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
                  className: "order-1 text-5xl font-extrabold text-primary-600",
                  children: slice.primary.metric3Number
                })]
              })]
            })
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var variations_StatsInCard = (StatsInCard);
;// CONCATENATED MODULE: ./slices/Stats/variations/StatsCounterWithIcons.tsx












var StatsCounterWithIcons_AnimatedCounter = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 932).then(__webpack_require__.bind(__webpack_require__, 1932));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1932)];
    }
  }
});

var StatsCounterWithIcons = function StatsCounterWithIcons(_ref) {
  var _slice$primary, _slice$primary2;

  var slice = _ref.slice;
  var items = slice.items;
  var size = items === null || items === void 0 ? void 0 : items.length;
  var ref = (0,react.useRef)(null);
  var onScreen = hooks_useOnScreen(ref, '0px');
  var locale = (0,useLocale/* default */.Z)();
  var verticalColor = (0,colors/* getColor */.Lq)((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.backgroundColor, 600);
  var color = ((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.backgroundColor) === 'grey' ? 'bg-gray-3' : verticalColor.bg;
  var hasOneCard = size === 1;
  var hasTwoCards = size === 2;
  var hasFourCards = size === 4;
  var hasFiveCards = size === 5;

  var formatNumber = function formatNumber(number) {
    return new Intl.NumberFormat(locale).format(number);
  };

  return size ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    ref: ref,
    className: classnames_default()(color, 'px-4 py-12 lg:dh-content-full text-white-2'),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()('flex flex-col font-bold text-center gap-8', 'lg:flex lg:flex-row lg:w-10/12 lg:mx-auto lg:flex-wrap lg:p-0 md:justify-between lg:max-w-7xl lg:m-auto', 'lg:gap-x-16 lg:gap-y-15 2xl:gap-y-[5rem] 2xl:gap-x-[4.875rem]', '2xl:w-full 2xl:justify-center 2xl:max-w-8xl 3xl:w-full', {
        'lg:justify-center': hasOneCard,
        'lg:w-7/12 lg:gap-x-16 lg:justify-evenly 2xl:w-7/12 2xl:justify-evenly': hasFourCards,
        'lg:justify-center lg:gap-x-16 2xl:gap-x-[4.875rem] 3xl:gap-x-[5.688rem] 2xl:w-10/12': hasFiveCards || hasTwoCards
      }),
      children: items === null || items === void 0 ? void 0 : items.map(function (_ref2) {
        var number = _ref2.number,
            description = _ref2.description,
            prefix = _ref2.prefix,
            suffix = _ref2.suffix,
            icon = _ref2.icon;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: classnames_default()('justify-center self-baseline flex flex-col text-center items-center w-full md:w-3/12', {
            'lg:w-3/7 2xl:w-3/7': hasFourCards,
            '3xl:w-3/10': hasTwoCards
          }),
          children: [(icon === null || icon === void 0 ? void 0 : icon.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: " block text-center mb-4 lg:mb-6 w-[4.75rem] 2xl:w-[5.25rem] 3xl:w-[6.25rem]",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              width: "100%",
              height: "100%",
              src: icon === null || icon === void 0 ? void 0 : icon.url,
              alt: icon === null || icon === void 0 ? void 0 : icon.alt
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "whitespace-nowrap overflow-hidden text-ellipsis max-w-full text-h4 leading-9 font-bold break-words lg:text-h2 lg:leading-[3.25rem] 3xl:text-5xl 3xl:leading-[3.875rem]",
            children: [prefix, /*#__PURE__*/(0,jsx_runtime.jsx)(StatsCounterWithIcons_AnimatedCounter, {
              number: number || 0,
              duration: 2000,
              onScreen: onScreen,
              formatNumber: formatNumber
            }), suffix]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "text-sm w-auto leading-5 pt-0.5 font-normal text-center inline-block lg:font-medium lg:text-lg lg:leading-6 3xl:text-2xl 3xl:leading-8 ",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
              render: description
            })
          })]
        }, (0,index_browser/* nanoid */.x0)());
      })
    })
  }) : null;
};

/* harmony default export */ var variations_StatsCounterWithIcons = (StatsCounterWithIcons);
;// CONCATENATED MODULE: ./slices/Stats/Stats.types.ts
var StatsVariations;

(function (StatsVariations) {
  StatsVariations["animatedCounter"] = "statsAnimatedCounter";
  StatsVariations["imageLight"] = "statsImageLight";
  StatsVariations["imageDark"] = "statsImageDark";
  StatsVariations["backgroundColor"] = "statsBackgroundColor";
  StatsVariations["inCard"] = "statsInCard";
  StatsVariations["counterWithIcons"] = "statsCounterWithIcons";
})(StatsVariations || (StatsVariations = {}));
;// CONCATENATED MODULE: ./slices/Stats/index.tsx










var Stats = function Stats(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case StatsVariations.animatedCounter:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_StatsAnimatedCounter, {
        slice: slice
      });

    case StatsVariations.imageLight:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_StatsImageLight, {
        slice: slice
      });

    case StatsVariations.imageDark:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_StatsImageDark, {
        slice: slice
      });

    case StatsVariations.backgroundColor:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_StatsBackgroundColor, {
        slice: slice
      });

    case StatsVariations.inCard:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_StatsInCard, {
        slice: slice
      });

    case StatsVariations.counterWithIcons:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_StatsCounterWithIcons, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var slices_Stats = (Stats);
;// CONCATENATED MODULE: ./slices/Steps/Steps.types.ts
var StepsVariations;

(function (StepsVariations) {
  StepsVariations["default"] = "steps";
})(StepsVariations || (StepsVariations = {}));
;// CONCATENATED MODULE: ./slices/Steps/variations/StepsDefault.tsx










var StartIcon = function StartIcon(_ref) {
  var icon = _ref.icon;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()('rounded-full w-10 flex justify-center items-center', 'lg:w-[3.75rem] lg:h-[3.75rem] 2xl:w-[4.375rem] 2xl:h-[4.375rem] 3xl:w-20 3xl:h-20'),
    children: icon
  });
};

var FinalIcon = function FinalIcon(_ref2) {
  var icon = _ref2.icon;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classnames_default()('rounded-full w-10 flex justify-center items-center absolute -right-1', 'xl:w-[3.75rem] lg:h-[3.75rem] 2xl:w-[4.375rem] 2xl:h-[4.375rem] 3xl:w-20 3xl:h-20'),
    children: icon
  });
};

var StepNumber = function StepNumber(_ref3) {
  var index = _ref3.index,
      color = _ref3.color;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    "aria-hidden": "true",
    className: classnames_default()('h-8 w-8 mx-auto rounded-full flex items-center justify-center', 'font-bold text-base leading-6 lg:mx-2', 'lg:w-10 lg:h-10 2xl:w-11 2xl:h-11 3xl:w-14 3xl:h-14', 'lg:text-h6 2xl:text-h5', color.bg, color.textContrast),
    children: index + 1
  });
};

var Step = function Step(_ref4) {
  var icon = _ref4.icon,
      children = _ref4.children,
      color = _ref4.color,
      _ref4$minHeight = _ref4.minHeight,
      minHeight = _ref4$minHeight === void 0 ? '4rem' : _ref4$minHeight;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "flex flex-row gap-3 lg:flex-col",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative flex",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "absolute inset-0 flex",
        "aria-hidden": "true",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()('w-0.5 h-full border-r border-dashed mx-auto flex-none', 'lg:h-0.5 lg:w-full lg:border-t lg:border-r-0 lg:my-auto', color)
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: " relative w-10 h-9 flex-none lg:flex lg:items-center lg:w-full lg:h-[3.75rem] 2xl:h-[4.375rem] 3xl:h-20 ",
        children: icon
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "lg:min-h-[4rem]",
      style: {
        minHeight: minHeight
      },
      children: children
    })]
  });
};

var StepsDefault = function StepsDefault(_ref5) {
  var _slice$_vertical, _slice$primary, _slice$primary2, _slice$primary2$iconB, _slice$primary3, _slice$primary3$iconB, _slice$primary4, _slice$primary4$iconB, _slice$primary5, _slice$primary5$iconF, _slice$primary6, _slice$primary6$iconF, _slice$primary7, _slice$primary7$iconF;

  var slice = _ref5.slice;
  var items = slice.items;
  var itemsLength = items.length;
  var vertical = slice === null || slice === void 0 ? void 0 : (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var color = (0,colors/* getColor */.Lq)(slice.primary.color || (vertical === null || vertical === void 0 ? void 0 : vertical.color));
  var backgroundColor = ((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.backgroundColor) === 'white' ? 'bg-white-1' : 'bg-black-2';
  var textColor = backgroundColor === 'bg-black-2' ? 'text-white-1' : 'text-black-1 border-black-1';
  if (!itemsLength) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: classnames_default()('dh-content-full', 'py-20 lg:py-[8.75rem] 2xl:py-[11.25rem] 3xl:py-[12.5rem]', backgroundColor),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "lg:m-auto lg:max-w-7xl 2xl:max-w-8xl 3xl:max-w-8x5l",
      children: [(0,prismic/* hasRichText */.M)(slice.primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        className: "text-center mb-8 lg:mb-[3.75rem]",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: classnames_default()('text-h4 lg:text-h2 3xl:text-h1', textColor),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: slice.primary.title
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "text-left",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
          "aria-label": "Progress",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
            className: "flex flex-col lg:flex-row lg:w-10/12 lg:justify-center lg:mx-auto",
            children: [((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : (_slice$primary2$iconB = _slice$primary2.iconBegin) === null || _slice$primary2$iconB === void 0 ? void 0 : _slice$primary2$iconB.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "relative -mb-2 lg:w-1/10",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Step, {
                color: textColor,
                icon: /*#__PURE__*/(0,jsx_runtime.jsx)(StartIcon, {
                  icon: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    width: "80px",
                    height: "80px",
                    src: (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : (_slice$primary3$iconB = _slice$primary3.iconBegin) === null || _slice$primary3$iconB === void 0 ? void 0 : _slice$primary3$iconB.url,
                    alt: (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : (_slice$primary4$iconB = _slice$primary4.iconBegin) === null || _slice$primary4$iconB === void 0 ? void 0 : _slice$primary4$iconB.alt
                  })
                })
              })
            }), items.map(function (item, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "relative lg:w-2/10",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Step, {
                  color: textColor,
                  icon: /*#__PURE__*/(0,jsx_runtime.jsx)(StepNumber, {
                    index: index,
                    color: color
                  }),
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "pb-8 lg:px-2",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: classnames_default()('text-h7 font-bold 3xl:text-h5', textColor),
                      children: item.title
                    }), (0,prismic/* hasRichText */.M)(item.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: classnames_default()('text-p3 font-medium mt-1.5 3xl:text-p2', textColor),
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                        render: item.description
                      })
                    })]
                  })
                })
              }, (0,index_browser/* nanoid */.x0)());
            }), ((_slice$primary5 = slice.primary) === null || _slice$primary5 === void 0 ? void 0 : (_slice$primary5$iconF = _slice$primary5.iconFinal) === null || _slice$primary5$iconF === void 0 ? void 0 : _slice$primary5$iconF.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "relative -mt-2 lg:mt-0 lg:w-1/10",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Step, {
                color: textColor,
                minHeight: "auto",
                icon: /*#__PURE__*/(0,jsx_runtime.jsx)(FinalIcon, {
                  icon: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    width: "80px",
                    height: "80px",
                    src: (_slice$primary6 = slice.primary) === null || _slice$primary6 === void 0 ? void 0 : (_slice$primary6$iconF = _slice$primary6.iconFinal) === null || _slice$primary6$iconF === void 0 ? void 0 : _slice$primary6$iconF.url,
                    alt: (_slice$primary7 = slice.primary) === null || _slice$primary7 === void 0 ? void 0 : (_slice$primary7$iconF = _slice$primary7.iconFinal) === null || _slice$primary7$iconF === void 0 ? void 0 : _slice$primary7$iconF.alt
                  })
                })
              })
            })]
          })
        })
      })]
    })
  });
};

/* harmony default export */ var variations_StepsDefault = (StepsDefault);
;// CONCATENATED MODULE: ./slices/Steps/index.tsx





var Steps = function Steps(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case StepsVariations["default"]:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_StepsDefault, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var slices_Steps = (Steps);
;// CONCATENATED MODULE: ./slices/Tabs/Tabs.types.ts
var TabsVariations;

(function (TabsVariations) {
  TabsVariations["withAccordionOnMobile"] = "tabsWithAccordionOnMobile";
  TabsVariations["productCardCheckout"] = "tabsProductCardCheckout";
})(TabsVariations || (TabsVariations = {}));
;// CONCATENATED MODULE: ./slices/Tabs/variations/TabsProductCardCheckout.tsx


function TabsProductCardCheckout_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function TabsProductCardCheckout_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { TabsProductCardCheckout_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { TabsProductCardCheckout_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

























var TabsProductCardCheckout_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var TabsProductCardCheckout_Tooltip = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 795).then(__webpack_require__.bind(__webpack_require__, 8795));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(8795)];
    }
  }
});
var TabsProductCardCheckout_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});
var TabsProductCardCheckout_InstallmentKeyText;

(function (InstallmentKeyText) {
  InstallmentKeyText["count"] = "[installment_count]";
})(TabsProductCardCheckout_InstallmentKeyText || (TabsProductCardCheckout_InstallmentKeyText = {}));

var TabsProductCardCheckout_installmentFormat = function installmentFormat(_ref) {
  var installmentCount = _ref.installmentCount,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text;
  return text.replace(TabsProductCardCheckout_InstallmentKeyText.count, installmentCount);
};

var TabsProductCardCheckout_formatCurrency = function formatCurrency(symbol, number, locale) {
  var numberFormatted = new Intl.NumberFormat(locale).format(number);
  return " ".concat(symbol).concat(numberFormatted);
};

var PaymentMethod = function PaymentMethod(_ref2) {
  var _slice$items;

  var slice = _ref2.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
    className: "text-gray-6 text-p4 font-medium mt-1.5 flex items-center gap-0.5",
    children: [slice.primary.paymentMethodsLabel, /*#__PURE__*/(0,jsx_runtime.jsx)(TabsProductCardCheckout_Tooltip, {
      tip: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "text-left",
        children: [(0,prismic/* hasRichText */.M)(slice.primary.paymentMethodsTooltip) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-p4 text-black",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: slice.primary.paymentMethodsTooltip
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-2.5",
          children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (_ref3) {
            var paymentMethodImage = _ref3.paymentMethodImage;
            return (paymentMethodImage === null || paymentMethodImage === void 0 ? void 0 : paymentMethodImage.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "inline-block mr-2.5 my-1",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: paymentMethodImage.url,
                alt: paymentMethodImage.alt,
                width: paymentMethodImage.dimensions.width,
                height: paymentMethodImage.dimensions.height
              })
            }, (0,index_browser/* nanoid */.x0)());
          })
        })]
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TabsProductCardCheckout_Icon, {
        icon: "exclamation-circle",
        className: "text-gray-6 w-3 h-3 inline-block"
      })
    })]
  });
};

var TabsProductCardCheckout = function TabsProductCardCheckout(_ref4) {
  var _slice$_vertical, _slice$_cluster, _slice$_checkout3, _Object$keys, _Object$keys$sort, _durations$0$id, _durations$, _slice$primary, _durations$2, _durations$3;

  var slice = _ref4.slice;

  if (slice.primary.isAsync) {
    var _slice$_checkout, _slice$_checkout$allP, _slice$_checkout2;

    var allProducts = (_slice$_checkout = slice._checkout) === null || _slice$_checkout === void 0 ? void 0 : (_slice$_checkout$allP = _slice$_checkout.allProducts) === null || _slice$_checkout$allP === void 0 ? void 0 : _slice$_checkout$allP.map(function (p) {
      return TabsProductCardCheckout_objectSpread(TabsProductCardCheckout_objectSpread({}, p), {}, {
        startsAt: '',
        endsAt: ''
      });
    }); // eslint-disable-next-line no-param-reassign

    if ((_slice$_checkout2 = slice._checkout) !== null && _slice$_checkout2 !== void 0 && _slice$_checkout2.products) slice._checkout.products = allProducts;
  }

  var vertical = (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : _slice$_vertical.data;
  var cluster = (_slice$_cluster = slice._cluster) === null || _slice$_cluster === void 0 ? void 0 : _slice$_cluster.data;
  var products = (_slice$_checkout3 = slice._checkout) === null || _slice$_checkout3 === void 0 ? void 0 : _slice$_checkout3.products;
  var productsByDuration = lodash_groupby_default()(products, 'duration.name');
  var durationKeys = (_Object$keys = Object.keys(productsByDuration)) === null || _Object$keys === void 0 ? void 0 : (_Object$keys$sort = _Object$keys.sort()) === null || _Object$keys$sort === void 0 ? void 0 : _Object$keys$sort.reverse();
  var durations = durationKeys.map(function (d) {
    return productsByDuration[d] && productsByDuration[d][0].duration;
  });
  var locale = (0,useLocale/* default */.Z)();

  var _useState = (0,react.useState)((_durations$0$id = (_durations$ = durations[0]) === null || _durations$ === void 0 ? void 0 : _durations$.id) !== null && _durations$0$id !== void 0 ? _durations$0$id : undefined),
      tab = _useState[0],
      setTab = _useState[1];

  var primaryColor = (0,colors/* getColor */.Lq)(slice.primary.primaryColor, 600);
  var secondaryColor = (0,colors/* getColor */.Lq)(slice.primary.secondaryColor, 600);
  var uniqueProductPlan = [];
  var isSingleTab = durations.length < 2;

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track;

  var intl = (0,useIntl/* default */.Z)();
  var trackPayload = (0,useTrackPayload/* useTrackingPayload */.E)({
    slice: slice,
    cluster: cluster,
    vertical: vertical
  });
  var geoCountry = (0,useGeoCountry/* default */.Z)();

  var _useState2 = (0,react.useState)(false),
      showSlice = _useState2[0],
      setShowSlice = _useState2[1];

  var _useState3 = (0,react.useState)(common/* defaultLocale.currencyCode */.al.currencyCode),
      currencyCode = _useState3[0],
      setCurrencyCode = _useState3[1];

  var _useState4 = (0,react.useState)(common/* defaultLocale.currencySymbol */.al.currencySymbol),
      currencySymbol = _useState4[0],
      setCurrencySymbol = _useState4[1];

  var _useState5 = (0,react.useState)(''),
      countryCode = _useState5[0],
      setCountryCode = _useState5[1];

  var queryParams = useCheckoutQueryParams();
  var primaryMessages = slice.primary;
  var defaultMessages = {
    checkoutButtonLabel: intl.formatMessage({
      id: "YG0xDz",
      defaultMessage: [{
        "type": 0,
        "value": "Reservar"
      }]
    }),
    checkoutButtonLastplaceLabel: intl.formatMessage({
      id: "wVMrPN",
      defaultMessage: [{
        "type": 0,
        "value": "¡Ultimos cupos!"
      }]
    }),
    checkoutButtonSoldoutLabel: intl.formatMessage({
      id: "spsPUc",
      defaultMessage: [{
        "type": 0,
        "value": "Sold out"
      }]
    })
  };
  (0,react.useEffect)(function () {
    if (!geoCountry) return;

    var _getLocalePlans = (0,checkout/* getLocalePlans */.Pq)({
      products: products,
      geoCountry: geoCountry,
      locale: locale
    }),
        currentLocale = _getLocalePlans.currentLocale,
        hasPlans = _getLocalePlans.hasPlans,
        isUnavailable = _getLocalePlans.isUnavailable;

    setShowSlice(!!(hasPlans && !isUnavailable));
    setCountryCode(currentLocale.countryCode);
    setCurrencyCode(currentLocale.currencyCode);
    setCurrencySymbol(currentLocale.currencySymbol);
  }, [geoCountry, locale, products]);
  var handleClick = (0,react.useCallback)(function (_ref5) {
    var _item$duration;

    var nextStep = _ref5.nextStep,
        _ref5$label = _ref5.label,
        label = _ref5$label === void 0 ? '' : _ref5$label,
        url = _ref5.url,
        item = _ref5.item;
    var payload = lodash_clonedeep_default()(trackPayload);
    lodash_set_default()(payload, 'context.next_step', nextStep);
    lodash_set_default()(payload, 'context.label', label);
    lodash_set_default()(payload, 'context.destination_url', url);
    lodash_set_default()(payload, 'product.start_date', item.startsAt);
    lodash_set_default()(payload, 'product.id', item.id);
    lodash_set_default()(payload, 'product.business_unit', item.defaultOffer.businessUnit);
    lodash_set_default()(payload, 'product.business_unit_id', item.defaultOffer.businessUnitId);
    lodash_set_default()(payload, 'product.vertical', item.defaultOffer.vertical);
    lodash_set_default()(payload, 'product.vertical_id', item.defaultOffer.verticalId);
    lodash_set_default()(payload, 'product.code', item.code);
    lodash_set_default()(payload, 'product.duration', (_item$duration = item.duration) === null || _item$duration === void 0 ? void 0 : _item$duration.name);
    track(constants/* TrackEvents.productApplicationClicked */.Um.productApplicationClicked, payload, locale);
  }, [trackPayload, locale, track]);
  if (!showSlice) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "dh-content-full px-4 py-15 lg:px-15 lg:pb-13 lg:pt-[8.75rem] 3xl:pt-40 bg-white-1",
    "data-testid": TabsVariations.productCardCheckout,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()('flex flex-col justify-center w-full 2xl:w-10/12 2xl:mx-auto', 'lg:m-auto lg:max-w-7xl 2xl:max-w-8xl 3xl:w-full'),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mx-auto",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("header", {
          className: "lg:mb-6 lg:flex lg:flex-row",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "grow",
            children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "text-black-1 text-h4 font-bold lg:text-h2 3xl:text-h1",
              children: slice.primary.title
            }), (0,prismic/* hasRichText */.M)(slice.primary.description) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-gray-1 text-p2 mt-1.5 font-medium lg:w-9/12 lg:mt-4 2xl:w-7/10",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                render: slice.primary.description
              })
            })]
          }), slice.primary.showTabs && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex-none w-full lg:w-3/12 2xl:w-3/10",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: classnames_default()('border rounded-[1.875rem] p-1 mt-10 w-full', primaryColor.border),
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row relative",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: classnames_default()('absolute top-0 h-full rounded-[1.875rem] transition-all', primaryColor.bg, {
                    'left-0': tab === ((_durations$2 = durations[0]) === null || _durations$2 === void 0 ? void 0 : _durations$2.id) || isSingleTab,
                    'left-1/2': tab !== ((_durations$3 = durations[0]) === null || _durations$3 === void 0 ? void 0 : _durations$3.id) && !isSingleTab,
                    'w-1/2': !isSingleTab,
                    'w-full': isSingleTab
                  })
                }), durations.map(function (duration) {
                  return duration && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: classnames_default()('p-2 text-center text-h7 font-bold cursor-pointer 3xl:text-h5', (0,defineProperty/* default */.Z)({
                      'text-white-1 z-0': tab === duration.id,
                      'w-1/2': !isSingleTab,
                      'w-full': isSingleTab
                    }, primaryColor.text, tab !== duration.id)),
                    onClick: function onClick() {
                      return setTab(duration.id);
                    },
                    children: duration.name
                  }, (0,index_browser/* nanoid */.x0)());
                })]
              })
            })
          })]
        }), products === null || products === void 0 ? void 0 : products.map(function (item) {
          var _item$defaultOffer$pl, _item$duration2, _plan$installmentAmou, _slice$items2, _item$duration3, _slice$primary$logo, _slice$primary$logo2, _slice$primary$logo3, _slice$primary$logo4, _slice$primary$logo5, _slice$primary2, _slice$primary3, _slice$primary3$benef, _slice$primary4, _slice$_checkout4;

          var plan = (_item$defaultOffer$pl = item.defaultOffer.plans) === null || _item$defaultOffer$pl === void 0 ? void 0 : _item$defaultOffer$pl.find(function (p) {
            return p.currency === currencyCode;
          });
          if (!plan) return null;
          var productKey = "".concat((_item$duration2 = item.duration) === null || _item$duration2 === void 0 ? void 0 : _item$duration2.name, "_").concat(plan === null || plan === void 0 ? void 0 : plan.remarkedInstallmentAmount);
          if (uniqueProductPlan.includes(productKey)) return null;
          uniqueProductPlan.push(productKey);
          var installmentAmount = (_plan$installmentAmou = plan === null || plan === void 0 ? void 0 : plan.installmentAmount) !== null && _plan$installmentAmou !== void 0 ? _plan$installmentAmou : plan === null || plan === void 0 ? void 0 : plan.remarkedInstallmentAmount;
          var hasPaymentTooltip = (0,prismic/* hasRichText */.M)(slice.primary.paymentMethodsTooltip) || !!((_slice$items2 = slice.items) !== null && _slice$items2 !== void 0 && _slice$items2.length);
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
            className: classnames_default()('bg-white-1 border-[0.031rem] border-white-3 shadow-md rounded inline-flex flex-col my-4', 'lg:gap-8 lg:flex-row', {
              hidden: ((_item$duration3 = item.duration) === null || _item$duration3 === void 0 ? void 0 : _item$duration3.id) !== tab
            }),
            "data-testid": "".concat(TabsVariations.productCardCheckout, "-item"),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: classnames_default()('text-white-1 lg:w-9 lg:min-h-[11.25rem] text-center font-bold text-h8 overflow-hidden', 'flex-none flex justify-center items-center rounded-t lg:rounded-l lg:rounded-t-0 lg:rounded-tr-none', primaryColor.bg, primaryColor.textContrast),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "lg:-rotate-90 h-9 flex justify-center items-center flex-none",
                children: slice.primary.installmentTag
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: " flex flex-col items-center justify-center w-full gap-8 py-10 px-6 lg:py-15 lg:flex-row lg:px-0",
              children: [(_slice$primary$logo = slice.primary.logo) !== null && _slice$primary$logo !== void 0 && _slice$primary$logo.url ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "flex-none flex items-center justify-center lg:w-[17.125rem] 3xl:w-[20.625rem]",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: (_slice$primary$logo2 = slice.primary.logo) === null || _slice$primary$logo2 === void 0 ? void 0 : _slice$primary$logo2.url,
                  alt: (_slice$primary$logo3 = slice.primary.logo) === null || _slice$primary$logo3 === void 0 ? void 0 : _slice$primary$logo3.alt,
                  width: (_slice$primary$logo4 = slice.primary.logo) === null || _slice$primary$logo4 === void 0 ? void 0 : _slice$primary$logo4.dimensions.width,
                  height: (_slice$primary$logo5 = slice.primary.logo) === null || _slice$primary$logo5 === void 0 ? void 0 : _slice$primary$logo5.dimensions.height
                })
              }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                  className: classnames_default()('text-h4 lg:text-h3 font-bold', primaryColor.text),
                  children: slice.primary.cardTitle
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "text-p2 text-gray-5 font-bold mt-0.5",
                  children: slice.primary.cardDescription
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col grow gap-8 lg:flex-row lg:mr-14 lg:justify-end",
                children: [!slice.primary.isAsync && !!(plan !== null && plan !== void 0 && plan.enrollmentAmount) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex flex-row gap-1.5",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TabsProductCardCheckout_Icon, {
                    icon: "check-circle-solid",
                    className: classnames_default()('w-6 h-6 flex-none', secondaryColor.text)
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "text-gray-1",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "text-h8 font-bold block mr-1.5 pt-0.5 3xl:text-h7 3xl:inline-block",
                      children: slice.primary.bookingLabel
                    }), !!plan.enrollmentAmount && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "text-h8 font-bold block pt-0.5 3xl:text-h7 3xl:inline-block",
                      children: TabsProductCardCheckout_formatCurrency(currencySymbol, plan === null || plan === void 0 ? void 0 : plan.enrollmentAmount, locale)
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "text-p3 font-medium block mt-0.5 text-gray-4",
                      children: slice.primary.bookingDescription
                    }), hasPaymentTooltip && !slice.primary.isAsync && /*#__PURE__*/(0,jsx_runtime.jsx)(PaymentMethod, {
                      slice: slice
                    })]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex flex-row gap-1.5",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TabsProductCardCheckout_Icon, {
                    icon: "check-circle-solid",
                    className: classnames_default()('w-6 h-6 flex-none', secondaryColor.text)
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "text-gray-1",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "text-h8 font-bold block mr-1.5 pt-0.5 3xl:text-h7 3xl:inline-block",
                      children: slice.primary.installmentLabel
                    }), !!slice.primary.installmentCount && !!plan.installmentCount && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "text-h8 font-bold block pt-0.5 3xl:text-h7 3xl:inline-block",
                      children: TabsProductCardCheckout_installmentFormat({
                        installmentCount: plan.installmentCount,
                        text: slice.primary.installmentCount
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "text-p3 font-medium block mt-0.5 text-gray-5",
                      children: slice.primary.installmentDescription
                    }), !!slice.primary.totalPriceLabel && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      className: "text-gray-6 text-p4 font-medium mt-1.5 flex items-center gap-0.5",
                      children: [slice.primary.totalPriceLabel, /*#__PURE__*/(0,jsx_runtime.jsx)(TabsProductCardCheckout_Tooltip, {
                        tip: TabsProductCardCheckout_formatCurrency(currencySymbol, plan.programAmount, locale),
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TabsProductCardCheckout_Icon, {
                          icon: "exclamation-circle",
                          className: "text-gray-6 w-3 h-3 inline-block"
                        })
                      })]
                    }), ((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.benefitsLabel) && ((_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : (_slice$primary3$benef = _slice$primary3.benefitsLink) === null || _slice$primary3$benef === void 0 ? void 0 : _slice$primary3$benef.uid) && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "text-p4 font-medium block mt-1.5 text-gray-5",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TabsProductCardCheckout_LinkWithQuery, {
                        href: prismic_reactjs.Link.url((_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.benefitsLink, common/* prismicLinkResolver */.LT),
                        target: "_blank",
                        className: "underline",
                        children: slice.primary.benefitsLabel
                      })
                    }), hasPaymentTooltip && slice.primary.isAsync && /*#__PURE__*/(0,jsx_runtime.jsx)(PaymentMethod, {
                      slice: slice
                    })]
                  })]
                }), !!installmentAmount && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "text-center lg:text-right relative",
                  children: [!!(plan !== null && plan !== void 0 && plan.discount) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    className: " inline-block bg-green-550 text-p3 font-bold text-white-1 rounded-full py-1.5 px-3.5 mb-1.5 lg:absolute lg:-top-9 lg:right-0 lg:mb-0 ",
                    children: [plan.discount, "% Off"]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    className: classnames_default()('text-h4 font-bold block 3xl:text-h3', primaryColor.text),
                    children: [TabsProductCardCheckout_formatCurrency(currencySymbol, plan === null || plan === void 0 ? void 0 : plan.installmentAmount, locale), slice.primary.installmentPriceSuffix]
                  }), !!(plan !== null && plan !== void 0 && plan.discount) && (plan === null || plan === void 0 ? void 0 : plan.remarkedInstallmentAmount) && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    className: "line-through text-p2 font-medium text-gray-8",
                    children: [TabsProductCardCheckout_formatCurrency(currencySymbol, plan === null || plan === void 0 ? void 0 : plan.remarkedInstallmentAmount, locale), slice.primary.installmentPriceSuffix]
                  })]
                }), slice.primary.showCheckoutButton && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "relative col-span-2 lg:col-span-1 whitespace-nowrap lg:pl-4",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TabsProductCardCheckout_LinkWithQuery, {
                    href: (0,checkout/* getCheckoutUrl */.Zs)(item, item.code, queryParams, (_slice$_checkout4 = slice._checkout) === null || _slice$_checkout4 === void 0 ? void 0 : _slice$_checkout4.sandbox, countryCode),
                    onClick: function onClick(e) {
                      var _slice$_checkout5;

                      return item.soldout ? e.preventDefault() : handleClick({
                        nextStep: constants/* NextStepFlow.checkout */.AH.checkout,
                        label: (0,common/* getDefaultText */.T9)('checkoutButtonLabel', primaryMessages, defaultMessages),
                        url: (0,checkout/* getCheckoutUrl */.Zs)(item, item.code, queryParams, (_slice$_checkout5 = slice._checkout) === null || _slice$_checkout5 === void 0 ? void 0 : _slice$_checkout5.sandbox, countryCode),
                        item: item
                      });
                    },
                    target: "_self",
                    className: classnames_default()('w-full dh-btn font-bold self-stretch text-p3 lg:text-p2 p-3 3xl:text-lg lg:px-7', {
                      ' bg-black-1 text-white-1 ': !item.soldout
                    }, {
                      'pointer-events-none bg-transparent text-gray-6 border-2 border-gray-6': item.soldout
                    }),
                    children: item.soldout ? (0,common/* getDefaultText */.T9)('checkoutButtonSoldoutLabel', primaryMessages, defaultMessages) : (0,common/* getDefaultText */.T9)('checkoutButtonLabel', primaryMessages, defaultMessages)
                  }, (0,index_browser/* nanoid */.x0)()), item.lastplaces && !item.soldout && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: " text-red-1 font-medium text-p4 w-full  mt-2.5 lg:text-p3 text-center lg:absolute",
                    children: (0,common/* getDefaultText */.T9)('checkoutButtonLastplaceLabel', primaryMessages, defaultMessages)
                  })]
                })]
              })]
            })]
          }, (0,index_browser/* nanoid */.x0)());
        })]
      })
    })
  });
};

/* harmony default export */ var variations_TabsProductCardCheckout = (TabsProductCardCheckout);
;// CONCATENATED MODULE: ./slices/Tabs/variations/TabsWithAccordionOnMobile.tsx






var TabsWithAccordionOnMobile_Accordion = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 451).then(__webpack_require__.bind(__webpack_require__, 9451));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9451)];
    }
  }
});
var TabsWithAccordionOnMobile_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});
var Tabs = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 360).then(__webpack_require__.bind(__webpack_require__, 2360));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(2360)];
    }
  }
});

var TabsWithAccordionOnMobile = function TabsWithAccordionOnMobile(_ref) {
  var _vertical$data, _slice$items, _slice$primary, _slice$primary2;

  var slice = _ref.slice;
  var vertical = slice._vertical;
  var color = (0,colors/* getColor */.Lq)(vertical === null || vertical === void 0 ? void 0 : (_vertical$data = vertical.data) === null || _vertical$data === void 0 ? void 0 : _vertical$data.color);
  return (_slice$items = slice.items) !== null && _slice$items !== void 0 && _slice$items.length ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-gray-2",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content max-w-4xl",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsxs)("h3", {
        className: classnames_default()('font-semibold text-athensGray text-xl leading-8 mb-6 text-center', 'sm:text-2xl sm:leading-9 sm:text-left'),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TabsWithAccordionOnMobile_Icon, {
          icon: "arrow-right-down-solid",
          className: "hidden sm:inline-block text-pink w-8 mr-3 -rotate-90"
        }), slice.primary.title]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "bg-white-2 rounded-2xl py-9 px-7 sm:px-11",
        children: [((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
          className: "text-center text-gray-1 text-2xl leading-9 font-semibold mb-8",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            children: slice.primary.tabsTitle
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "sm:hidden",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TabsWithAccordionOnMobile_Accordion, {
            items: slice.items,
            activeColor: color.text
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hidden sm:block",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tabs, {
            items: slice.items,
            activeColor: color.text
          })
        })]
      })]
    })
  }) : null;
};

/* harmony default export */ var variations_TabsWithAccordionOnMobile = (TabsWithAccordionOnMobile);
;// CONCATENATED MODULE: ./slices/Tabs/index.tsx






var Tabs_Stats = function Stats(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case TabsVariations.withAccordionOnMobile:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_TabsWithAccordionOnMobile, {
        slice: slice
      });

    case TabsVariations.productCardCheckout:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_TabsProductCardCheckout, {
        slice: slice
      });

    default:
      return null;
  }
};

/* harmony default export */ var slices_Tabs = (Tabs_Stats);
;// CONCATENATED MODULE: ./slices/Team/variations/TeamWithLargeImages.tsx









var TeamWithLargeImages_LinkWithQuery = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1590));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1590)];
    }
  }
});
var TeamWithLargeImages_Icon = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 682));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(682)];
    }
  }
});

var isOdd = function isOdd(num) {
  return num % 2;
};

var TeamWithLargeImages = function TeamWithLargeImages(_ref) {
  var _slice$items;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "bg-white",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "dh-content",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "space-y-12",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: "space-y-14 lg:grid lg:gap-y-28 lg:space-y-0",
          children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (person, i) {
            var _person$image, _person$link;

            return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: classnames_default()('space-y-5 lg:space-y-0 lg:flex', {
                  'lg:flex-row-reverse': isOdd(i)
                }),
                children: [((_person$image = person.image) === null || _person$image === void 0 ? void 0 : _person$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "aspect-w-3 aspect-h-2 lg:w-1/2 rounded-2xl relative overflow-hidden",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    src: person.image.url,
                    alt: person.image.alt,
                    width: person.image.dimensions.width,
                    height: person.image.dimensions.height,
                    layout: "responsive",
                    objectFit: "cover"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: classnames_default()('flex items-center space-y-2 lg:w-1/2', isOdd(i) ? 'lg:pr-28' : 'lg:pl-28'),
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "text-lg leading-6 font-medium space-y-5",
                    children: [person.icon && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TeamWithLargeImages_Icon, {
                        icon: person.icon,
                        className: "h-6 w-6"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                      className: "text-2xl font-bold dark:text-black-2",
                      children: person.title
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                      className: "dh-description dark:text-gray-2",
                      children: person.description
                    }), ((_person$link = person.link) === null || _person$link === void 0 ? void 0 : _person$link.url) && /*#__PURE__*/(0,jsx_runtime.jsx)(TeamWithLargeImages_LinkWithQuery, {
                      href: prismic_reactjs.Link.url(person.link, function (doc) {
                        return (0,common/* prismicLinkResolver */.LT)(doc);
                      }),
                      className: "dh-button-sm",
                      children: person.linkLabel
                    })]
                  })
                })]
              })
            }, (0,index_browser/* nanoid */.x0)());
          })
        })
      })
    })
  });
};

/* harmony default export */ var variations_TeamWithLargeImages = (TeamWithLargeImages);
;// CONCATENATED MODULE: ./slices/Team/variations/TeamWithOneImage.tsx






var TeamWithOneImage = function TeamWithOneImage(_ref) {
  var _slice$primary, _slice$primary$image, _slice$primary2, _slice$primary2$image, _slice$primary3, _slice$primary3$image, _slice$primary4, _slice$primary4$image, _slice$primary5, _slice$primary5$image;

  var slice = _ref.slice;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "bg-white",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "dh-content",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: classnames_default()('space-y-5 lg:space-y-0 lg:flex bg-gray-800 rounded p-[3.313rem]'),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()('flex items-center space-y-2 lg:w-1/2'),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "grid place-content-center text-lg leading-6 font-medium space-y-5 w-full",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: "text-2xl leading-[2.188rem] font-bold text-white text-center lg:text-left lg:max-w-xs",
              children: (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title
            })
          })
        }), ((_slice$primary$image = slice.primary.image) === null || _slice$primary$image === void 0 ? void 0 : _slice$primary$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()('aspect-w-3 aspect-h-2 lg:w-1/2 relative overflow-hidden lg:max-w-lg'),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            className: "rounded-[1.25rem] mx-auto",
            src: (_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : (_slice$primary2$image = _slice$primary2.image) === null || _slice$primary2$image === void 0 ? void 0 : _slice$primary2$image.url,
            alt: (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : (_slice$primary3$image = _slice$primary3.image) === null || _slice$primary3$image === void 0 ? void 0 : _slice$primary3$image.alt,
            width: (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : (_slice$primary4$image = _slice$primary4.image) === null || _slice$primary4$image === void 0 ? void 0 : _slice$primary4$image.dimensions.width,
            height: (_slice$primary5 = slice.primary) === null || _slice$primary5 === void 0 ? void 0 : (_slice$primary5$image = _slice$primary5.image) === null || _slice$primary5$image === void 0 ? void 0 : _slice$primary5$image.dimensions.height,
            layout: "responsive",
            objectFit: "cover"
          })
        })]
      })
    })
  });
};

/* harmony default export */ var variations_TeamWithOneImage = (TeamWithOneImage);
;// CONCATENATED MODULE: ./slices/Team/Team.types.ts
var TeamVariations;

(function (TeamVariations) {
  TeamVariations["imageParagraph"] = "teamImageParagraph";
  TeamVariations["withLargeImages"] = "teamWithLargeImages";
  TeamVariations["withOneImage"] = "teamWithOneImage";
  TeamVariations["smallImages"] = "teamSmallImages";
})(TeamVariations || (TeamVariations = {}));
;// CONCATENATED MODULE: ./slices/Team/index.tsx










var Team = function Team(_ref) {
  var _slice$items, _slice$items2;

  var slice = _ref.slice;

  switch (slice.variation) {
    // TODO: move to variation component
    case TeamVariations.imageParagraph:
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "dh-content",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "space-y-12 lg:grid lg:grid-cols-3 lg:gap-8 lg:space-y-0",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "space-y-5 sm:space-y-4",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: "dh-title dark:text-gray-900",
                children: prismic_reactjs.RichText.asText(slice.primary.title)
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "dh-description dark:text-gray-500",
                children: prismic_reactjs.RichText.asText(slice.primary.description)
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "lg:col-span-2",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                className: "space-y-12 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:gap-x-8",
                children: (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.map(function (person) {
                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "space-y-4",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "aspect-w-3 aspect-h-2 shadow-lg rounded-lg relative overflow-hidden",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                          src: person.image.url,
                          alt: person.image.alt,
                          width: person.image.dimensions.width,
                          height: person.image.dimensions.height,
                          layout: "responsive",
                          objectFit: "cover"
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "text-lg leading-6 font-medium space-y-1",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                          children: person.name
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                          className: "text-primary-600",
                          children: person.role
                        })]
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "text-lg",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                          className: "text-gray-500",
                          children: prismic_reactjs.RichText.asText(person.bio)
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                        className: "flex space-x-5",
                        children: [person.twitterUrl && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                            href: prismic_reactjs.Link.url(person.twitterUrl),
                            className: "text-gray-400 hover:text-gray-500",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                              className: "sr-only",
                              children: "Twitter"
                            }), /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
                              className: "w-5 h-5",
                              "aria-hidden": "true",
                              fill: "currentColor",
                              viewBox: "0 0 20 20",
                              children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                                d: "M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84"
                              })
                            })]
                          })
                        }), person.linkedinUrl && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                            href: prismic_reactjs.Link.url(person.linkedinUrl),
                            className: "text-gray-400 hover:text-gray-500",
                            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                              className: "sr-only",
                              children: "LinkedIn"
                            }), /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
                              className: "w-5 h-5",
                              "aria-hidden": "true",
                              fill: "currentColor",
                              viewBox: "0 0 20 20",
                              children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                                fillRule: "evenodd" // eslint-disable-next-line max-len
                                ,
                                d: "M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z",
                                clipRule: "evenodd"
                              })
                            })]
                          })
                        })]
                      })]
                    })
                  }, (0,index_browser/* nanoid */.x0)());
                })
              })
            })]
          })
        })
      });

    case TeamVariations.withLargeImages:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_TeamWithLargeImages, {
        slice: slice
      });

    case TeamVariations.withOneImage:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_TeamWithOneImage, {
        slice: slice
      });

    case TeamVariations.smallImages:
    default:
      // TODO: move to variation component
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "grid grid-cols-1 gap-12 lg:grid-cols-3 lg:gap-8",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "space-y-5 sm:space-y-4",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                className: "dh-title dark:text-gray-900",
                children: prismic_reactjs.RichText.asText(slice.primary.title)
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "dh-description dark:text-gray-500",
                children: prismic_reactjs.RichText.asText(slice.primary.description)
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "lg:col-span-2",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                className: "space-y-12 sm:grid sm:grid-cols-2 sm:gap-12 sm:space-y-0 lg:gap-x-8",
                children: (_slice$items2 = slice.items) === null || _slice$items2 === void 0 ? void 0 : _slice$items2.map(function (person) {
                  var _person$image;

                  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "flex items-center space-x-4 lg:space-x-6",
                      children: [!!((_person$image = person.image) !== null && _person$image !== void 0 && _person$image.url) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "flex-none w-16 h-16 lg:w-20 lg:h-20 rounded-full overflow-hidden relative",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                          src: person.image.url,
                          alt: person.image.alt,
                          layout: "fill",
                          objectFit: "cover"
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "font-medium text-lg leading-6 space-y-1",
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                          children: person.name
                        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                          className: "text-primary-600",
                          children: person.role
                        })]
                      })]
                    })
                  }, (0,index_browser/* nanoid */.x0)());
                })
              })
            })]
          })
        })
      });
  }
};

/* harmony default export */ var slices_Team = (Team);
;// CONCATENATED MODULE: ./slices/Video/Video.types.ts
var VideoVariations;

(function (VideoVariations) {
  VideoVariations["youtubeTwoCols"] = "videoYtTwoCols";
  VideoVariations["simpleYoutube"] = "videoSimpleYouTube";
  VideoVariations["carouselWithModal"] = "videoCarouselWithModal";
  VideoVariations["mp4"] = "videoMp4";
})(VideoVariations || (VideoVariations = {}));
;// CONCATENATED MODULE: ./slices/Video/variations/VideoSimpleYouTube.tsx





var regex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*?[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/gi;

var getYouTubeKey = function getYouTubeKey() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var _ref = regex.exec(url) || [],
      _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
      key = _ref2[1];

  return key;
};

var VideoSimpleYouTube = function VideoSimpleYouTube(_ref3) {
  var _slice$primary2, _slice$primary3, _slice$primary4;

  var slice = _ref3.slice;

  var _useState = (0,react.useState)(),
      videoKey = _useState[0],
      setVideoKey = _useState[1];

  (0,react.useEffect)(function () {
    var _slice$primary, _slice$primary$link;

    setVideoKey(getYouTubeKey(slice === null || slice === void 0 ? void 0 : (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : (_slice$primary$link = _slice$primary.link) === null || _slice$primary$link === void 0 ? void 0 : _slice$primary$link.url));
  }, [slice]);
  return videoKey ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-gray-1",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content justify-center text-center",
      children: [((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "text-athensGray font-semibold text-3.5xl pb-12",
          children: (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "rounded-2xl overflow-hidden aspect-video",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
          className: "w-full h-full",
          src: "https://www.youtube.com/embed/".concat(videoKey),
          title: ((_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.title) || 'YouTube video player',
          frameBorder: "0",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowFullScreen: true
        })
      })]
    })
  }) : null;
};

/* harmony default export */ var variations_VideoSimpleYouTube = (VideoSimpleYouTube);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.esm.js + 3 modules
var transition_esm = __webpack_require__(9196);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.esm.js + 6 modules
var dialog_esm = __webpack_require__(8346);
;// CONCATENATED MODULE: ./slices/Video/variations/components/ImagePreview.tsx



function ImagePreview_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ImagePreview_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ImagePreview_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ImagePreview_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var videoPreview = {
  url: '',
  dimensions: {
    width: 490,
    height: 300
  }
};

var ImagePreview_getYouTubeKey = function getYouTubeKey() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var regex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*?[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/gi;

  var _ref = regex.exec(url) || [],
      _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
      key = _ref2[1];

  return key;
};

var getPreviewProps = function getPreviewProps(url) {
  if (!url) return {};
  var videoKey = ImagePreview_getYouTubeKey(url);

  var preview = ImagePreview_objectSpread(ImagePreview_objectSpread({}, videoPreview), {}, {
    url: "https://i.ytimg.com/vi/".concat(videoKey, "/maxresdefault.jpg")
  });

  var video = {
    url: "https://www.youtube.com/embed/".concat(videoKey, "?autoplay=1&mute=0&enablejsapi=1")
  };
  return {
    preview: preview,
    video: video
  };
};

var PlayIcon = function PlayIcon(_ref3) {
  var play = _ref3.play;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
    type: "button",
    className: "absolute w-full h-full flex justify-center items-center cursor-pointer z-10",
    onClick: play,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      width: "80",
      height: "80",
      viewBox: "0 0 80 80",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: "cursor-pointer",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: "40",
        cy: "40",
        r: "40",
        fill: "#FCFCFE"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M53.4922 36.0158C56.1589 37.5554 56.1589 41.4044 53.4922 42.944L37.4922 52.1816C34.8255 53.7212 31.4922 51.7967 31.4922 48.7175L31.4922 30.2423C31.4922 27.1631 34.8255 25.2386 37.4922 26.7782L53.4922 36.0158Z",
        fill: "#0F0F11"
      })]
    })
  });
};

var ImagePreview = function ImagePreview(_ref4) {
  var _image$dimensions, _image$dimensions2;

  var image = _ref4.image,
      play = _ref4.play;
  return image !== null && image !== void 0 && image.url ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "aspect-video relative",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PlayIcon, {
      play: play
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: image === null || image === void 0 ? void 0 : image.url,
      alt: image === null || image === void 0 ? void 0 : image.alt,
      width: (image === null || image === void 0 ? void 0 : (_image$dimensions = image.dimensions) === null || _image$dimensions === void 0 ? void 0 : _image$dimensions.width) || '490',
      height: (image === null || image === void 0 ? void 0 : (_image$dimensions2 = image.dimensions) === null || _image$dimensions2 === void 0 ? void 0 : _image$dimensions2.height) || '310',
      layout: "intrinsic",
      className: "rounded-2xl aspect-video"
    })]
  }) : null;
};

/* harmony default export */ var components_ImagePreview = (ImagePreview);
;// CONCATENATED MODULE: ./slices/Video/variations/VideoYTTwoCols.tsx









var VideoYoutubeRwoCols = function VideoYoutubeRwoCols(_ref) {
  var _slice$primary2, _slice$primary3, _slice$primary4, _slice$primary5, _slice$primary6;

  var slice = _ref.slice;

  var _useState = (0,react.useState)(),
      videoProps = _useState[0],
      setVideoProps = _useState[1];

  var _useState2 = (0,react.useState)(false),
      open = _useState2[0],
      setOpen = _useState2[1];

  (0,react.useEffect)(function () {
    var _slice$primary, _slice$primary$videoL;

    setVideoProps(getPreviewProps(slice === null || slice === void 0 ? void 0 : (_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : (_slice$primary$videoL = _slice$primary.videoLink) === null || _slice$primary$videoL === void 0 ? void 0 : _slice$primary$videoL.url));
  }, [slice]);
  if (!(videoProps !== null && videoProps !== void 0 && videoProps.video)) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "bg-gray-1",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content grid justify-center text-center",
      children: [((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.title) && /*#__PURE__*/(0,jsx_runtime.jsx)("header", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "text-athensGray font-semibold text-3.5xl pb-4 sm:pb-12",
          children: (_slice$primary3 = slice.primary) === null || _slice$primary3 === void 0 ? void 0 : _slice$primary3.title
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "grid gap-4 justify-center sm:grid-cols-2",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "overflow-hidden",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_ImagePreview, {
            image: videoProps.preview,
            play: function play() {
              setOpen(true);
            }
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("aside", {
          className: "text-white-1",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            className: "pb-4 text-athensGray font-semibold text-3xl sm:pb-12 text-left",
            children: (_slice$primary4 = slice.primary) === null || _slice$primary4 === void 0 ? void 0 : _slice$primary4.videoTitle
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-left",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
              render: (_slice$primary5 = slice.primary) === null || _slice$primary5 === void 0 ? void 0 : _slice$primary5.videoDescription
            })
          })]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition_esm/* Transition.Root */.u.Root, {
      show: open,
      as: react.Fragment,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(dialog_esm/* Dialog */.V, {
        as: "div",
        className: "fixed inset-0 flex z-40 justify-center items-center",
        onClose: function onClose() {
          return setOpen(false);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(transition_esm/* Transition.Child */.u.Child, {
          as: react.Fragment,
          enter: "transition-opacity ease-linear duration-300",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition-opacity ease-linear duration-300",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(dialog_esm/* Dialog.Overlay */.V.Overlay, {
            className: "fixed inset-0 bg-black/80"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition_esm/* Transition.Child */.u.Child, {
          as: react.Fragment,
          enter: "transition ease-in-out duration-300 transform",
          enterFrom: "translate-x-full",
          enterTo: "translate-x-0",
          leave: "transition ease-in-out duration-300 transform",
          leaveFrom: "translate-x-0",
          leaveTo: "translate-x-full",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "w-11/12 h-2/5 z-30 sm:w-10/12 sm:h-3/4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              type: "button",
              onClick: function onClick() {
                return setOpen(false);
              },
              className: "px-3 py-3 text-white-1 place-self-end z-50",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* XIcon */.b0D, {
                className: "h-5 w-5 text-white-1",
                "aria-hidden": "true"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
              className: "w-full h-full rounded-2xl overflow-hidden",
              src: videoProps.video.url,
              title: ((_slice$primary6 = slice.primary) === null || _slice$primary6 === void 0 ? void 0 : _slice$primary6.title) || 'YouTube video player',
              frameBorder: "0",
              allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
              allowFullScreen: true
            })]
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var VideoYTTwoCols = (VideoYoutubeRwoCols);
;// CONCATENATED MODULE: ./slices/Video/variations/VideoMP4.tsx









var VideoMP4_PlayIcon = function PlayIcon(_ref) {
  var play = _ref.play;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
    type: "button",
    className: "absolute w-full h-full flex justify-center items-center z-10",
    onClick: function onClick() {
      return play();
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", {
      width: "80",
      height: "80",
      viewBox: "0 0 80 80",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        cx: "40",
        cy: "40",
        r: "40",
        fill: "#FCFCFE"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        d: "M53.4922 36.0158C56.1589 37.5554 56.1589 41.4044 53.4922 42.944L37.4922 52.1816C34.8255 53.7212 31.4922 51.7967 31.4922 48.7175L31.4922 30.2423C31.4922 27.1631 34.8255 25.2386 37.4922 26.7782L53.4922 36.0158Z",
        fill: "#0F0F11"
      })]
    })
  });
};

var VideoMP4_ImagePreview = function ImagePreview(_ref2) {
  var _image$dimensions, _image$dimensions2;

  var image = _ref2.image,
      playing = _ref2.playing,
      play = _ref2.play;
  return image !== null && image !== void 0 && image.url && !playing ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "w-full relative",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(VideoMP4_PlayIcon, {
      play: play
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      src: image === null || image === void 0 ? void 0 : image.url,
      alt: image === null || image === void 0 ? void 0 : image.alt,
      width: (image === null || image === void 0 ? void 0 : (_image$dimensions = image.dimensions) === null || _image$dimensions === void 0 ? void 0 : _image$dimensions.width) || '100%',
      height: (image === null || image === void 0 ? void 0 : (_image$dimensions2 = image.dimensions) === null || _image$dimensions2 === void 0 ? void 0 : _image$dimensions2.height) || '100%',
      layout: "intrinsic",
      className: "rounded"
    })]
  }) : null;
};

var Video = function Video(_ref3) {
  var video = _ref3.video,
      playing = _ref3.playing;
  return video.url && playing ? /*#__PURE__*/(0,jsx_runtime.jsxs)("video", {
    className: "w-full h-full overflow-hidden rounded",
    preload: "none",
    playsInline: true,
    autoPlay: true,
    controls: true,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
      src: video.url,
      type: video.type
    }), "Your browser does not support the video tag."]
  }) : null;
};

var VideoDevice;

(function (VideoDevice) {
  VideoDevice[VideoDevice["mobile"] = 0] = "mobile";
  VideoDevice[VideoDevice["desktop"] = 1] = "desktop";
})(VideoDevice || (VideoDevice = {}));

var getBgColor = function getBgColor(color) {
  if (!color) return 'bg-white-1';

  switch (color) {
    case 'black':
      return 'bg-black-2';

    case 'white':
      return 'bg-white-1';

    default:
      return (0,colors/* getColor */.Lq)(color, 600).bg;
  }
};

var VideoMP4 = function VideoMP4(_ref4) {
  var _slice$primary, _slice$primary$imageP, _slice$primary2, _slice$primary2$video, _slice$primary3, _slice$primary3$image, _slice$primary4, _slice$primary4$video, _slice$primary5, _slice$primary6, _slice$primary7, _slice$primary8, _slice$primary9, _slice$primary10;

  var slice = _ref4.slice;

  var _useState = (0,react.useState)(null),
      playVideo = _useState[0],
      setPlayVideo = _useState[1];

  var hasVideoMobile = !!((_slice$primary = slice.primary) !== null && _slice$primary !== void 0 && (_slice$primary$imageP = _slice$primary.imagePreviewMobile) !== null && _slice$primary$imageP !== void 0 && _slice$primary$imageP.url && (_slice$primary2 = slice.primary) !== null && _slice$primary2 !== void 0 && (_slice$primary2$video = _slice$primary2.videoMobile) !== null && _slice$primary2$video !== void 0 && _slice$primary2$video.url);
  var hasVideoDesktop = !!((_slice$primary3 = slice.primary) !== null && _slice$primary3 !== void 0 && (_slice$primary3$image = _slice$primary3.imagePreviewDesktop) !== null && _slice$primary3$image !== void 0 && _slice$primary3$image.url && (_slice$primary4 = slice.primary) !== null && _slice$primary4 !== void 0 && (_slice$primary4$video = _slice$primary4.videoDesktop) !== null && _slice$primary4$video !== void 0 && _slice$primary4$video.url);
  var bgTop = getBgColor((_slice$primary5 = slice.primary) === null || _slice$primary5 === void 0 ? void 0 : _slice$primary5.backgroundTop);
  var bgBottom = getBgColor((_slice$primary6 = slice.primary) === null || _slice$primary6 === void 0 ? void 0 : _slice$primary6.backgroundBottom);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: classnames_default()('relative', bgTop),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()('absolute bottom-0 w-full h-1/6 -mb-[1px]', bgBottom)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "dh-content-full flex justify-center items-center 3xl:w-8/12 lg:w-10/12 m-auto relative z-0 lg:m-auto lg:max-w-7xl 2xl:max-w-8xl 3xl:max-w-[74rem]",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(lib/* default */.ZP, {
        children: [hasVideoMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "lg:hidden",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(VideoMP4_ImagePreview, {
            image: (_slice$primary7 = slice.primary) === null || _slice$primary7 === void 0 ? void 0 : _slice$primary7.imagePreviewMobile,
            playing: playVideo === VideoDevice.mobile,
            play: function play() {
              return setPlayVideo(VideoDevice.mobile);
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Video, {
            video: (_slice$primary8 = slice.primary) === null || _slice$primary8 === void 0 ? void 0 : _slice$primary8.videoMobile,
            playing: playVideo === VideoDevice.mobile
          })]
        }), hasVideoDesktop && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "hidden lg:block",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(VideoMP4_ImagePreview, {
            image: (_slice$primary9 = slice.primary) === null || _slice$primary9 === void 0 ? void 0 : _slice$primary9.imagePreviewDesktop,
            playing: playVideo === VideoDevice.desktop,
            play: function play() {
              return setPlayVideo(VideoDevice.desktop);
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Video, {
            video: (_slice$primary10 = slice.primary) === null || _slice$primary10 === void 0 ? void 0 : _slice$primary10.videoDesktop,
            playing: playVideo === VideoDevice.desktop
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ var variations_VideoMP4 = (VideoMP4);
;// CONCATENATED MODULE: ./slices/Video/variations/VideoCarouselWithModal.tsx












var VideoCarouselWithModal_ReactCarousel = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(957), __webpack_require__.e(892)]).then(__webpack_require__.bind(__webpack_require__, 1892));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(1892)];
    }
  }
});
var VideoCarouselWithModal_itemsToShowSm = 1;
var VideoCarouselWithModal_itemsToShowLg = 3;
var VideoCarouselWithModal_breakPoints = [{
  width: 1,
  itemsToShow: VideoCarouselWithModal_itemsToShowSm,
  itemPadding: [0, 5, 0, 5],
  pagination: true
}, {
  width: 955,
  itemsToShow: VideoCarouselWithModal_itemsToShowLg,
  itemPadding: [0, 16, 0, 16],
  pagination: true
}];
var VideoCarouselWithModal_carouselOptions = {
  isRTL: false,
  pagination: true,
  breakPoints: VideoCarouselWithModal_breakPoints
};

var VideoCarouselWithModal = function VideoCarouselWithModal(_ref) {
  var _slice$items, _slice$primary, _slice$primary2, _slice$_vertical, _slice$_vertical$data;

  var slice = _ref.slice;

  var _useState = (0,react.useState)(null),
      open = _useState[0],
      setOpen = _useState[1];

  var items = (_slice$items = slice.items) === null || _slice$items === void 0 ? void 0 : _slice$items.filter(function (item) {
    return (0,prismic/* hasLink */.A)(item.videoLink);
  });
  var itemsLength = items === null || items === void 0 ? void 0 : items.length;
  VideoCarouselWithModal_carouselOptions.breakPoints[0].pagination = itemsLength > VideoCarouselWithModal_itemsToShowSm;
  VideoCarouselWithModal_carouselOptions.breakPoints[1].pagination = itemsLength > VideoCarouselWithModal_itemsToShowLg;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "bg-gray-100 dark:bg-gray-2",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "dh-content",
      children: [((_slice$primary = slice.primary) === null || _slice$primary === void 0 ? void 0 : _slice$primary.title) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "max-w-3xl mx-auto text-center mb-16",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "dh-title",
          children: slice.primary.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "text-p2 text-white-1 mt-4",
          children: (0,prismic/* hasRichText */.M)((_slice$primary2 = slice.primary) === null || _slice$primary2 === void 0 ? void 0 : _slice$primary2.description) && /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
            render: slice.primary.description
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(VideoCarouselWithModal_ReactCarousel, {
        options: VideoCarouselWithModal_carouselOptions,
        color: (_slice$_vertical = slice._vertical) === null || _slice$_vertical === void 0 ? void 0 : (_slice$_vertical$data = _slice$_vertical.data) === null || _slice$_vertical$data === void 0 ? void 0 : _slice$_vertical$data.color,
        children: items === null || items === void 0 ? void 0 : items.map(function (item) {
          var _item$videoLink, _videoProps$preview;

          var videoProps = getPreviewProps((_item$videoLink = item.videoLink) === null || _item$videoLink === void 0 ? void 0 : _item$videoLink.url);

          var _getVerticalByLink = (0,common/* getVerticalByLink */.SP)(item.videoButtonLink, slice._verticals, slice._clusters, slice._products),
              verticalId = _getVerticalByLink.uid,
              clusterId = _getVerticalByLink.clusterId;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("article", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_ImagePreview, {
              image: videoProps.preview,
              play: function play() {
                setOpen({
                  item: item,
                  videoProps: videoProps
                });
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "text-h8 text-white-1 py-2",
              children: item.videoTitle
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-p4 text-white-2",
              children: (0,prismic/* hasRichText */.M)(item.videoDescription) && /*#__PURE__*/(0,jsx_runtime.jsx)(prismic_reactjs.RichText, {
                render: item.videoDescription
              })
            }), (0,prismic/* hasLink */.A)(item.videoButtonLink) && /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery["default"], {
              href: prismic_reactjs.Link.url(item.videoButtonLink, function (doc) {
                return (0,common/* prismicLinkResolver */.LT)(doc, {
                  verticalId: verticalId,
                  clusterId: clusterId
                });
              }),
              className: "dh-button-sm dh-pill mt-4 h-9 self-end text-xs text-athensGray bg-black-2 border-white-1",
              children: item.videoButtonLabel
            })]
          }, (_videoProps$preview = videoProps.preview) === null || _videoProps$preview === void 0 ? void 0 : _videoProps$preview.url);
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition_esm/* Transition.Root */.u.Root, {
      show: open !== null,
      as: react.Fragment,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(dialog_esm/* Dialog */.V, {
        as: "div",
        className: "fixed inset-0 flex z-50 justify-center items-center",
        onClose: function onClose() {
          return setOpen(null);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(transition_esm/* Transition.Child */.u.Child, {
          as: react.Fragment,
          enter: "transition-opacity ease-linear duration-300",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition-opacity ease-linear duration-300",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(dialog_esm/* Dialog.Overlay */.V.Overlay, {
            className: "fixed inset-0 bg-black/80"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition_esm/* Transition.Child */.u.Child, {
          as: react.Fragment,
          enter: "transition ease-in-out duration-300 transform",
          enterFrom: "translate-x-full",
          enterTo: "translate-x-0",
          leave: "transition ease-in-out duration-300 transform",
          leaveFrom: "translate-x-0",
          leaveTo: "translate-x-full",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "w-11/12 h-2/5 z-30 sm:w-10/12 sm:h-3/4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              type: "button",
              onClick: function onClick() {
                return setOpen(null);
              },
              className: "px-3 py-3 text-white-1 place-self-end z-50",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(solid_esm/* XIcon */.b0D, {
                className: "h-5 w-5 text-white-1",
                "aria-hidden": "true"
              })
            }), open && /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
              className: "w-full h-full rounded-2xl overflow-hidden",
              src: open.videoProps.video.url,
              title: open.item.videoTitle || 'YouTube video player',
              frameBorder: "0",
              allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
              allowFullScreen: true
            })]
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var variations_VideoCarouselWithModal = (VideoCarouselWithModal);
;// CONCATENATED MODULE: ./slices/Video/index.tsx








var Video_Form = function Form(_ref) {
  var slice = _ref.slice;

  switch (slice.variation) {
    case VideoVariations.youtubeTwoCols:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(VideoYTTwoCols, {
        slice: slice
      });

    case VideoVariations.simpleYoutube:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_VideoSimpleYouTube, {
        slice: slice
      });

    case VideoVariations.mp4:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_VideoMP4, {
        slice: slice
      });

    case VideoVariations.carouselWithModal:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(variations_VideoCarouselWithModal, {
        slice: slice
      });

    default:
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {});
  }
};

/* harmony default export */ var slices_Video = (Video_Form);
;// CONCATENATED MODULE: ./slices/index.js
// This file is generated by Prismic local builder. Update with care!


























;// CONCATENATED MODULE: ./sm-resolver.js


var _excluded = ["sliceName"];

function sm_resolver_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function sm_resolver_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { sm_resolver_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { sm_resolver_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var __allSlices = sm_resolver_objectSpread({}, slices_namespaceObject);

var NotFound = function NotFound(_ref) {
  var sliceName = _ref.sliceName,
      slice = _ref.slice,
      i = _ref.i;
  console.error("[sm-resolver] component \"".concat(sliceName, "\" not found at index ").concat(i, "."));
  console.warn("slice data: ".concat(slice));
  return  false ? /*#__PURE__*/0 : null;
};

function SliceResolver(_ref2) {
  var sliceName = _ref2.sliceName,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  return __allSlices[sliceName] ? __allSlices[sliceName] : function () {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(NotFound, sm_resolver_objectSpread({
      sliceName: sliceName
    }, rest));
  };
}

/***/ }),

/***/ 1746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yH": function() { return /* binding */ addQueryParamsToCheckoutUrl; },
  "Zs": function() { return /* binding */ getCheckoutUrl; },
  "Pq": function() { return /* binding */ getLocalePlans; },
  "j_": function() { return /* binding */ getPlansByShowcase; },
  "I7": function() { return /* binding */ getRelevantProduct; }
});

// UNUSED EXPORTS: applyOffer, applyProductFormat, getDefaultOffer, getOffers, getProducts, snakeToCamel

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/lodash.clonedeep/index.js
var lodash_clonedeep = __webpack_require__(3465);
// EXTERNAL MODULE: ./node_modules/lodash.sortby/index.js
var lodash_sortby = __webpack_require__(8254);
// EXTERNAL MODULE: ./node_modules/lodash.set/index.js
var lodash_set = __webpack_require__(1468);
// EXTERNAL MODULE: ./node_modules/@sentry/nextjs/esm/index.client.js + 69 modules
var index_client = __webpack_require__(26);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/http/createHttpLink.js + 10 modules
var createHttpLink = __webpack_require__(5543);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 9 modules
var inMemoryCache = __webpack_require__(6495);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ApolloClient.js + 14 modules
var ApolloClient = __webpack_require__(280);
// EXTERNAL MODULE: ./node_modules/cross-fetch/dist/browser-ponyfill.js
var browser_ponyfill = __webpack_require__(4098);
var browser_ponyfill_default = /*#__PURE__*/__webpack_require__.n(browser_ponyfill);
// EXTERNAL MODULE: ./node_modules/@apollo/client/link/error/index.js
var error = __webpack_require__(3200);
// EXTERNAL MODULE: ./node_modules/apollo3-cache-persist/bundle.umd.js
var bundle_umd = __webpack_require__(5281);
;// CONCATENATED MODULE: ./graphql/client.ts
/* eslint-disable no-restricted-syntax */





var client_FetchPolicy;

(function (FetchPolicy) {
  FetchPolicy["cacheFirst"] = "cache-first";
  FetchPolicy["networkOnly"] = "network-only";
  FetchPolicy["cacheOnly"] = "cache-only";
  FetchPolicy["noCache"] = "no-cache";
  FetchPolicy["standby"] = "standby";
})(client_FetchPolicy || (client_FetchPolicy = {}));

var client_ErrorPolicy; // Agregamos un objeto para manejar múltiples endpoints

(function (ErrorPolicy) {
  ErrorPolicy["none"] = "none";
  ErrorPolicy["ignore"] = "ignore";
  ErrorPolicy["all"] = "all";
})(client_ErrorPolicy || (client_ErrorPolicy = {}));

var APOLLO_ENDPOINTS = {
  "default": "https://growth-api.digitalhouse.com/gql/graphql",
  checkout: "https://bff-sales.digitalhouse.com"
};

var createApolloLink = function createApolloLink(endpoint) {
  return (0,error/* onError */.q)(function (_ref) {
    var graphQLErrors = _ref.graphQLErrors,
        networkError = _ref.networkError;

    if (graphQLErrors) {
      graphQLErrors.forEach(function (_ref2) {
        var message = _ref2.message;
        var err = new Error("[GraphQL error]: Message: ".concat(message));
        index_client/* captureException */.Tb(err);
      });
    }

    if (networkError) index_client/* captureException */.Tb(new Error("[Network error]: ".concat(networkError)));
  }).concat((0,createHttpLink/* createHttpLink */.L)({
    uri: APOLLO_ENDPOINTS[endpoint] || APOLLO_ENDPOINTS["default"],
    // Usamos el endpoint seleccionado o el por defecto
    fetch: (browser_ponyfill_default())
  }));
};

var cache = new inMemoryCache/* InMemoryCache */.h();
var client_apolloClient = null;

var createApolloClient = function createApolloClient(endpoint) {
  if (true) {
    (0,bundle_umd.persistCacheSync)({
      cache: cache,
      storage: new bundle_umd.SessionStorageWrapper(window.sessionStorage)
    });
  }

  var link = createApolloLink(endpoint);
  return new ApolloClient/* ApolloClient */.f({
    ssrMode: true,
    // set to true for SSR
    link: link,
    cache: cache
  });
};

var initializeApollo = function initializeApollo() {
  var endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';

  if (!client_apolloClient || endpoint !== 'default') {
    client_apolloClient = createApolloClient(endpoint);
  } // For SSG and SSR always create a new Apollo Client


  if (false) {}
  return client_apolloClient;
};
/* harmony default export */ var client = (initializeApollo);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(1383);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(9989);
;// CONCATENATED MODULE: ./graphql/queries.ts


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;


var queries_GET_DEFAULT_OFFER = (0,lib/* gql */.Ps)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query getDefaultOffers ($id1: ID!) {\n    offer1: getProduct(productID: $id1) {\n      id\n      name\n      businessUnit\n      businessUnitId\n      vertical\n      verticalId\n      isSubscription\n      type\n      defaultOffer {\n        id\n        maxPurchases\n        token\n        plans(productID: $id1) {\n          id\n          discount\n          installmentCount: installment\n          installmentAmount\n          enrollmentAmount\n          remarkedEnrollmentAmount\n          remarkedInstallmentAmount\n          programAmount\n          currency\n        }\n      }\n    }\n  }\n"])));
var queries_GET_DEFAULT_OFFERS = (0,lib/* gql */.Ps)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  query getDefaultOffers ($id1: ID!, $id2: ID!) {\n    offer1: getProduct(productID: $id1) {\n      id\n      name\n      businessUnit\n      businessUnitId\n      vertical\n      verticalId\n      isSubscription\n      type\n      defaultOffer {\n        id\n        maxPurchases\n        token\n        plans(productID: $id1) {\n          id\n          discount\n          installmentCount: installment\n          installmentAmount\n          enrollmentAmount\n          remarkedEnrollmentAmount\n          remarkedInstallmentAmount\n          programAmount\n          currency\n        }\n      }\n    }\n\n    offer2: getProduct(productID: $id2) {\n      id\n      name\n      businessUnit\n      businessUnitId\n      vertical\n      verticalId\n      isSubscription\n      type\n      defaultOffer {\n        id\n        maxPurchases\n        token\n        plans(productID: $id2) {\n          id\n          discount\n          installmentCount: installment\n          installmentAmount\n          enrollmentAmount\n          remarkedEnrollmentAmount\n          remarkedInstallmentAmount\n          programAmount\n          currency\n        }\n      }\n    }\n  }\n"])));
var queries_GET_PRODUCT = (0,lib/* gql */.Ps)(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    query getProducts($id1: ID!, $country: String) {\n      products1: getAllEvents(productID: $id1, country: $country) {\n        id\n        code\n        startsAt\n        endsAt: endDate\n        lastplaces\n        soldout\n        quota\n        duration {\n          name,\n          id\n        }\n        externalAdmissionId\n        slotFrom\n        slotTo\n        schedules {\n          day,\n          startTime,\n          endTime\n        }\n      }\n    }\n"])));
var queries_GET_PRODUCTS = (0,lib/* gql */.Ps)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n    query getProducts($id1: ID!, $id2: ID!, $country: String) {\n      products1: getAllEvents(productID: $id1, country: $country) {\n        id\n        code\n        startsAt\n        endsAt: endDate\n        lastplaces\n        soldout\n        quota\n        duration {\n          name,\n          id\n        }\n        externalAdmissionId\n        slotFrom\n        slotTo\n        schedules {\n          day,\n          startTime,\n          endTime\n        }\n      }\n\n      products2: getAllEvents(productID: $id2, country: $country) {\n        id\n        code\n        startsAt\n        endsAt: endDate\n        lastplaces\n        soldout\n        quota\n        duration {\n          name,\n          id\n        }\n        externalAdmissionId\n        slotFrom\n        slotTo\n        schedules {\n          day,\n          startTime,\n          endTime\n        }\n      }\n    }  \n"])));
var OFFER1 = "\n    offer1: getOffer(token: $token1, productID: $id1, country: $country) {\n      id\n      token\n      maxPurchases\n      plans(productID: $id1, country: $country) {\n        id\n        discount\n        installmentCount: installment\n        installmentAmount\n        enrollmentAmount\n        remarkedEnrollmentAmount\n        remarkedInstallmentAmount\n        programAmount\n        currency\n      }\n    }\n";
var OFFER2 = "\n    offer2: getOffer(token: $token2, productID: $id2, country: $country) {\n      id\n      token\n      maxPurchases\n      plans(productID: $id2, country: $country) {\n        id\n        discount\n        installmentCount: installment\n        installmentAmount\n        enrollmentAmount\n        remarkedEnrollmentAmount\n        remarkedInstallmentAmount\n        programAmount\n        currency\n      }\n    }\n";
var queries_GET_OFFER = (0,lib/* gql */.Ps)(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  query getOffer($token1: String, $id1: ID!, $country: String) {\n    ", "\n  }\n"])), OFFER1);
var queries_GET_OFFERS = (0,lib/* gql */.Ps)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  query getOffer($token1: String, $token2: String, $id1: ID!, $id2: ID!, $country: String) {\n    ", "\n\n    ", "\n  }\n"])), OFFER1, OFFER2);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(352);
// EXTERNAL MODULE: ./utils/common.ts
var common = __webpack_require__(8058);
;// CONCATENATED MODULE: ./graphql/queriesCheckout.ts


var queriesCheckout_templateObject;


var getOffersCheckout = function getOffersCheckout() {
  return (0,lib/* gql */.Ps)(queriesCheckout_templateObject || (queriesCheckout_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  query GetOffer($ware: ID!, $token: String!, $currency: String, $showcase: Int) {\n    getOffer(ware: $ware, token: $token, currency: $currency, showcase: $showcase) {\n      name\n      start_at\n      end_at\n      plans {\n        id\n        billing_range\n        total_amount\n        subtotal\n        discount\n        nominal_discount_amount\n        financial_installments\n        installment\n        financial_installments\n        financial_amount\n        amount\n        remarked\n        checkout_url\n        showcase_order\n      }\n      ware {\n        product {\n          cluster {\n            alias\n            vertical {\n              id\n              name\n            }\n            business_unit {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n"])));
};
;// CONCATENATED MODULE: ./utils/checkout.ts





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }











var formatProduct = function formatProduct(product, wareId, currency, label, defaultOffer) {
  var _product$duration, _product$duration2;

  return _objectSpread(_objectSpread({}, product), {}, {
    wareId: wareId,
    currency: currency,
    label: (_product$duration = product.duration) !== null && _product$duration !== void 0 && _product$duration.name ? label.replace(new RegExp((_product$duration2 = product.duration) === null || _product$duration2 === void 0 ? void 0 : _product$duration2.name, 'i'), '') : label,
    defaultOffer: defaultOffer
  });
};

var getData = function getData(query, variables) {
  var endpoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'default';
  var client = apolloClient(endpoint);
  return client.query({
    query: query,
    variables: variables,
    fetchPolicy: FetchPolicy.cacheFirst,
    errorPolicy: ErrorPolicy.all
  });
};

var getProducts = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id1, id2, country) {
    var _multipleWares;

    var multipleWares, both, _error$graphQLErrors;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            both = !!id1 && !!id2;
            _context.next = 4;
            return getData(both ? GET_PRODUCTS : GET_PRODUCT, {
              id1: id1,
              id2: id2,
              country: country
            });

          case 4:
            multipleWares = _context.sent;
            _context.next = 12;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            multipleWares = null; // TODO: implement error handler

            if (_context.t0.networkError) Sentry.captureException(_context.t0);
            if ((_error$graphQLErrors = _context.t0.graphQLErrors) !== null && _error$graphQLErrors !== void 0 && _error$graphQLErrors.length) Sentry.captureException(_context.t0);

          case 12:
            if ((_multipleWares = multipleWares) !== null && _multipleWares !== void 0 && _multipleWares.errors) {
              multipleWares.errors = undefined;
            }

            return _context.abrupt("return", multipleWares);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function getProducts(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}()));
var getDefaultOffer = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id1, id2) {
    var _defaultOffers$data, _defaultOffers;

    var defaultOffers, both, _error$graphQLErrors2;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            both = !!id1 && !!id2;
            _context2.next = 4;
            return getData(both ? GET_DEFAULT_OFFERS : GET_DEFAULT_OFFER, {
              id1: id1,
              id2: id2
            });

          case 4:
            defaultOffers = _context2.sent;
            _context2.next = 11;
            break;

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            // TODO: implement error handler
            if (_context2.t0.networkError) Sentry.captureException('Network Error: ', _context2.t0.networkError);
            if ((_error$graphQLErrors2 = _context2.t0.graphQLErrors) !== null && _error$graphQLErrors2 !== void 0 && _error$graphQLErrors2.length) Sentry.captureException('API Graph Error:', _context2.t0.graphQLErrors[0].message);

          case 11:
            return _context2.abrupt("return", (_defaultOffers$data = (_defaultOffers = defaultOffers) === null || _defaultOffers === void 0 ? void 0 : _defaultOffers.data) !== null && _defaultOffers$data !== void 0 ? _defaultOffers$data : null);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));

  return function getDefaultOffer(_x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}()));
var getOffers = /*#__PURE__*/(/* unused pure expression or super */ null && (function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(token, wareId, country) {
    var _offers, _offers$errors, _offers$data, _offers2;

    var offers, _token$, _token$2, _wareId$, _wareId$2, variables, _error$graphQLErrors3;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            variables = {
              token1: (_token$ = token[0]) !== null && _token$ !== void 0 ? _token$ : '',
              token2: (_token$2 = token[1]) !== null && _token$2 !== void 0 ? _token$2 : '',
              id1: (_wareId$ = wareId[0]) !== null && _wareId$ !== void 0 ? _wareId$ : '',
              id2: (_wareId$2 = wareId[1]) !== null && _wareId$2 !== void 0 ? _wareId$2 : '',
              country: country
            };
            _context3.next = 4;
            return getData(!!token[0] && !!token[1] ? GET_OFFERS : GET_OFFER, variables);

          case 4:
            offers = _context3.sent;
            _context3.next = 11;
            break;

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            // TODO: implement error handler
            if (_context3.t0.networkError) Sentry.captureException('Network Error: ', _context3.t0.networkError);
            if ((_error$graphQLErrors3 = _context3.t0.graphQLErrors) !== null && _error$graphQLErrors3 !== void 0 && _error$graphQLErrors3.length) Sentry.captureException('API Graph Error:', _context3.t0.graphQLErrors[0].message);

          case 11:
            (_offers = offers) === null || _offers === void 0 ? void 0 : (_offers$errors = _offers.errors) === null || _offers$errors === void 0 ? void 0 : _offers$errors.forEach(function (e) {
              Sentry.captureException(e.message, {
                extra: {
                  wares: [wareId[0], wareId[1]].join(),
                  token: [token[0], token[1]].join(),
                  country: country
                }
              });
            });
            return _context3.abrupt("return", (_offers$data = (_offers2 = offers) === null || _offers2 === void 0 ? void 0 : _offers2.data) !== null && _offers$data !== void 0 ? _offers$data : null);

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));

  return function getOffers(_x6, _x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}()));
var applyOffer = function applyOffer(oldOffers, newOffer, path) {
  return newOffer ? set(cloneDeep(oldOffers), path, newOffer) : oldOffers;
};
var applyProductFormat = function applyProductFormat(waresId, country, currencyCode, currencySymbol, checkoutProducts, offers) {
  if (!(offers !== null && offers !== void 0 && offers.length)) {
    return {
      productsNextStarts: [],
      products: []
    };
  }

  var defaultOffers = [];
  var currency = {
    symbol: currencySymbol,
    code: currencyCode
  };

  try {
    waresId.forEach(function (ware, index) {
      var defaultOffer = _objectSpread(_objectSpread(_objectSpread({}, offers[index].offer1), offers[index].defaultOffer), {}, {
        country: country
      });

      defaultOffer.plans = defaultOffer.plans ? sortBy(defaultOffer.plans, ['currency', 'installmentAmount']) : [];
      var uniquePlans = [];
      var seen = new Set();
      defaultOffer.plans.forEach(function (plan) {
        var key = "".concat(plan.currency, "-").concat(plan.id);

        if (!seen.has(key)) {
          seen.add(key);
          uniquePlans.push(plan);
        }
      });
      defaultOffer.plans = uniquePlans;
      var product = checkoutProducts[index] ? formatProduct(checkoutProducts[index], ware, currency, offers[index].name, defaultOffer) : {};
      defaultOffers.push(product);
    });
    var productsSorted = sortBy(defaultOffers, [function (_ref4) {
      var startsAt = _ref4.startsAt;
      return new Date(startsAt).getTime();
    }]);
    var productsNextStarts = productsSorted.filter(function (_ref5) {
      var startsAt = _ref5.startsAt,
          offer = _ref5.defaultOffer;
      return (offer === null || offer === void 0 ? void 0 : offer.isSubscription) || new Date(startsAt).getTime() > new Date().getTime();
    });
    productsSorted.forEach(function (product) {
      offers.forEach(function (offer) {
        if (product.wareId === offer.id) {
          var mappedOffer = {
            businessUnitId: offer === null || offer === void 0 ? void 0 : offer.businessUnitId,
            businessUnit: offer === null || offer === void 0 ? void 0 : offer.businessUnit,
            verticalId: offer === null || offer === void 0 ? void 0 : offer.verticalId,
            vertical: offer === null || offer === void 0 ? void 0 : offer.vertical,
            type: offer === null || offer === void 0 ? void 0 : offer.type,
            name: offer === null || offer === void 0 ? void 0 : offer.name
          };
          Object.assign(product, mappedOffer);
        }
      });
    });
    return {
      productsNextStarts: productsNextStarts,
      products: productsSorted
    };
  } catch (error) {
    console.error(error);
    return {
      productsNextStarts: [],
      products: []
    };
  }
};

var formatCountryCode = function formatCountryCode(code) {
  if (!code) return code;

  var _code$split = code.split('-'),
      _code$split2 = _slicedToArray(_code$split, 2),
      language = _code$split2[0],
      country = _code$split2[1];

  if (!country) return code;
  return "".concat(language, "-").concat(country.toUpperCase());
};

var getCheckoutUrl = function getCheckoutUrl(checkout, groupId, queryParams, sandbox, countryCode, plan) {
  var version = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'new';
  var wareId = checkout.wareId;
  var baseUrl = '';
  baseUrl = [constants/* CHECKOUT_NEW_URL */.ho, wareId, "personal-data?token=".concat(checkout.offerId, "&planId=").concat(plan)].join('/');
  var url = new URL(baseUrl); // Agregar o reemplazar los valores de queryParams en url.searchParams

  Object.keys(queryParams).forEach(function (key) {
    url.searchParams.set(key, queryParams[key]);
  }); // Iterar sobre los parámetros de la URL y eliminar los que estén vacíos

  url.searchParams.forEach(function (value, key) {
    if (!value) {
      url.searchParams["delete"](key);
    }
  }); // Devolver la URL completa

  return url.toString();
};
var addQueryParamsToCheckoutUrl = function addQueryParamsToCheckoutUrl(checkoutUrl, queryParams) {
  var url = new URL(checkoutUrl);
  Object.keys(queryParams).forEach(function (key) {
    url.searchParams.set(key, queryParams[key]);
  });
  url.searchParams.forEach(function (value, key) {
    if (!value) {
      url.searchParams["delete"](key);
    }
  });
  return url.toString();
};
var getLocalePlans = function getLocalePlans(_ref6) {
  var products = _ref6.products,
      geoCountry = _ref6.geoCountry,
      locale = _ref6.locale,
      _ref6$currency = _ref6.currency,
      currency = _ref6$currency === void 0 ? '' : _ref6$currency,
      _ref6$allCurrencies = _ref6.allCurrencies,
      allCurrencies = _ref6$allCurrencies === void 0 ? [] : _ref6$allCurrencies;
  var currentLocale = (0,common/* getLocale */.Kd)(locale === common/* defaultLocale.key */.al.key ? geoCountry : locale);
  var currentCurrency = currentLocale.currencyCode;

  if (currency && allCurrencies !== null && allCurrencies !== void 0 && allCurrencies.length) {
    var _allCurrencies$find, _allCurrencies$find$c;

    currentCurrency = currency;
    currentLocale = {
      countryCode: allCurrencies === null || allCurrencies === void 0 ? void 0 : (_allCurrencies$find = allCurrencies.find(function (c) {
        return c.alias === currency;
      })) === null || _allCurrencies$find === void 0 ? void 0 : (_allCurrencies$find$c = _allCurrencies$find.country) === null || _allCurrencies$find$c === void 0 ? void 0 : _allCurrencies$find$c.locale
    };
  }

  var isUnavailable = false;
  var plans = products === null || products === void 0 ? void 0 : products.flatMap(function (item) {
    var _item$defaultOffer$pl, _item$defaultOffer;

    return (_item$defaultOffer$pl = (_item$defaultOffer = item.defaultOffer) === null || _item$defaultOffer === void 0 ? void 0 : _item$defaultOffer.plans) !== null && _item$defaultOffer$pl !== void 0 ? _item$defaultOffer$pl : [];
  });
  var hasPlans = plans === null || plans === void 0 ? void 0 : plans.some(function (p) {
    return p.currency === currentCurrency;
  });
  return {
    currentLocale: currentLocale,
    currentCurrency: currentCurrency,
    isUnavailable: isUnavailable,
    hasPlans: hasPlans
  };
};
function getRelevantProduct(objects) {
  if (!(objects !== null && objects !== void 0 && objects.allProducts)) return null;
  var allProducts = objects.allProducts;
  var selectedProduct = allProducts.find(function (p) {
    return p.isSubscription;
  }) || allProducts[0];
  return {
    platform: constants/* CHECKOUT_UTM_SOURCE */.H0,
    product: {
      id: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.id,
      code: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.code,
      name: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.name,
      type: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.type,
      business_unit_id: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.businessUnitId,
      business_unit: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.businessUnit,
      vertical_id: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.verticalId,
      vertical: selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.vertical
    }
  };
}
var snakeToCamel = function snakeToCamel(obj) {
  if (Array.isArray(obj)) {
    return obj.map(snakeToCamel);
  }

  if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce(function (acc, key) {
      var camelKey = key.replace(/_([a-z])/g, function (_, letter) {
        return letter.toUpperCase();
      });
      acc[camelKey] = snakeToCamel(obj[key]);
      return acc;
    }, {});
  }

  return obj;
};
var getPlansByShowcase = /*#__PURE__*/function () {
  var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(variables) {
    var _yield$apolloClient$q, data, error, offerData;

    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return client('checkout').query({
              query: getOffersCheckout(variables),
              variables: variables
            });

          case 3:
            _yield$apolloClient$q = _context4.sent;
            data = _yield$apolloClient$q.data;
            error = _yield$apolloClient$q.error;

            if (error) {
              console.error('Error fetching plan', error);
            }

            if (!(data !== null && data !== void 0 && data.getOffer)) {
              _context4.next = 10;
              break;
            }

            offerData = data !== null && data !== void 0 && data.getOffer ? snakeToCamel(data.getOffer) : null;
            return _context4.abrupt("return", offerData);

          case 10:
            return _context4.abrupt("return", null);

          case 13:
            _context4.prev = 13;
            _context4.t0 = _context4["catch"](0);
            console.error('Error fetching offers checkout:', _context4.t0);
            return _context4.abrupt("return", null);

          case 17:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 13]]);
  }));

  return function getPlansByShowcase(_x9) {
    return _ref7.apply(this, arguments);
  };
}();

/***/ }),

/***/ 5963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lq": function() { return /* binding */ getColor; }
/* harmony export */ });
/* unused harmony exports defaultColorKey, colors, ColorDefault */
var defaultColorKey = 'blue';
var colorText = {
  green: {
    200: 'text-green-200',
    400: 'text-green-400',
    500: 'text-green-500',
    600: 'text-green-600',
    800: 'text-green-800'
  },
  yellow: {
    200: 'text-yellow-200',
    400: 'text-yellow-400',
    500: 'text-yellow-500',
    600: 'text-yellow-600',
    800: 'text-yellow-800'
  },
  yellowGreen: {
    200: 'text-yellowGreen-200',
    400: 'text-yellowGreen-400',
    500: 'text-yellowGreen-500',
    600: 'text-yellowGreen-600',
    800: 'text-yellowGreen-800'
  },
  deepPurple: {
    200: 'text-deepPurple-200',
    400: 'text-deepPurple-400',
    500: 'text-deepPurple-500',
    600: 'text-deepPurple-600',
    800: 'text-deepPurple-800'
  },
  skyBlue: {
    200: 'text-skyBlue-200',
    400: 'text-skyBlue-400',
    500: 'text-skyBlue-500',
    600: 'text-skyBlue-600',
    800: 'text-skyBlue-800'
  },
  violet: {
    200: 'text-violet-200',
    400: 'text-violet-400',
    500: 'text-violet-500',
    600: 'text-violet-600',
    800: 'text-violet-800'
  },
  coral: {
    200: 'text-coral-200',
    400: 'text-coral-400',
    500: 'text-coral-500',
    600: 'text-coral-600',
    800: 'text-coral-800'
  },
  blue: {
    200: 'text-blue-200',
    400: 'text-blue-400',
    500: 'text-blue-500',
    600: 'text-blue-600',
    800: 'text-blue-800'
  },
  lime: {
    200: 'text-lime-200',
    400: 'text-lime-400',
    500: 'text-lime-500',
    600: 'text-lime-600',
    800: 'text-lime-800'
  },
  orange: {
    200: 'text-orange-200',
    400: 'text-orange-400',
    500: 'text-orange-500',
    600: 'text-orange-600',
    800: 'text-orange-800'
  },
  purple: {
    200: 'text-purple-200',
    400: 'text-purple-400',
    500: 'text-purple-500',
    600: 'text-purple-600',
    800: 'text-purple-800'
  },
  pink: {
    200: 'text-pink-200',
    400: 'text-pink-400',
    500: 'text-pink-500',
    600: 'text-pink-600',
    800: 'text-pink-800'
  },
  emerald: {
    200: 'text-emerald-200',
    400: 'text-emerald-400',
    500: 'text-emerald-500',
    600: 'text-emerald-600',
    800: 'text-emerald-800'
  },
  white: {
    600: 'text-white-1'
  },
  black: {
    500: 'text-black-1',
    600: 'text-black-2'
  }
};
var colorBg = {
  green: {
    200: 'bg-green-200',
    400: 'bg-green-400',
    500: 'bg-green-500',
    600: 'bg-green-600',
    800: 'bg-green-800'
  },
  yellow: {
    200: 'bg-yellow-200',
    400: 'bg-yellow-400',
    500: 'bg-yellow-500',
    600: 'bg-yellow-600',
    800: 'bg-yellow-800'
  },
  yellowGreen: {
    200: 'bg-yellowGreen-200',
    400: 'bg-yellowGreen-400',
    500: 'bg-yellowGreen-500',
    600: 'bg-yellowGreen-600',
    800: 'bg-yellowGreen-800'
  },
  deepPurple: {
    200: 'bg-deepPurple-200',
    400: 'bg-deepPurple-400',
    500: 'bg-deepPurple-500',
    600: 'bg-deepPurple-600',
    800: 'bg-deepPurple-800'
  },
  skyBlue: {
    200: 'bg-skyBlue-200',
    400: 'bg-skyBlue-400',
    500: 'bg-skyBlue-500',
    600: 'bg-skyBlue-600',
    800: 'bg-skyBlue-800'
  },
  violet: {
    200: 'bg-violet-200',
    400: 'bg-violet-400',
    500: 'bg-violet-500',
    600: 'bg-violet-600',
    800: 'bg-violet-800'
  },
  coral: {
    200: 'bg-coral-200',
    400: 'bg-coral-400',
    500: 'bg-coral-500',
    600: 'bg-coral-600',
    800: 'bg-coral-800'
  },
  blue: {
    200: 'bg-blue-200',
    400: 'bg-blue-400',
    500: 'bg-blue-500',
    600: 'bg-blue-600',
    800: 'bg-blue-800'
  },
  lime: {
    200: 'bg-lime-200',
    400: 'bg-lime-400',
    500: 'bg-lime-500',
    600: 'bg-lime-600',
    800: 'bg-lime-800'
  },
  orange: {
    200: 'bg-orange-200',
    400: 'bg-orange-400',
    500: 'bg-orange-500',
    600: 'bg-orange-600',
    800: 'bg-orange-800'
  },
  purple: {
    200: 'bg-purple-200',
    400: 'bg-purple-400',
    500: 'bg-purple-500',
    600: 'bg-purple-600',
    800: 'bg-purple-800'
  },
  pink: {
    200: 'bg-pink-200',
    400: 'bg-pink-400',
    500: 'bg-pink-500',
    600: 'bg-pink-600',
    800: 'bg-pink-800'
  },
  emerald: {
    200: 'bg-emerald-200',
    400: 'bg-emerald-400',
    500: 'bg-emerald-500',
    600: 'bg-emerald-600',
    800: 'bg-emerald-800'
  },
  white: {
    600: 'bg-white-1'
  },
  black: {
    500: 'bg-black-1',
    600: 'bg-black-2'
  }
};
var colorBgHover = {
  green: {
    200: 'hover:bg-green-200',
    400: 'hover:bg-green-400',
    500: 'hover:bg-green-500',
    600: 'hover:bg-green-600',
    800: 'hover:bg-green-800'
  },
  yellow: {
    200: 'hover:bg-yellow-200',
    400: 'hover:bg-yellow-400',
    500: 'hover:bg-yellow-500',
    600: 'hover:bg-yellow-600',
    800: 'hover:bg-yellow-800'
  },
  yellowGreen: {
    200: 'hover:bg-yellowGreen-200',
    400: 'hover:bg-yellowGreen-400',
    500: 'hover:bg-yellowGreen-500',
    600: 'hover:bg-yellowGreen-600',
    800: 'hover:bg-yellowGreen-800'
  },
  deepPurple: {
    200: 'hover:bg-deepPurple-200',
    400: 'hover:bg-deepPurple-400',
    500: 'hover:bg-deepPurple-500',
    600: 'hover:bg-deepPurple-600',
    800: 'hover:bg-deepPurple-800'
  },
  skyBlue: {
    200: 'hover:bg-skyBlue-200',
    400: 'hover:bg-skyBlue-400',
    500: 'hover:bg-skyBlue-500',
    600: 'hover:bg-skyBlue-600',
    800: 'hover:bg-skyBlue-800'
  },
  violet: {
    200: 'hover:bg-violet-200',
    400: 'hover:bg-violet-400',
    500: 'hover:bg-violet-500',
    600: 'hover:bg-violet-600',
    800: 'hover:bg-violet-800'
  },
  coral: {
    200: 'hover:bg-coral-200',
    400: 'hover:bg-coral-400',
    500: 'hover:bg-coral-500',
    600: 'hover:bg-coral-600',
    800: 'hover:bg-coral-800'
  },
  blue: {
    200: 'hover:bg-blue-200',
    400: 'hover:bg-blue-400',
    500: 'hover:bg-blue-500',
    600: 'hover:bg-blue-600',
    800: 'hover:bg-blue-800'
  },
  lime: {
    200: 'hover:bg-lime-200',
    400: 'hover:bg-lime-400',
    500: 'hover:bg-lime-500',
    600: 'hover:bg-lime-600',
    800: 'hover:bg-lime-800'
  },
  orange: {
    200: 'hover:bg-orange-200',
    400: 'hover:bg-orange-400',
    500: 'hover:bg-orange-500',
    600: 'hover:bg-orange-600',
    800: 'hover:bg-orange-800'
  },
  purple: {
    200: 'hover:bg-purple-200',
    400: 'hover:bg-purple-400',
    500: 'hover:bg-purple-500',
    600: 'hover:bg-purple-600',
    800: 'hover:bg-purple-800'
  },
  pink: {
    200: 'hover:bg-pink-200',
    400: 'hover:bg-pink-400',
    500: 'hover:bg-pink-500',
    600: 'hover:bg-pink-600',
    800: 'hover:bg-pink-800'
  },
  emerald: {
    200: 'hover:bg-emerald-200',
    400: 'hover:bg-emerald-400',
    500: 'hover:bg-emerald-500',
    600: 'hover:bg-emerald-600',
    800: 'hover:bg-emerald-800'
  },
  white: {
    600: 'hover-white-1'
  },
  black: {
    500: 'hover-black-1',
    600: 'hover-black-2'
  }
};
var colorBorder = {
  green: {
    200: 'border-green-200',
    400: 'border-green-400',
    500: 'border-green-500',
    600: 'border-green-600',
    800: 'border-green-800'
  },
  yellow: {
    200: 'border-yellow-200',
    400: 'border-yellow-400',
    500: 'border-yellow-500',
    600: 'border-yellow-600',
    800: 'border-yellow-800'
  },
  yellowGreen: {
    200: 'border-yellowGreen-200',
    400: 'border-yellowGreen-400',
    500: 'border-yellowGreen-500',
    600: 'border-yellowGreen-600',
    800: 'border-yellowGreen-800'
  },
  deepPurple: {
    200: 'border-deepPurple-200',
    400: 'border-deepPurple-400',
    500: 'border-deepPurple-500',
    600: 'border-deepPurple-600',
    800: 'border-deepPurple-800'
  },
  skyBlue: {
    200: 'border-skyBlue-200',
    400: 'border-skyBlue-400',
    500: 'border-skyBlue-500',
    600: 'border-skyBlue-600',
    800: 'border-skyBlue-800'
  },
  violet: {
    200: 'border-violet-200',
    400: 'border-violet-400',
    500: 'border-violet-500',
    600: 'border-violet-600',
    800: 'border-violet-800'
  },
  coral: {
    200: 'border-coral-200',
    400: 'border-coral-400',
    500: 'border-coral-500',
    600: 'border-coral-600',
    800: 'border-coral-800'
  },
  blue: {
    200: 'border-blue-200',
    400: 'border-blue-400',
    500: 'border-blue-500',
    600: 'border-blue-600',
    800: 'border-blue-800'
  },
  lime: {
    200: 'border-lime-200',
    400: 'border-lime-400',
    500: 'border-lime-500',
    600: 'border-lime-600',
    800: 'border-lime-800'
  },
  orange: {
    200: 'border-orange-200',
    400: 'border-orange-400',
    500: 'border-orange-500',
    600: 'border-orange-600',
    800: 'border-orange-800'
  },
  purple: {
    200: 'border-purple-200',
    400: 'border-purple-400',
    500: 'border-purple-500',
    600: 'border-purple-600',
    800: 'border-purple-800'
  },
  pink: {
    200: 'border-pink-200',
    400: 'border-pink-400',
    500: 'border-pink-500',
    600: 'border-pink-600',
    800: 'border-pink-800'
  },
  emerald: {
    200: 'border-emerald-200',
    400: 'border-emerald-400',
    500: 'border-emerald-500',
    600: 'border-emerald-600',
    800: 'border-emerald-800'
  },
  white: {
    600: 'border-white-1'
  },
  black: {
    500: 'border-black-1',
    600: 'border-black-2'
  }
};
var colorTextContrast = {
  blue: 'text-white-1',
  coral: 'text-white-1',
  emerald: 'text-gray-1',
  green: 'text-white-1',
  lime: 'text-gray-1',
  orange: 'text-gray-1',
  pink: 'text-white-1',
  purple: 'text-white-1',
  yellow: 'text-gray-1',
  yellowGreen: 'text-gray-1',
  deepPurple: 'text-white-1',
  skyBlue: 'text-white-1',
  violet: 'text-white-1',
  white: 'text-black-1',
  black: 'text-white-1'
};
var colors = {
  text: colorText,
  textContrast: colorTextContrast,
  bg: colorBg,
  bgHover: colorBgHover,
  border: colorBorder
};
var ColorDefault;

(function (ColorDefault) {
  ColorDefault["text"] = "text-primary";
  ColorDefault["textContrast"] = "text-white";
  ColorDefault["border"] = "border-primary";
  ColorDefault["bg"] = "bg-primary";
  ColorDefault["bgHover"] = "hover:bg-primary-800";
})(ColorDefault || (ColorDefault = {}));

var getColor = function getColor() {
  var _colors$textContrast$;

  var colorKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultColorKey;
  var scale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var scaleHover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 800;
  var key = colors.bg[colorKey] ? colorKey : defaultColorKey;
  return {
    bg: colors.bg[key] && colors.bg[key][scale] ? colors.bg[key][scale] : ColorDefault.bg,
    bgHover: colors.bgHover[key] && colors.bgHover[key][scaleHover] ? colors.bgHover[key][scaleHover] : ColorDefault.bgHover,
    border: colors.border[key] && colors.border[key][scale] ? colors.border[key][scale] : ColorDefault.border,
    text: colors.text[key] && colors.text[key][scale] ? colors.text[key][scale] : ColorDefault.text,
    textContrast: (_colors$textContrast$ = colors.textContrast[key]) !== null && _colors$textContrast$ !== void 0 ? _colors$textContrast$ : ColorDefault.textContrast
  };
};

/***/ }),

/***/ 7744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DJ": function() { return /* binding */ DATE_LOCALES; },
/* harmony export */   "Et": function() { return /* binding */ getCurrentDateLocale; },
/* harmony export */   "aG": function() { return /* binding */ isMorning; },
/* harmony export */   "jK": function() { return /* binding */ groupBySchedules; },
/* harmony export */   "sG": function() { return /* binding */ parseDate; }
/* harmony export */ });
/* unused harmony export formatSchedule */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8420);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9525);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2699);
/* harmony import */ var date_fns_fp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1393);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3345);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5826);
/* harmony import */ var date_fns_locale__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9081);



var DATE_LOCALES = {
  es: date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
  ar: date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
  mx: date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
  co: date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
  cl: date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
  en: date_fns_locale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
  pt: date_fns_locale__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
  br: date_fns_locale__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
};
var getCurrentDateLocale = function getCurrentDateLocale(dateLocales, lang) {
  var _Object$keys$find;

  return dateLocales[(_Object$keys$find = Object.keys(dateLocales).find(function (locale) {
    return new RegExp("^".concat(locale)).test(lang);
  })) !== null && _Object$keys$find !== void 0 ? _Object$keys$find : 'es'];
};
var parseDate = function parseDate(date) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : date_fns_locale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z;
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'dd/MM/yyyy';
  if (!date) return '';
  return (0,date_fns_fp__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    locale: locale
  }, format)((0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(date));
};
var isMorning = function isMorning(date) {
  var dateGMT = (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new Date(date), 'yyyy-MM-dd HH:mm:ss').replace(' ', 'T');
  var regex = /([0-2][0-9]:[0-5][0-9]:[0-5][0-9])/gm;
  var noonDate = dateGMT.replace(regex, '12:00:00');
  var noonDummyDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new Date(noonDate), 'yyyy-MM-dd HH:mm:ss');
  return (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(new Date(noonDummyDate), new Date(dateGMT));
};

var formatHours = function formatHours(time, endTime) {
  var dummyDate = '3032-12-15';
  var startTimeSlot = new Date("".concat(dummyDate, "T").concat(time, "-00:00"));
  var endTimeSlot = new Date("".concat(dummyDate, "T").concat(endTime, "-00:00"));
  var formattedHour = time && endTime ? "".concat((0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(startTimeSlot, 'k:mm'), "hs a ").concat((0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(endTimeSlot, 'k:mm'), "hs") : '';
  return formattedHour;
};

var formatSchedule = function formatSchedule(duplicatedSchedules, formatDay) {
  var formatted = [];
  var days = duplicatedSchedules.map(function (d) {
    return formatDay(d.day);
  }).join(', ');
  var hours = formatHours(duplicatedSchedules[0].startTime, duplicatedSchedules[0].endTime);
  var daysFormatted = days.replace(/,(?=[^,]*$)/, ' y');
  formatted.push("".concat(daysFormatted, " - ").concat(hours));
  return formatted;
};
var groupBySchedules = function groupBySchedules(schedules, formatDay) {
  var matrixSchedule = [];
  schedules === null || schedules === void 0 ? void 0 : schedules.forEach(function (element) {
    var index = matrixSchedule.findIndex(function (item) {
      return item.some(function (schedule) {
        return schedule.startTime === element.startTime && schedule.endTime === element.endTime;
      });
    });

    if (index >= 0) {
      matrixSchedule[index].push(element);
    } else {
      matrixSchedule.push([element]);
    }
  });
  return matrixSchedule.map(function (e) {
    return formatSchedule(e, formatDay);
  });
};

/***/ }),

/***/ 5220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getExperiments; }
/* harmony export */ });
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2705);

/**
 * Get experiments data
 */

var getExperiments = function getExperiments() {
  try {
    var _global$gaData$;

    var experiments = (_global$gaData$ = _global__WEBPACK_IMPORTED_MODULE_0__/* ["default"].gaData */ .Z.gaData["".concat("UA-70310111-4")]) === null || _global$gaData$ === void 0 ? void 0 : _global$gaData$.experiments;
    return experiments ? Object.keys(experiments).map(function (item) {
      return {
        id: item,
        variant: experiments[item]
      };
    }) : undefined;
  } catch (e) {
    return undefined;
  }
};

/***/ }),

/***/ 1369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ hasLink; },
/* harmony export */   "M": function() { return /* binding */ hasRichText; }
/* harmony export */ });
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5833);
/* harmony import */ var prismic_reactjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prismic_reactjs__WEBPACK_IMPORTED_MODULE_0__);

var hasRichText = function hasRichText(richtext) {
  return !!prismic_reactjs__WEBPACK_IMPORTED_MODULE_0__.RichText.asText(richtext !== null && richtext !== void 0 ? richtext : []);
};
var hasLink = function hasLink(link) {
  return !!(link !== null && link !== void 0 && link.url) || !!(link !== null && link !== void 0 && link.id);
};

/***/ })

}]);